/* Posterized wall builder — pick a wall size, fill each slot from the
   catalog or your own photo, one add-to-cart. */
(function () {
  'use strict';

  var cfg = window.PZ_WALL_CONFIG;
  var root = document.getElementById('pz-wall');
  if (!cfg || !root) return;
  /* the query string as the visitor landed - Dawn's variant sync rewrites the URL (?variant=) during boot (Arjun 09-10 gallery) */
  var LANDING_QS = location.search || '';

  /* ---------- layout data ----------
     Sizes in dm (210mm → 2.10). Columns stack top-to-bottom and are
     vertically centered; slots are numbered column by column. */
  /* SPLIT3 = the 3-piece A3 split centerpiece (print canvas 35.079×16.535in from
     the SOP); SPLIT13 = the same idea on 13×19 sheets (39×19in canvas) */
  var DIM = { A5: [1.48, 2.10], A4: [2.10, 2.97], A4L: [2.97, 2.10], A3: [2.97, 4.20], A3L: [4.20, 2.97], P13: [3.30, 4.83], SPLIT3: [8.91, 4.20], SPLIT13: [9.90, 4.83], SPLIT4: [6.30, 2.97], SPLIT5A3: [14.85, 4.20], SPLIT5A4: [10.50, 2.97], SPLIT8A4: [8.70, 6.04], SPLIT8A3: [12.18, 8.50], SPLIT8P13: [13.50, 9.76], Q2A3: [6.04, 8.50], H2A3: [4.20, 5.94], H6A3: [8.91, 8.40] };
  var GAP = 0.30;

  /* a column entry is either one size, or an ARRAY = a horizontal row
     (the A5 strips above/below each split centerpiece) */
  var RETIRED_KEYS = { gallery: 1, panorama: 1, centre: 1, mega: 1, grand: 1, museum: 1, statement: 1,
    heart: 1,   /* Arjun 30-09: Duo Wall takes Heart's Rs699 place on the rail; Heart still opens from old links */
    cinema: 1,   /* Arjun 03-10: Cinema 33 replaces Cinema 17 - the old layout stays so carts and links holding it still open */
    /* Arjun 14-10 ("mosic wall intha theme layum sethuko", after Growth brought it back on live): Mosaic 19 (Rs849) is on the ladder again */
    /* Arjun 16-09: the two ready-made walls (Porsche -> track, Dream Garage -> garage) are NOT part of the
       Build Your Wall ladder - 17 posters at Rs599 next to Studio's 10 at Rs599 made no sense. They open only
       from their pack pages ("Customise this wall" -> ?fill=) and stay on the rail/gallery only while chosen. */
    track: 1, garage: 1,
    cinema2: 1, collector: 1,   /* Arjun 14-10 (BYW Real Walls draft): the two widest walls are off while the photo walls are tried; links and saved walls open Mix 25 */
    full: 1,   /* Arjun 14-10 ("full wall venda remove pannu", same draft): Full 23 is off too; links and saved walls open the Hero Wall (same Rs899) */
    mix: 1,   /* Arjun 14-10 ("ok mix wall remove paniru", same draft, after the Showcase Wall): Mix 25 is off; Mix, Cinema 33 and Collector 42
                 links and saved walls now open the Hero Wall (Rs899, on sale from publish; Showcase stays sold out until the floor reads its 3x2 split) */
    classic: 1 }; /* Arjun 08-10 (ships Thu 15-10): Classic retired - Studio is Rs549 and Large 17; RETIRE_TO opens Studio for old Classic links / saved walls */ /* Compact back on sale (Arjun 04-09 late); Classic + Studio were hidden 09-10 and are back since 09-12 (Arjun: they still sold 120 orders a week and fill the 499/599 step between Compact and Large) */
  var RETIRE_TO = { classic: 'studio', cinema2: 'hero', collector: 'hero', mix: 'hero', full: 'hero' };   /* a retired wall a link or a saved wall still names -> the wall that replaced it */
  var LAYOUTS = {
    /* Arjun 14-10 ("ella layouts layum posters gaps ah kammi pannu", BYW Real Walls draft): compact, studio, duo, mix
       and hero now hang with 1.5 cm gaps (were 3 cm, hero 2 cm); Large keeps 3 cm ("larger wall ku mattum 3cm gap vei") - same shapes, rebuilt from their structure
       (byw-real-walls-1410/gaps/gaps.py); the cm sizes in the notes below are the old 3 cm walls. Spot order unchanged. */
    /* Large = Arjun's 21-08 mosaic: 16 A4 (two landscape) stepping diagonally
       around a 3-piece A3 split. Column objects carry a vertical offset (dy, dm);
       row objects carry an alignment (the rows hugging the split align to it). */
    /* Large = split centre, A5 quads above + below, A4 pairs at the sides
       (Arjun 22-08: keep this one; the 19-poster mosaic was rejected) */
    /* Arjun 08-10 (ships Thu 15-10): Large = 17 posters - each A5 row gets a fifth A5, so a row is as wide as the
       split (8.60 vs 8.91 dm) and the wall stays 137 x 90 cm. Written as abs (same maths as the old cols layout) so
       the first 13 spots keep their old numbers - saved walls, cart edits and the floor's slot list from the
       15-poster Large still line up; the two new A5 (right end of the top and bottom rows) are spots 14 and 15. */
    /* Arjun 14-10 ("intha large wall layout vendam, ithuku munnadi eruntha maari maathu"): the 19-poster Large (A5 between the side
       A4s) is dropped - back to Large 17, 3 cm gaps, its own desk photo */
    /* Arjun 15-10 ("large wall ah intha layout ah maathu", the home BYW card animation's wall): the Large 21 Blumun layout
       (18 A5) is dropped - back to Large 17: split centre, 2 A4 each side, 5 A5 above and below, 3 cm gaps, 137 x 90 cm,
       its own desk photo. Same spot numbers as the live Large 17, so saved walls, cart edits and the floor slot list match. */
    large:   { abs: [
      ['A4', 0.00, 1.38], ['A4', 0.00, 4.65],
      ['A5', 2.555, 0.00], ['A5', 4.335, 0.00], ['A5', 6.115, 0.00], ['A5', 7.895, 0.00],
      ['SPLIT3', 2.40, 2.40],
      ['A5', 2.555, 6.90], ['A5', 4.335, 6.90], ['A5', 6.115, 6.90], ['A5', 7.895, 6.90],
      ['A4', 11.61, 1.38], ['A4', 11.61, 4.65],
      ['A5', 9.675, 0.00], ['A5', 9.675, 6.90]
    ] },
    /* Classic (23-08, v3): Arjun's zigzag sketch, transcribed exactly. Eight A4
       in four columns of two; columns 2 and 4 drop 0.85 dm so the tops
       alternate high-low-high-low. Column gaps are our standard 0.30 dm rather
       than the tighter gaps in the drawing - that spacing is the hanging spec,
       not part of the shape. All A4: 152 g + a 140 g A4 tube = 292 g, one
       0.5 kg slab. 93 x 71 cm. */
    /* Arjun 09-09: the Ultimate Porsche Wall Setup pack, exact sizes, traced
       off its size chart (2 cm gaps): 5-piece A4 split top right with two A5
       tucked bottom-aligned to its left, 5-piece A3 split full width, then
       two A5 + the 3-piece A4 split. 148.5 x 105.4 cm. */
    track: { abs: [
      ['A5', 1.00, 0.87], ['A5', 2.70, 0.87], ['SPLIT5A4', 4.35, 0.00],
      ['SPLIT5A3', 0.00, 3.17],
      ['A5', 0.00, 7.57], ['A5', 1.68, 7.57], ['SPLIT4', 3.43, 7.57]
    ] },
    /* Arjun 09-15: the Dream Garage pack's layout (its size chart, 2 cm gaps): a row of
       eight A5 above and below a 3-piece A3 split, two A5 stacked at each side of the
       split. 132.4 x 90 cm. Slot order = top row, left pair, split, right pair, bottom
       row, so ?fill=defender lands the split in the middle and the singles around it. */
    garage: { abs: [
      ['A5', 0.00, 0.00], ['A5', 1.68, 0.00], ['A5', 3.36, 0.00], ['A5', 5.04, 0.00], ['A5', 6.72, 0.00], ['A5', 8.40, 0.00], ['A5', 10.08, 0.00], ['A5', 11.76, 0.00],
      ['A5', 0.49, 2.30], ['A5', 0.49, 4.60],
      ['SPLIT3', 2.17, 2.40],
      ['A5', 11.28, 2.30], ['A5', 11.28, 4.60],
      ['A5', 0.00, 6.90], ['A5', 1.68, 6.90], ['A5', 3.36, 6.90], ['A5', 5.04, 6.90], ['A5', 6.72, 6.90], ['A5', 8.40, 6.90], ['A5', 10.08, 6.90], ['A5', 11.76, 6.90]
    ] },
    classic: { abs: [
      ['A4', 0.00, 0.00], ['A4', 0.00, 3.27],
      ['A4', 2.40, 0.85], ['A4', 2.40, 4.12],
      ['A4', 4.80, 0.00], ['A4', 4.80, 3.27],
      ['A4', 7.20, 0.85], ['A4', 7.20, 4.12]
    ] },
    /* Studio (23-08): the Rs599 rung, from Arjun's sketch. Same zigzag idea as
       Classic but five columns of two - ten A4, cols 2 and 4 dropping 1.10 dm.
       Deliberately only two posters more than Classic (Rs62 -> Rs60 a poster)
       so the jump to Large Wall's 15 at Rs47 is the obvious one. 190 g + a
       140 g A4 tube = 330 g, one 0.5 kg slab. 117 x 73 cm. */
    studio: { abs: [
      ['A4', 0.00, 0.00], ['A4', 0.00, 3.12],
      ['A4', 2.25, 1.10], ['A4', 2.25, 4.22],
      ['A4', 4.50, 0.00], ['A4', 4.50, 3.12],
      ['A4', 6.75, 1.10], ['A4', 6.75, 4.22],
      ['A4', 9.00, 0.00], ['A4', 9.00, 3.12]
    ] },
    /* Compact (23-08): the second Rs399 way in — Arjun's sketch of one A3 in
       the middle with two A4 stacked each side. A3 centred on both axes.
       112 g + 260 g A3 tube = 372 g, also inside the first 0.5 kg slab.
       78 x 62 cm — landscape-ish, where Starter is square. */
    compact: { abs: [
      ['A4', 0.00, 0.00], ['A4', 0.00, 3.12],
      ['A3', 2.25, 0.945],
      ['A4', 5.37, 0.00], ['A4', 5.37, 3.12]
    ] },
    full:    { cols: [['A5', 'A5'], ['A4', 'A4', 'A4'], [['A5', 'A5', 'A5', 'A5', 'A5'], 'SPLIT13', ['A5', 'A5', 'A5', 'A5', 'A5']], ['A4', 'A4', 'A4'], ['A5', 'A5']] },
    /* Arjun's four drawn mosaics (22-08), transcribed to absolute placement.
       His sketches butt the frames together; we keep the 0.30 dm GAP, so the
       reconstructions read a little wider than the drawings. */
    gallery: { abs: [
      ['P13', 0.00, 0.00], ['A4', 5.86, 1.86], ['A3L', 8.26, 1.86],
      ['A4', 1.36, 5.13], ['A3L', 3.76, 5.13], ['A4L', 8.26, 5.13],
      ['A3L', 0.00, 8.40], ['A4', 4.50, 8.40], ['P13', 8.26, 7.53]
    ] },
    centre: { abs: [
      ['A3L', 4.70, 1.23], ['A3', 9.20, 0.00],
      ['A3L', 0.00, 4.50], ['A4', 4.50, 4.50], ['P13', 6.90, 4.50], ['A4', 10.50, 4.50], ['A3L', 12.90, 4.50],
      ['A4L', 3.60, 7.77], ['A4L', 10.50, 7.77],
      ['A3', 4.70, 10.17], ['A3L', 7.97, 10.17]
    ] },
    /* 14-10 (Real Walls draft, Mosaic back): the 2nd column's A4s sat flush against the 3-piece split (x 2.40 + 2.10 = 4.50) and
       read as one block on the room photo - the split and everything right of it moves 3 cm right (the usual gap) */
    mosaic: { abs: [
      ['A4', 0.00, 5.49], ['A4', 0.00, 8.76],
      ['A4', 2.40, 3.59], ['A4', 2.40, 6.86], ['A4', 2.40, 10.13],
      ['A4', 5.94, 0.32], ['A4', 8.34, 0.32], ['A4L', 10.74, 1.19],
      ['SPLIT3', 4.80, 3.59],
      ['A4L', 5.20, 8.09], ['A4', 8.47, 8.09], ['A4', 10.87, 8.09],
      ['A4', 14.01, 0.00], ['A4', 14.01, 3.27], ['A4', 14.01, 6.54],
      ['A4', 16.41, 1.03], ['A4', 16.41, 4.30]
    ] },
    /* Arjun 30-09 "Duo Wall" v2 (after the #315887 test prints - the 2x2 A3 split was too big): two A2-portrait
       splits side by side, each ONE design printed as 2 A3 landscape sheets stacked (42 x 59.4 cm, one joint).
       Top row A5 A4 A5 A4 A5 A4 A5 (bottoms level, 3 cm above the splits), A4 + A5 left and A5 + A4 right
       (centred on the splits), bottom row A4 A5 A4 A5 A4 A5 A4 (tops level; 30-09 tweak: an A4 added at each end).
       20 pieces (4 A3 + 9 A4 + 9 A5), ~146 x 125 cm.
       H2A3 is NOT an isSplit() size: the spot takes any single design or photo (A2 portrait = A3 shape) from the
       normal poster catalogue; only the wall draws its joint, and the floor cuts it into the 2 A3 sheets. */
    /* Arjun 03-10 (mock-ups ~/Downloads/new-layouts X-A / X-B / X-D): Duo-style walls, wide rather than tall, 3 cm gaps.
       Top rows sit on one line 3 cm above the body (bottoms level), bottom rows hang 3 cm below it (tops level), every
       row centred. Slot order = top row, body left to right (top to bottom in a column), bottom row. */
    /* Mix Wall, 25: A5 A4 A5 A4 A4 A5 A4 A5 / [2 A5][2 A5][3-pc A3 split][2 A5][2 A5] / A4 A5 A4 A5 A5 A4 A5 A4. ~164 x 110 cm */
    mix: { abs: [
      ['A5', 0.03, 0.87], ['A4', 1.66, 0.00], ['A5', 3.91, 0.87], ['A4', 5.54, 0.00], ['A4', 7.79, 0.00], ['A5', 10.04, 0.87], ['A4', 11.67, 0.00], ['A5', 13.92, 0.87],
      ['A5', 0.00, 3.12], ['A5', 0.00, 5.37], ['A5', 1.63, 3.12], ['A5', 1.63, 5.37],
      ['SPLIT3', 3.26, 3.195],
      ['A5', 12.32, 3.12], ['A5', 12.32, 5.37], ['A5', 13.95, 3.12], ['A5', 13.95, 5.37],
      ['A4', 0.03, 7.62], ['A5', 2.28, 7.62], ['A4', 3.91, 7.62], ['A5', 6.16, 7.62], ['A5', 7.79, 7.62], ['A4', 9.42, 7.62], ['A5', 11.67, 7.62], ['A4', 13.30, 7.62]
    ] },
    /* Cinema Wall, 33: 11 across (A5 A4 ... A5) / [2 A5][2 A5][A3][3-pc A3 split][A3][2 A5][2 A5] / 11 across (A4 A5 ... A4). ~230 x 110 cm */
    cinema2: { abs: [
      ['A5', 0.31, 0.87], ['A4', 2.09, 0.00], ['A5', 4.49, 0.87], ['A4', 6.27, 0.00], ['A5', 8.67, 0.87], ['A4', 10.45, 0.00], ['A5', 12.85, 0.87], ['A4', 14.63, 0.00], ['A5', 17.03, 0.87], ['A4', 18.81, 0.00], ['A5', 21.21, 0.87],
      ['A5', 0.21, 3.27], ['A5', 0.21, 5.67], ['A5', 1.99, 3.27], ['A5', 1.99, 5.67],
      ['A3', 3.77, 3.42], ['SPLIT3', 7.04, 3.42], ['A3', 16.25, 3.42],
      ['A5', 19.52, 3.27], ['A5', 19.52, 5.67], ['A5', 21.30, 3.27], ['A5', 21.30, 5.67],
      ['A4', 0.00, 8.07], ['A5', 2.40, 8.07], ['A4', 4.18, 8.07], ['A5', 6.58, 8.07], ['A4', 8.36, 8.07], ['A5', 10.76, 8.07], ['A4', 12.54, 8.07], ['A5', 14.94, 8.07], ['A4', 16.72, 8.07], ['A5', 19.12, 8.07], ['A4', 20.90, 8.07]
    ] },
    /* Collector Wall, 42: 13 A5 / [2 A4][3 A5][2 A4][A2 split][A2 split][2 A4][3 A5][2 A4] / 13 A5. ~228 x 117 cm */
    collector: { abs: [
      ['A5', 0.00, 0.00], ['A5', 1.78, 0.00], ['A5', 3.56, 0.00], ['A5', 5.34, 0.00], ['A5', 7.12, 0.00], ['A5', 8.90, 0.00], ['A5', 10.68, 0.00], ['A5', 12.46, 0.00], ['A5', 14.24, 0.00], ['A5', 16.02, 0.00], ['A5', 17.80, 0.00], ['A5', 19.58, 0.00], ['A5', 21.36, 0.00],
      ['A4', 0.49, 2.73], ['A4', 0.49, 6.00],
      ['A5', 2.89, 2.40], ['A5', 2.89, 4.80], ['A5', 2.89, 7.20],
      ['A4', 4.67, 2.73], ['A4', 4.67, 6.00],
      ['H2A3', 7.07, 2.88], ['H2A3', 11.57, 2.88],
      ['A4', 16.07, 2.73], ['A4', 16.07, 6.00],
      ['A5', 18.47, 2.40], ['A5', 18.47, 4.80], ['A5', 18.47, 7.20],
      ['A4', 20.25, 2.73], ['A4', 20.25, 6.00],
      ['A5', 0.00, 9.60], ['A5', 1.78, 9.60], ['A5', 3.56, 9.60], ['A5', 5.34, 9.60], ['A5', 7.12, 9.60], ['A5', 8.90, 9.60], ['A5', 10.68, 9.60], ['A5', 12.46, 9.60], ['A5', 14.24, 9.60], ['A5', 16.02, 9.60], ['A5', 17.80, 9.60], ['A5', 19.58, 9.60], ['A5', 21.36, 9.60]
    ] },
    /* Arjun 14-10 Hero Wall (preview artifact v3): centre = ONE design or photo printed as 4 A3 sheets (2x2, 59.4 x 84 cm);
       top row 4 A5; inner columns A4 / A5 / A4 each side; outer columns 2 A5 each side; bottom row A5 A4 A5; 2 cm gaps.
       18 spots = the hero + 17 singles = 21 prints (4 A3 + 5 A4 + 12 A5), ~139 x 139 cm. Spot order = hero, top row,
       left inner column, right inner column, left outer, right outer, bottom row (the floor's Slot numbers). */
    /* Arjun 14-10 ("A2 ok, build pannu", after "set aagatha maari eruku"): the 2x2 A3 hero stays; 3 A4 each side (centred on the
       hero), 2 A5 outside them, A5 A4 A5 above (bottoms level) and below (tops level), rows 1.5 cm from the hero.
       17 spots = 20 prints (4 A3 + 8 A4 + 8 A5), ~137 x 146 cm. Spot order = hero, top row, left A4s, right A4s, left A5s,
       right A5s, bottom row (Hero never sold in its 18-spot form, so no saved wall or cart depends on the old order). */
    hero: { abs: [
      ['Q2A3', 3.830, 3.070], ['A5', 4.170, 0.870], ['A4', 5.800, 0.000], ['A5', 8.050, 0.870],
      ['A4', 1.630, 2.715], ['A4', 1.630, 5.835], ['A4', 1.630, 8.955], ['A4', 9.970, 2.715], ['A4', 9.970, 5.835], ['A4', 9.970, 8.955],
      ['A5', 0.000, 5.145], ['A5', 0.000, 7.395], ['A5', 12.220, 5.145], ['A5', 12.220, 7.395], ['A5', 4.170, 11.670], ['A4', 5.800, 11.670], ['A5', 8.050, 11.670]
    ] },
    /* Arjun 14-10 Showcase Wall (his STARBOY reference, "center hero A3 3x2, apro side la fillers"; the standard-size version he
       picked): one design or photo on 6 A3 portrait sheets (3 x 2, 89.1 x 84 cm), an A4 column (3 A4) beside it and an A5 column
       (4 A5) outside it on each side, every column centred on the hero, 1.5 cm gaps. 15 spots = 20 prints (6 A3 + 6 A4 + 8 A5),
       ~167 x 92 cm. Spot order = hero, left A4s, right A4s, left A5s, right A5s (top to bottom). */
    showcase: { abs: [
      ['H6A3', 3.880, 0.405],
      ['A4', 1.630, 0.000], ['A4', 1.630, 3.120], ['A4', 1.630, 6.240], ['A4', 12.940, 0.000], ['A4', 12.940, 3.120], ['A4', 12.940, 6.240],
      ['A5', 0.000, 0.180], ['A5', 0.000, 2.430], ['A5', 0.000, 4.680], ['A5', 0.000, 6.930], ['A5', 15.190, 0.180], ['A5', 15.190, 2.430], ['A5', 15.190, 4.680], ['A5', 15.190, 6.930]
    ] },
    /* Arjun 14-10 Trio XL (his Blumun reference made better - "C2 ok, Trio XL name, build pannu"): three 2x2 A3 heroes side by side,
       each one design printed uncropped as A1 on 4 A3 (the Hero Wall's Q2A3 spot); A5 A4 A5 above and below each hero; A4/A5/A4
       columns at both ends with an A5 above and below. 31 spots = 40 prints (12 A3 + 10 A4 + 18 A5), ~226 x 146 cm. Spot order:
       heroes left to right, top row, left column, right column, bottom row. */
    trio: { abs: [   /* 14-10 ("3 cm gap vei"): 3 cm between the hero boxes (4 cm print to print) */
      ['Q2A3', 2.200, 3.070], ['Q2A3', 8.540, 3.070], ['Q2A3', 14.880, 3.070],
      ['A5', 0.310, 0.870], ['A5', 2.540, 0.870], ['A4', 4.170, 0.000], ['A5', 6.420, 0.870], ['A5', 8.880, 0.870], ['A4', 10.510, 0.000], ['A5', 12.760, 0.870], ['A5', 15.220, 0.870], ['A4', 16.850, 0.000], ['A5', 19.100, 0.870], ['A5', 21.330, 0.870],
      ['A4', 0.000, 3.120], ['A5', 0.310, 6.270], ['A4', 0.000, 8.550], ['A4', 21.020, 3.120], ['A5', 21.330, 6.270], ['A4', 21.020, 8.550],
      ['A5', 0.310, 11.670], ['A5', 2.540, 11.670], ['A4', 4.170, 11.670], ['A5', 6.420, 11.670], ['A5', 8.880, 11.670], ['A4', 10.510, 11.670], ['A5', 12.760, 11.670], ['A5', 15.220, 11.670], ['A4', 16.850, 11.670], ['A5', 19.100, 11.670], ['A5', 21.330, 11.670]
    ] },
    /* Arjun 14-10 (after several passes: corners in, middle A4 + A5 out, centre gap closed, then "mela erukra 4 A5 & 2 A4 kelayum
       maathum, both sides la 2 A4 vei"): A5 A4 A5 | A5 A4 A5 above (bottoms level) and below (tops level), 2 A4 at each side centred on
       the heroes, rows 1.5 cm from the side columns, groups 1.5 cm apart. 18 spots (2 splits + 8 A4 + 8 A5), ~131 x 123 cm.
       Spot order: top row (6), left column (2), heroes, right column (2), bottom row (6). */
    duo: { abs: [
      ['A5', 1.09, 0.87], ['A4', 2.72, 0.00], ['A5', 4.97, 0.87], ['A5', 6.60, 0.87], ['A4', 8.23, 0.00], ['A5', 10.48, 0.87],
      ['A4', 0.00, 3.12], ['A4', 0.00, 6.24],
      ['H2A3', 2.25, 3.195], ['H2A3', 6.60, 3.195],
      ['A4', 10.95, 3.12], ['A4', 10.95, 6.24],
      ['A5', 1.09, 9.36], ['A4', 2.72, 9.36], ['A5', 4.97, 9.36], ['A5', 6.60, 9.36], ['A4', 8.23, 9.36], ['A5', 10.48, 9.36]
    ] },
    /* wings of A4-landscape + A3-landscape either side, three columns of A4
       stepping down to a point — the middle column sits ~1.2 dm lower, which
       is what gives it the heart silhouette */
    heart: { abs: [
      ['A4L', 1.23, 0.00], ['A3L', 0.00, 2.40], ['A4L', 1.23, 5.67],
      ['A4', 4.50, 0.90], ['A4', 4.50, 4.17], ['A4', 4.50, 7.44],
      ['A4', 6.90, 2.07], ['A4', 6.90, 5.34], ['A4', 6.90, 8.61],
      ['A4', 9.30, 0.90], ['A4', 9.30, 4.17], ['A4', 9.30, 7.44],
      ['A4L', 11.70, 0.00], ['A3L', 11.70, 2.40], ['A4L', 11.70, 5.67]
    ] },
    /* one long sight line for a whole wall above a sofa — every piece is
       centred on the same axis, so it reads as a single ribbon
       */
    panorama: { abs: [
      ['A5', 0.00, 2.83], ['A4', 1.78, 2.40], ['A3', 4.18, 1.78],
      ['A4L', 7.45, 2.83], ['P13', 10.72, 1.47], ['A4L', 14.32, 2.83],
      ['A3', 17.59, 1.78], ['A4', 20.86, 2.40], ['A5', 23.26, 2.83],
      ['A5', 2.09, 0.00], ['A5', 2.09, 5.67], ['A5', 8.20, 0.43],
      ['A5', 8.20, 5.23], ['A5', 15.06, 0.43], ['A5', 15.06, 5.23],
      ['A5', 21.17, 0.00], ['A5', 21.17, 5.67]
    ] },
    /* a 13x19 split hero framed by landscape bands and A3 bookends
       */
    cinema: { abs: [
      ['SPLIT13', 5.60, 2.39], ['A4L', 5.60, 0.00], ['A4L', 8.87, 0.00],
      ['A4L', 12.14, 0.00], ['A4L', 5.60, 7.52], ['A4L', 8.87, 7.52],
      ['A4L', 12.14, 7.52], ['A4', 3.20, 0.06], ['A4', 3.20, 3.33],
      ['A4', 3.20, 6.60], ['A4', 15.80, 0.06], ['A4', 15.80, 3.33],
      ['A4', 15.80, 6.60], ['A3', 0.00, 2.71], ['A3', 18.20, 2.71]
    ] },
    /* 13x19 split centre, A3 columns, A4 and A5 stepping outward
       */
    grand: { abs: [
      ['A5', 0.00, 1.04], ['A5', 0.00, 3.44], ['A5', 0.00, 5.84],
      ['A5', 0.00, 8.24], ['A4', 1.78, 0.94], ['A4', 1.78, 4.21],
      ['A4', 1.78, 7.48], ['A3', 4.18, 1.34], ['A3', 4.18, 5.84],
      ['SPLIT13', 7.45, 3.27], ['A4', 7.45, 0.00], ['A4', 9.85, 0.00],
      ['A4', 12.25, 0.00], ['A4', 14.65, 0.00], ['A4', 7.45, 8.40],
      ['A4', 9.85, 8.40], ['A4', 12.25, 8.40], ['A4', 14.65, 8.40],
      ['A3', 17.65, 1.34], ['A3', 17.65, 5.84], ['A4', 20.92, 0.94],
      ['A4', 20.92, 4.21], ['A4', 20.92, 7.48], ['A5', 23.32, 1.04],
      ['A5', 23.32, 3.44], ['A5', 23.32, 5.84], ['A5', 23.32, 8.24]
    ] },
    /* big formats only — 13x19 singles and A3 — so it reads premium and
       still has just 17 spots to fill
       */
    museum: { abs: [
      ['SPLIT13', 8.07, 5.13], ['P13', 7.77, 0.00], ['P13', 11.37, 0.00],
      ['P13', 14.97, 0.00], ['P13', 7.77, 10.25], ['P13', 11.37, 10.25],
      ['P13', 14.97, 10.25], ['A3', 4.50, 3.19], ['A3', 4.50, 7.69],
      ['A3L', 0.00, 2.79], ['A3L', 0.00, 6.06], ['A3L', 0.00, 9.33],
      ['A3', 18.57, 3.19], ['A3', 18.57, 7.69], ['A3L', 21.84, 2.79],
      ['A3L', 21.84, 6.06], ['A3L', 21.84, 9.33]
    ] },
    /* two heroes stacked, a 13x19 split over an A3 split, inside a full
       symmetric frame. The biggest wall we sell.
       */
    statement: { abs: [
      ['SPLIT13', 8.35, 3.27], ['SPLIT3', 8.85, 8.40], ['A4', 8.35, 0.00],
      ['A4', 10.75, 0.00], ['A4', 13.15, 0.00], ['A4', 15.55, 0.00],
      ['A4', 8.35, 12.90], ['A4', 10.75, 12.90], ['A4', 13.15, 12.90],
      ['A4', 15.55, 12.90], ['A5', 0.00, 2.40], ['A5', 0.00, 4.80],
      ['A5', 0.00, 7.20], ['A5', 0.00, 9.60], ['A5', 0.00, 12.00],
      ['A4', 1.78, 1.86], ['A4', 1.78, 5.13], ['A4', 1.78, 8.40],
      ['A4', 1.78, 11.67], ['A3', 4.18, 1.65], ['A3', 4.18, 6.15],
      ['A3', 4.18, 10.65], ['A3', 18.55, 1.65], ['A3', 18.55, 6.15],
      ['A3', 18.55, 10.65], ['A4', 21.82, 1.86], ['A4', 21.82, 5.13],
      ['A4', 21.82, 8.40], ['A4', 21.82, 11.67], ['A5', 24.22, 2.40],
      ['A5', 24.22, 4.80], ['A5', 24.22, 7.20], ['A5', 24.22, 9.60],
      ['A5', 24.22, 12.00]
    ] },
    /* traced pixel-for-pixel off Arjun's drawing at 56.5 px/dm — do NOT
       re-derive these from gap chains, that is what shifted the shape last
       time. Every new layout gets transcribed this way. */
    mega: { abs: [
      ['A4', 3.26, 0.00], ['A4L', 5.38, 0.90], ['A4', 8.48, 0.90],
      ['A3', 10.80, 1.88], ['A3', 13.84, 1.95],
      ['A4', 0.90, 2.00], ['A4', 3.26, 3.04], ['A4', 5.40, 3.04], ['A4L', 7.61, 4.00],
      ['A4', 0.90, 5.03], ['A4', 0.90, 8.11],
      ['SPLIT13', 3.22, 6.27],
      ['A4', 13.66, 6.27], ['A4', 13.66, 9.35], ['A4', 13.66, 12.50],
      ['A3', 0.00, 11.38], ['A3', 3.06, 11.38],
      ['A4L', 6.12, 11.38], ['A4', 9.17, 11.38], ['A4', 11.35, 11.38],
      ['A4', 6.12, 13.54], ['A4L', 8.30, 14.48], ['A4', 11.35, 14.48]
    ] }
  };

  /* Order here IS the order of the swipe rail. Kept price-ascending on Arjun's
     call (23-08): a customer who sees 5 posters at Rs399, then 7 at Rs499, then
     15 at Rs699 reads Large Wall as the value pick. Keep new packs in price
     order when adding them. */
  var SIZE_META = {
    compact:   { name: 'Compact Wall',   posters: 5,  desc: 'A3 centre + 4 A4' },
    classic:   { name: 'Classic Wall',   posters: 8,  desc: '8 A4, zigzag columns' },
    studio:    { name: 'Studio Wall',    posters: 10, desc: '10 A4, zigzag columns' },
    large:     { name: 'Large Wall',     posters: 17, desc: '3-pc A3 split + 4 A4 + 10 A5' },   /* 15-10: back to 17 (Large 21 dropped); 08-10: was 15 (8 A5) */
    track:     { name: 'Track Wall',     posters: 17, desc: '5-pc A3 split + 5-pc A4 split + 3-pc A4 split + 4 A5' },
    garage:    { name: 'Garage Wall',    posters: 21, desc: '3-pc A3 split + 20 A5' },
    gallery:   { name: 'Gallery Wall',   posters: 9,  desc: '2 big 13\u00d719 + 3 A3 + 4 A4' },
    panorama:  { name: 'Panorama Wall',  posters: 17, desc: '13\u00d719 centre + 2 A3 + 4 A4 + 10 A5' },
    heart:     { name: 'Heart Wall',     posters: 15, desc: '2 A3 + 13 A4, heart shape' },
    duo:       { name: 'Duo Wall',       posters: 18, desc: '2 A3 top/bottom splits + 8 A4 + 8 A5' },   /* 14-10: was 20 (middle A4 + A5 removed) */
    /* Arjun 03-10 - the floor's exact Wall Size wording (one '+' part per size) */
    mix:       { name: 'Mix Wall',       posters: 25, desc: '3-pc A3 split + 8 A4 + 16 A5' },
    cinema2:   { name: 'Cinema Wall',    posters: 33, desc: '3-pc A3 split + 2 A3 + 11 A4 + 19 A5' },
    collector: { name: 'Collector Wall', posters: 42, desc: '2 A3 top/bottom splits + 8 A4 + 32 A5' },
    hero:      { name: 'Hero Wall',      posters: 20, desc: '2\u00d72 A3 hero split + 8 A4 + 8 A5' },   /* Arjun 14-10: floor reads the 2x2 A3 split as 4 A3 sheets */   /* floor reads the leading 2 as two splits (30-09) */
    showcase:  { name: 'Showcase Wall',  posters: 20, desc: '3\u00d72 A3 hero split + 6 A4 + 8 A5' },   /* Arjun 14-10 ("itha layout koda include pannu"): one design on 6 A3 sheets (3 across x 2 down); floor must read the 3x2 split before it sells */
    trio:      { name: 'Trio XL Wall',   posters: 40, desc: '3 \u00d7 2\u00d72 A3 heroes + 10 A4 + 18 A5' },   /* Arjun 14-10: three A1 heroes (floor reads each 2x2 A3 split as 4 A3 sheets) */
    centre:    { name: 'Centre Wall',    posters: 11, desc: '13\u00d719 centre + 6 A3 + 4 A4' },
    full:      { name: 'Full Wall',      posters: 23, desc: '3-pc 13\u00d719 split + 6 A4 + 14 A5' },
    mosaic:    { name: 'Mosaic Wall',    posters: 19, desc: '3-pc A3 split + 16 A4' },
    cinema:    { name: 'Cinema Wall',    posters: 17, desc: '3-pc 13\u00d719 split + 2 A3 + 12 A4' },
    mega:      { name: 'Mega Wall',      posters: 25, desc: '3-pc 13\u00d719 split + 4 A3 + 18 A4' },
    grand:     { name: 'Grand Wall',     posters: 29, desc: '3-pc 13\u00d719 split + 4 A3 + 14 A4 + 8 A5' },
    museum:    { name: 'Museum Wall',    posters: 19, desc: '3-pc 13\u00d719 split + 6 \u00d7 13\u00d719 + 10 A3' },
    statement: { name: 'Statement Wall', posters: 38, desc: '13\u00d719 + A3 splits + 6 A3 + 16 A4 + 10 A5' }
  };

  /* print sizes in inches for the DPI gate + export caps */
  /* 14-10 (Floor reply SPLIT-TILES-FLOOR-REPLY-1410: A3 tiles keep a 3.39 mm white border, 13x19 2.54 mm, and every split is
     scaled once to the panels' printable areas side by side, then cut exactly - trimmed and rejoined, nothing lost or repeated).
     So a split's crop is the trimmed picture, not the full sheets: 3-piece A3 870.7 x 413.3 mm, 2x2 580.5 x 826.5, 2-piece stack
     413.3 x 580.5, 3x2 870.7 x 826.5, 3-piece 13x19 975.3 x 477.5 - what the customer crops is exactly what prints. */
  var PRINT_IN = { A5: [5.827, 8.268], A4: [8.268, 11.693], A4L: [11.693, 8.268], A3: [11.693, 16.535], A3L: [16.535, 11.693], P13: [13, 19], SPLIT3: [34.28, 16.272], SPLIT13: [38.398, 18.799], SPLIT4: [24.803, 11.693], SPLIT5A3: [58.465, 16.535], SPLIT5A4: [41.339, 11.693], SPLIT8A4: [33.071, 23.386], SPLIT8A3: [46.772, 33.071], SPLIT8P13: [52, 38], Q2A3: [22.854, 32.539], H2A3: [16.272, 22.854], H6A3: [34.28, 32.539] };
  var OUT_PX = { A5: [1748, 2480], A4: [2480, 3508], A4L: [3508, 2480], A3: [3508, 4961], A3L: [4961, 3508], P13: [3900, 5700], SPLIT3: [5262, 2480], SPLIT13: [5850, 2850], SPLIT4: [7440, 3508], SPLIT5A3: [17540, 4961], SPLIT5A4: [12400, 3508], SPLIT8A4: [9920, 7016], SPLIT8A3: [14032, 9922], SPLIT8P13: [15600, 11400], Q2A3: [6856, 9762], H2A3: [4881, 6856], H6A3: [10284, 9762] };

  function ratioFor(size) {
    var pi = PRINT_IN[size] || PRINT_IN.A4;
    return pi[0] / pi[1];
  }
  function isSplit(size) { return String(size).indexOf('SPLIT') === 0; }
  /* Arjun 09-09: Pinterest pins are mostly 564-1200 px; the print prep
     upscales customer photos (LSDIR), so a pin only needs half the floor -
     it is warned about, not refused. Uploads keep the strict floor. */
  function isPinFile(file) { return !!(file && /^pinterest-/i.test(file.name || '')); }
  function floorDpiFor(size, file) { var f = isSplit(size) ? 50 : 80; return isPinFile(file) ? Math.round(f * 0.62) : f; }
  /* Arjun 16-10: below the floor a Build Your Wall / Mix & Match photo is taken with a warning, down to 35% of it (the floor's
     upscaler handles ~4x); framed prints and photo products keep the hard floor */
  function lowFloorFor(size) { return Math.round((isSplit(size) ? 50 : 80) * 0.35); }
  function lowOK() { return !FRAMED && !PHOTO; }
  /* how a split cell is cut: 3-piece = 3 across, 8-panel = 4 across x 2 down */
  function panelsOf(size) { if (/^SPLIT8/.test(size)) return { c: 4, r: 2 }; if (/^SPLIT5/.test(size)) return { c: 5, r: 1 }; if (isSplit(size)) return { c: 3, r: 1 }; if (size === 'H2A3') return { c: 1, r: 2 }; return { c: 1, r: 1 }; }
  /* 14-10 (Arjun: "build pannu" - custom photos in the 4- and 6-piece heroes): the joints drawn over a spot (crop editor, wall
     preview, drawn scenes) - the 2x2 A3 (Q2A3) and 3x2 A3 (H6A3) heroes too, so a face is not placed on a joint. panelsOf
     stays as it is: it also sorts single from split picks. */
  function jointsOf(size) { if (size === 'Q2A3') return { c: 2, r: 2 }; if (size === 'H6A3') return { c: 3, r: 2 }; return panelsOf(size); }
  function hasJoints(size) { return isSplit(size) || size === 'H2A3' || size === 'Q2A3' || size === 'H6A3'; }
  var CUSTOM = /^custom/.test(cfg.mode || '');
  /* ---- photo products (Arjun 28-09: "mini prints, retro prints, photobooth, personalize your wall - BYW / Mix & Match
     style la venum") ----
     PHOTO  = the four own-photo products on this engine: custom-mini, custom-retro, custom-booth and custom
              (Personalize Your Wall Space). custom8 (the 8-panel split) keeps its own path.
     FRAMED = the three white-frame prints (mini / retro / booth), drawn true to the floor's print templates
              (posterized-floor bin/sheets.py SPECS, measured off the PSDs): white card, photo window, plain bottom band.
     A framed spot is the whole card (mini, retro); a booth spot is one photo window, the strip is drawn behind it. */
  var PHOTO = CUSTOM && cfg.mode !== 'custom8';
  var FRAMED = /^custom-(mini|retro|booth)$/.test(cfg.mode || '');
  var FRAMED_KIND = FRAMED ? String(cfg.mode).replace(/^custom-/, '') : '';
  /* Arjun 08-10: Retro + Mini prints get a big "upload all photos at once" button. The picker always took many photos
     (one tap on a spot, multi-select, the batch fills the empty spots and a too-big batch offers the bigger pack) but
     nobody found it - the button says it out loud. 09-10: Booth strips too. Personalize (one poster) is unchanged. */
  var BULK_UP = FRAMED_KIND === 'retro' || FRAMED_KIND === 'mini' || FRAMED_KIND === 'booth';
  /* card sizes in dm (sheets.py, 300 dpi): Mini 750x900 px, Retro 3.5x4.2" 1050x1260, Retro A6 1240x1748, Booth strip 576x1997;
     BOOTHW = one booth photo window (538 px square) - the spot; BOOTH = the whole strip (decoration) */
  DIM.MINI = [0.635, 0.762]; DIM.RETRO = [0.889, 1.067]; DIM.RETROA6 = [1.05, 1.48]; DIM.BOOTH = [0.488, 1.691]; DIM.BOOTHW = [0.4555, 0.4555];
  /* the photo window, as fractions of the card [left, top, width, height] - everything below it is the plain white band */
  var FRAME_WIN = { MINI: [0.0480, 0.0389, 0.9053, 0.8000], RETRO: [0.0571, 0.0500, 0.8857, 0.7381], RETROA6: [0.0403, 0.0892, 0.9194, 0.6510] };
  /* booth strip: three square windows stacked, blank foot (~15%) below */
  var BOOTH_WIN = { x: 0.030, w: 0.934, y: [0.0205, 0.2994, 0.5764], h: 0.2694 };
  /* the photo WINDOW in inches (crop aspect + DPI gate: 80 DPI hard floor, 150 DPI low-res line) and the export size
     (600 DPI of the window; never upscaled). A6 at 2280 px clears the floor's 1824 px AI-upscale threshold. */
  PRINT_IN.MINI = [2.263, 2.4]; PRINT_IN.RETRO = [3.1, 3.1]; PRINT_IN.RETROA6 = [3.8, 3.8]; PRINT_IN.BOOTHW = [1.793, 1.793];
  OUT_PX.MINI = [1358, 1441]; OUT_PX.RETRO = [1860, 1860]; OUT_PX.RETROA6 = [2280, 2280]; OUT_PX.BOOTHW = [1076, 1076];
  /* what one sellable unit is called, singular / plural (SIZE_META.unit keeps the plural it always had) */
  var UNIT_ONE = { posters: 'poster', sets: 'set', prints: 'print', strips: 'strip' };
  function unitNoun(m, n) { var u = (m && m.unit) || 'posters'; return n === 1 ? (UNIT_ONE[u] || u.replace(/s$/, '')) : u; }
  /* the price of one unit: a booth pack is priced per STRIP (3 photos each), everything else per spot */
  function perUnit(vr, m) { return Math.round(vr.v.price / ((m && m.units) || (m && m.posters) || 1)); }
  /* the photo cells' names (editor title, toasts): the product words customers see on the page */
  var PHOTO_CELL_NAME = { MINI: 'mini print', RETRO: '3.5\u00d74.2" retro print', RETROA6: 'A6 retro print', BOOTHW: 'photobooth strip' };
  function sizeLabel(size) { if (PHOTO_CELL_NAME[size]) return PHOTO_CELL_NAME[size]; if (size === 'SPLIT8A4') return '8-Panel A4 Split'; if (size === 'SPLIT8A3') return '8-Panel A3 Split'; if (size === 'SPLIT8P13') return '8-Panel 13\u00d719 Split'; if (size === 'SPLIT5A3') return '5-Piece A3 Split'; if (size === 'SPLIT5A4') return '5-Piece A4 Split'; if (size === 'SPLIT4') return '3-Piece A4 Split'; if (size === 'SPLIT3') return '3-Piece A3 Split'; if (size === 'SPLIT13') return '3-Piece 13×19 Split'; if (size === 'A4L') return 'A4 Landscape'; if (size === 'A3L') return 'A3 Landscape'; if (size === 'P13') return '13×19'; if (size === 'Q2A3') return '4-Piece 2×2 A3 Split'; if (size === 'H6A3') return '6-Piece 3×2 A3 Split'; if (size === 'H2A3') return '2-Piece A3 Split (top/bottom)';   /* floor A3 SPLIT-STACK2 (30-09): '2-Piece' = 2 panels */   /* floor parser (30-09, commit 8ec2f4d): needs Split + A3 + 2x2; 4-Piece = 4 panels */ return size; }
  function isLandscape(size) { return size === 'A4L' || size === 'A3L'; }

  /* every catalog collection is BEST_SELLING-sorted in Shopify except
     all-posters (newest first) — so the All tab leads with the
     top-selling-products collection, then the full catalog behind it
     (merge:'concat'). Multi-collection tabs interleave by sales rank. */
  /* no Your Photo tab any more (Arjun 22-08) — uploading is the first card
     inside every category instead, because the tab row scrolls on mobile and a
     trailing tab was going unseen */
  /* Arjun 28-08: Gen-Z tab expansion - Gaming / Sports / Pop Culture /
     Divine / Kollywood were sitting in Shopify collections but never surfaced
     in the drawer. All existing collections, nothing new created. Order =
     what that audience reaches for first. */
  var TABS = [
    /* Rail order (Arjun 09-09): Pinterest chip → Music → Aesthetic → Anime →
       Cars → Superheroes → Gaming → Sports → Movies → the rest → All Posters (default grid, Arjun: 'all posters last la vei'); Collections chip last.
       Anime/Aesthetic/Coffee are builder-only theme assets (flat art, portrait only);
       `extra` tabs merge pz-extra.json items on top of their Shopify collections. */
    { key: 'music',  label: 'Music',       handles: ['hip-hop', 'music-artist', 'k-pop'], extra: 'pz-extra.json' },
    { key: 'aesthetic', label: 'Aesthetic', handles: [], asset: 'pz-extra.json', flat: true, portraitOnly: true },
    { key: 'anime', label: 'Anime', handles: [], asset: 'pz-anime.json', flat: true, portraitOnly: true },
    { key: 'cars',   label: 'Cars',        handles: ['cars'], extra: 'pz-extra.json' },
    { key: 'heroes', label: 'Superheroes', handles: ['marvel-collections', 'dcu-collections'], extra: 'designs' },   /* 10-10: floor uploads were dropped (no extra) */
    { key: 'gaming', label: 'Gaming',      handles: ['games'], extra: 'pz-extra.json' },
    { key: 'sports', label: 'Sports & F1', handles: ['foot-ball', 'cricket', 'sports', 'f1-race', 'german-gp'], extra: 'pz-extra.json' },
    { key: 'movies', label: 'Hollywood', handles: ['all-movies', 'series'], extra: 'pz-extra.json' },   /* 16-10: Movies & Series = Hollywood (Arjun) */
    { key: 'pop',    label: 'Pop Culture', handles: ['pop-culture'], pages: 3, extra: 'pz-extra.json', extraKey: 'movies' },
    { key: 'gym',    label: 'Gym & Quotes', handles: ['gym', 'motivational-1'], extra: 'pz-extra.json' },   /* Arjun 09-09: 104 quote designs ride on this tab */
    { key: 'coffee', label: 'Coffee & Kitchen', handles: [], asset: 'pz-extra.json', flat: true, portraitOnly: true },
    { key: 'divine', label: 'Divine',      handles: ['hindu-god', 'devotional-poster'], extra: 'designs' },   /* 10-10: floor uploads were dropped (no extra) */
    { key: 'desi',   label: 'Kollywood',   handles: ['kollywood', 'south-india'], extra: 'designs' },   /* 10-10: floor uploads were dropped (no extra) */
    { key: 'all',    label: 'All Posters', handles: ['top-selling-products', 'all-posters'], pages: [1, 9], merge: 'concat' }
  ];
  /* the split centerpiece picks from the store-wide 3 Piece Sets smart
     collection (title contains "3 Piece"/"3-Piece", best-selling first) —
     the old `combo` source only carried ~half the sets */
  /* Arjun 28-09 (floor session): "23 Piece Panel" / "13 piece" packs matched a bare /3\s*piece/ in the
     split slot's search, related row and collection tabs - #313255 got the Ultimate Gaming
     Wall Setup pack photo as its 3-piece split, which has no print file. The digit before
     the piece count must stand alone. */
  var SPLIT3_RE = /(^|[^0-9])3[\s-]*piece/i, SPLIT5_RE = /(^|[^0-9])5[\s-]*piece|piece of 0?5/i;
  /* Arjun 10-10 / 14-10 ("landscape fix ithu la pannu", landscape-fix-1010/BRIEF.md): every landscape poster says "Landscape" in its
     title - floor uploads (designs list) and Shopify singles missing from the LANDSCAPE id map were treated as portrait and
     printed with the middle band cut. A single design is landscape by the map OR its title; split sets are left alone. */
  function isLandscapeTitle(t) { t = String(t || ''); return /\blandscape\b/i.test(t) && !SPLIT3_RE.test(t) && !SPLIT5_RE.test(t); }
  var SPLIT_TABS = [
    { key: 'split3s', label: '3-Piece Sets', handles: ['3-piece-sets'], pages: 2, include: /(^|[^0-9])3[\s-]*piece[\s-]*set/i }  /* "23 Piece Panel" packs slipped in via "3 Piece" (Arjun 09-09) */,
    /* Arjun 28-08: anime 3-panel splits are builder-only, same deal as the
       anime singles — not Shopify products, so they ship as a theme asset and
       the art is FLAT (11700x5700 originals), never a room mockup. */
    { key: 'animesplit', label: 'Anime Splits', handles: [], asset: 'pz-anime-split.json', flat: true }
  ];
  /* Arjun 09-09 (Track Wall = the Porsche pack's sizes): a 5-panel split slot
     picks from the 5-piece sets, never from the 3-piece catalogue - a 3-panel
     design cut five ways would be nonsense */
  var FIVE_TABS = [
    { key: 'split5s', label: '5-Piece Sets', handles: ['pack-of-5'], pages: 2, include: SPLIT5_RE }
  ];
  function isSplitTabs(t) { return t === SPLIT_TABS || t === FIVE_TABS; }
  function tabsFor(size) { return !isSplit(size) ? TABS : panelsOf(size).c === 5 ? FIVE_TABS : SPLIT_TABS; }
  /* ---------- design drops from the floor app (Arjun 09-10) ----------
     New posters are uploaded on the floor app and published to the uploads worker
     on Cloudflare. One fetch for the page. If it cannot be reached, the theme's own
     copies (pz-extra / pz-anime / pz-anime-split.json) are used exactly as before. */
  var DESIGNS = null, designsWaiters = [];
  function withDesigns(cb) {
    if (DESIGNS) return cb(DESIGNS);
    designsWaiters.push(cb);
    if (designsWaiters.length > 1) return;
    /* a waiter that throws is reported but cannot stop the others or change the result */
    var done = function (d) { DESIGNS = d; var w = designsWaiters; designsWaiters = []; w.forEach(function (f) { try { f(d); } catch (e) { setTimeout(function () { throw e; }); } }); };
    if (!cfg.designsUrl) return done({ ok: false });
    var x = new XMLHttpRequest();
    x.open('GET', cfg.designsUrl, true);
    x.timeout = 6000;
    x.onload = function () {
      /* parse inside the try, hand out the result outside it: before 09-10 a waiter's
         TypeError was caught here and a good list was replaced by ok:false */
      var d = { ok: false };
      try {
        var j = JSON.parse(x.responseText);
        if (x.status === 200 && j && j.items && j.items.length) d = { ok: true, tabs: j.tabs || [], items: j.items };
      } catch (e) {}
      done(d);
    };
    x.onerror = x.ontimeout = function () { done({ ok: false }); };
    x.send();
  }
  /* a category Dhanush creates on the floor becomes its own tab here, before All Posters.
     The photo products have no catalogue: no designs.json fetch there (28-09) */
  if (!PHOTO) withDesigns(function (D) {
    if (!D.ok) return;
    var have = {};
    TABS.concat(SPLIT_TABS, FIVE_TABS).forEach(function (t) { have[t.key] = 1; });
    var at = -1;
    for (var i = 0; i < TABS.length; i++) if (TABS[i] && TABS[i].key === 'all') { at = i; break; }
    (D.tabs || []).forEach(function (t) {
      if (!t || !t.key || have[t.key]) return;
      /* Arjun 21-10 (Floor brief): a 3-piece category made on the floor /designs page (tabs: split:"3", items: tab
         'animesplit' + home = the tab key) is a chip in the 3-PIECE drawer only, built like a Collections split tab but
         with no Shopify collection behind it - the floor drops are its whole list (loadAssetTab: home || tab === extraKey).
         No chip until at least one design names it in `home`; never a single-poster tab. */
      if (String(t.split || '') === '3') {
        if (!D.items.some(function (it) { return it && it.home === t.key; })) return;
        SPLIT_TABS.push({ key: t.key, kind: 3, label: t.label || t.key, handles: [], asset: 'designs', flat: true, extraKey: t.key });
        have[t.key] = 1;
        return;
      }
      if (!D.items.some(function (it) { return it.tab === t.key; })) return;
      var nt = { key: t.key, label: t.label || t.key, handles: [], asset: 'designs', flat: true, portraitOnly: true };
      if (at < 0) TABS.push(nt); else TABS.splice(at++, 0, nt);
      have[t.key] = 1;
    });
  });
  /* Arjun 15-10 ("upload aana ellam picker la varra maari pannu"): single posters whose edge-to-edge flat file the team
     uploaded to Shopify Files (<handle>--pzflat.jpg, each checked against its product's mockup) show that flat in the
     picker, on the wall and in the wall picture instead of the room mockup. The handle list is a theme asset
     (assets/pz-flat-map.json - bump FLATS_VER when it changes); products are not touched. Display only: the fit rules
     still read `flat` (floor designs), so a single poster never reaches a split spot. 15-10 later: the team's 3-piece
     flats (2000 x 974, the split's own shape) are in the list too - a handle only ever meets its own tab, so a 3-piece
     product in a split tab shows its flat art and a single in a poster tab shows its own. */
  var FLATS_VER = '2910d', FLATS = null, flatsWait = [], FLAT_BASE = 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/';
  var FLAT_IMG_RE = /--pzflat\.|pz-byw-flat-|pz-byw-land-/;
  function isFlatSel(o) { return !!(o && (o.flat || FLAT_IMG_RE.test(o.img || ''))); }
  function flatImg(handle, img) { return handle && FLATS && FLATS[handle] ? FLAT_BASE + handle + '--pzflat.jpg?v=' + FLATS_VER : img; }   /* 29-10: ?v busts the CDN after a Files > Replace */
  function whenFlats(fn) { if (!flatsWait) fn(); else flatsWait.push(fn); }
  (function () {
    function done(m) { FLATS = m || {}; var q = flatsWait; flatsWait = null; q.forEach(function (f) { f(); }); }
    var sc = document.querySelector('script[src*="pz-wall-builder"]'), base = sc ? sc.src.split('?')[0] : '';
    var u = base.replace(/pz-wall-builder[^\/]*\.js$/, 'pz-flat-map.json');
    if (!base || u === base) return done(null);
    var x = new XMLHttpRequest();
    x.open('GET', u + '?v=' + FLATS_VER, true);
    x.timeout = 2500;   /* a slow or missing list never holds the picker back - it falls back to the mockups */
    x.onload = function () {
      var m = null;
      try { var j = JSON.parse(x.responseText); if (x.status === 200 && j && j.h) { m = {}; j.h.forEach(function (h) { m[h] = 1; }); } } catch (e) {}
      done(m);
    };
    x.onerror = x.ontimeout = function () { done(null); };
    x.send();
  })();
  /* multi-piece / custom products never belong in a single-poster slot */
  var EXCLUDE = /combo|\bset\b|\bsets\b|pack|mystery|bundle|split|panel|custom|sticker|glue|frame/i;
  /* landscape designs (full-catalogue sweep 2026-08-22: all 1,602 singles
     reviewed as contact sheets, then every hit re-verified at 2x — the
     2026-08-21 partial list had ~25 portraits wrongly flagged) are hidden
     from portrait
     single-poster slots — the slot preview crops into the poster, and a
     landscape design would show a meaningless middle band */
  var LANDSCAPE = {8284410183976:1,8284697592104:1,8284717121832:1,8298288972072:1,8298290807080:1,8298293854504:1,8298296901928:1,8438489514280:1,8438510682408:1,8438512976168:1,8438515171624:1,8438521430312:1,8438523822376:1,8438527197480:1,8438531916072:1,8438705619240:1,8438706897192:1,8449921614120:1,8550155190568:1,8605384409384:1,8619468292392:1,8627499237672:1,8633674727720:1,8663395729704:1,8663404740904:1,8663410802984:1,8663426761000:1,8663433183528:1,8684180013352:1,8698976207144:1,8698981056808:1,8699008385320:1,8699012383016:1,8699020607784:1,8699025621288:1,8699033583912:1,8699035222312:1,8699037221160:1,8699037876520:1,8699040956712:1,8700300493096:1,8710743490856:1,8710750077224:1,8712651833640:1,8727320002856:1,8728108663080:1,8818492571944:1,8820271710504:1,8821047755048:1,8835058565416:1,8860577431848:1,8900571562280:1,8900802216232:1,8909402308904:1,8922197983528:1,9298243420456:1,9353079488808:1,9369326453032:1,9411008626984:1,9416839692584:1,9416896119080:1,9418216571176:1,9421168378152:1,9423120662824:1,9423121318184:1};

  /* ---- pick-any modes (Arjun 03-09) ----
     "Build Your Poster Pack" (mode 'singles') and "Build Your Split Set"
     (mode 'splits') reuse this engine with ONE layout per variant, generated
     here from what Liquid hands over: a plain grid of N identical cells.
     Everything downstream - slots, drawer, auto-fill, preview, cart
     properties, floor slip - is untouched. The floor reads "(7 A4)" /
     "(3 split)" out of the Wall Size text exactly as for the drawn walls. */
  var MODE = cfg.mode || '';
  var GRID_CELL = {
    singles: { A5: 'A5', A4: 'A4', A3: 'A3', '13X19': 'P13' },
    splits:  { A4: 'SPLIT4', A3: 'SPLIT3', '13X19': 'SPLIT13' },
    /* Arjun 04-09: Personalize Your Wall Space - same cells as singles, but
       every spot is the customer's own photo (no catalogue, no offer strip) */
    custom:  { A5: 'A5', A4: 'A4', A3: 'A3', '13X19': 'P13' },
    /* Personalize Your Wall Space | 8 Panel Split: one photo over a 4 x 2 split, one cell per size */
    custom8: { A4: 'SPLIT8A4', A3: 'SPLIT8A3', '13X19': 'SPLIT8P13' },
    /* Arjun 28-09: the framed photo prints - size keys are normSize() of the Size option ('3.5 X 4.2"' -> 35X42);
       Mini and Booth have no Size option, the snippet sends MINI / BOOTH */
    'custom-mini':  { MINI: 'MINI' },
    'custom-retro': { '35X42': 'RETRO', A6: 'RETROA6' },
    'custom-booth': { BOOTH: 'BOOTHW' }
  };
  var GRID_COLS = { 1: 1, 3: 3, 4: 2, 7: 4, 8: 4, 10: 5, 18: 6, 36: 9 };
  function normSize(sz) { return String(sz || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  /* ---- framed photo prints: neat rows (Arjun 28-09) ----
     Row-major numbering (spot 1 top-left), the last row centred, a small gap between cards. Columns are picked so a
     card stays about 52 px wide on a phone (a booth window about 46 px). Booth: a spot is one window, strip-major -
     spots 1-3 are strip 1 top to bottom (the floor fills strip k with _Poster 3k-2 .. 3k); the strips are .deco.
     Retro: every size of one pack shares the same wall width, so A6 is visibly bigger than 3.5 x 4.2 when the size
     changes (the wall does not re-fit); each row hangs on a twine (.rows). */
  var FR_GAP = { mini: [0.04, 0.05], retro: [0.055, 0.17], booth: [0.07, 0.16] };   /* dm: across, down */
  var FR_WIDE = (window.innerWidth || 0) >= 750;                                      /* desktop: wider rows */
  var FR_COLS = FR_WIDE ? { mini: { 5: 5, 15: 5, 30: 10 }, retro: { 10: 5, 20: 10, 50: 10 }, booth: { 3: 3, 6: 6, 12: 6 } }
                        : { mini: { 5: 5, 15: 5, 30: 6 }, retro: { 10: 5, 20: 5, 50: 5 }, booth: { 3: 3, 6: 6, 12: 6 } };
  /* the rail's little picture of each pack (a landscape card): 50 retro prints read better 10 across */
  var FR_COLS_RAIL = { mini: { 5: 5, 15: 5, 30: 6 }, retro: { 10: 5, 20: 5, 50: 10 }, booth: { 3: 3, 6: 6, 12: 6 } };
  function frCols(table, units) { return (table[FRAMED_KIND] || {})[units] || Math.max(1, Math.ceil(Math.sqrt(units * 1.5))); }
  /* ---- named packs (Arjun 29-09, "BYW maari named walls"): Retro 10 = String Wall (2 rows of 5 on a fairy-light twine,
     a clip on every print), 20 = Heart Wall, 30 = Grid Wall 6 x 5 (hidden until the snippet shows 30), 40 = Big Grid
     Wall, 50 = Mega Collage (brick rows). Mini keeps its rows and only gets names. Spot numbering stays row-major
     (top row first, left to right) in every shape, so _Poster N always walks the same way. */
  var FR_NAMES = {
    retro: { 10: 'String Wall', 20: 'Heart Wall', 30: 'Grid Wall', 40: 'Big Grid Wall', 50: 'Mega Collage' },
    mini: { 5: 'Phone-case set', 15: 'Mini wall', 30: 'Collage' }
  };
  function frName(units) { return (FR_NAMES[FRAMED_KIND] || {})[units] || ''; }
  var FR_HEART = ['0110110', '1111111', '0111110', '0011100', '0001000'];   /* 20 prints */
  /* where the units of one pack sit (dm): {at, W, H, tops} - tops only where a twine hangs (retro String Wall and
     the retro fallback rows); rail = the rail card's landscape picture */
  function frPlace(d, units, rail) {
    var gap = FR_GAP[FRAMED_KIND];
    if (FRAMED_KIND === 'retro') {
      var tight = [0.045, 0.055];
      if (units === 20) {
        var at = [], cols = FR_HEART[0].length;
        FR_HEART.forEach(function (row, r) {
          for (var c = 0; c < row.length; c++) if (row.charAt(c) === '1') at.push([c * (d[0] + tight[0]), r * (d[1] + tight[1])]);
        });
        return { at: at, W: cols * d[0] + (cols - 1) * tight[0], H: FR_HEART.length * d[1] + (FR_HEART.length - 1) * tight[1], tops: [] };
      }
      if (units === 30 || units === 40) {
        var gc = units === 30 ? 6 : (rail || FR_WIDE ? 8 : 5), g = frArrange(d, units, gc, tight);
        g.tops = []; return g;
      }
      if (units === 50) {
        /* brick rows: every second row shifts half a print, so the collage does not read as a spreadsheet */
        var bc = rail || FR_WIDE ? 10 : 5, sh = (d[0] + tight[0]) / 2, bat = [], rows = Math.ceil(units / bc);
        for (var k = 0; k < units; k++) {
          var br = Math.floor(k / bc), cc = k % bc;
          bat.push([cc * (d[0] + tight[0]) + (br % 2 ? sh : 0), br * (d[1] + tight[1])]);
        }
        return { at: bat, W: bc * d[0] + (bc - 1) * tight[0] + sh, H: rows * d[1] + (rows - 1) * tight[1], tops: [] };
      }
    }
    return frArrange(d, units, frCols(rail ? FR_COLS_RAIL : FR_COLS, units), gap);
  }
  function frUnitDim(cell) { return FRAMED_KIND === 'booth' ? DIM.BOOTH : DIM[cell]; }
  /* units (cards / strips) of size d in rows of `cols`, row-major, last row centred: positions + extent in dm */
  function frArrange(d, units, cols, gap) {
    cols = Math.max(1, Math.min(cols, units));
    var rows = Math.ceil(units / cols), W = cols * d[0] + (cols - 1) * gap[0], H = rows * d[1] + (rows - 1) * gap[1], at = [], tops = [];
    for (var k = 0; k < units; k++) {
      var r = Math.floor(k / cols), c = k % cols, inRow = Math.min(cols, units - r * cols);
      var x0 = (W - (inRow * d[0] + (inRow - 1) * gap[0])) / 2;
      at.push([x0 + c * (d[0] + gap[0]), r * (d[1] + gap[1])]);
      if (!c) tops.push(r * (d[1] + gap[1]));
    }
    return { at: at, W: W, H: H, tops: tops };
  }
  /* the widest arrangement of this pack over every size the product has (retro: A6) */
  function frSharedW(units) {
    var cells = GRID_CELL[MODE] || {}, w = 0;
    Object.keys(cells).forEach(function (s) { w = Math.max(w, frPlace(frUnitDim(cells[s]), units).W); });
    return w;
  }
  function framedLayout(v, cell, sz) {
    var units = Number(v.units) || (FRAMED_KIND === 'booth' ? Math.round(Number(v.count) / 3) : Number(v.count));
    var a = frPlace(frUnitDim(cell), units), boxW = Math.max(a.W, frSharedW(units)), ox = (boxW - a.W) / 2;
    var L = { box: [boxW, a.H], abs: [] };
    if (FRAMED_KIND === 'booth') {
      var sd = DIM.BOOTH;
      L.deco = a.at.map(function (p) { return ['BOOTH', ox + p[0], p[1]]; });
      a.at.forEach(function (p) {
        BOOTH_WIN.y.forEach(function (fy) { L.abs.push([cell, ox + p[0] + BOOTH_WIN.x * sd[0], p[1] + fy * sd[1]]); });
      });
    } else {
      L.abs = a.at.map(function (p) { return [cell, ox + p[0], p[1]]; });
      if (FRAMED_KIND === 'retro' && a.tops.length) { L.rows = a.tops.map(function (t) { return t + 0.012; }); L.clips = true; }   /* twine just under each row's top edge, a clip on every print */
    }
    LAYOUTS[v.key] = L;
    var one = String(v.unit || 'print').toLowerCase();
    var n = L.abs.length, cm = function (x) { return String(Math.round(x * 100) / 10); }, d = frUnitDim(cell);
    SIZE_META[v.key] = { name: frName(units) || v.label || (units + ' ' + one + (units === 1 ? '' : 's')), posters: n, units: units, unit: one + 's',
      desc: units + ' ' + one + (units === 1 ? '' : 's') + (FRAMED_KIND === 'booth' ? ' \u00b7 ' + n + ' photos' : '') + ' (' + cm(d[0]) + ' \u00d7 ' + cm(d[1]) + ' cm)',
      size: sz, tier: '', top: false };
  }
  if (MODE) {
    Object.keys(cfg.variants).forEach(function (id) {
      var v = cfg.variants[id];
      if (!v.count || !v.size) return;
      var sz = normSize(v.size);
      if (/^COMPACT/.test(sz)) {
        /* Arjun 04-09: the NEW Compact Wall on Mix & Match Posters - five A4
           (no A3 centre, no size choice), a fixed Rs399 entry that leads
           people to the bigger packs. Own size pill, own layout. */
        var a4 = DIM.A4, cy = ((a4[1] * 2 + GAP) - a4[1]) / 2;
        LAYOUTS[v.key] = { abs: [
          ['A4', 0, 0], ['A4', 0, a4[1] + GAP],
          ['A4', a4[0] + GAP, cy],
          ['A4', (a4[0] + GAP) * 2, 0], ['A4', (a4[0] + GAP) * 2, a4[1] + GAP]
        ] };
        SIZE_META[v.key] = { name: 'Compact Wall', posters: 5, desc: '5 A4, fixed layout', size: sz, tier: '', unit: 'posters', top: false };
        return;
      }
      var cell = (GRID_CELL[MODE] || {})[sz];
      if (!cell) return;
      if (v.hidden) return;   /* retro 30 / 40: still in Shopify for old links, never offered here (startPackKey maps them) */
      if (FRAMED) { framedLayout(v, cell, sz); return; }
      var n = Number(v.count), c = GRID_COLS[n] || Math.ceil(Math.sqrt(n * 1.5));
      var d = DIM[cell];
      if (MODE === 'custom8') {
        LAYOUTS[v.key] = { abs: [[cell, 0, 0]] };
        SIZE_META[v.key] = { name: v.label, posters: 1, desc: '4 \u00d7 2 \u00b7 ' + (sz === '13X19' ? '13\u00d719' : sz) + ' panels', size: sz, tier: '', unit: 'sets', top: false };
        return;
      }
      if (MODE === 'splits' && n === 3) {
        /* Arjun's photo (09-09): two sets side by side on top, the third
           centred underneath - replaces the 04-09 stair */
        LAYOUTS[v.key] = { abs: [[cell, 0, 0], [cell, d[0] + GAP, 0], [cell, (d[0] + GAP) / 2, d[1] + GAP]] };
      } else if (MODE === 'splits' && n < 3) {
        /* a short stack of wide splits reads best as a stair - each set
           nudged the other way from the one above (Arjun's sketch, 04-09) */
        var abs = [];
        for (var k = 0; k < n; k++) abs.push([cell, (k % 2) * d[0] * 0.22, k * (d[1] + GAP)]);
        LAYOUTS[v.key] = { abs: abs };
      } else if (MODE === 'splits') {
        /* bigger split packs: two per row, every second row shifted right
           like brickwork (Arjun's sketch, 04-09) */
        var brick = [], shift = d[0] * 0.22;
        for (var k = 0; k < n; k++) {
          var row = Math.floor(k / 2), col = k % 2;
          brick.push([cell, col * (d[0] + GAP) + (row % 2 ? shift : 0), row * (d[1] + GAP)]);
        }
        LAYOUTS[v.key] = { abs: brick };
      } else if (PHOTO && n === 1) {
        /* Personalize "1 Poster" (about half of its orders, Arjun 28-09): one poster on the board at an honest size -
           every size shares one board, so A3 reads bigger than A4 when the size changes, instead of each blown up to
           the screen width */
        var bw = DIM.P13[0] / 0.8, bh = d[1] * 1.2;
        LAYOUTS[v.key] = { abs: [[cell, (bw - d[0]) / 2, (bh - d[1]) / 2]], box: [bw, bh] };
      } else {
        /* columns of equal cells, every second column dropped by about a
           third of a cell so the wall zig-zags like Classic / Studio instead
           of sitting in a boxy grid (Arjun's sketch, 04-09) */
        var cols = [];
        if (n === 7) {
          /* Arjun's sketch (04-09): 2 · 3 · 2 - the middle column of three
             stands taller, the side pairs sit centred against it */
          cols = [ { items: [cell, cell], dy: 0 }, { items: [cell, cell, cell], dy: 0 }, { items: [cell, cell], dy: 0 } ];
        } else {
          for (var i = 0; i < c; i++) cols.push({ items: [], dy: (i % 2) ? d[1] * 0.34 : 0 });
          for (var k = 0; k < n; k++) cols[k % c].items.push(cell);
        }
        LAYOUTS[v.key] = { cols: cols };
      }
      var unitSz = MODE === 'splits' ? 'split' : (sz === '13X19' ? '13\u00d719' : sz);
      SIZE_META[v.key] = { name: v.label, posters: n, desc: n + ' ' + unitSz, size: sz, tier: CUSTOM && !PHOTO ? '' : (v.tier || ''),
                           unit: MODE === 'splits' ? 'sets' : 'posters', top: false };
      if (PHOTO) SIZE_META[v.key].units = Number(v.units) || n;   /* Personalize: the offer strips come back (28-09) */
    });
    /* the biggest pack of each size carries BEST VALUE */
    var bySize = {};
    Object.keys(SIZE_META).forEach(function (k) { var m = SIZE_META[k]; if (!bySize[m.size] || bySize[m.size].posters < m.posters) bySize[m.size] = m; });
    Object.keys(bySize).forEach(function (sz) { bySize[sz].top = true; });
  }
  /* Arjun 07-09 (v2): blank room photos as the wall for the Mix & Match packs.
     Two shots of the same desk - "near" (3-pack mockup framing) and "wide" (the
     36-pack mockup framing, 1.6x more wall above the monitor) - each with a
     pointing (base) and a thumbs-up (done) frame; the paper sheets of Arjun's
     mockups were inpainted out (scratchpad/blank/*.jpg). The posters are DRAWN by us at their real size
     (DIM, dm) with a 3 cm gap, in the same column patterns as Arjun's mockups,
     centred on the free wall (box = the wall right of the person, above the
     light bar). Near photo wins when the set fits it at real scale; otherwise the
     far photo; if even that is too small the whole arrangement is scaled down
     to fit (the wall is only ~1 m wide - 36 A4 posters can never be life-size). */
  var ROOMS = [
    /* near: the 3-pack mockup framing (A4 sheet = 214 px → 101.9 px/dm); box clears the person (x ≤ 253) and the light bar (y 1130) */
    { key: 'near', src: 'https://img.posterizedfloor.uk/site/2026/09/730f52a2-eeb2-4d57-ac82-0765df9283b3.jpg', done: 'https://img.posterizedfloor.uk/site/2026/09/ea077364-67b8-4e70-8e75-37f52d0ed058.jpg', W: 1200, H: 1600, pxdm: 101.9, box: [270, 30, 1170, 1105], cx: 607 },
    /* wide: the 36-pack mockup framing (monitor 337 px → 81.8 px/dm) - the tall wall for the big packs; outer columns end above the head (y 1061) */
    { key: 'wide', src: 'https://img.posterizedfloor.uk/site/2026/09/8d49347c-418b-4dee-9128-9c4b52f9c43f.jpg', done: 'https://img.posterizedfloor.uk/site/2026/09/b70cbb9c-35ef-44d3-868d-ff37fbb6a49d.jpg', W: 1200, H: 1600, pxdm: 81.8, box: [40, 30, 1160, 1210], cx: 611 }
  ];
  var ROOM_COLS = { 3: [1, 1, 1], 7: [2, 3, 2], 10: [2, 2, 2, 2, 2], 18: [3, 4, 4, 4, 3], 36: [4, 5, 6, 6, 6, 5, 4] };
  var ROOM_GAP = 0.3; /* dm */
  function planRoom(n, cell) {
    var cols = ROOM_COLS[n], d = DIM[cell];
    if (!cols || !d) return null;
    var pw = d[0], ph = d[1], rows = Math.max.apply(null, cols), stagger = n === 10;
    var arrW = cols.length * pw + (cols.length - 1) * ROOM_GAP;
    var arrH = rows * ph + (rows - 1) * ROOM_GAP + (stagger ? (ph + ROOM_GAP) / 2 : 0);
    var pick = null;
    for (var r = 0; r < ROOMS.length; r++) {
      var rm = ROOMS[r], bw = (rm.box[2] - rm.box[0]) / rm.pxdm, bh = (rm.box[3] - rm.box[1]) / rm.pxdm;
      var sc = Math.min(1, bw / arrW, bh / arrH);
      if (!pick || sc > pick.sc + 1e-6) pick = { room: rm, sc: sc };
      if (sc >= 1) break;                          /* first room that fits at real scale */
    }
    var room = pick.room, f = pick.sc * room.pxdm; /* px per dm on this photo */
    var rw = pw * f, rh = ph * f, gap = ROOM_GAP * f, totW = arrW * f, totH = arrH * f, half = (rh + gap) / 2;
    var bx0 = room.box[0], bx1 = room.box[2], by0 = room.box[1], by1 = room.box[3];
    var cx = Math.min(Math.max(room.cx, bx0 + totW / 2), bx1 - totW / 2);
    var left = cx - totW / 2, top = by0 + Math.max(0, (by1 - by0 - totH)) * 0.5;
    var rects = [];
    cols.forEach(function (cnt, ci) {
      var x = left + ci * (rw + gap), colH = cnt * rh + (cnt - 1) * gap;
      var y0 = top + (totH - (stagger ? half : 0) - colH) / 2 + (stagger && ci % 2 ? half : 0);
      for (var k = 0; k < cnt; k++) rects.push([x, y0 + k * (rh + gap), rw, rh]);
    });
    return { room: room, rects: rects, scale: pick.sc };
  }
  /* Arjun 07-09 (v3): he shoots one photo per pack AND size with real white
     sheets on the wall (pointing = base, thumbs-up = done, same tripod framing).
     MOCK[count][size] = {src, done, W, H, rects[x,y,w,h] px column-wise}. A combo
     without its own photo falls back to the drawn-room plan above until the
     photo arrives. */
  var MOCK = {"3":{"A4":{"src":"https://img.posterizedfloor.uk/site/2026/09/1f661451-2a7d-44b3-975d-5c6760685508.jpg","done":null,"W":1080,"H":1080,"rects":[[384,393,95,135],[492,393,94,135],[599,393,94,135]],"zoom":2.0},"13X19":{"src":"https://img.posterizedfloor.uk/site/2026/09/c1f07d43-5a1c-4d50-8be3-078cfd1f210b.jpg","done":null,"W":1080,"H":1080,"rects":[[288,417,153,218],[463,417,152,218],[635,417,153,218]],"zoom":2.0},"A3":{"src":"https://img.posterizedfloor.uk/site/2026/09/c1f07d43-5a1c-4d50-8be3-078cfd1f210b.jpg","done":null,"W":1080,"H":1080,"rects":[[288,417,153,218],[463,417,152,218],[635,417,153,218]],"zoom":2.0}},"7":{"A4":{"src":"https://img.posterizedfloor.uk/site/2026/09/a76cf001-28c5-4d87-9ccc-7ec819b5ca03.jpg","done":null,"W":1080,"H":1080,"rects":[[384,171,95,135],[384,314,95,135],[492,108,94,135],[492,252,94,134],[492,393,94,135],[599,171,94,135],[599,314,94,135]],"zoom":1.8},"A5":{"src":"https://img.posterizedfloor.uk/site/2026/09/7c201394-39d0-4e7a-8d1d-1a090a9bf37d.jpg","done":null,"W":1080,"H":1080,"rects":[[428,264,69,97],[428,368,69,97],[505,211,69,97],[505,313,69,96],[505,414,69,97],[583,264,69,97],[583,368,69,97]],"zoom":2.0,"zc":[540,410]},"A3":{"src":"https://img.posterizedfloor.uk/site/2026/09/f68c097e-3a9f-4fb0-b789-7d1d1f6c3e27.jpg","done":null,"W":1080,"H":1080,"rects":[[328,231,130,186],[328,431,130,186],[473,142,130,186],[473,342,130,186],[473,542,130,186],[618,231,131,186],[618,431,131,186]],"zoom":1.4},"13X19":{"src":"https://img.posterizedfloor.uk/site/2026/09/d32d2e3a-3e10-439d-83ce-ec865c69b9bc.jpg","done":null,"W":1080,"H":1080,"rects":[[288,151,155,222],[288,389,155,222],[460,46,155,221],[460,283,155,221],[460,521,155,221],[633,151,155,222],[633,389,155,222]],"zoom":1.6}},"10":{"A4":{"src":"https://img.posterizedfloor.uk/site/2026/09/13a35922-2fe9-4ecc-b890-011880f314b1.jpg","done":null,"W":1080,"H":1080,"rects":[[280,178,95,135],[280,318,94,135],[388,252,95,135],[388,393,94,135],[492,178,94,135],[492,318,94,135],[599,252,94,135],[599,393,94,135],[703,178,94,135],[703,318,94,135]],"zoom":1.5},"A5":{"src":"https://img.posterizedfloor.uk/site/2026/09/3f91e79d-1609-4358-a6fd-411206144210.jpg","done":null,"W":1080,"H":1080,"rects":[[350,312,69,97],[350,414,69,97],[428,344,69,97],[428,446,69,97],[505,313,69,96],[505,414,69,97],[583,344,69,97],[583,446,69,97],[660,312,69,97],[660,414,69,97]],"zoom":2.0,"zc":[540,430]},"A3":{"src":"https://img.posterizedfloor.uk/site/2026/09/57108744-937a-40eb-ace1-b404e8a448eb.jpg","done":null,"W":1080,"H":1080,"rects":[[193,238,130,186],[193,431,130,186],[333,258,130,186],[333,451,130,186],[473,230,130,186],[473,422,130,186],[613,258,131,186],[613,451,131,186],[753,238,130,186],[753,431,130,186]],"zoom":1.3},"13X19":{"src":"https://img.posterizedfloor.uk/site/2026/09/edbb9987-11b0-408b-8a50-ba868eadb7ff.jpg","done":null,"W":1080,"H":1080,"rects":[[122,153,157,224],[122,385,157,224],[290,153,157,224],[290,385,157,225],[460,55,156,224],[460,287,156,224],[628,153,157,224],[628,385,157,225],[796,153,157,224],[796,385,157,224]],"zoom":1.4}},"18":{"A4":{"src":"https://img.posterizedfloor.uk/site/2026/09/3f20691c-ab6c-4f2f-89f7-680f29479c09.jpg","done":null,"W":1080,"H":1080,"rects":[[128,252,94,135],[232,184,94,135],[232,325,94,135],[336,110,95,135],[336,252,95,135],[336,393,94,135],[440,110,94,135],[440,252,94,135],[440,393,94,135],[543,110,94,135],[543,252,94,135],[543,393,94,135],[647,110,94,135],[647,252,94,135],[647,393,94,135],[751,184,94,135],[751,325,94,135],[855,252,94,135]],"zoom":1.2},"A5":{"src":"https://img.posterizedfloor.uk/site/2026/09/8ae04915-8d98-4585-a816-b3c47ef9c26b.jpg","done":null,"W":1080,"H":1080,"rects":[[350,202,69,97],[350,304,69,97],[350,406,69,97],[428,162,69,97],[428,263,69,97],[428,364,69,97],[428,466,69,97],[505,162,69,96],[505,263,69,96],[505,364,69,97],[505,466,69,97],[582,162,69,97],[582,263,69,97],[582,364,69,97],[582,466,69,97],[659,202,69,97],[659,304,69,97],[659,406,69,97]],"zoom":2.0,"zc":[539,400]},"A3":{"src":"https://img.posterizedfloor.uk/site/2026/09/1fb94612-ac12-4c8c-8d50-9911cc8629b8.jpg","done":null,"W":1080,"H":1080,"rects":[[123,225,130,186],[123,418,130,186],[263,125,130,186],[263,318,130,186],[263,511,130,186],[403,31,130,186],[403,223,130,186],[403,415,130,186],[403,609,130,186],[543,30,130,186],[543,223,131,186],[543,416,131,186],[543,609,130,186],[683,125,130,186],[683,318,130,186],[683,511,130,186],[823,225,130,186],[823,418,130,186]],"zoom":1.05},"13X19":{"src":"https://img.posterizedfloor.uk/site/2026/09/1563fa56-c6ed-4cca-9499-6263967e9376.jpg","done":null,"W":1080,"H":1080,"rects":[[104,235,138,198],[104,441,138,198],[253,129,138,198],[253,334,138,198],[253,539,138,198],[402,29,138,198],[402,233,138,198],[402,437,138,198],[402,644,138,198],[550,28,139,198],[550,233,140,198],[550,438,140,199],[550,644,139,198],[699,129,139,198],[699,334,139,198],[699,539,139,199],[848,235,139,198],[848,441,139,198]],"zoom":1.2}},"36":{"A4":{"src":"https://img.posterizedfloor.uk/site/2026/09/e7e131dc-8f25-4140-9528-6847242aa191.jpg","done":null,"W":1080,"H":1080,"rects":[[149,157,94,135],[149,301,94,135],[149,445,94,135],[149,587,94,135],[253,157,94,135],[253,301,94,135],[253,445,94,135],[253,587,94,135],[357,83,95,135],[357,225,95,135],[357,367,95,135],[357,508,94,135],[357,651,94,135],[461,83,94,135],[461,225,94,135],[461,367,94,135],[461,508,94,135],[461,651,94,135],[564,83,94,135],[564,225,94,135],[564,367,94,135],[564,508,94,135],[564,651,94,135],[668,83,94,135],[668,225,94,135],[668,367,94,135],[668,508,94,135],[668,651,94,135],[772,157,94,135],[772,301,94,135],[772,445,94,135],[772,587,94,135],[876,157,94,135],[876,301,94,135],[876,445,94,135],[876,587,94,135]],"zoom":1.05},"A5":{"src":"https://img.posterizedfloor.uk/site/2026/09/67021157-8845-4616-8588-1ba2bd0776a0.jpg","done":null,"W":1080,"H":1080,"rects":[[201,151,69,97],[200,253,69,97],[200,355,69,97],[200,457,69,97],[277,151,69,97],[277,253,69,97],[277,355,69,97],[277,457,69,97],[353,152,69,97],[353,253,69,97],[353,355,69,97],[353,457,69,97],[428,152,69,97],[428,253,69,97],[428,355,69,97],[428,457,69,97],[505,152,69,96],[505,253,69,97],[505,355,69,97],[505,457,69,97],[582,152,69,97],[582,253,69,97],[582,355,69,97],[582,457,69,97],[658,152,69,97],[658,253,69,97],[658,355,69,97],[658,457,69,97],[734,151,69,97],[734,253,69,97],[734,355,69,97],[734,457,69,97],[809,151,69,97],[809,253,69,97],[809,356,69,96],[809,457,69,97]],"zoom":1.5,"zc":[539,400]},"A3":{"src":"https://img.posterizedfloor.uk/site/2026/09/63dfe067-fb7a-496e-bf28-5dc28e033e6d.jpg","done":null,"W":1080,"H":1080,"rects":[[59,126,101,144],[59,276,101,144],[59,425,100,144],[58,574,101,144],[165,126,101,144],[165,276,101,144],[165,425,101,144],[165,574,101,144],[273,126,101,144],[274,276,100,144],[274,425,101,144],[274,574,100,144],[382,126,101,144],[382,276,101,144],[382,425,101,144],[382,574,101,144],[490,127,101,143],[490,277,101,144],[490,425,101,144],[490,574,101,143],[598,126,101,144],[598,276,101,144],[598,425,101,144],[598,574,101,144],[707,127,100,143],[707,276,100,144],[707,425,100,144],[707,574,100,144],[815,127,101,143],[815,276,100,144],[815,425,100,144],[815,574,100,144],[922,127,101,143],[922,276,100,144],[922,426,101,144],[922,574,101,144]],"zoom":1.05},"13X19":{"src":"https://img.posterizedfloor.uk/site/2026/09/9d99c618-b528-4fb0-91d2-1f0c368c9f2c.jpg","done":null,"W":1080,"H":1080,"rects":[[55,65,115,164],[55,235,115,164],[55,404,115,164],[55,573,115,164],[176,24,115,164],[176,194,115,164],[176,364,114,163],[176,533,114,165],[298,24,115,164],[298,194,115,164],[298,364,116,163],[298,533,115,165],[297,704,116,163],[422,24,115,164],[422,195,115,164],[422,364,115,164],[422,533,115,164],[422,703,116,164],[545,24,115,164],[545,194,115,164],[545,364,115,164],[545,533,115,165],[545,703,114,164],[670,24,115,164],[670,194,113,163],[670,364,113,164],[670,533,113,165],[668,704,114,164],[793,24,115,164],[793,194,113,164],[793,364,114,164],[793,533,114,165],[917,65,115,164],[917,235,115,164],[917,404,115,165],[917,573,115,164]],"zoom":1.05}}};
  /* Arjun 27-09: "mix and match la real images use panirukom layouts show panna, athuku bathila BYW maari HTML la
     preview venum" - the Mix & Match packs draw their scene (person, furniture, the sheets in the zig-zag columns
     above) exactly like Build Your Wall; no room photo on the pack cards, the rail or the page wall. Slot order and
     sizes are unchanged (every spot of a pack is the same size), so saved walls and the cart properties still line up.
     The photos (MOCK / ROOMS) stay below; set MM_ROOMS_ON = true to bring them back. */
  var MM_ROOMS_ON = false;
  /* Arjun 27-09: "mix match singles la layouts 2x2 la vei" - on phones the four packs of a size sit in a 2 x 2 grid
     (7, 10 / 18, 36), all on screen, no sideways swipe; "Mix sizes?" becomes a slim row under them. Desktop already
     shows every card in one row and stays as it is. */
  var MM_RAIL_2X2 = true;
  /* Arjun 27-09: "BYW and mix match la layout name keela text kasa kasa - necessary text mattum, matha details layout
     select pannathukku apram; per poster ah sticker maari highlight". The Build Your Wall and Mix & Match rail cards
     carry the name, the price (BYW: the poster count) and a per-poster sticker; the piece mix, poster size and wall
     size show in one line under the rail for the chosen layout. Split sets and the photo products keep their cards. */
  var LEAN_RAIL = !MODE || MODE === 'singles' || PHOTO;   /* 28-09: the four photo products get the same lean "value" cards */
  /* Arjun 16-10 ("just one layut mobile la visble ah erukra maari panni kaatu. but both sides la slight ah matha layouts
     therinum"; "mix match single and split product page um BYW la panna changes la pannanum"): on phones the Build Your
     Wall and split-set rails are a one-card carousel - one card in the middle, its neighbours peeking on both sides.
     Mix & Match singles keep their 2 x 2 (Arjun 27-09: every pack on screen, no sideways swipe). */
  /* Arjun 17-10 (publishing Wall Band now): "horizontal swipe panra maadhiri change panniyirundhom, adhai revert pannanum, current theme
     maadhiri vekkanum" - the one-card carousel is OFF, every rail is the live grid again (peekRail() kept but unused). */
  var PEEK_RAIL = false;
  /* Arjun 16-10 ("green label price ku side la varra maari pannu. space micham aagum"): the per-poster sticker rides on
     the price line (it wraps under the price only when the card is too narrow) - Build Your Wall + M&M singles */
  var PRICE_ROW = !MODE || MODE === 'singles';
  /* 16-10: the picking band's real-wall look (wall band, option 3) - Build Your Wall + both Mix & Match pages */
  var BAND_WALL = !MODE || MODE === 'singles' || MODE === 'splits';
  /* 27-09 redesign: the drawn scene fills its card edge to edge - a little headroom above the sheets, then the
     viewBox is widened (or heightened) to the card's aspect by stretching the full-width wall/floor rects, so the
     scene never letterboxes. Aspect must match .pz-wb-size-mini in the CSS (BYW 1.3, Mix & Match 1.5). */
  var MINI_ASPECT = MODE ? 1.5 : 1.3;
  function fitScene(svg, A, head) {
    if (!svg) return;
    var p = String(svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    if (p.length !== 4 || p.some(isNaN) || !p[2] || !p[3]) return;
    var x = p[0], y = p[1], w = p[2], h = p[3], i, el;
    var rects = svg.querySelectorAll('rect:not(.t)'), sheets = svg.querySelectorAll('rect.t');
    function a(e, k) { return +e.getAttribute(k) || 0; }
    function growTop(dy) {
      for (i = 0; i < rects.length; i++) {
        el = rects[i];
        if (a(el, 'y') <= y + 0.5 && a(el, 'y') + a(el, 'height') > y + h * 0.5 && a(el, 'width') >= w - 0.5) {
          el.setAttribute('y', (a(el, 'y') - dy).toFixed(1)); el.setAttribute('height', (a(el, 'height') + dy).toFixed(1));
        }
      }
      y -= dy; h += dy;
    }
    if (head > 0 && sheets.length) {
      var top = Infinity;
      for (i = 0; i < sheets.length; i++) top = Math.min(top, a(sheets[i], 'y'));
      var gap = top - y;
      if (gap < head * h) growTop((head * h - gap) / (1 - head));
    }
    var r = w / h;
    if (r < A - 0.005) {
      var nw = h * A, dx = (nw - w) / 2;
      for (i = 0; i < rects.length; i++) {
        el = rects[i];
        if (a(el, 'x') <= x + 0.5 && a(el, 'x') + a(el, 'width') >= x + w - 0.5) {
          el.setAttribute('x', (a(el, 'x') - dx).toFixed(1)); el.setAttribute('width', (a(el, 'width') + 2 * dx).toFixed(1));
        }
      }
      x -= dx; w = nw;
    } else if (r > A + 0.005) {
      growTop(w / A - h);
    }
    svg.setAttribute('viewBox', [x.toFixed(1), y.toFixed(1), w.toFixed(1), h.toFixed(1)].join(' '));
  }
  function fitMini(el) {
    if (!LEAN_RAIL || !el || !el.closest || !el.closest('.pz-wb-sizes--lean')) return;
    var sv = el.querySelector('svg.pz-wb-scene');
    if (sv) fitScene(sv, MINI_ASPECT, 0.1);
  }
  /* Arjun 27-09 "size choose panna periya size kidaikum nu user ku notify panra maari yethavathu venum": on Mix &
     Match the size pills are size cards (poster drawn to its real height, cm, the price for the chosen pack count;
     "2× bigger" on the next size up, "Biggest" on 13x19) and the detail box ends in a one-tap "2× bigger?" upgrade
     that keeps every picked poster. Data (30 days, M&M singles): A4 57%, A5 22%, A3 13%, 13x19 7% of orders, while
     split sets - where sizes are more visible - sell 30% in 13x19. */
  var SZC = { A5: { h: 0.43, cm: '15\u00d721 cm' }, A4: { h: 0.61, cm: '21\u00d730 cm' }, A3: { h: 0.87, cm: '30\u00d742 cm' }, '13X19': { h: 1, cm: '33\u00d748 cm' },
    /* Retro Prints (28-09): the card drawn as a white frame with its photo window, heights relative to A6 (14.8 cm) */
    '35X42': { h: 0.72, cm: '8.9\u00d710.7 cm', fr: 'RETRO' }, A6: { h: 1, cm: '10.5\u00d714.8 cm', fr: 'RETROA6' } };
  /* the size cards' picture of one print: a poster sheet, or a white frame with its window (retro) */
  function szIcoHtml(s) {
    if (!s.fr) return '<i style="--h:' + s.h + '"></i>';
    var d = DIM[s.fr], w = FRAME_WIN[s.fr];
    return '<i class="fr" style="--h:' + s.h + ';--a:' + (d[0] / d[1]).toFixed(3) + ';--wl:' + (w[0] * 100).toFixed(2) + '%;--wt:' + (w[1] * 100).toFixed(2) +
      '%;--ww:' + (w[2] * 100).toFixed(2) + '%;--wh:' + (w[3] * 100).toFixed(2) + '%"></i>';
  }
  function szOrder() { return gridSizes().map(function (x) { return x.key; }); }
  function szName(label) { return String(label).replace(/x/i, '\u00d7'); }
  function szKeyFor(size, posters) {
    return Object.keys(SIZE_META).filter(function (k) {
      var m = SIZE_META[k];
      return m.size === size && m.posters === posters && !isFixedKey(k) && !RETIRED_KEYS[k] && variantFor(k);
    })[0] || null;
  }
  function szCardHtml(sz, posters, cur) {
    var s = SZC[sz.key] || { h: 0.6, cm: '' }, k = posters && szKeyFor(sz.key, posters), vr = k && variantFor(k);
    var ord = szOrder(), next = cur ? ord[ord.indexOf(cur) + 1] : null, tag = '';
    if (cur && sz.key === '13X19' && cur !== '13X19') tag = 'Biggest';
    else if (cur && sz.key === next) tag = FRAMED ? 'Bigger' : '2\u00d7 bigger';   /* A6 is 1.6x the card, not 2x (28-09) */
    return (tag ? '<span class="szc-tag">' + tag + '</span>' : '') +
      '<span class="szc-ico" aria-hidden="true">' + szIcoHtml(s) + '</span>' +
      '<b class="szc-name">' + szName(sz.label) + '</b>' + (s.cm ? '<small class="szc-cm">' + s.cm + '</small>' : '') +
      (vr ? '<em class="szc-price">' + money(vr.v.price) + '</em>' : '');
  }
  function sizeUpBtn(key) {
    var m = SIZE_META[key];
    if (!m || isFixedKey(key)) return null;
    var ord = szOrder(), nx = ord[ord.indexOf(m.size) + 1];
    if (!nx) return null;
    var nk = szKeyFor(nx, m.posters), vc = variantFor(key), vn = nk && variantFor(nk);
    if (!vc || !vn) return null;
    var g = gridSizes().filter(function (x) { return x.key === nx; })[0], nm = szName(g ? g.label : nx);
    var big = nx === '13X19', cnt = m.units || m.posters;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pz-wb-sizeup';
    b.setAttribute('data-to', nx);
    /* retro (28-09): an honest "Bigger A6?" - A6 is 1.6x the card, not 2x */
    b.innerHTML = '<span class="su-ico" aria-hidden="true"><i style="--h:' + ((SZC[m.size] || {}).h || 0.6) + '"></i><i style="--h:' + ((SZC[nx] || {}).h || 1) + '"></i></span>' +
      '<span class="su-t"><b>' + (FRAMED ? 'Bigger ' + nm + '?' : big ? 'Biggest size?' : '2\u00d7 bigger?') + '</b> ' +
        (PHOTO && cnt === 1 ? 'Your ' + unitNoun(m, 1) : 'Same ' + cnt + (big && !FRAMED ? '' : ' ' + unitNoun(m, cnt))) + ' in&nbsp;' + nm + '</span>' +   /* 1 poster: "Your poster in A3" */
      '<span class="su-p">' + money(vn.v.price) + ' <small>+' + money(vn.v.price - vc.v.price) + '</small></span><span class="su-go">Switch</span>';
    b.addEventListener('click', function (e) { e.preventDefault(); pzTrack('size-up'); morphSize(nk); });
    return b;
  }
  /* the photo packs' ribbons, as their old pack cards had them (snippets/pz-packs-config.liquid pz_pop / pz_best) */
  var PHOTO_RIBBON = { mini: { 15: 'MOST POPULAR', 30: 'BEST VALUE' }, retro: { 20: 'MOST POPULAR', 50: 'BEST VALUE' }, booth: { 6: 'MOST POPULAR', 12: 'BEST VALUE' } };
  function photoRibbon(key) { var m = SIZE_META[key]; return (m && FRAMED && (PHOTO_RIBBON[FRAMED_KIND] || {})[m.units]) || ''; }
  /* a quiet second line on a photo pack card: booth "9 photos"; Personalize's slim 1-poster card its size */
  function photoCardSub(key) {
    var m = SIZE_META[key];
    if (!m) return '';
    if (FRAMED_KIND === 'booth') return '<span class="pz-wb-size-sub">' + m.posters + ' photos</span>';
    if (FRAMED && frName(m.units)) return '<span class="pz-wb-size-sub">' + m.units + ' ' + unitNoun(m, m.units) + '</span>';   /* "Heart Wall" / "20 prints" */
    if (MODE === 'custom' && isOneKey(key)) {
      var g = gridSizes().filter(function (x) { return x.key === m.size; })[0], s = SZC[m.size];
      return '<span class="pz-wb-size-sub">Single ' + szName(g ? g.label : m.size) + ' poster' + (s ? ' &middot; ' + s.cm : '') + '</span>';
    }
    return '';
  }
  /* Arjun 14-10 night ("per poster price ku pathila vera wordings - Compact Starter, Studio Beginner maari, gents ku
     pudicha names"): on Build Your Wall the green sticker names the wall's level instead of its price per poster */
  var BYW_TIER = { compact: 'STARTER', studio: 'LEVEL UP', large: 'PRO', duo: 'DOUBLE UP', mosaic: 'COLLECTOR',
                   hero: 'MAIN CHARACTER', showcase: 'BIG SCREEN', trio: 'BOSS LEVEL' };
  function pppHtml(key) {
    var vr = variantFor(key), m = SIZE_META[key];
    if (!vr || !m || !m.posters) return '';
    if (!MODE && BYW_TIER[key]) return '<b>' + BYW_TIER[key] + '</b>';
    /* swing-tag sticker (27-09); the photo products name their own unit - per print / per strip (28-09) */
    return '<b>' + money(perUnit(vr, m)) + '</b><i>per ' + (PHOTO ? unitNoun(m, 1) : 'poster') + '</i>';
  }
  if (MODE === 'singles' && MM_ROOMS_ON) {
    Object.keys(LAYOUTS).forEach(function (key) {
      var m = SIZE_META[key];
      if (!m || isFixedKey(key)) return;
      var cell = (GRID_CELL.singles || {})[m.size] || 'A4';
      var mk = (MOCK[String(m.posters)] || {})[m.size], rects, src, done, W, H, zoom = null;
      if (mk) {
        rects = mk.rects; src = mk.src; done = mk.done || null; W = mk.W; H = mk.H;
        /* Arjun 07-09 "rombo chinna, konjam zoom": a wide room shot can carry
           zoom (factor) + zc (centre px) - room and sheets scale together about
           that point, so the sheets stay under the spots */
        if (mk.zoom && mk.zoom !== 1) {
          var f = mk.zoom, x0 = Infinity, y0 = Infinity, x1 = 0, y1 = 0;
          rects.forEach(function (r) { x0 = Math.min(x0, r[0]); y0 = Math.min(y0, r[1]); x1 = Math.max(x1, r[0] + r[2]); y1 = Math.max(y1, r[1] + r[3]); });
          /* Arjun 07-09: "posters frame ulla therinum eppavum" - the sheets must stay
             inside the frame with a 4% margin; the frame may crop the desk below.
             Shrink the zoom if the arrangement cannot fit, then slide the centre. */
          var mx = 0.04 * W, my = 0.04 * H;
          f = Math.min(f, W / (x1 - x0 + 2 * mx), H / (y1 - y0 + 2 * my));
          var zc = (mk.zc || [(x0 + x1) / 2, (y0 + y1) / 2]).slice();
          var fitC = function (c, lo, hi, m, S) { var k = 1 - 1 / f; if (k <= 0) return c; var left = Math.min(Math.max(c * k, hi + m - S / f), lo - m); return left / k; };
          zc[0] = fitC(zc[0], x0, x1, mx, W); zc[1] = fitC(zc[1], y0, y1, my, H);
          rects = rects.map(function (r) { return [zc[0] + (r[0] - zc[0]) * f, zc[1] + (r[1] - zc[1]) * f, r[2] * f, r[3] * f]; });
          zoom = [f, zc[0] / W, zc[1] / H];
        }
      }
      else {
        var plan = planRoom(m.posters, cell);
        if (!plan) return;
        rects = plan.rects; src = plan.room.src; done = plan.room.done; W = plan.room.W; H = plan.room.H;
      }
      var dmPerPx = DIM[cell][0] / rects[0][2];   /* the sheet in the photo defines the photo's scale */
      LAYOUTS[key] = {
        abs: rects.map(function (r) { return [cell, r[0] * dmPerPx, r[1] * dmPerPx]; }),
        box: [W * dmPerPx, H * dmPerPx],
        mock: src,
        mockDone: done,
        mockZoom: zoom,
        native: !!mk                              /* the photo already shows the sheets */
      };
    });
  }
  /* Arjun 09-10: Build Your Wall rooms - his photos of the desk wall with blank
     "CHOOSE YOUR OWN IMAGE" sheets for Compact, Classic, Studio and Large, the
     same treatment as the Mix & Match rooms. The sheets were traced off the
     1080 x 1080 photos (scratchpad/byw) and are listed in each layout's own spot
     order, so saved walls and cart properties keep their spot numbers; the
     arrangement on screen follows the photo (Classic reads high-low-low-high, as
     shot). Same zoom rule as the Mix & Match rooms. Walls without a photo keep
     the drawn scene.
     OFF since 09-12 (Arjun: "real images venda, HTML image eh erukatum") - every Build
     Your Wall layout draws its own scene again. The photos and rects stay here; set
     BYW_ROOMS_ON = true to bring them back. Mix & Match rooms (MOCK) are untouched. */
  /* Arjun 14-10 (BYW Real Walls draft): ON again with new photos - the same AI room for every wall, each sheet blank
     matte white with a dark "+" (byw-ladder-1510/real-images/blank-plus). rects = [size, x, y, w, h] in the photo's
     own pixels, in each layout's spot order; a wall whose sizes do not line up with its layout keeps the drawn scene.
     Photos are Shopify Files (cdn.shopify.com); the rail + gallery load a 720 px copy (&width=720). */
  /* Arjun 14-10 ("B2 ok"): no monitor desk any more - a Gen-Z streetwear desk room in bright daylight (laptop, Bearbrick,
     headphones, black mushroom lamp, dark plants beside the desk), AI room + our exact layouts pasted on at true cm scale
     (byw-real-walls-1410/rooms/comp_room.py, room 'street'). Files pz-byw-desk-<wall>.jpg, 1080 px. */
  /* Arjun 16-10 ("duo layout supr ah eruku ... ithe maari ella layouts kum create pannu"): the eight rail walls show the same
     room with a guy in the chair glancing up at the posters (Higgsfield gpt-image, byw-model-1610/v3-*), each warped
     back onto its original photo so the sheets sit on the rects below to +-1 px (warp.py). Files pz-byw-model-<wall>.jpg;
     the old pz-byw-desk-*.jpg stay in Files for rollback. */
  var BYW_ROOMS_ON = true;
  var BYW_ROOMS = {
    compact: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-compact.jpg?v=1792155027', w: 1080, h: 1351, zoom: 1.6, keep: 723,
      rects: [['A4',348,135,108,153],['A4',348,296,108,153],['A3',464,184,153,216],['A4',624,135,108,153],['A4',624,296,108,153]] },
    studio: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-studio.jpg?v=1792155027', w: 1080, h: 1350, zoom: 1.6, keep: 779,
      rects: [['A4',255,135,108,153],['A4',255,296,108,153],['A4',371,192,108,153],['A4',371,352,108,153],['A4',486,135,108,153],['A4',486,296,108,153],['A4',602,192,108,153],['A4',602,352,108,153],['A4',718,135,108,153],['A4',718,296,108,153]] },
    large: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-large.jpg?v=1792155027', w: 1080, h: 1350, zoom: 1.6, keep: 859,
      rects: [['A4',194,205,106,150],['A4',194,370,106,150],['A5',323,135,75,106],['A5',413,135,75,106],['A5',503,135,75,106],['A5',593,135,75,106],['SPLIT3',316,256,449,212],['A5',323,483,75,106],['A5',413,483,75,106],['A5',503,483,75,106],['A5',593,483,75,106],['A4',780,205,106,150],['A4',780,370,106,150],['A5',682,135,75,106],['A5',682,483,75,106]] },
    duo: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-duo.jpg?v=1792155027', w: 1080, h: 1350, zoom: 1.6, keep: 1207,   /* Arjun 14-10 ("large wall maari preview duo wall ku kodu"): the room line the Large card shows */
      rects: [['A5',261,180,76,108],['A4',345,135,108,153],['A5',460,180,76,108],['A5',544,180,76,108],['A4',628,135,108,153],['A5',744,180,76,108],['A4',205,296,108,153],['A4',205,456,108,153],['H2A3',320,299,216,305],['H2A3',544,299,216,305],['A4',768,296,108,153],['A4',768,456,108,153],['A5',261,616,76,108],['A4',345,616,108,153],['A5',460,616,76,108],['A5',544,616,76,108],['A4',628,616,108,153],['A5',744,616,76,108]] },
    full: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-room-full.jpg?v=1791962764', w: 1190, h: 1488, zoom: 1.6,
      rects: [['A5',115,468,78,111],['A5',115,594,78,111],['A4',208,336,111,156],['A4',208,508,111,156],['A4',208,680,111,156],['A5',369,333,78,111],['A5',462,333,78,111],['A5',556,333,78,111],['A5',650,333,78,111],['A5',743,333,78,111],['SPLIT13',335,459,521,254],['A5',369,729,78,111],['A5',462,729,78,111],['A5',556,729,78,111],['A5',650,729,78,111],['A5',743,729,78,111],['A4',871,336,111,156],['A4',871,508,111,156],['A4',871,680,111,156],['A5',998,468,78,111],['A5',998,594,78,111]] },
    mix: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-desk-mix.jpg?v=1791967989', w: 1080, h: 1350, zoom: 1.6, keep: 849,
      rects: [['A5',196,174,66,94],['A4',269,135,94,133],['A5',370,174,66,94],['A4',443,135,94,133],['A4',543,135,94,133],['A5',644,174,66,94],['A4',717,135,94,133],['A5',818,174,66,94],['A5',194,275,66,94],['A5',194,376,66,94],['A5',267,275,66,94],['A5',267,376,66,94],['SPLIT3',341,278,399,188],['A5',746,275,66,94],['A5',746,376,66,94],['A5',820,275,66,94],['A5',820,376,66,94],['A4',196,476,94,133],['A5',297,476,66,94],['A4',370,476,94,133],['A5',470,476,66,94],['A5',543,476,66,94],['A4',617,476,94,133],['A5',717,476,66,94],['A4',790,476,94,133]] },
    hero: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-hero.jpg?v=1792155027', w: 1080, h: 1350, zoom: 1.6, keep: 1295,   /* the Mix card's room line (14-10) */
      rects: [['Q2A3',387,290,305,429],['A5',405,179,75,106],['A4',487,135,106,150],['A5',600,179,75,106],['A4',277,272,106,150],['A4',277,429,106,150],['A4',277,587,106,150],['A4',697,272,106,150],['A4',697,429,106,150],['A4',697,587,106,150],['A5',194,394,75,106],['A5',194,508,75,106],['A5',811,394,75,106],['A5',811,508,75,106],['A5',405,724,75,106],['A4',487,724,106,150],['A5',600,724,75,106]] },
    showcase: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-showcase.jpg?v=1792155027', w: 1080, h: 1350, zoom: 1.6, keep: 803,
      rects: [['H6A3',355,217,370,348],['A4',262,200,87,123],['A4',262,329,87,123],['A4',262,459,87,123],['A4',731,200,87,123],['A4',731,329,87,123],['A4',731,459,87,123],['A5',194,207,61,87],['A5',194,301,61,87],['A5',194,394,61,87],['A5',194,487,61,87],['A5',825,207,61,87],['A5',825,301,61,87],['A5',825,394,61,87],['A5',825,487,61,87]] },
    trio: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-trio.jpg?v=1792155027', w: 1080, h: 1350, zoom: 1.6, keep: 994,
      rects: [['Q2A3',208,298,211,297],['Q2A3',430,298,211,297],['Q2A3',651,298,211,297],['A5',142,221,52,73],['A5',220,221,52,73],['A4',277,190,73,104],['A5',356,221,52,73],['A5',441,221,52,73],['A4',498,190,73,104],['A5',577,221,52,73],['A5',663,221,52,73],['A4',720,190,73,104],['A5',799,221,52,73],['A5',877,221,52,73],['A4',131,299,73,104],['A5',142,410,52,73],['A4',131,489,73,104],['A4',866,299,73,104],['A5',877,410,52,73],['A4',866,489,73,104],['A5',142,598,52,73],['A5',220,598,52,73],['A4',277,598,73,104],['A5',356,598,52,73],['A5',441,598,52,73],['A4',498,598,73,104],['A5',577,598,52,73],['A5',663,598,52,73],['A4',720,598,73,104],['A5',799,598,52,73],['A5',877,598,52,73]] },
    mosaic: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/pz-byw-model-mosaic.jpg?v=1792155027', w: 1080, h: 1350, zoom: 1.6, keep: 970,
      rects: [['A4',194,374,78,111],['A4',194,496,78,111],['A4',284,303,78,111],['A4',284,425,78,111],['A4',284,547,78,111],['A4',416,181,78,111],['A4',506,181,78,111],['A4L',595,213,111,78],['SPLIT3',374,303,333,157],['A4L',388,471,111,78],['A4',511,471,78,111],['A4',600,471,78,111],['A4',717,169,78,111],['A4',717,291,78,111],['A4',717,413,78,111],['A4',807,207,78,111],['A4',807,329,78,111]] }
  };
  if (!MODE && BYW_ROOMS_ON) {
    Object.keys(BYW_ROOMS).forEach(function (key) {
      var rm = BYW_ROOMS[key], W = rm.w || 1080, H = rm.h || 1080;
      if (!LAYOUTS[key] || !rm.src) return;
      var sizes = computeLayout(key).slots.map(function (g) { return g.size; });
      if (sizes.length !== rm.rects.length) return;   /* the photo no longer matches the layout: keep the drawn wall */
      /* 14-10: rects may carry their size first - every spot must sit on a sheet of its own size */
      if (rm.rects.some(function (r, i) { return typeof r[0] === 'string' && r[0] !== sizes[i]; })) { try { console.warn('pz-wb: room photo spots do not match', key); } catch (e) {} return; }
      var rects = rm.rects.map(function (r) { return typeof r[0] === 'string' ? r.slice(1) : r; }), x0 = Infinity, y0 = Infinity, x1 = 0, y1 = 0;
      rects.forEach(function (r) { x0 = Math.min(x0, r[0]); y0 = Math.min(y0, r[1]); x1 = Math.max(x1, r[0] + r[2]); y1 = Math.max(y1, r[1] + r[3]); });
      var mx = 0.04 * W, my = 0.04 * H;
      var f = Math.min(rm.zoom, W / (x1 - x0 + 2 * mx), H / (y1 - y0 + 2 * my));
      /* Arjun 14-10 ("hero wall la room theriyala"): rm.keep = a line under the wall (photo px, the desk top) that stays in
         view on the builder wall, the rail and the gallery, so a tall wall (Hero) still shows the room; it only lowers the zoom */
      var yk = rm.keep ? Math.max(y1 + my, rm.keep) - my : y1;
      if (rm.keep) f = Math.min(f, Math.max(1, H / (yk - y0 + 2 * my)));
      var zc = [(x0 + x1) / 2, (y0 + y1) / 2];
      var fitC = function (c, lo, hi, m, S) { var k = 1 - 1 / f; if (k <= 0) return c; var left = Math.min(Math.max(c * k, hi + m - S / f), lo - m); return left / k; };
      zc[0] = fitC(zc[0], x0, x1, mx, W); zc[1] = fitC(zc[1], y0, yk, my, H);
      var zr = rects.map(function (r) { return [zc[0] + (r[0] - zc[0]) * f, zc[1] + (r[1] - zc[1]) * f, r[2] * f, r[3] * f]; });
      /* scale from the sheets themselves (median dm per px); each spot centred on its sheet */
      var per = zr.map(function (r, i) { return DIM[sizes[i]][0] / r[2]; }).sort(function (a, b) { return a - b; });
      var s = per[Math.floor(per.length / 2)];
      LAYOUTS[key] = {
        abs: zr.map(function (r, i) { var d = DIM[sizes[i]]; return [sizes[i], (r[0] + r[2] / 2) * s - d[0] / 2, (r[1] + r[3] / 2) * s - d[1] / 2]; }),
        box: [W * s, H * s],
        mock: rm.src,
        mockSmall: rm.src + (rm.src.indexOf('?') > -1 ? '&' : '?') + 'width=720',   /* rail + gallery cards (14-10) */
        mockDone: null,
        mockZoom: f !== 1 ? [f, zc[0] / W, zc[1] / H] : null,
        keepU: rm.keep ? rm.keep / W : 0,         /* the keep line in photo widths, for the gallery crop (14-10) */
        native: true                              /* the photo already shows the sheets */
      };
    });
  }
  if (!MODE && BYW_ROOMS_ON) {
    try {
      var pzNat = document.createElement('style');
      pzNat.textContent = '.pz-wb-wallwrap.photo .pz-wb-slot.pz-native:not(.filled):not(.cur){background:transparent;border-color:transparent}' +
        /* 14-10: the Showcase hero's joints, 2 upright + 1 across (3 x 2 A3) */
        '.pz-wb-cuts.pz-wb-cuts--s{background-image:repeating-linear-gradient(to bottom,rgba(255,255,255,.9) 0 7px,transparent 7px 13px),repeating-linear-gradient(to bottom,rgba(255,255,255,.9) 0 7px,transparent 7px 13px),repeating-linear-gradient(to right,rgba(255,255,255,.9) 0 7px,transparent 7px 13px);background-size:1.5px 100%,1.5px 100%,100% 1.5px;background-position:33.33% 0,66.66% 0,0 50%;background-repeat:no-repeat}' +
        '.pz-wb-cuts.pz-wb-cuts--s.pz-wb-cuts--qe{background-image:repeating-linear-gradient(to bottom,rgba(0,0,0,.28) 0 7px,transparent 7px 13px),repeating-linear-gradient(to bottom,rgba(0,0,0,.28) 0 7px,transparent 7px 13px),repeating-linear-gradient(to right,rgba(0,0,0,.28) 0 7px,transparent 7px 13px)}';
      document.head.appendChild(pzNat);
    } catch (e) {}
  }
  var SIZE_RANK = { A5: 1, A4: 2, A3: 3, '13X19': 4, '35X42': 0.4, A6: 0.6 };   /* retro: 3.5 x 4.2 then A6 (28-09) */
  /* Arjun 04-09: a fixed wall (Compact Wall, five A4) is not a size - it is a
     card that sits first on the rail whatever size pill is on; while it is
     selected the size pills are locked, and picking any other card releases them. */
  function isFixedKey(k) { var m = SIZE_META[k]; return !!(m && /^COMPACT/.test(m.size)); }
  function gridSizes() {
    var seen = { COMPACTWALL: 1 }, out = [];
    (cfg.sizes || []).forEach(function (sz) { var n = normSize(sz); if (/^COMPACT/.test(n)) return; if (!seen[n]) { seen[n] = 1; out.push({ key: n, label: sz }); } });
    Object.keys(SIZE_META).forEach(function (k) { var n = SIZE_META[k].size; if (n && !/^COMPACT/.test(n) && !seen[n]) { seen[n] = 1; out.push({ key: n, label: n }); } });
    /* smallest to largest (Arjun 04-09): A5 first even though A4 is the default */
    out.sort(function (a, b) { return (SIZE_RANK[a.key] || 9) - (SIZE_RANK[b.key] || 9); });
    return out;
  }

  var LS_KEY = 'pz_wall_' + cfg.productId;
  var state = { size: null, slots: [], more: [] };   /* slots: {size, sel:{type,title,img}|null}; more: photo-product photos past the pack (28-09) */
  /* The rail ALWAYS opens on card 1 so the price ladder reads left to right
     (Rs399 -> Rs499 -> Rs699, Arjun 23-08) even though Large Wall is the
     pre-selected card further along. Only an actual tap on a card moves the
     rail. Returning visitors used to get dragged to their saved pack, which
     hid the cheap packs off-screen to the LEFT - the entry price has to be
     the first thing anyone sees, saved session or not. */
  var railFollowsSelection = false;
  /* Arjun 16-09 (pack mode): set by ?fill=<pack> - the pack's own header replaces the layout
     rail and the wall is the first thing on the page; cleared when another layout is chosen */
  var packMode = null;
  var packOff = null;    /* the pack layout the shopper stepped out of with "Change layout" - normal builder until another wall is chosen */
  /* Arjun 16-09: pack mode only on a ?fill= visit (the Porsche / Dream Garage pages' "customise this wall").
     A plain "Build your own wall" link - every other pack page, the menu, home - always opens the normal
     builder, even when the last wall saved here was a ready-made one. */
  var packUrl = !MODE && /[?&]fill=[a-z0-9-]+/.test(location.search || '');
  var LS_PARK = LS_KEY + '_pack';
  /* Arjun 27-09: "cart la Edit your wall kodutha antha exact variant oda wall picker open aaganum, edit mudichathum OK".
     The cart drawer's Edit wall button (pz-cart-thumbs.js) opens this page with ?pzedit=<cart line key>. The wall
     comes back from that line's properties, the shopper changes what they like, and OK writes the same line back
     (/cart/change.js) - no second wall in the cart. The shopper's own unfinished wall in localStorage is left alone
     while editing (save() is off) and returns afterwards. */
  var EDIT = null;
  (function () {
    var em = /[?&]pzedit=([^&#]+)/.exec(LANDING_QS);
    if (!em) return;
    var k = em[1];
    try { k = decodeURIComponent(k); } catch (e) {}
    EDIT = { key: k, item: null };
    /* Dawn rewrites the URL on every variant change (?variant=…) and dropped pzedit: a reload mid-edit (the phone
       killing the tab behind the photo picker, back from Pinterest) came back as a normal builder, and a second
       Add to cart doubled the wall (review 27-09). While editing, every URL change keeps pzedit. */
    try {
      ['replaceState', 'pushState'].forEach(function (fn) {
        var orig = history[fn];
        if (typeof orig !== 'function') return;
        history[fn] = function (st, title, url) {
          try {
            if (EDIT && url != null) {
              var u = new URL(String(url), location.href);
              if (!u.searchParams.has('pzedit')) { u.searchParams.set('pzedit', EDIT.key); url = u.pathname + u.search + u.hash; }
            }
          } catch (e) {}
          return orig.call(history, st, title, url);
        };
      });
    } catch (e) {}
  })();
  /* a ready-made wall a plain visit steps away from is parked with its swaps, and comes back on the next ?fill= */
  function parkPackWall() {
    try {
      localStorage.setItem(LS_PARK, JSON.stringify({ size: state.size, sels: state.slots.map(function (s) { return s.sel; }) }));
    } catch (e) {}
  }
  function unparkPackWall(layout) {
    try {
      var raw = JSON.parse(localStorage.getItem(LS_PARK) || 'null');
      if (!raw || raw.size !== layout) return null;   /* another pack's wall stays parked for its own link */
      localStorage.removeItem(LS_PARK);
      return raw;
    } catch (e) { return null; }
  }
  var pzScrollGen = 0; /* generation counter so a new pack-click cancels the previous scroll animation */
  var catalog = {};                        /* tabKey -> {status, items:[]} */
  var activeSlot = -1;
  var form = null, propsBox = null;

  function money(n) { return '₹' + Number(n).toLocaleString('en-IN'); }
  function toast(msg) {
    var t = document.createElement('div');
    t.className = 'pz-wb-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 2800);
  }

  /* ---------- funnel beacon (Arjun 28-08) ----------
     One ping per session per step -> upload-worker /t counters (R2 objects,
     /t/stats to read). src: 'land' = arrived on this page from outside the
     store (ad / direct / WhatsApp), 'nav' = navigated from another store
     page. Fire-and-forget image ping; never blocks the UI. Orders are NOT
     tracked here - Shopify order rows are the source of truth for that. */
  var pzSrc = 'land';
  try {
    var pzRef = document.referrer && new URL(document.referrer).hostname;
    if (pzRef && (pzRef.indexOf('posterized.in') > -1 || pzRef.indexOf('myshopify.com') > -1)) pzSrc = 'nav';
  } catch (e) {}
  function pzTrack(ev) {
    try {
      var k = 'pz_wb_t_' + ev + (PHOTO ? '_' + MODE : '');   /* photo products: once per session PER PRODUCT (a Mini view never hides a Retro view); BYW / M&M keys unchanged */
      if (sessionStorage.getItem(k)) return;
      sessionStorage.setItem(k, '1');
      /* the photo products say which one (28-09: &p=custom-mini); BYW / Mix & Match beacons are unchanged */
      new Image().src = cfg.endpoint.replace(/\/$/, '') + '/t?e=' + ev + '&s=' + pzSrc + (PHOTO ? '&p=' + encodeURIComponent(MODE) : '') + '&r=' + Date.now();
    } catch (e) {}
  }

  /* a variant that cannot be bought (tracked at 0 with deny) counts as missing, so the gallery,
     the size pills, the upsell and ?pack= never offer a pack whose cart add would fail
     (09-15: all three Mix & Match "3 Posters" variants were sold out but still on the gallery) */
  /* Arjun 16-09: the two ready-made walls (Porsche -> Track Wall, Dream Garage -> Garage Wall) are
     the packs from snippets/pz-packs-data.liquid; their gallery / rail cards show the pack's photo and
     name, and picking one fills the wall with the pack's designs (like ?fill=) - the shopper swaps. */
  function packForLayout(key) {
    if (MODE || !cfg.packs) return null;
    var ks = Object.keys(cfg.packs);
    for (var i = 0; i < ks.length; i++) {
      var pk = cfg.packs[ks[i]];
      if (pk && pk.layout === key && (pk.items || []).length) { pk.key = ks[i]; return pk; }
    }
    return null;
  }
  function packLabel(pk) {
    var n = String(pk.name || '').replace(/^your\s+/i, '');
    return n ? n.charAt(0).toUpperCase() + n.slice(1) : 'Ready-made wall';
  }
  /* the pack's designs into the wall, one per matching-size slot (onlyEmpty: keep what is already picked) */
  function fillFromPack(pk, onlyEmpty) {
    var used = {}, filled = 0;
    (pk.items || []).forEach(function (it) {
      for (var i = 0; i < state.slots.length; i++) {
        if (used[i] || state.slots[i].size !== it.size || (onlyEmpty && state.slots[i].sel)) continue;
        if (!fitsSlot(it.title, state.slots[i].size, !it.handle)) continue;   /* 01-10 / 03-10: the spot's own kind only */
        used[i] = 1;
        state.slots[i].sel = { type: 'catalog', title: it.title, img: it.img, handle: it.handle || null, flat: !it.handle };
        filled++;
        break;
      }
    });
    return filled;
  }
  function previewTheme() {
    /* 03-10: only a real preview - Shopify sets previewMode on a theme preview (?preview_theme_id=, the admin "Preview"
       button) and designMode in the theme editor. Not "role !== main": in a Shopify rollout the unpublished arm serves
       real buyers, and they must never see a sold-out wall. */
    var S = window.Shopify;
    return !!(S && (S.designMode || S.previewMode === true));
  }
  /* 03-10: the variant key is the title's first word - "Cinema Wall · 33 Posters" and the old "· 17 Posters" are both
     "cinema". A variant whose poster count matches another layout of the same name takes that layout's key (cinema2). */
  var keysMapped = false;
  function mapVariantKeys() {
    if (keysMapped || MODE) return;
    keysMapped = true;
    Object.keys(cfg.variants).forEach(function (id) {
      var v = cfg.variants[id], m = /(\d+)\s+(posters|pieces|prints|big prints|large prints)/i.exec(String(v.label || ''));
      if (!m) return;
      var n = +m[1], cur = SIZE_META[v.key];
      if (cur && cur.posters === n) return;
      Object.keys(SIZE_META).some(function (k) {
        var sm = SIZE_META[k];
        if (sm.posters === n && String(sm.name).split(' ')[0].toLowerCase() === v.key) { v.key = k; return true; }
        return false;
      });
    });
  }
  function variantFor(key) {
    mapVariantKeys();
    var ids = Object.keys(cfg.variants);
    for (var i = 0; i < ids.length; i++) {
      var v = cfg.variants[ids[i]];
      /* Arjun 30-09: a theme PREVIEW (unpublished theme / theme editor) also shows sold-out layouts, so a new wall can be
         seen before it goes on sale; the live theme keeps hiding them. oos marks them so Add to cart can say so. */
      if (v.key === key) return v.available === false && !previewTheme() ? null : { id: ids[i], v: v, oos: v.available === false };
    }
    return null;
  }

  /* ---------- geometry ---------- */
  function normEntry(e) {
    if (typeof e === 'string') return { row: [e], align: 'center' };
    if (Array.isArray(e)) return { row: e, align: 'center' };
    return { row: e.row, align: e.align || 'center' };
  }
  function normCol(c) {
    return Array.isArray(c) ? { items: c, dy: 0 } : { items: c.items, dy: c.dy || 0 };
  }
  function entryDims(e) {
    var n = normEntry(e);
    var w = (n.row.length - 1) * GAP, h = 0;
    n.row.forEach(function (s) { w += DIM[s][0]; h = Math.max(h, DIM[s][1]); });
    return { w: w, h: h };
  }

  /* two layout formats: `cols` (columns of sizes/rows, auto-centred) and
     `abs` (explicit [size, x, y] in dm from the top-left) — Arjun's drawn
     mosaics are free-form, they don't decompose into columns */
  function computeLayout(key, opts) {
    var L = LAYOUTS[key];
    if (L.abs) {
      var aW = 0, aH = 0, minX = Infinity, minY = Infinity;
      L.abs.forEach(function (a) { var d = DIM[a[0]]; aW = Math.max(aW, a[1] + d[0]); aH = Math.max(aH, a[2] + d[1]); minX = Math.min(minX, a[1]); minY = Math.min(minY, a[2]); });
      /* a photo-backed layout (box) keeps the whole photo as the wall; art = the posters' own extent.
         Arjun 08-09: while PICKING (opts.plain) the wall is a plain HTML board - just the
         arrangement with a small margin, no room photo - so every spot is big and clear;
         the room photo is the reward once the picks are done (page wall). */
      var plain = !!(opts && opts.plain) && !!L.box;
      var pad = plain ? Math.max(0.6, (aW - minX) * 0.05) : 0;
      var ox = plain ? minX - pad : 0, oy = plain ? minY - pad : 0;
      var bW = plain ? (aW - minX) + 2 * pad : (L.box ? L.box[0] : aW), bH = plain ? (aH - minY) + 2 * pad : (L.box ? L.box[1] : aH);
      var out = {
        W: bW, H: bH, mock: plain ? null : (L.mock || null), mockDone: plain ? null : (L.mockDone || null), mockZoom: plain ? null : (L.mockZoom || null), plain: plain,
        art: { x: minX - ox, y: minY - oy, w: aW - minX, h: aH - minY },
        slots: L.abs.map(function (a) {
          var d = DIM[a[0]];
          return { size: a[0], x: (a[1] - ox) / bW * 100, y: (a[2] - oy) / bH * 100, w: d[0] / bW * 100, h: d[1] / bH * 100 };
        })
      };
      /* framed photo prints (28-09): the booth strips behind the windows, the retro twine rows - % of the wall */
      if (L.deco) out.deco = L.deco.map(function (a) { var d = DIM[a[0]]; return { size: a[0], x: (a[1] - ox) / bW * 100, y: (a[2] - oy) / bH * 100, w: d[0] / bW * 100, h: d[1] / bH * 100 }; });
      if (L.rows) out.rows = L.rows.map(function (y) { return (y - oy) / bH * 100; });
      if (L.clips) out.clips = true;
      return out;
    }
    var cols = L.cols.map(normCol);
    var colW = cols.map(function (c) {
      return Math.max.apply(null, c.items.map(function (e) { return entryDims(e).w; }));
    });
    var colH = cols.map(function (c) {
      var h = (c.items.length - 1) * GAP;
      c.items.forEach(function (e) { h += entryDims(e).h; });
      return h;
    });
    /* each column is centred on a shared axis, then nudged by its dy —
       the bounding box grows to fit whatever sticks out */
    var tops = cols.map(function (c, i) { return -colH[i] / 2 + c.dy; });
    var minTop = Math.min.apply(null, tops);
    var maxBottom = Math.max.apply(null, tops.map(function (t, i) { return t + colH[i]; }));
    var W = colW.reduce(function (a, b) { return a + b; }, 0) + GAP * (cols.length - 1);
    var H = maxBottom - minTop;
    var slots = [], x = 0;
    cols.forEach(function (c, ci) {
      var y = tops[ci] - minTop;
      c.items.forEach(function (e) {
        var n = normEntry(e);
        var ed = entryDims(e);
        var rx = x + (colW[ci] - ed.w) / 2;
        n.row.forEach(function (s) {
          var d = DIM[s];
          var iy = n.align === 'top' ? 0 : n.align === 'bottom' ? (ed.h - d[1]) : (ed.h - d[1]) / 2;
          slots.push({
            size: s,
            x: rx / W * 100,
            y: (y + iy) / H * 100,
            w: d[0] / W * 100,
            h: d[1] / H * 100
          });
          rx += d[0] + GAP;
        });
        y += ed.h + GAP;
      });
      x += colW[ci] + GAP;
    });
    return { W: W, H: H, slots: slots };
  }

  /* ---------- persistence ---------- */
  function save() {
    if (EDIT) return;   /* editing a wall that is already in the cart: the unfinished wall in storage stays as it was */
    if (PHOTO) { photoSave(); return; }   /* 28-09: 6 h, every photo (none truncated), only finished uploads */
    try {
      localStorage.setItem(LS_KEY, JSON.stringify({
        size: state.size,
        sels: state.slots.map(function (s) { return s.sel; }),
        pv: state.pv || null,
        pvKey: state.pvKey || null
      }));
    } catch (e) {}
  }
  /* the pack a pick-any page opens on: the variant the link names (?variant=), else - Arjun 18-09 night - 10 posters
     (Buy 5 Get 5) on Mix & Match posters instead of the product's first variant (7). Other pick-any products keep it. */
  function startPackKey() {
    var sv = cfg.variants[String(cfg.selectedVariantId)];
    var key = sv && LAYOUTS[sv.key] ? sv.key : null;
    /* a hidden pack (retro 30 / 40 via an old ?variant= link) opens on 20 of the same size, else the nearest pack shown */
    if (sv && sv.hidden && !key) key = hiddenFallbackKey(sv);
    if (MODE === 'singles' && !/[?&]variant=/.test(LANDING_QS) && LAYOUTS['s10-a4'] && SIZE_META['s10-a4'] && variantFor('s10-a4')) return 's10-a4';
    return key;
  }
  function hiddenFallbackKey(sv) {
    var sz = normSize(sv.size), best = null, want = 20;
    Object.keys(SIZE_META).forEach(function (k) {
      var m = SIZE_META[k];
      if (m.size !== sz || !LAYOUTS[k] || !variantFor(k)) return;
      var d = Math.abs((m.units || m.posters) - want);
      if (!best || d < best.d) best = { k: k, d: d };
    });
    return best ? best.k : null;
  }
  function restore() {
    if (PHOTO) { photoRestore(); return; }   /* 28-09: back on the SAVED pack, stuck uploads dropped */
    try {
      var raw = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (!raw || !LAYOUTS[raw.size]) return;
      var key = raw.size;
      if (!MODE && RETIRE_TO[key] && LAYOUTS[RETIRE_TO[key]]) key = RETIRE_TO[key];   /* 08-10: a saved Classic wall comes back as Studio */
      if (MODE) {
        /* Arjun 04-09: the pick-any products always open on the variant the
           page was opened with - the default (A4 · Buy 4 get 3) on a plain
           visit, or the pack an offer card linked to (?variant=) - never on
           the size the visitor left last time. Picked posters still come back. */
        var dk = startPackKey();
        if (dk) key = dk;
      }
      if (!variantFor(key)) return;   /* the saved wall's variant has sold out since */
      setSize(key, true);
      (raw.sels || []).forEach(function (sel, i) {
        /* an own-photo pick that never got a permanent URL (blob: only) is dead after a
           reload - a broken "Your photo" tile is worse than an empty spot (Arjun 08-09) */
        if (sel && sel.type === 'upload' && !sel.url && !(sel.thumb && !/^blob:/.test(sel.thumb))) return;
        if (sel && sel.type === 'upload') delete sel.blobUrl;   /* blob: URLs never survive a reload - fall back to url/thumb */
        if (sel && state.slots[i]) state.slots[i].sel = sel;
      });
      dropMisfits();   /* 01-10: a wall saved before the single-spot rule */
      state.pv = raw.pv || null;
      state.pvKey = raw.pvKey || null;
    } catch (e) {}
  }

  /* ---------- size selection ---------- */
  var animNext = false;
  /* Arjun 17-09 ("wall posters blink"): every render() created new <img>s for the spots, and iPhone Safari paints a
     fresh image only after an async decode - the posters vanished for a frame or two on every pick, Done, size
     change. The decoded element is reused for the same picture (one per spot per render) and decodes in sync. */
  var slotImgPool = {}, renderSeq = 0;
  var railCache = null;   /* the rail element + the inputs it was built from - reused while they hold (17-09) */
  function setSize(key, quiet) {
    if (!quiet) animNext = true;
    var old = state.slots;
    state.size = key;
    if (PHOTO) { photoCarry(computeLayout(key).slots); photoRefit(); }   /* 28-09: a pack change never drops a photo (30 -> 5 -> 30 keeps all 30); a new size re-cuts */
    else state.slots = computeLayout(key).slots.map(function (g, i) {
      var keep = old[i] && old[i].sel && old[i].size === g.size ? old[i].sel : null;
      return { size: g.size, sel: keep };
    });
    syncVariant(key);
    if (!quiet) save();
    if (PHOTO && !quiet) phSmallNote();   /* 28-09 preview test: a switch that makes a photo too small says so at once */
    render();
  }

  function syncVariant(key) {
    var vr = variantFor(key);
    if (!vr) return;
    /* click the (hidden) Dawn variant pill so price/form stay in sync. Scope
       to the live product section: while Dawn swaps the section HTML the old
       and new variant pickers coexist for a moment, and ticking a radio in
       the outgoing copy does nothing. */
    var scope = (form && form.closest('.shopify-section')) || document;
    var radios = scope.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
    if (!radios.length) radios = document.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
    var clicked = false;
    if (MODE) {
      /* pick-any products have TWO option rows (Size, Pack): tick both, Size
         first so Dawn resolves the right variant, then Pack. Clicking only a
         label-matched pill left the form on the opening variant (03-09). */
      var wantVals = [String(vr.v.size), String(vr.v.pack)];
      wantVals.forEach(function (val) {
        for (var i = 0; i < radios.length; i++) {
          if (String(radios[i].value) === val) {
            if (!radios[i].checked) radios[i].click();
            clicked = true;
            break;
          }
        }
      });
    } else {
      for (var i = 0; i < radios.length; i++) {
        if (String(radios[i].value) === String(vr.v.label)) {
          if (!radios[i].checked) radios[i].click();
          clicked = true;
          break;
        }
      }
    }
    if (!clicked) {
      var idInput = form && form.querySelector('input[name="id"], select[name="id"]');
      if (idInput) { idInput.disabled = false; idInput.value = vr.id; }
    }
  }

  /* ---------- catalog ---------- */
  function loadAssetTab(tab) {
    var store = { status: 'loading', items: [] };
    catalog[tab.key] = store;
    withDesigns(function (D) {
      if (!D.ok) return loadAssetTabFromTheme(tab, store);
      var want = tab.extraKey || tab.key;
      store.items = D.items.filter(function (it) { return (it.home || it.tab) === want; }).map(function (it) {
        return { id: it.id, title: it.title, img: it.img, t: it.t, handle: null, landscape: isLandscapeTitle(it.title), flat: true };
      });
      store.status = 'ready';
      if (drawerTab === tab.key) renderDrawerGrid();
    });
  }
  function loadAssetTabFromTheme(tab, store) {
    var url = (cfg.assets && cfg.assets[tab.asset]) || '';
    if (!url) { store.status = 'ready'; renderDrawerGrid(); return; }
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
      try {
        var list = JSON.parse(xhr.responseText) || [];
        /* a shared asset (pz-extra.json) carries a `tab` on every item - keep this tab's */
        list = list.filter(function (it) { return !it.tab || it.tab === (tab.extraKey || tab.key); });
        store.items = list.map(function (it) {
          return { id: it.id, title: it.title, img: it.img, handle: null, landscape: isLandscapeTitle(it.title), flat: true };
        });
      } catch (e) {}
      store.status = 'ready';
      if (drawerTab === tab.key) renderDrawerGrid();
    };
    xhr.onerror = function () { store.status = 'ready'; if (drawerTab === tab.key) renderDrawerGrid(); };
    xhr.send();
  }

  function loadTab(tab) {
    var c = catalog[tab.key];
    if (c && (c.status === 'ready' || c.status === 'loading' || c.status === 'partial')) return;
    if (tab.asset) return loadAssetTab(tab);
    var store = { status: 'loading', items: [] };
    catalog[tab.key] = store;
    var byId = {};
    var jobs = [];
    /* extra flat designs (theme asset) sit FIRST in the tab - new drop, seen first */
    var extra = [];
    if (tab.extra) {
      withDesigns(function (D) {
        var want = tab.extraKey || tab.key;
        var take = function (arr) {
          /* 16-10 (Collections rebuild): a merged tile takes several design tabs (array); '*new' = the newest floor singles
             (designs.json lists the newest first) */
          var wantOf = function (it) { var k = it.home || it.tab; return Array.isArray(want) ? want.indexOf(k) > -1 : k === want; };
          extra = (want === '*new'
            ? (arr || []).filter(function (it) { return it && !it.split && it.tab !== 'animesplit' && !/^c:/.test(it.home || ''); }).slice(0, 120)
            : (arr || []).filter(wantOf))
            .map(function (it) { return { id: it.id, title: it.title, img: it.img, t: it.t, handle: null, landscape: isLandscapeTitle(it.title), flat: true, sort: -1e9 }; });
          if (store.status !== 'loading') { publish(); if (drawerTab === tab.key) renderDrawerGrid(); }
        };
        if (D.ok) return take(D.items);
        if (!(cfg.assets && cfg.assets[tab.extra])) return;
        var ex = new XMLHttpRequest();
        ex.open('GET', cfg.assets[tab.extra], true);
        ex.onload = function () { try { take(JSON.parse(ex.responseText)); } catch (e) {} };
        ex.send();
      });
    }
    function publish() {
      store.items = extra.concat(Object.keys(byId).map(function (k) { return byId[k]; })
        .sort(function (a, b) { return a.sort - b.sort; }));
    }
    tab.handles.forEach(function (h, hi) {
      var pages = Array.isArray(tab.pages) ? (tab.pages[hi] || 1) : (tab.pages || 1);
      for (var p = 1; p <= pages; p++) jobs.push({ h: h, hi: hi, p: p });
    });
    var left = jobs.length;
    /* deterministic best-sellers-first ordering regardless of fetch timing:
       'concat' keeps whole collections in sequence, default interleaves
       the collections by each product's sales rank */
    function sortKey(hi, rank) {
      return tab.merge === 'concat' ? hi * 1e6 + rank : rank * 10 + hi;
    }
    /* max 2 fetches in flight with one retry each — Shopify throttles
       bursts of products.json requests, which silently emptied tabs */
    var queue = jobs.slice();
    var active = 0;
    function runNext() {
      if (active >= 2 || !queue.length) return;
      var job = queue.shift();
      active++;
      fetch('/collections/' + job.h + '/products.json?limit=250&page=' + job.p)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function (data) {
          (data.products || []).forEach(function (p, idx) {
            if (tab.include ? !tab.include.test(p.title) : EXCLUDE.test(p.title)) return;
            /* EXCLUDE is skipped on a tab that has its own include regex, so the
               builder-product guard needs its own line here (17-09). */
            if (NOT_A_POSTER.test(p.title)) return;
            if (tab.include && isVerticalSet(p)) return;   /* 03-10: a split spot is a side-by-side set, never a stacked one */
            /* A size-filtered tab must not offer a design that has no size option at
               all: 'NEVER STOP DREAMING | Bugatti La Voiture Noire' and 'HELL CHARGER |
               Dodge Car Set' are legacy mixed sets (2xA4 + 1xA3, one Default Title
               variant) and were sold as 13X19 and A4 splits that do not exist — 4 of
               those 9 orders were held on the floor. Hides 2 of the 235 products in
               3-piece-sets, none in pack-of-5. Must stay inside this forEach: the
               pz-extra.json records carry no variants key. */
            if (tab.include && !(p.variants || []).some(function (v) {
              return v.title && v.title !== 'Default Title';
            })) return;
            var img = p.images && p.images[0] && p.images[0].src;
            if (!img) return;
            var key = sortKey(job.hi, (job.p - 1) * 250 + idx);
            if (byId[p.id] && byId[p.id].sort <= key) return;
            byId[p.id] = { id: p.id, title: cleanTitle(p.title), img: flatImg(p.handle, img), handle: p.handle, sort: key, landscape: !!LANDSCAPE[p.id] || isLandscapeTitle(p.title),
                           tags: (p.tags || []).map(function (t) { return String(t).toLowerCase(); }) };
          });
        })
        .catch(function () {
          if (!job.retried) {
            job.retried = true;
            queue.push(job);
            left++;
          }
        })
        .then(function () {
          active--;
          left--;
          publish();
          store.status = left === 0 ? 'ready' : 'partial';
          if (drawerTab === tab.key) renderDrawerGrid();
          setTimeout(runNext, job.retried && left > 0 ? 400 : 0);
        });
      runNext();
    }
    whenFlats(runNext);   /* 15-10: the flat list first (2.5 s cap), so the grid never swaps mockups for flats mid-scroll */
  }

  function cleanTitle(t) {
    /* "BMW M2 | VECTOR STYLE CARS #01 | CAR POSTERS" → "BMW M2" reads better,
       but the print team needs the full title — keep full, trim trailing noise */
    return String(t).replace(/\s*\|\s*(CAR POSTERS|POSTERS?)\s*$/i, '').trim();
  }

  function thumb(src, w) {
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 320);
  }

  /* ---------- drawer ---------- */
  var drawer = null, drawerTab = 'all', drawerTabs = TABS, drawerQ = '', drawerShown = 120;
  function firstTabKey() { return drawerTabs.some(function (t) { return t.key === 'all'; }) ? 'all' : drawerTabs[0].key; }   /* 16-10: All Posters is the default tab */
  /* ---- collections view (Arjun 04-09) ----
     The first thing a shopper sees when they tap a spot is a grid of every
     collection the store sells - the same list as the site menu - with the
     upload tile in front. Picking one loads that collection into the tile
     grid as a dynamic tab; the old category chips stay for quick access. */
  var drawerView = 'grid', colsSeen = false, COLS = null, DYN = {};
  function tabFor(key) {
    return drawerTabs.filter(function (t) { return t.key === key; })[0] || DYN[key] || null;
  }
  /* 28-09 preview test: a Collections / ?col= tab keeps the kind of spot it was built for (0 = single poster,
     3 = 3-piece split, 5 = 5-piece split). Moving to a spot of another kind (tap, auto-advance, jump) drops it, so a
     5-piece tab never lists in a 3-piece spot and a singles / 3-piece tab never in a 5-piece spot (#313711). */
  function drawerKind(tabs) { return tabs === FIVE_TABS ? 5 : tabs === SPLIT_TABS ? 3 : 0; }
  function tabFits(key) {
    if (drawerTabs.some(function (t) { return t.key === key; })) return true;
    var d = DYN[key];
    return !!d && (d.kind || 0) === drawerKind(drawerTabs);
  }
  function colsFor() {
    if (!COLS) return null;
    return isSplitTabs(drawerTabs) ? COLS.splits : COLS.singles;
  }
  /* 10-10 (designs hotfix): Collections-view single tiles whose uploads live under a builder tab key */
  var COL_LIST_KEY = { 'super-heros': 'heroes', 'marvel-collections': 'heroes', 'dcu-collections': 'heroes',
                       'devotional-poster': 'divine', 'hindu-god': 'divine', 'kollywood': 'desi', 'south-india': 'desi' };
  function colTab(c, split) {
    /* Arjun 23-09: a 3-piece uploaded on the floor names the split collection it
       belongs to ('c:tv-series-split-collections') in `home` - it sits first in that
       collection's tab, like the floor drops in the single-poster tabs.
       Arjun 28-09 (floor session): split = 0 | 3 | 5. A collection opened from the 5-piece
       drawer took the 3-piece filter (#313711 got two 3-piece sets in its 5-piece spots);
       5-piece tabs filter on SPLIT5_RE, keep their own cache key and get no 3-piece drops. */
    var five = split === 5, hs = c.handles || [c.handle];
    /* 16-10 (Collections rebuild): a merged tile (Cars & Bikes = 6 collections ...) names its own floor-design tab(s) in
       extraKey; a merged 3-piece tile takes the floor's 3-piece drops of every one of its collections */
    var xk = c.extraKey || (split === 3 ? (hs.length > 1 ? hs.map(function (h) { return 'c:' + h; }) : 'c:' + hs[0]) : !split ? COL_LIST_KEY[hs[0]] : undefined);
    return { key: (five ? 'c5:' : 'c:') + (c.key || hs[0]), kind: five ? 5 : split ? 3 : 0, label: c.label, handles: hs, pages: c.pages || 2,
             include: five ? SPLIT5_RE : split ? SPLIT3_RE : undefined, merge: 'concat',
             extra: !five && xk ? 'designs' : undefined,
             extraKey: !five ? xk : undefined };
  }
  function loadCols() {
    if (COLS || loadCols.busy) return;
    var url = cfg.assets && cfg.assets['pz-collections.json'];
    if (!url) { COLS = { singles: [], splits: [] }; return; }
    loadCols.busy = true;
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
      try { COLS = JSON.parse(xhr.responseText) || { singles: [], splits: [] }; } catch (e) { COLS = { singles: [], splits: [] }; }
      if (drawer && drawerView === 'cols') renderDrawerGrid();
      if (drawer && drawerTabs === SPLIT_TABS) { renderTabButtons(); renderDrawerGrid(); }
    };
    xhr.onerror = function () { COLS = { singles: [], splits: [] }; };
    xhr.send();
  }
  function lazyColImage(c, im) {
    /* 16-10: the grid is often re-drawn before this fetch returns, so the picture goes to every tile of the collection on
       screen (data-colh), not only to the <img> that asked - 13 of 30 covers stayed blank */
    var h = c.handle || (c.handles && c.handles[0]);
    if (im && h) im.setAttribute('data-colh', h);
    if (c.img || c._busy || !h) return;
    c._busy = true;
    fetch('/collections/' + h + '/products.json?limit=1')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var p = d.products && d.products[0];
        var src = p && p.images && p.images[0] && p.images[0].src;
        if (!src) return;
        c.img = flatImg(p.handle, src);
        Array.prototype.forEach.call(document.querySelectorAll('img[data-colh="' + h + '"]'), function (x) { x.src = thumb(c.img, 400); });
      }).catch(function () { c._busy = false; });
  }
  function chooseCol(c) {
    var t = c.tab ? drawerTabs.filter(function (x) { return x.key === c.tab; })[0] : null;
    /* 16-10: a design-only tile (Bollywood ...) whose floor tab has not reached this drawer yet opens straight from designs.json */
    if (!t && c.tab && !c.handles && !c.handle) {
      t = DYN[c.tab] || { key: c.tab, kind: drawerKind(drawerTabs), label: c.label, handles: [], asset: 'designs', flat: true, portraitOnly: true };
      DYN[t.key] = t;
    }
    if (!t) { t = colTab(c, drawerTabs === FIVE_TABS ? 5 : drawerTabs === SPLIT_TABS ? 3 : 0); DYN[t.key] = t; }
    drawerTab = t.key; drawerShown = 120; drawerView = 'grid'; colsSeen = true; drawerQ = '';
    var inp = drawer.querySelector('.pz-wb-d-search input');
    if (inp) inp.value = '';
    renderTabButtons();
    if (t.handles.length || t.asset) loadTab(t);
    renderDrawerGrid();
    pzTrack('col');
  }
  /* ---- search (Arjun 04-09: "Odyssey" must find everything Odyssey, and
     suggest related designs) ----
     Three layers, merged and de-duplicated:
       1. local - every loaded poster, matched token by token on title + tags
          with prefix and one-typo tolerance, best matches first;
       2. Shopify predictive search - catches tags, vendor, type and typos on
          products not loaded yet;
       3. Shopify recommendations for the top hit - the "related" row. */
  var searchCache = {}, searchTimer = null;
  var searchExtra = { q: '', items: [], related: [], relTitle: '' };
  function norm(str) { return String(str || '').toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function oneEdit(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, e = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++e > 1) return false;
      if (a.length > b.length) i++; else if (a.length < b.length) j++; else { i++; j++; }
    }
    return e + (a.length - i) + (b.length - j) <= 1;
  }
  /* 16-10 (Arjun: "images related ah search pannave antha posters appear aaganum, just title vechu mattum vara kodathu"):
     every poster picture was read once by AI - assets/pz-search-tags.json holds who / what is in it, the words printed on
     it, its colours, style and the nicknames people type (thala, baba yaga, cr7). Loaded on the first search, from the
     same folder as this file; a picture tag scores a little under a title word, so a poster NAMED Batman comes first. */
  var STAGS = null, stagsBusy = false;
  var STOP = { poster: 1, posters: 1, wall: 1, print: 1, prints: 1, design: 1, designs: 1, the: 1, a: 1, an: 1, of: 1, and: 1, for: 1, with: 1, in: 1 };
  function loadSearchTags(cb) {
    if (STAGS || stagsBusy) return;
    var sc = document.querySelector('script[src*="pz-wall-builder"]'), base = sc ? sc.src.split('?')[0] : '';
    var u = base.replace(/pz-wall-builder[^\/]*\.js$/, 'pz-search-tags.json');
    if (!base || u === base) return;
    stagsBusy = true;
    var x = new XMLHttpRequest();
    x.open('GET', u + '?v=1610a', true);
    x.onload = function () { try { STAGS = JSON.parse(x.responseText).t || {}; } catch (e) { STAGS = {}; } if (cb) cb(); };
    x.onerror = function () { stagsBusy = false; };
    x.send();
  }
  function tagsOf(it) { return STAGS ? STAGS[it.handle ? 'p:' + it.handle : 'a:' + it.id] || '' : ''; }
  function scoreItem(it, toks) {
    if (!it._n) it._n = norm(it.title) + ' ' + (it.tags || []).join(' ');
    if (STAGS && it._t == null) it._t = norm(tagsOf(it));
    var hay = ' ' + it._n + ' ', words = it._n.split(' '), score = 0;
    var thay = it._t ? ' ' + it._t + ' ' : '', twords = it._t ? it._t.split(' ') : [];
    for (var t = 0; t < toks.length; t++) {
      var q = toks[t], best = 0;
      if (hay.indexOf(' ' + q + ' ') > -1) best = 3;
      else {
        for (var w = 0; w < words.length && best < 2; w++) {
          if (words[w].indexOf(q) === 0) best = 2;
          else if (q.length >= 5 && oneEdit(q, words[w])) best = Math.max(best, 1);
        }
      }
      if (best < 2 && thay) {
        if (thay.indexOf(' ' + q + ' ') > -1) best = 2;
        else if (q.length >= 3) for (var v = 0; v < twords.length; v++) if (twords[v].indexOf(q) === 0) { best = Math.max(best, 1.5); break; }
      }
      if (!best) return 0;
      score += best;
    }
    return score;
  }
  function localSearch(items, q) {
    var all = norm(q).split(' ').filter(Boolean), toks = all.filter(function (w) { return !STOP[w]; });
    if (!toks.length) toks = all;   /* "poster" alone still searches */
    if (!toks.length) return items;
    return items.map(function (it) { return { it: it, s: scoreItem(it, toks) }; })
      .filter(function (x) { return x.s > 0; })
      .sort(function (a, b) { return b.s - a.s || (a.it.sort || 0) - (b.it.sort || 0); })
      .map(function (x) { return x.it; });
  }
  function toItem(p) {
    var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.image;
    if (img && img.src) img = img.src;
    if (!img || typeof img !== 'string') return null;
    /* 13-10 (#325176 slot 5): a set whose only variant is "Default Title" has no split version (2 x A4 + 1 x A3 legacy sets) -
       the collection tabs already drop it (loadTab); search and the related row bring it through here, so it is flagged */
    var vs = p.variants || null;
    img = flatImg(p.handle, img);   /* 15-10: singles and 3-piece sets - each handle maps to its own flat */
    return { id: p.id, title: cleanTitle(p.title), img: img, handle: p.handle, sort: 5e6, landscape: !!LANDSCAPE[p.id] || isLandscapeTitle(p.title),
             tags: (p.tags || []).map(function (t) { return String(t).toLowerCase(); }), rawTitle: p.title,
             noSize: !!(vs && vs.length && vs.every(function (v) { return !v || !v.title || v.title === 'Default Title'; })) };
  }
  /* Arjun 17-09 (#306523): the builder PRODUCTS are not designs — their picture is a
     listing mockup, and one of them ("Mix & Match Any Posters | Pick Any 7, 10, 18 or 36")
     reached a picker slot, so the floor was told to print that mockup as the customer's
     10th poster. Checked against the live catalogue: only the two Pick-Any builder
     products match, every real design is kept. */
  var NOT_A_POSTER = /personali[sz]e|customi[sz]e|build your|wall space|pick any|mix (&|and) match/i;
  /* Arjun 03-10 ("3 pcs la vertical designs um varthu"): 7 sets in 3-piece-sets are three panels STACKED (tags "vertical
     poster" / "VERTICAL SPLIT" - Unstoppable, WhatsUp Danger, Batman Begins ...). The builder's split spots are side by side, so a split
     drawer never lists them. */
  function isVerticalSet(p) {
    return (p.tags || []).some(function (t) { return /^vertical[\s-]*(poster|split)$/i.test(String(t).trim()); });   /* tags "vertical poster" / "VERTICAL SPLIT" */
  }
  var NO_SPLIT_RE = /never stop dreaming|hell charger|porsche x car set|2\s*[x\u00d7]\s*a4\s*\+\s*1\s*[x\u00d7]\s*a3/i;   /* the legacy mixed sets (2 x A4 + 1 x A3, one variant): by name, old or new title (14-10: + Porsche x Car Set, any '2xA4 + 1xA3') */
  function fitsContext(p) {
    var title = p.rawTitle || p.title || '';
    if (NOT_A_POSTER.test(title)) return false;
    if (isSplitTabs(drawerTabs) && (p.noSize || NO_SPLIT_RE.test(title))) return false;   /* 13-10: no split version exists */
    if (isSplitTabs(drawerTabs) && isVerticalSet(p)) return false;
    return drawerTabs === FIVE_TABS ? SPLIT5_RE.test(title) : drawerTabs === SPLIT_TABS ? SPLIT3_RE.test(title) : !EXCLUDE.test(title);
  }
  function remoteSearch(q, cb) {
    var key = 'q:' + q;
    if (searchCache[key]) return cb(searchCache[key]);
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=20&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,vendor,tag')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (((d || {}).resources || {}).results || {}).products || [];
        /* Shopify's predictive search also matches on description text, which
           drags in loose hits; keep only items whose title or tags actually
           carry a query token - everything else belongs in the related row */
        var toks = norm(q).split(' ').filter(Boolean);
        var out = list.map(toItem).filter(function (p) { return p && fitsContext(p) && scoreItem(p, toks) > 0; });
        searchCache[key] = out; cb(out);
      }).catch(function () { cb([]); });
  }
  function relatedFor(item, cb) {
    if (!item || !item.id || !/^\d+$/.test(String(item.id))) return cb([]);
    var key = 'rel:' + item.id;
    if (searchCache[key]) return cb(searchCache[key]);
    fetch('/recommendations/products.json?product_id=' + item.id + '&limit=12&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var out = ((d || {}).products || []).map(toItem).filter(function (p) { return p && fitsContext(p); });
        searchCache[key] = out; cb(out);
      }).catch(function () { cb([]); });
  }
  function searchPool() {
    var base = drawerTabs === FIVE_TABS ? 'split5s' : drawerTabs === SPLIT_TABS ? 'split3s' : 'all';
    var seen = {}, out = [];
    [catalog[drawerTab], catalog[base]].forEach(function (c) {
      if (!c) return;
      c.items.forEach(function (it) { if (!seen[it.id]) { seen[it.id] = 1; out.push(it); } });
    });
    /* 10-10 (designs hotfix): a floor upload is found from any tab of the single-poster drawer, not only while its own
       tab is open - once the published list is in, its single designs join the pool (never a split; a spot keeps its
       fitsSlot rule, and the grid's portrait / landscape filter still applies to the results) */
    if (drawerTabs === TABS && DESIGNS && DESIGNS.ok) {
      var psz = activeSlot > -1 && state.slots[activeSlot] ? state.slots[activeSlot].size : null;
      DESIGNS.items.forEach(function (it) {
        if (!it || !it.id || !it.img || seen[it.id]) return;
        if (it.split || it.tab === 'animesplit' || /^c:/.test(it.home || '')) return;
        if (psz && !fitsSlot(it.title, psz, true)) return;
        seen[it.id] = 1;
        out.push({ id: it.id, title: it.title, img: it.img, t: it.t, handle: null, landscape: isLandscapeTitle(it.title), flat: true });
      });
    }
    return out;
  }
  function searchResults(q) {
    var seen = {}, out = [];
    localSearch(searchPool(), q).forEach(function (it) { seen[it.id] = 1; out.push(it); });
    if (searchExtra.q === q) {
      searchExtra.items.forEach(function (it) { if (!seen[it.id]) { seen[it.id] = 1; out.push(it); } });
      searchExtra.related.forEach(function (it) {
        if (seen[it.id]) return;
        seen[it.id] = 1;
        var r = {}; for (var k in it) r[k] = it[k]; r._rel = true; out.push(r);
      });
    }
    return out;
  }
  function kickRemoteSearch(q) {
    clearTimeout(searchTimer);
    if (q.length < 2) return;
    searchTimer = setTimeout(function () {
      remoteSearch(q, function (items) {
        if (drawerQ !== q) return;
        searchExtra = { q: q, items: items, related: [], relTitle: '' };
        renderDrawerGrid();
        var top = localSearch(searchPool(), q).filter(function (it) { return /^\d+$/.test(String(it.id)); })[0] || items[0];   /* 10-10: an upload ('d-...') has no Shopify relations */
        relatedFor(top, function (rel) {
          if (drawerQ !== q) return;
          searchExtra.related = rel; searchExtra.relTitle = top ? top.title : '';
          renderDrawerGrid();
        });
      });
    }, 280);
  }

  function pickedCount(it) {
    var n = 0, key = (it.img || '').split('?')[0];
    for (var i = 0; i < state.slots.length; i++) {
      var sel = state.slots[i].sel;
      if (sel && sel.type === 'catalog' && (sel.img || '').split('?')[0] === key) n++;
    }
    return n;
  }
  /* 16-10 (Collections rebuild): 2 tiles a row on phones (4 on desktop), and the upload / paste-link cards across the full
     width - the old 3-across flex basis squeezed both first cards into one 111 px tile */
  function colCss() {
    if (document.getElementById('pz-wb-cols-css')) return;
    var st = document.createElement('style');
    st.id = 'pz-wb-cols-css';
    st.textContent = '.pz-wb-d-grid.cols>.pz-wb-d-first{flex:0 0 100%;width:100%;max-width:100%}' +
      /* 16-10 later (Arjun, option 3): 3 tiles a row on phones, 5 on desktop */
      '.pz-wb-d-grid.cols>.pz-wb-d-col{flex:0 0 calc((100% - 20px) / 3);width:calc((100% - 20px) / 3);max-width:calc((100% - 20px) / 3)}' +
      '@media(min-width:750px){.pz-wb-d-grid.cols>.pz-wb-d-col{flex-basis:calc((100% - 40px) / 5);width:calc((100% - 40px) / 5);max-width:calc((100% - 40px) / 5)}}' +
      '.pz-wb-d-grid.cols .pz-wb-d-colcap{font-size:13px;padding:8px 10px 10px}' +
      /* 16-10 (Arjun): the Collections chip stays pinned at the left of the chip row */
      '.pz-wb-d-tabs>.pz-wb-d-tab.browse{position:sticky;left:0;z-index:3;box-shadow:-14px 0 0 0 #fff,10px 0 12px -8px rgba(0,0,0,.28)}' +
      /* 16-10 (Arjun picked option 3): cream tile, colour disc, three heroes cut from our own posters, live label */
      '.pz-wb-d-grid.cols>.pz-wb-d-col.pz-cov{position:relative;display:block;aspect-ratio:1;padding:0;border:0;border-radius:14px;overflow:hidden;background:#f3efe6;isolation:isolate}' +
      '.pz-cov-disc{position:absolute;width:84%;aspect-ratio:1;border-radius:50%;right:-14%;bottom:-16%;background:var(--pzc);z-index:1}' +
      '.pz-cov-art{position:absolute;left:0;top:0;width:100%;height:100%;z-index:2;display:block}' +
      '.pz-cov-lab{position:absolute;left:11px;top:11px;z-index:3;max-width:74%;font:800 22px/.92 "Barlow Condensed",Barlow,system-ui,sans-serif;text-transform:uppercase;color:#111;text-align:left;text-shadow:0 0 10px #f3efe6,0 0 3px #f3efe6}' +
      '.pz-cov-lab:after{content:"";display:block;width:22px;height:4px;border-radius:2px;background:#ffba00;margin-top:7px}' +
      '.pz-cov-arr{position:absolute;left:11px;bottom:11px;z-index:3;width:24px;height:24px;border-radius:50%;background:#111;color:#ffba00;font:800 14px/24px Barlow,system-ui,sans-serif;text-align:center}' +
      /* small tiles (3 a row): smaller label, no arrow */
      '.pz-wb-d-grid.cols>.pz-wb-d-col.pz-cov{border-radius:12px}' +
      '.pz-wb-d-grid.cols .pz-cov-lab{left:8px;top:8px;font-size:15px}' +
      '.pz-wb-d-grid.cols .pz-cov-lab:after{width:14px;height:3px;margin-top:4px}' +
      '.pz-wb-d-grid.cols .pz-cov-arr{display:none}' +
      '@media(min-width:750px){.pz-wb-d-grid.cols .pz-cov-lab{font-size:17px}}' +
      /* the Collections button beside the search box */
      '.pz-wb-d-search{display:flex;gap:8px;align-items:center}' +
      '.pz-wb-d-search input{flex:1 1 auto;min-width:0;width:auto}' +
      '.pz-wb-drawer .pz-wb-d-search .pz-wb-d-tab.pz-wb-d-colbtn{flex:none;display:inline-flex;align-items:center;gap:6px;height:38px;padding:0 12px;border-radius:10px;background:#111;border:1.5px solid #111;color:#ffba00;font:800 13px/1 Barlow,system-ui,sans-serif;position:static;box-shadow:none}' +
      '.pz-wb-drawer.docked .pz-wb-d-search .pz-wb-d-tab.pz-wb-d-colbtn{height:34px;padding:0 11px}' +
      '.pz-wb-d-search .pz-wb-d-colbtn svg{width:15px;height:15px;flex:none}' +
      '.pz-wb-drawer .pz-wb-d-search .pz-wb-d-tab.pz-wb-d-colbtn.on{background:#ffba00;border-color:#ffba00;color:#111}' +
      '.pz-wb-drawer .pz-wb-d-search .pz-wb-d-tab.pz-wb-d-colbtn.on svg rect{fill:#111}' +
      '.pz-wb-d-search .pz-wb-d-colbtn[hidden]{display:none}';
    document.head.appendChild(st);
    var fl = document.createElement('link');
    fl.rel = 'stylesheet';
    fl.href = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@800&display=swap';
    document.head.appendChild(fl);
  }
  function renderCols(grid) {
    colCss();
    grid.innerHTML = '';
    firstCards(grid);
    var list = colsFor();
    if (!list) {
      var m = document.createElement('div');
      m.className = 'pz-wb-d-msg';
      m.textContent = 'Loading collections\u2026';
      grid.appendChild(m);
      return;
    }
    list.forEach(function (c) {
      if (c.cover) {
        var cv = document.createElement('button');
        cv.type = 'button';
        cv.className = 'pz-wb-d-col pz-cov';
        cv.style.setProperty('--pzc', c.color || '#ffba00');
        cv.setAttribute('aria-label', c.label);
        cv.innerHTML = '<span class="pz-cov-disc"></span><img class="pz-cov-art" alt="" loading="lazy" decoding="async"><span class="pz-cov-lab"></span><span class="pz-cov-arr">&rarr;</span>';
        cv.querySelector('img').src = c.cover;
        cv.querySelector('.pz-cov-lab').innerHTML = String(c.label).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(' &amp; ', ' &amp;<br>');
        cv.addEventListener('click', function () { chooseCol(c); });
        grid.appendChild(cv);
        return;
      }
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-wb-d-col';
      /* the image sits in a padding-top square: Chrome sizes grid rows from
         the item's intrinsic height, and an aspect-ratio image contributes
         nothing to that, which collapsed the rows to the caption height */
      var box = document.createElement('span');
      box.className = 'pz-wb-d-colimg';
      var im = document.createElement('img');
      im.loading = 'lazy';
      im.alt = c.label;
      if (c.img) im.src = thumb(c.img, 400); else lazyColImage(c, im);
      box.appendChild(im);
      var cap = document.createElement('span');
      cap.className = 'pz-wb-d-colcap';
      cap.textContent = c.label;
      b.appendChild(box);
      b.appendChild(cap);
      b.addEventListener('click', function () { chooseCol(c); });
      grid.appendChild(b);
    });
  }

  function openDrawer(slotIdx) {
    activeSlot = slotIdx;
    buildDrawer();
    if (CUSTOM) {
      /* no catalogue on this product: a tap on a spot goes straight to the
         phone's photo picker, then into the crop editor */
      drawer.querySelector('.pz-wb-d-up input[type="file"]').click();
      return;
    }
    /* a tap during the 190ms exit fade: finish that teardown first, then open
       clean - never an empty dock */
    if (closeTimer) finishClose({ to: 'none' });
    clearTimeout(holdTimer); holdTimer = null;
    resetSheetStyles();
    drawer.classList.add('show');
    /* .docked carries the sheet's split layout (full height, wall band, 44px
       head...) and lives until finishClose(), so the 190ms exit fade plays on
       the SAME layout the shopper was looking at. html.pz-wb-split is the JS
       contract (isSplitOn / stageWall / jumpToSlot-vs-openDrawer) and still
       comes off synchronously in closeDrawer(). */
    drawer.classList.add('docked');
    /* Arjun 07-09 ("ellame single window-la"): the sheet must not hide the wall.
       Arjun 08-09: ONE surface. The sheet owns the whole screen and the real
       wall is docked INSIDE it, as the band under the head (flex column: head,
       wall, progress, tabs, search, grid). Nothing floats, nothing can cover
       the Done button, and the sheet slides up with the wall already in it -
       one motion. sizeDock() needs the sheet laid out, hence after .show. */
    document.documentElement.classList.add('pz-wb-split');
    state.wallZoom = false;   /* the board always opens fitted - a zoom left on from the page wall clipped the layout (Arjun 08-09) */
    render();          /* re-draw as the plain picking board (Arjun 08-09) - render() ends with stageWall() */
    document.documentElement.classList.add('pz-wb-lock');
    var slot = state.slots[slotIdx];
    var wasTabs = drawerTabs;
    drawerTabs = tabsFor(slot.size);
    var switched = drawerTabs !== wasTabs;
    /* a ?col= / Collections tab (DYN) survives the switch only into the kind of spot it was built for (28-09 preview
       test: a 5-piece Cars tab carried into the 3-piece spot and its 5-piece set was pickable there) */
    if ((switched && !DYN[drawerTab]) || !tabFits(drawerTab)) drawerTab = firstTabKey();
    /* Arjun 04-09: open straight on the poster grid (All Posters, or the tab
       last used); the Collections chip above is there when they want a theme */
    drawerView = 'grid';
    loadCols();
    renderTabButtons();
    updateDrawerHead();
    var tab = tabFor(drawerTab) || drawerTabs[0];
    if (tab.handles.length || tab.asset) loadTab(tab);
    renderDrawerGrid();
    /* measure the band only now, with the tab rail and the head rendered
       (an empty rail measures ~10px, not ~40px) - same task as .show, so
       there is no paint in between and no visible jump */
    sizeDock();
    markCur();
    /* first open: the snippet's MutationObserver injects the Pinterest row as
       a microtask queued when buildDrawer appended the drawer, i.e. it runs
       before this one - re-measure with that 40px row in, still pre-paint */
    Promise.resolve().then(function () {
      if (drawer.classList.contains('show') && isSplitOn()) { sizeDock(); markCur(); }
    });
  }

  /* Arjun 09-09: the paste row shows a how-to guide INSTEAD of the poster grid
     (snippet renders it); any other tab / Collections puts the grid back.
     Arjun 09-11: the "Paste link" chip left the rail (the paste tile is first in every
     category) - the tile and the snippet (back from Pinterest) open the row here */
  function closePinRow() {
    var row = drawer && drawer.querySelector('.pz-wb-pin');
    if (!row || !row.classList.contains('open')) return;
    row.classList.remove('open');
    sizeDock();
  }
  function openPinRow() {
    var row = drawer && drawer.querySelector('.pz-wb-pin');
    if (!row || row.classList.contains('open')) return;
    row.classList.add('open');
    sizeDock();
  }
  window.pzWbOpenPin = openPinRow;
  function renderTabButtons() {
    colCss();
    var tabsBox = drawer.querySelector('.pz-wb-d-tabs');
    if (drawerTabs === FIVE_TABS && drawerView === 'cols') drawerView = 'grid';   /* 29-09: no Collections page in the 5-piece drawer */
    tabsBox.innerHTML = '';
    var browse = document.createElement('button');
    browse.type = 'button';
    browse.className = 'pz-wb-d-tab browse';
    browse.setAttribute('data-tab', '__cols');
    browse.innerHTML = '&#9638; Collections';
    browse.addEventListener('click', function () {
      closePinRow();
      drawerView = 'cols';
      loadCols();
      renderTabButtons();
      renderDrawerGrid();
    });
    var list = drawerTabs.slice();
    /* 16-10 (Arjun): All Posters first - it is the grid the picker opens on - then Music, Cars ... */
    if (drawerTabs === TABS) list.sort(function (a, b) { return (b.key === 'all') - (a.key === 'all'); });
    /* Arjun 23-09: in the 3-piece drawer every split collection is its own chip in the
       rail, like the single-poster categories - no separate Collections page to open */
    var splitRail = drawerTabs === SPLIT_TABS;
    if (splitRail && COLS && COLS.splits) {
      COLS.splits.forEach(function (c) {
        if (c.tab || !(c.handle || c.handles)) return;      /* Best Sellers / Anime Splits are already chips */
        var ck = 'c:' + (c.key || c.handle);                /* 16-10: merged collections (handles[]) carry their own key */
        if (!DYN[ck]) DYN[ck] = colTab(c, 3);
        list.push(DYN[ck]);
      });
    }
    if (DYN[drawerTab] && list.indexOf(DYN[drawerTab]) < 0 && tabFits(drawerTab)) list.unshift(DYN[drawerTab]);
    /* 16-10 later (Arjun, option 3): Collections is a button beside the search box, so the chip row is all categories.
       It keeps the chip's class + data-tab, so the on-state and the Pinterest guide's chip logic treat it as before. */
    var srow = drawer.querySelector('.pz-wb-d-search'), cb = srow && srow.querySelector('.pz-wb-d-colbtn');
    if (srow && !cb) {
      cb = document.createElement('button');
      cb.type = 'button';
      cb.className = 'pz-wb-d-tab browse pz-wb-d-colbtn';
      cb.setAttribute('data-tab', '__cols');
      cb.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="8" height="8" rx="2" fill="#ffba00"/><rect x="13" y="3" width="8" height="8" rx="2" fill="#ffba00"/><rect x="3" y="13" width="8" height="8" rx="2" fill="#ffba00"/><rect x="13" y="13" width="8" height="8" rx="2" fill="#ffba00"/></svg>Collections';
      cb.addEventListener('click', function () {
        closePinRow();
        drawerView = 'cols';
        loadCols();
        renderTabButtons();
        renderDrawerGrid();
      });
      srow.appendChild(cb);
    }
    if (cb) { cb.hidden = splitRail || drawerTabs === FIVE_TABS; cb.classList.toggle('on', drawerView === 'cols'); }
    list.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-wb-d-tab';
      b.textContent = t.label;
      b.setAttribute('data-tab', t.key);
      b.addEventListener('click', function () {
        closePinRow();
        drawerTab = t.key;
        drawerShown = 120;
        drawerView = 'grid';
        colsSeen = true;
        if (t.handles.length || t.asset) loadTab(t);
        renderTabButtons();
        renderDrawerGrid();
      });
      tabsBox.appendChild(b);
    });
    /* Arjun 29-09: no Collections chip in the 5-piece drawer either - its collection tiles show 3-piece covers and
       most open to "No posters found" (only a few 5-piece sets exist). 5-Piece Sets + search only; a ?col= tab
       built for a 5-piece spot (DYN, above) still shows. */
    /* (16-10: the Collections chip now leads the row - appended above; still not in the split / 5-piece drawers) */
  }
  /* closeDrawer: state synchronously, visuals deferred. The lock/split classes
     come off and the page wall is rebuilt BEFORE this returns, so callers can
     scroll to the rail / upsell right away; the sheet itself fades out over
     190ms with the wall still docked inside it, then finishClose() tears down.
     opts.to = 'none' skips the 600ms tween to the page wall (callers that set
     their own scroll position); opts.swipe = the sheet is already dragged down
     by the finger, so no CSS exit animation - just fade the backdrop. */
  function closeDrawer(opts) {
    opts = opts || {};
    clearTimeout(holdTimer); holdTimer = null;
    if (!drawer || closeTimer) return;
    if (!drawer.classList.contains('show')) { activeSlot = -1; return; }
    var wasSplit = isSplitOn();
    var sheet = drawer.querySelector('.pz-wb-d-sheet');
    var back = drawer.querySelector('.pz-wb-d-back');
    document.documentElement.classList.remove('pz-wb-lock');
    document.documentElement.classList.remove('pz-wb-split');
    activeSlot = -1;
    if (sheet) sheet.classList.remove('kb');
    if (wasSplit && !reduceMotion) {
      /* set the timer BEFORE render(): stageWall() must leave the docked wall
         alone while the exit plays (the closeTimer guard) */
      drawer.classList.add(opts.swipe ? 'swiped' : 'closing');
      if (opts.swipe && back) { back.style.transition = 'opacity .18s ease'; back.style.opacity = '0'; }
      closeTimer = setTimeout(function () { finishClose(opts); }, 190);
      render();
    } else {
      if (wasSplit) render();
      finishClose(opts);
    }
  }
  /* clear whatever the swipe / exit left inline on the sheet and backdrop */
  function resetSheetStyles() {
    if (!drawer) return;
    var sheet = drawer.querySelector('.pz-wb-d-sheet'), back = drawer.querySelector('.pz-wb-d-back');
    if (sheet) { sheet.style.transform = ''; sheet.style.transition = ''; sheet.style.opacity = ''; }
    if (back) { back.style.opacity = ''; back.style.transition = ''; }
  }
  function finishClose(opts) {
    opts = opts || {};
    clearTimeout(closeTimer);
    closeTimer = null;
    if (!drawer) return;
    drawer.classList.remove('show');
    drawer.classList.remove('closing');
    drawer.classList.remove('swiped');
    drawer.classList.remove('docked');
    var sheet = drawer.querySelector('.pz-wb-d-sheet');
    if (sheet) { sheet.classList.remove('done'); sheet.classList.remove('kb'); sheet.classList.remove('kbanim'); }
    resetSheetStyles();
    var dock = drawer.querySelector('.pz-wb-d-wall');
    if (dock) { dock.innerHTML = ''; dock.classList.remove('photo', 'scrolls', 'at-end'); }
    if (opts.to !== 'none') {
      pzScrollTo(function () { return root.querySelector('.pz-wb-wallwrap'); }, 90);
    }
  }

  function buildDrawer() {
    if (drawer) return;
    drawer = document.createElement('div');
    drawer.className = 'pz-wb-drawer';
    drawer.innerHTML =
      '<div class="pz-wb-d-back"></div>' +
      '<div class="pz-wb-d-sheet">' +
        '<div class="pz-wb-d-grab" aria-hidden="true"></div>' +
        '<div class="pz-wb-d-head">' +
          '<span class="pz-wb-d-title"></span>' +
          '<button type="button" class="pz-wb-d-pack">Change pack</button>' +
          '<button type="button" class="pz-wb-d-x" aria-label="Done, back to wall">Done</button>' +
        '</div>' +
        '<div class="pz-wb-d-sizes"></div>' +
        '<div class="pz-wb-d-wall"></div>' +
        '<div class="pz-wb-d-mini"><span class="pz-wb-d-prog"></span></div>' +
        '<div class="pz-wb-d-tabs"></div>' +
        '<div class="pz-wb-d-search"><input type="search" placeholder="Search posters…"></div>' +
        '<div class="pz-wb-d-grid"></div>' +
        '<div class="pz-wb-d-up" hidden>' +
          '<p>Print your own photo in this spot — it will be fitted to a perfect ' + '' + 'poster crop.</p>' +
          '<button type="button" class="pz-wb-d-upbtn">Choose photo</button>' +
          '<input type="file" accept="image/jpeg,image/png,image/webp" hidden>' +
          '<p class="pz-wb-d-upnote">JPG, PNG or WEBP · use original photos, not WhatsApp-compressed copies</p>' +
        '</div>' +
      '</div>';
    document.body.appendChild(drawer);
    /* any row added to / removed from the sheet column (the snippet's
       Pinterest row, future chrome) re-shares the band vs the grid */
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (drawer.classList.contains('show') && isSplitOn()) { sizeDock(); markCur(); }
      }).observe(drawer.querySelector('.pz-wb-d-sheet'), { childList: true });
    }
    /* an own-photo flow started from the Pinterest row (snippet-owned, so it
       cannot reach holdTimer): the last-pick hold must not close the sheet
       under the fetch / crop editor */
    ['focusin', 'click', 'paste'].forEach(function (ev) {
      drawer.addEventListener(ev, function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.pz-wb-pin')) cancelHold();
      }, true);
    });

    drawer.querySelector('.pz-wb-d-x').addEventListener('click', function () {
      closeDrawer();
      /* editing a cart wall: OK on a full wall saves it straight back to the cart */
      if (EDIT && EDIT.item && state.slots.length && filledCount() === state.slots.length) submitWall();
    });
    drawer.querySelector('.pz-wb-d-pack').addEventListener('click', function () {
      closeDrawer({ to: 'none' });
      if (!CUSTOM) { showGallery(); return; }   /* back to the layout / pack gallery (Arjun 09-10) */
      var rail = root.querySelector('.pz-wb-sizes');
      if (rail) window.scrollTo(0, rail.getBoundingClientRect().top + window.pageYOffset - 120);
    });
    /* every exit ends in the same state: Done, backdrop, Escape, swipe-down */
    drawer.querySelector('.pz-wb-d-back').addEventListener('click', function () { closeDrawer(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('show') && !(ed && ed.open)) closeDrawer();
    });
    var sheetEl = drawer.querySelector('.pz-wb-d-sheet');
    var backEl = drawer.querySelector('.pz-wb-d-back');
    /* iOS ignores overflow:hidden for touch: swallow every touch-scroll that is
       not inside the grid / tabs / an input, so the page never moves under the
       sheet. The grid is the only vertical scroller (overscroll-behavior:contain). */
    drawer.addEventListener('touchmove', function (e) {
      var t = e.target;
      if (!t || !t.closest) { e.preventDefault(); return; }
      if (t.closest('.pz-wb-d-grid, .pz-wb-d-tabs, .pz-wb-d-up')) return;
      /* only the input being edited may pan (sideways, to reach long text -
         its row is touch-action:pan-x); a drag that merely STARTS on a field
         must not scroll the page under the sheet */
      if (t === document.activeElement && /^(INPUT|TEXTAREA)$/i.test(t.tagName || '')) return;
      /* dense photo rooms overflow the band on purpose (wall-width floor) and
         scroll inside the dock; anything that does not overflow is swallowed */
      var ww = t.closest('.pz-wb-d-wall .pz-wb-wallwrap');
      if (ww && (ww.scrollHeight > ww.clientHeight + 1 || ww.scrollWidth > ww.clientWidth + 1)) return; /* zoomed plain boards overflow sideways too (Arjun 09-09) */
      e.preventDefault();
    }, { passive: false });
    /* swipe-down on the grab handle / head closes; the sheet follows the finger */
    var swY = null, swT = 0, swDy = 0;
    function swipeStart(e) {
      if (!drawer.classList.contains('show') || closeTimer || !e.target.closest || e.target.closest('button')) { swY = null; return; }
      swY = e.touches[0].clientY; swT = Date.now(); swDy = 0;
    }
    function swipeMove(e) {
      if (swY === null) return;
      var dy = e.touches[0].clientY - swY;
      if (dy <= 0) return;
      swDy = dy;
      e.preventDefault();
      sheetEl.style.transition = 'none';
      sheetEl.style.transform = 'translateY(' + dy + 'px)';
      backEl.style.opacity = String(Math.max(.2, 1 - dy / 400));
    }
    function swipeEnd() {
      if (swY === null) return;
      var dy = swDy, dt = Math.max(1, Date.now() - swT);
      swY = null;
      if (dy <= 6 || closeTimer || !drawer.classList.contains('show')) { resetSheetStyles(); return; } /* a tap, not a drag */
      if (dy > 90 || (dy > 30 && dy / dt > .6)) {
        /* keep sliding the way the finger went, then tear down */
        sheetEl.style.transition = 'transform .18s ease, opacity .18s ease';
        sheetEl.style.transform = 'translateY(' + Math.round(dy + 80) + 'px)';
        sheetEl.style.opacity = '0';
        closeDrawer({ swipe: true });
      } else {
        sheetEl.style.transition = 'transform .2s ease';
        sheetEl.style.transform = '';
        backEl.style.opacity = '';
        setTimeout(function () { sheetEl.style.transition = ''; }, 220);
      }
    }
    [].forEach.call(drawer.querySelectorAll('.pz-wb-d-grab, .pz-wb-d-head'), function (h) {
      h.addEventListener('touchstart', swipeStart, { passive: true });
      h.addEventListener('touchmove', swipeMove, { passive: false });
      h.addEventListener('touchend', swipeEnd);
      h.addEventListener('touchcancel', swipeEnd);
    });
    /* keyboard up (search / Pinterest): shrink the wall band so ~2 rows of
       results survive the pushed-up viewport */
    var kbT = null, vv = window.visualViewport || null, vvBase = 0;
    function kbInputFocused() {
      var a = document.activeElement;
      return !!(a && a.closest && drawer.contains(a) && a.closest('.pz-wb-d-search, .pz-wb-pin'));
    }
    /* desktop / hardware-keyboard devices never get a soft keyboard: a click
       into the search box must not collapse the wall band there */
    function softKbPlausible() {
      return window.innerWidth < 750 && !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    }
    var kbAnimT = null;
    function setKb(on) {
      if (sheetEl.classList.contains('kb') === on) return;
      /* .kbanim: the band's height tween runs ONLY for the keyboard toggle -
         never on open (fallback 220px -> sized band) or on rotation */
      sheetEl.classList.add('kbanim');
      clearTimeout(kbAnimT);
      kbAnimT = setTimeout(function () { sheetEl.classList.remove('kbanim'); markCur(); dockScrollCue(); }, 300); /* band settled: re-centre the ring, refresh the fade */
      sheetEl.classList.toggle('kb', on);
      sizeDock(); /* the band height (--pz-wall-h) is owned by sizeDock, incl. the 120px keyboard cap */
    }
    function kbCheck() {
      if (!drawer.classList.contains('show') || !kbInputFocused() || !softKbPlausible()) { setKb(false); return; }
      /* with visualViewport the keyboard is CONFIRMED by the viewport shrinking
         (>120px vs the keyboard-down height); iOS keeps innerHeight, Android
         shrinks both, so the baseline is the last height seen with no field
         focused. Without visualViewport, fall back to focus alone. */
      if (vv && vvBase) setKb(vv.height < vvBase - 120);
      else setKb(true);
    }
    if (vv) {
      vvBase = vv.height;
      vv.addEventListener('resize', function () {
        if (!kbInputFocused()) vvBase = vv.height;
        if (drawer.classList.contains('show')) kbCheck();
      });
    }
    drawer.addEventListener('focusin', function (e) {
      if (!e.target.closest || !e.target.closest('.pz-wb-d-search, .pz-wb-pin')) return;
      clearTimeout(kbT);
      if (vv && !sheetEl.classList.contains('kb')) vvBase = Math.max(vvBase, vv.height);
      kbCheck();
    });
    drawer.addEventListener('focusout', function () {
      clearTimeout(kbT);
      kbT = setTimeout(kbCheck, 60);
    });
    drawer.querySelector('.pz-wb-d-search input').addEventListener('focus', function () { loadSearchTags(function () { if (drawerQ) renderDrawerGrid(); }); });
    drawer.querySelector('.pz-wb-d-search input').addEventListener('input', function (e) {
      loadSearchTags(function () { if (drawerQ) renderDrawerGrid(); });
      drawerQ = e.target.value.toLowerCase();
      drawerShown = 120;
      /* typing searches the whole catalogue, whatever is on screen */
      if (drawerQ) {
        if (drawerView === 'cols') { drawerView = 'grid'; colsSeen = true; renderTabButtons(); }
        loadTab(drawerTabs[0]);
        kickRemoteSearch(drawerQ);
      }
      renderDrawerGrid();
    });
    /* the full catalog is ~1,600 posters — render 120 at a time and append
       the next batch as the shopper nears the bottom of the grid */
    var gridEl = drawer.querySelector('.pz-wb-d-grid');
    /* 1px off either end so iOS never hands the scroll to the page */
    gridEl.addEventListener('touchstart', function () {
      if (gridEl.scrollTop <= 0) gridEl.scrollTop = 1;
      else if (gridEl.scrollTop + gridEl.clientHeight >= gridEl.scrollHeight) gridEl.scrollTop -= 1;
    }, { passive: true });
    gridEl.addEventListener('scroll', function () {
      if (gridEl.scrollTop + gridEl.clientHeight < gridEl.scrollHeight - 600) return;
      var c = catalog[drawerTab];
      if (!c || drawerShown >= c.items.length) return;
      drawerShown += 120;
      var st = gridEl.scrollTop;
      renderDrawerGrid();
      gridEl.scrollTop = st;
    });
    var upBtn = drawer.querySelector('.pz-wb-d-upbtn');
    var upInput = drawer.querySelector('.pz-wb-d-up input[type="file"]');
    upBtn.addEventListener('click', function () { cancelHold(); upInput.click(); });
    upInput.addEventListener('change', function () {
      cancelHold(); /* covers the snippet's Pinterest DataTransfer path too */
      if (upInput.files && upInput.files[0]) openEditor(upInput.files[0]);
      upInput.value = '';
    });
  }

  /* Arjun 09-10: a "Paste image link" tile sits first in EVERY category and in the
     Collections view, next to the upload tile - it opens the paste guide/row (the
     crop editor then takes the pasted picture). Not on the custom-photo product.
     Arjun 09-11: the empty space holds a small demo - a link bar types a pin link and
     a poster from the tab being browsed pops out of it (fillSourceDemo) */
  function pinterestCard() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pz-wb-d-card pz-wb-d-pincard';
    b.innerHTML =
      '<span class="pz-wb-d-badge">New</span>' +
      '<span class="pz-src-demo" aria-hidden="true">' +
        '<span class="bar">' + (window.PZ_LINK_ICONS || window.PZ_PIN_ICON || '') + '<span class="url"><span>pin.it/art</span></span></span>' +
        '<span class="pop"><img alt=""><img alt=""><img alt=""></span>' +
      '</span>' +
      '<span class="pz-wb-d-ct"><b>Paste image link</b>' +
      '<i>Pinterest, Google &amp; more</i></span>';
    b.addEventListener('click', function () {
      cancelHold();
      openPinRow();
      var sheet = drawer.querySelector('.pz-wb-d-sheet');
      if (sheet) sheet.scrollTop = 0;
      try { if (window.gtag) gtag('event', 'pinterest_tile', { product: 'wall_builder' }); } catch (e) {}
    });
    return b;
  }
  /* Arjun 09-10: the two source tiles share one full-width first row (2-up,
     short), then the catalogue starts on the next row */
  /* Arjun 18-09 (iPhone recording): every pick re-ran renderDrawerGrid() and built the whole grid again - up to 120
     tiles with new <img>s, plus these two. On iPhone Safari a new image paints blank until it is decoded, so the grid
     went grey and came back on every tap, and the tap itself felt late. Tiles are built once and reused. */
  var firstRowCache = null, tilePool = {}, tilePoolN = 0;
  function firstCards(grid) {
    if (firstRowCache) { grid.appendChild(firstRowCache); return; }
    var row = document.createElement('div');
    row.className = 'pz-wb-d-first';
    if (!CUSTOM) row.appendChild(pinterestCard());
    row.appendChild(uploadCard());
    grid.appendChild(row);
    firstRowCache = row;
    setTimeout(function () { fillSourceDemo(row, grid); }, 0);   /* the tab's posters are in the grid by then */
  }
  /* the paste demo shows three posters of the tab being browsed (already loading below it) */
  function fillSourceDemo(row, grid) {
    var demo = row.querySelector('.pz-src-demo');
    if (!demo) return;
    var srcs = [].slice.call(grid.querySelectorAll('.pz-wb-d-card:not(.pz-wb-d-pincard):not(.pz-wb-d-upcard) img'))
      .map(function (im) { return im.getAttribute('src'); }).filter(Boolean).slice(0, 3);
    if (!srcs.length) return;
    var imgs = demo.querySelectorAll('.pop img');
    for (var i = 0; i < imgs.length; i++) imgs[i].src = srcs[i % srcs.length];
    demo.classList.add('has-img');
  }

  function uploadCard() {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pz-wb-d-card pz-wb-d-upcard';
    b.innerHTML =
      '<span class="pz-wb-upic" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' +
          '<path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h2L8 5h8l1.5 2h2A1.5 1.5 0 0 1 21 8.5v10A1.5 1.5 0 0 1 19.5 20h-15A1.5 1.5 0 0 1 3 18.5z"/>' +
          '<circle cx="12" cy="13" r="3.4"/>' +
        '</svg>' +
      '</span>' +
      '<span class="pz-up-demo" aria-hidden="true"><span></span><span></span><span></span></span>' +
      '<span class="pz-wb-d-ct"><b>Upload your image</b>' +
      '<i>From your gallery</i></span>';
    b.addEventListener('click', function () {
      cancelHold(); /* the file picker / crop editor outlasts the 500ms last-pick hold */
      var inp = drawer.querySelector('.pz-wb-d-up input[type="file"]');
      if (inp) inp.click();
    });
    return b;
  }

  var fillBusy = false;
  function readyThemes() {
    return TABS.filter(function (t) { return t.handles.length || t.asset; });
  }
  /* the pool 'Fill the rest' draws from: the tab the shopper is browsing when
     it is a loadable singles catalogue (built-in or a Collections tab), else
     the first ready theme (All Posters / Best Sellers) */
  function fillTheme() {
    var cur = tabFor(drawerTab);
    if (cur && !isSplitTabs(drawerTabs) && drawerView !== 'cols' && (cur.handles.length || cur.asset)) return cur;
    return readyThemes()[0] || null;
  }
  function splitPool(size) {
    var tabs = size && panelsOf(size).c === 5 ? FIVE_TABS : SPLIT_TABS;
    for (var i = 0; i < tabs.length; i++) {
      var c = catalog[tabs[i].key];
      if (c && c.items.length) return c;
    }
    return null;
  }
  /* single posters from the first poster tab that has loaded (never a split / set tab) */
  function singlesPool(wantLand) {
    for (var i = 0; i < TABS.length; i++) {
      var c = catalog[TABS[i].key];
      var its = c && c.items ? c.items.filter(function (it) { return !!it.landscape === !!wantLand && fitsSlot(it.rawTitle || it.title, 'A4'); }) : [];
      if (its.length) return its;
    }
    return [];
  }
  /* 01-10: no set / split design may sit in a single-poster spot, whichever way it got there (an older saved wall,
     a ready-made pack, a fill). Returns how many spots were emptied. */
  function dropMisfits() {
    if (PHOTO) return 0;
    var n = 0;
    state.slots.forEach(function (sl) {
      if (sl.sel && sl.sel.type === 'catalog' && !fitsSlot(sl.sel.title, sl.size, sl.sel.flat || (sl.sel.img && !/cdn\.shopify\.com|\/cdn\/shop\//.test(sl.sel.img)))) { sl.sel = null; n++; }   /* 03-10: split spots too */
      else if (sl.sel && sl.sel.type === 'catalog' && !isSplit(sl.size) && !isLandscape(sl.size) && isLandscapeTitle(sl.sel.title)) { sl.sel = null; n++; }   /* 14-10: landscape design in a portrait spot */
    });
    return n;
  }
  function poolsReady(tab) {
    var c = catalog[tab.key];
    if (!c || !c.items.length) return false;
    /* every split slot needs its own pool ready (3-piece sets, 5-piece sets) */
    return state.slots.every(function (s) { return !isSplit(s.size) || !!splitPool(s.size); });
  }
  /* the docked picker follows the wall: head, gold track, ticks, Done label */
  function refreshPicker() {
    if (!(isSplitOn() && drawer && drawer.classList.contains('show'))) return;
    var g = drawer.querySelector('.pz-wb-d-grid'), st = g ? g.scrollTop : 0;
    renderDrawerGrid();
    g = drawer.querySelector('.pz-wb-d-grid');
    if (g) g.scrollTop = st;
    updateDrawerHead();
    markCur();
  }
  /* land = true from the drawer's 'Fill the rest' (the sheet closed with
     to:'none', so land on the upsell card like the last catalog pick does);
     the page-level chips are already on screen and keep their position */
  function applyFill(tab, land) {
    var c = catalog[tab.key] || { items: [] };
    var port = c.items.filter(function (i) { return !i.landscape; });
    var land = c.items.filter(function (i) { return i.landscape; });
    var pi = 0, li = 0, si = 0, filled = 0;
    state.slots.forEach(function (sl) {
      if (sl.sel) return;
      var pool = isSplit(sl.size) ? (splitPool(sl.size) || { items: [] }).items : isLandscape(sl.size) ? land : port;
      /* Arjun 01-10 "single poster-la split designs yethuvum kaata kodathu" (#315856: a "3 Piece Set" in an A5 spot, the
         floor printed 3 panels for 1 poster): a single spot is filled only with single posters. "Fill the rest" pressed
         in a split drawer passes a split tab - its sets are dropped here and the singles come from a poster tab. */
      pool = pool.filter(function (i) { return fitsSlot(i.rawTitle || i.title, sl.size, i.flat); });   /* 03-10: every spot */
      if (!isSplit(sl.size) && !pool.length) pool = singlesPool(isLandscape(sl.size));
      /* Arjun 30-09: the Duo's big A2 spot showed a product photo with a room mockup in it - fill it only from flat
         design files (this tab's, else any loaded tab's); product photos stay for the small sheets */
      if (sl.size === 'H2A3' || sl.size === 'H6A3') {   /* 14-10: Showcase hero too */
        var flatP = port.filter(function (i) { return isFlatSel(i); });   /* 15-10: the team's flat files count as flat art here */
        if (!flatP.length) TABS.some(function (tb) { flatP = ((catalog[tb.key] || {}).items || []).filter(function (i) { return isFlatSel(i) && !i.landscape; }); return flatP.length; });   /* poster tabs only - never a split tab's sets (01-10) */
        flatP = flatP.filter(function (i) { return fitsSlot(i.rawTitle || i.title, sl.size); });
        if (flatP.length) pool = flatP;
      }
      if (!pool.length) return;
      var it = isSplit(sl.size) ? pool[si++ % pool.length]
             : isLandscape(sl.size) ? pool[li++ % pool.length]
             : pool[pi++ % pool.length];
      sl.sel = { type: 'catalog', title: it.title, img: it.img, handle: it.handle, flat: !!it.flat };
      filled++;
    });
    if (filled) pzTrack('fill');
    save(); render();
    /* the fill resolved while the picker is (re)open: keep its head / track /
       ticks in step with the wall it is docked around */
    refreshPicker();
    if (land && !isSplitOn()) {
      setTimeout(function () {
        var t = root.querySelector('.pz-wb-up') || root.querySelector('.pz-wb-wallwrap');
        if (t) pzScrollTo(t, 70);
      }, 60);
    }
    var left = state.slots.filter(function (sl) { return !sl.sel; }).length;
    if (!filled) toast('Every spot is already filled — tap a poster to swap it.');
    else if (left) toast(left + ' spot' + (left > 1 ? 's' : '') + ' left — ' + tab.label +
      ' has no landscape designs for those. Pick them from another category or use your own photo.');
  }
  function fillWith(tab, land) {
    if (fillBusy) return;
    if (!state.slots.some(function (sl) { return !sl.sel; })) {
      toast('Every spot is already filled — tap a poster to swap it.');
      return;
    }
    fillBusy = true;
    render();
    loadTab(tab);
    if (state.slots.some(function (sl) { return isSplit(sl.size) && panelsOf(sl.size).c !== 5; })) loadTab(SPLIT_TABS[0]);
    if (state.slots.some(function (sl) { return isSplit(sl.size) && panelsOf(sl.size).c === 5; })) loadTab(FIVE_TABS[0]);
    var tries = 0;
    (function wait() {
      if (poolsReady(tab)) { fillBusy = false; applyFill(tab, land); return; }
      if (++tries > 40) {
        fillBusy = false; render(); refreshPicker();
        if (land && !isSplitOn()) pzScrollTo(function () { return root.querySelector('.pz-wb-wallwrap'); }, 90);
        toast('Could not load those posters — please try again.');
        return;
      }
      setTimeout(wait, 250);
    })();
  }
  function clearWall() {
    if (PHOTO) {
      /* the photos kept past the pack go too, and their uploads stop. 28-09 preview test: 20-50 uploaded photos are
         minutes of work - Clear all can be undone for a few seconds */
      var snap = state.slots.map(function (sl) { return sl.sel; }), more = (state.more || []).slice(), size = state.size;
      var n = photoAll().filter(Boolean).length;
      var kept = new Map();   /* round 2: the files being sent (editor crops) - Undo re-sends them, not a fresh automatic cut */
      photoAll().forEach(function (x) { var j = x && PH.jobs.get(x); if (j && j.out) kept.set(x, j.out); });
      photoClearAll();
      save(); render();
      if (n) phActToast(n === 1 ? '1 photo removed' : n + ' photos removed', 'Undo', function () {
        if (state.size !== size || photoAll().some(Boolean)) return;   /* new photos went in meanwhile: leave them */
        snap.forEach(function (sel, i) { if (state.slots[i]) state.slots[i].sel = sel; });
        state.more = more;
        var rest = [];
        snap.concat(more).forEach(function (x) {
          if (x && kept.has(x) && !(x.status === 'done' && x.url)) phUpload(x, kept.get(x));
          else rest.push(x);
        });
        phRevive(rest);
        save(); render();
      }, 6000);
      return;
    }
    /* Arjun 15-10 ("remove all button veklam"): Remove all on the wall itself; a whole wall of picks can be undone for a few seconds */
    var snapW = state.slots.map(function (sl) { return sl.sel; }), sizeW = state.size, nW = snapW.filter(Boolean).length;
    state.slots.forEach(function (sl) { sl.sel = null; });
    lookHint = null;   /* 20-10: a cleared wall is the shopper's own again - no look hint */
    save(); render();
    if (nW) phActToast(nW === 1 ? '1 poster removed' : nW + ' posters removed', 'Undo', function () {
      if (state.size !== sizeW || state.slots.some(function (sl) { return sl.sel; })) return;   /* new picks went in meanwhile */
      snapW.forEach(function (sel, i) { if (state.slots[i]) state.slots[i].sel = sel; });
      save(); render();
    }, 6000);
  }
  function readyBar() {
    var bar = document.createElement('div');
    bar.className = 'pz-wb-ready';
    var lab = document.createElement('span');
    lab.className = 'pz-wb-ready-lab';
    lab.textContent = fillBusy ? 'Filling your wall…' : 'Fill it in one tap:';
    bar.appendChild(lab);
    if (PHOTO) return photoReadyBar(bar, lab);
    if (CUSTOM) {
      /* own-photo product: nothing to auto-fill; just the clear button when needed */
      lab.textContent = filledCount() ? '' : 'Tap a spot to add a photo';
      if (filledCount()) {
        var cc = document.createElement('button');
        cc.type = 'button'; cc.className = 'pz-wb-ready-chip clear'; cc.textContent = 'Clear all';
        cc.addEventListener('click', clearWall); bar.appendChild(cc);
      }
      return bar;
    }
    if (!fillBusy) {
      readyThemes().forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pz-wb-ready-chip';
        b.textContent = t.key === 'all' ? 'Best Sellers' : t.label;
        b.addEventListener('click', function () { fillWith(t); });
        bar.appendChild(b);
      });
      if (filledCount()) {
        var cl = document.createElement('button');
        cl.type = 'button';
        cl.className = 'pz-wb-ready-chip clear';
        cl.textContent = 'Clear all';
        cl.addEventListener('click', clearWall);
        bar.appendChild(cl);
      }
    }
    return bar;
  }

  /* 28-09 photo products: "3 / 5 photos added" with a progress line, "Tap a photo to adjust" once any is in, Clear all */
  function photoReadyBar(bar, lab) {
    var done = filledCount(), total = state.slots.length;
    bar.classList.add('pz-wb-ready--photo');
    var upl = state.slots.filter(function (s) { return s.sel && s.sel.status === 'uploading'; }).length;   /* photo agent 28-09 */
    var small = phSmallCount();   /* 28-09 preview test: a photo too small for this size is not "added" - never green */
    if (done && done === total && !upl && !small) bar.classList.add('full');
    lab.innerHTML = '<span class="pz-wb-ready-n"><b>' + done + '</b> / ' + total + (total === 1 ? ' photo' : ' photos') + ' added</span>' +
      '<i class="pz-wb-ready-track" style="--p:' + (total ? (done / total).toFixed(3) : 0) + '" aria-hidden="true"><i></i></i>';
    if (BULK_UP && total > 1 && done < total && !phInCart()) bar.insertBefore(phBulkButton(total, done), bar.firstChild);
    if (done) {
      var cc = document.createElement('button');
      cc.type = 'button'; cc.className = 'pz-wb-ready-chip clear'; cc.textContent = 'Clear all';
      cc.addEventListener('click', clearWall); bar.appendChild(cc);
      var hint = document.createElement('span');
      hint.className = 'pz-wb-ready-hint';
      /* 28-09 preview test: "Tap a photo to adjust" only while a photo can be adjusted (its original is in memory - not
         after a reload or on a cart edit); "In your cart" once this exact set was added */
      var canAdj = state.slots.some(function (s) { var j = s.sel && PH.jobs.get(s.sel); return !!(j && j.orig); });
      hint.textContent = upl ? 'Uploading ' + upl + (upl === 1 ? ' photo' : ' photos') + '\u2026 keep this page open'
        : phInCart() ? 'In your cart \u2713 \u00b7 tap Clear all to start a new set'
        : canAdj ? 'Tap a photo to adjust' : 'Tap \u00d7 to change a photo';
      bar.appendChild(hint);
    }
    return bar;
  }
  /* the bulk button (Retro / Mini, 08-10): opens the same multi-select picker on the first empty spot */
  function phBulkButton(total, done) {
    if (!document.getElementById('pz-wb-bulk-css')) {
      var st = document.createElement('style');
      st.id = 'pz-wb-bulk-css';
      st.textContent = '.pz-wb-bulk{all:unset;box-sizing:border-box;cursor:pointer;flex:1 1 100%;display:flex;align-items:center;gap:12px;width:100%;margin:0 0 10px;padding:13px 16px;border-radius:14px;background:#111;color:#fff;-webkit-tap-highlight-color:transparent;box-shadow:0 10px 24px -14px rgba(0,0,0,.55)}' +
        '.pz-wb-bulk:active{transform:scale(.99)}.pz-wb-bulk svg{width:26px;height:26px;flex:none;fill:none;stroke:#ffba00;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}' +
        '.pz-wb-bulk span{display:flex;flex-direction:column;gap:2px;min-width:0}.pz-wb-bulk b{font:800 15px/1.2 "Barlow",system-ui,sans-serif;letter-spacing:.01em}' +
        '.pz-wb-bulk i{font-style:normal;font-size:12.5px;line-height:1.35;color:rgba(255,255,255,.72)}.pz-wb-ready--photo{flex-wrap:wrap}';
      document.head.appendChild(st);
    }
    var left = total - done, b = document.createElement('button');
    b.type = 'button'; b.className = 'pz-wb-bulk';
    b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/></svg>' +
      '<span><b>' + (done ? 'Add the other ' + left + ' photos at once' : 'Upload all ' + total + ' photos at once') + '</b>' +
      '<i>Select them together from your gallery — we fill every spot for you</i></span>';
    b.addEventListener('click', function () { var at = phEmpties(0)[0]; photoPick(at == null ? 0 : at); });
    return b;
  }
  function renderDrawerGrid() {
    if (!drawer) return;
    var grid = drawer.querySelector('.pz-wb-d-grid');
    var up = drawer.querySelector('.pz-wb-d-up');
    var search = drawer.querySelector('.pz-wb-d-search');
    drawer.querySelectorAll('.pz-wb-d-tab').forEach(function (b) {
      var k = b.getAttribute('data-tab');
      b.classList.toggle('on', drawerView === 'cols' ? k === '__cols' : k === drawerTab);
    });

    grid.hidden = false; search.style.display = ''; up.hidden = true;
    /* Arjun 23-09: a split collection tab (Movies, Cars ...) is not in SPLIT_TABS, so its
       sets were drawn as portrait single tiles - a crop of the room mockup, the set itself
       cut off. Every tab in the split drawer is a split tab. */
    var splitTab = isSplitTabs(drawerTabs);
    grid.classList.toggle('split', splitTab);
    /* Landscape A4/A3 spots list landscape designs, so the tiles must be
       landscape too. Until 02-09 every tile was a portrait 0.707 box with
       object-fit: cover, which cropped a wide car poster down to a middle
       strip - Arjun read it as the builder turning landscape art portrait. */
    grid.classList.toggle('land', !splitTab && activeSlot > -1 && isLandscape(state.slots[activeSlot].size));
    grid.classList.toggle('cols', drawerView === 'cols');
    if (drawerView === 'cols') {
      grid.classList.remove('split'); grid.classList.remove('land');
      renderCols(grid);
      return;
    }

    var c = catalog[drawerTab];
    grid.innerHTML = '';
    if (!c || ((c.status === 'loading' || c.status === 'partial') && !c.items.length)) {
      grid.innerHTML = '<div class="pz-wb-d-msg">Loading posters…</div>';
      return;
    }
    var items = c.items;
    /* portrait slots hide landscape designs; the landscape A4 slots show ONLY them */
    if (!isSplitTabs(drawerTabs)) {
      var wantLand = activeSlot > -1 && isLandscape(state.slots[activeSlot].size);
      items = items.filter(function (i) { return !!i.landscape === wantLand; });
    }
    if (drawerQ) {
      items = searchResults(drawerQ);
      /* landscape spots still only take landscape designs */
      if (!isSplitTabs(drawerTabs) && activeSlot > -1) {
        var wl = isLandscape(state.slots[activeSlot].size);
        items = items.filter(function (i) { return !!i.landscape === wl; });
      }
    }
    /* 14-10 (Arjun): a 2xA4 + 1xA3 combo is never even shown in a split drawer (tab or search) */
    if (isSplitTabs(drawerTabs)) items = items.filter(function (i) { return !NO_SPLIT_RE.test(i.rawTitle || i.title || ''); });
    /* upload always sits in the first tile, in every category — the shopper
       never has to go looking for it */
    if (!drawerQ) firstCards(grid);
    if (!items.length) {
      var none = document.createElement('div');
      none.className = 'pz-wb-d-msg';
      var wantLand = activeSlot > -1 && !isSplit(state.slots[activeSlot].size) && isLandscape(state.slots[activeSlot].size);
      none.textContent = drawerQ
        ? 'No posters found for \u201C' + drawerQ + '\u201D.'
        : wantLand
          ? 'This is a landscape spot and this category has no landscape designs. Try another category, or upload your own photo.'
          : 'No posters found.';
      grid.appendChild(none);
      return;
    }
    /* related designs simply continue the grid after the direct hits - no
       separate 'Related to' block (Arjun 04-09) */
    if (tilePoolN > 1500) { tilePool = {}; tilePoolN = 0; }   /* a long browse across many tabs: start over rather than hold thousands of nodes */
    items.slice(0, drawerShown).forEach(function (it) {
      /* one tile per design (and per tile shape), built once - see firstCards() above */
      var tkey = (splitTab ? 's|' : 'p|') + (it.id || it.handle || it.img);
      var card = tilePool[tkey];
      if (!card) {
        card = document.createElement('button');
        card.type = 'button';
        card.className = 'pz-wb-d-card';
        /* Arjun 06-09: the picker shows the DESIGN, not the room - catalog
           mockups are zoom-cropped to the poster (same crop as the wall spot),
           flat art is left alone; one short line of title; 4 to a row */
        var imw = document.createElement('span');
        imw.className = 'pz-wb-d-im';
        var im = document.createElement('img');
        im.loading = 'lazy';
        im.src = it.t || thumb(it.img, 320);   /* floor-published designs carry a 320 px WebP (09-10) */
        im.alt = it.title;
        imw.appendChild(im);
        if (isFlatSel(it)) card.classList.add('flat');
        var cap = document.createElement('span');
        cap.className = 'cap';
        cap.textContent = String(it.title || '').split('|')[0].trim();
        card.appendChild(imw);
        card.appendChild(cap);
        card.addEventListener('click', function () {
          pickCatalog(it);
        });
        tilePool[tkey] = card; tilePoolN++;
      }
      /* Arjun 04-09: a chosen design must read as chosen in the grid, not only
         in the counter - tick + how many spots it fills. The tick is the only part that changes between renders. */
      var oldPk = card.querySelector('.pz-wb-d-pick');
      if (oldPk) card.removeChild(oldPk);
      var used = pickedCount(it);
      card.classList.toggle('picked', !!used);
      if (used) {
        var pk = document.createElement('i');
        pk.className = 'pz-wb-d-pick';
        pk.textContent = used > 1 ? '\u2713 ' + used : '\u2713';
        card.insertBefore(pk, card.firstChild);
      }
      grid.appendChild(card);
    });
    if (items.length > drawerShown || c.status === 'partial') {
      var more = document.createElement('div');
      more.className = 'pz-wb-d-msg';
      more.textContent = c.status === 'partial'
        ? 'Loading more posters… search covers everything once loaded.'
        : 'Showing ' + Math.min(drawerShown, items.length) + ' of ' + items.length + ' — scroll for more, or search.';
      grid.appendChild(more);
    }
  }

  /* 28-09 preview test: the last line of defence for the floor, whatever tab or search the design came from - a 5-piece
     spot takes only a 5-piece set (a "3 Piece Set" there was #313711), a 3-piece spot never a 5-piece set, a single
     poster spot never a set */
  /* 03-10 (#318192, 4 orders since 25-09): a wall setup pack ("Ultimate Gaming Wall Setup Combo | 23 Piece Panel | Wall
     Setup Pack") reached a 3-piece spot - the old rule let anything that was not a 5-piece set into it. Now:
       a pack / combo / "N Piece Panel" never fits any spot;
       a 3-piece spot takes a "3 Piece" title, or flat split art (Anime Splits / floor drops: "Anime - DBZ - v1");
       a 5-piece spot takes only a "5 Piece" title; a single spot never a set (01-10). */
  var PACK_RE = /wall\s*setup|setup\s*combo|\d+\s*[- ]?piece\s*panel|collage\s*set|mystery\s*poster/i;
  function fitsSlot(title, size, flat) {
    var t = String(title || '');
    if (PACK_RE.test(t)) return false;
    if (isSplit(size) && NO_SPLIT_RE.test(t)) return false;   /* 14-10 (Arjun): a 2xA4 + 1xA3 set never sits in a split spot - also drops it from saved walls and cart edits */
    if (!isSplit(size)) return !SPLIT3_RE.test(t) && !SPLIT5_RE.test(t);
    var c = panelsOf(size).c;
    return c === 5 ? SPLIT5_RE.test(t) : c === 3 ? !SPLIT5_RE.test(t) && (SPLIT3_RE.test(t) || !!flat) : true;
  }
  function pickCatalog(it) {
    if (activeSlot < 0) return;
    var psz = state.slots[activeSlot].size;
    if (isSplit(psz) && (it.noSize || NO_SPLIT_RE.test(it.rawTitle || it.title || ''))) {   /* 13-10: last line for the split guard */
      toast('This set has no split version - pick another set.');
      return;
    }
    if (!isSplit(psz) && !!(it.landscape || isLandscapeTitle(it.rawTitle || it.title)) !== isLandscape(psz)) {   /* 14-10: landscape fix */
      toast(isLandscape(psz) ? 'This spot takes a landscape poster.' : 'Landscape posters need a landscape spot - pick a portrait one here.');
      return;
    }
    if (!fitsSlot(it.rawTitle || it.title, psz, it.flat)) {
      var pc = isSplit(psz) ? panelsOf(psz).c : 1;
      toast(pc === 5 ? 'This spot takes a 5-piece set — pick one from 5-Piece Sets.' : pc === 3 ? 'This spot takes a 3-piece set.' : 'This spot takes a single poster.');
      return;
    }
    state.slots[activeSlot].sel = { type: 'catalog', title: it.title, img: it.img, handle: it.handle, flat: !!it.flat };
    pzTrack('fill');
    save();
    var picked = activeSlot;
    advanceDrawer();
    /* Arjun 15-10 ("hero la poster tap panna direct ah apply tha aaguthu, adjust page open aagala"): a design picked for
       the Showcase hero opens Adjust straight away, once it has landed; the picker carries on behind it */
    if (canMove(state.slots[picked])) setTimeout(function () { if (canMove(state.slots[picked]) && !document.querySelector('.pz-wb-mv')) openMove(picked); }, reduceMotion ? 0 : 380);
  }

  /* Arjun 04-09 (vs theprintlab's tap-tap-tap bundle): picking a poster must
     not throw the shopper back to the wall for every spot - 36 posters were 36
     open/close cycles. The drawer stays open and moves to the next empty spot;
     the head shows progress and a one-tap "fill the rest". It closes by itself
     only when the last spot is filled. */
  function nextEmptySlot(from) {
    for (var i = 0; i < state.slots.length; i++) {
      var k = (from + 1 + i) % state.slots.length;
      if (!state.slots[k].sel) return k;
    }
    return -1;
  }
  function advanceDrawer() {
    var next = nextEmptySlot(activeSlot);
    var landed = activeSlot;
    render();
    /* the poster pops into its spot on the docked wall */
    var le = slotEl(landed);
    if (le && !reduceMotion) le.classList.add('landed');
    if (next < 0) {
      /* last pick: hold the finished wall (thumbs-up photo, gold "See wall")
         for half a second, then close and land on the upsell card */
      var sheet = drawer.querySelector('.pz-wb-d-sheet');
      if (sheet) sheet.classList.add('done');
      updateDrawerHead();
      markCur();
      toast('All ' + state.slots.length + ' spots filled \u2713');
      /* the hold is cancellable: a tap on a docked spot (swap), Done, or a
         re-open during the 500ms takes over and the stale close never fires */
      clearTimeout(holdTimer);
      holdTimer = setTimeout(function () {
        holdTimer = null;
        if (!drawer.classList.contains('show') || closeTimer || activeSlot !== landed) return;
        closeDrawer({ to: 'none' });
        setTimeout(function () {
          var t = root.querySelector('.pz-wb-up') || root.querySelector('.pz-wb-wallwrap');
          if (t) pzScrollTo(t, 70);
        }, 60);
      }, reduceMotion ? 0 : 500);
      return;
    }
    var wasTabs = tabsFor(state.slots[activeSlot].size), nowTabs = tabsFor(state.slots[next].size);
    activeSlot = next;
    if (wasTabs !== nowTabs) {
      drawerTabs = nowTabs;
      if (!tabFits(drawerTab)) drawerTab = firstTabKey();   /* 28-09: a Collections tab only in its own kind of spot */
      drawerView = 'grid';
      renderTabButtons();
      var tb = tabFor(drawerTab) || drawerTabs[0];
      if (tb.handles.length || tb.asset) loadTab(tb);
      renderDrawerGrid();
    } else {
      /* same kind of spot: keep the tab and the scroll position, redraw the
         tiles so the chosen design shows its tick, and flash the grid */
      var g = drawer.querySelector('.pz-wb-d-grid');
      var st = g ? g.scrollTop : 0;
      renderDrawerGrid();
      g = drawer.querySelector('.pz-wb-d-grid');
      if (g) {
        g.scrollTop = st;
        g.classList.add('picked');
        setTimeout(function () { g.classList.remove('picked'); }, 350);
      }
    }
    updateDrawerHead();
    markCur();
    var ne = slotEl(next);
    if (ne && !reduceMotion) { ne.classList.add('pulse'); setTimeout(function () { ne.classList.remove('pulse'); }, 1400); }
  }
  function jumpToSlot(i) {
    clearTimeout(holdTimer); holdTimer = null;
    if (i === activeSlot || !state.slots[i]) return;
    var wasTabs = tabsFor(state.slots[activeSlot].size), nowTabs = tabsFor(state.slots[i].size);
    activeSlot = i;
    if (wasTabs !== nowTabs) {
      drawerTabs = nowTabs;
      if (!tabFits(drawerTab)) drawerTab = firstTabKey();   /* 28-09: a Collections tab only in its own kind of spot */
      drawerView = 'grid';
      renderTabButtons();
      var tb = tabFor(drawerTab) || drawerTabs[0];
      if (tb.handles.length || tb.asset) loadTab(tb);
    }
    /* same kind of spot: the grid keeps its scroll position */
    var g = drawer.querySelector('.pz-wb-d-grid');
    var st = (wasTabs === nowTabs && g) ? g.scrollTop : 0;   /* was wasSplit/nowSplit - left behind by the 09-09 FIVE_TABS rename, threw on every spot jump (fixed 09-10) */
    renderDrawerGrid();
    if (st && g) g.scrollTop = st;
    updateDrawerHead();
    markCur();
  }

  /* ---- split-view helpers ----
     While the picker is open the wall lives inside the sheet's dock, not in
     #pz-wall - anything that needs a spot element must go through these. */
  function isSplitOn() { return document.documentElement.classList.contains('pz-wb-split'); }
  function wallEl() {
    return (isSplitOn() && drawer && drawer.querySelector('.pz-wb-d-wall .pz-wb-wallwrap')) || root.querySelector('.pz-wb-wallwrap');
  }
  function slotEl(i) {
    var w = wallEl();
    return w && w.querySelector('[data-slot="' + i + '"]');
  }
  /* gold ring on the spot being filled */
  function markCur() {
    var w = wallEl();
    if (!w) return;
    [].forEach.call(w.querySelectorAll('.pz-wb-slot.cur'), function (el) { el.classList.remove('cur'); });
    if (activeSlot >= 0 && isSplitOn() && drawer && drawer.classList.contains('show')) {
      var el = slotEl(activeSlot);
      if (el) { el.classList.add('cur'); keepInBand(el, w); }
    }
  }
  /* dense photo rooms scroll inside the band: bring the ringed spot into view
     by scrolling ONLY the wallwrap. Never scrollIntoView - that also moves the
     locked page / visual viewport under the sheet. offsetTop is relative to
     .pz-wb-wall (position:relative, the wallwrap's first flex-start child), so
     it equals the scroll offset. Centred when it is out of view; a spot that
     is already inside (with a 12px margin) leaves the band where it is. */
  function keepInBand(el, ww) {
    if (!el || !ww || ww.scrollHeight <= ww.clientHeight + 1) return;
    var top = el.offsetTop, bot = top + el.offsetHeight, pad = 12;
    if (top - pad >= ww.scrollTop && bot + pad <= ww.scrollTop + ww.clientHeight) return;
    ww.scrollTop = Math.max(0, Math.min(ww.scrollHeight - ww.clientHeight, Math.round(top - (ww.clientHeight - el.offsetHeight) / 2)));
  }
  /* bottom fade on the band while the room has rows below the fold (the
     wallwrap's scrollbar is hidden, so this is the only cue that it scrolls);
     .at-end drops it once the last row is in view */
  function dockScrollCue() {
    var dock = drawer && drawer.querySelector('.pz-wb-d-wall');
    if (!dock) return;
    var ww = dock.firstElementChild;
    var over = !!(ww && ww.scrollHeight > ww.clientHeight + 1);
    /* every photo room overflows by design (the crop frames its top share),
       so the fade means 'spots below', not 'pixels below': only when a spot's
       bottom edge is past the band's visible window */
    var hidden = over && [].some.call(ww.querySelectorAll('.pz-wb-slot'), function (sl) {
      return sl.offsetTop + sl.offsetHeight > ww.scrollTop + ww.clientHeight - 4;
    });
    dock.classList.toggle('scrolls', hidden);
    dock.classList.toggle('at-end', !hidden);
  }
  /* the wall band is a px share of the sheet (never vh - iOS Safari's vh is
     the LARGE viewport, the sheet is the real one): 30% on phones (38% for
     dense 18 / 36 rooms), 32% on desktop, 26% on landscape phones - but never
     more than what the sheet has left after its fixed chrome (grab / head /
     progress / tabs / search / Pinterest, measured live: ~210px) and two rows
     of posters, so the grid - the only scroller - never collapses to one row
     on short viewports (SE/8 with the Safari toolbar, landscape). Plain walls
     are further capped at their own fitted height (no empty beige above and
     below a wide wall). */
  var MIN_SPOT = 34; /* px: the smallest docked spot must stay tappable */
  function sizeDock() {
    if (!drawer || !isSplitOn()) return;
    var sheet = drawer.querySelector('.pz-wb-d-sheet');
    if (!sheet) return;
    var H = sheet.clientHeight || window.innerHeight, W = sheet.clientWidth || window.innerWidth;
    var desk = window.innerWidth >= 750, short = H < 520, dense = state.slots.length >= 18, h;
    var dock = sheet.querySelector('.pz-wb-d-wall'), grid = sheet.querySelector('.pz-wb-d-grid');
    /* everything in the column except the band and the grid; display:none /
       hidden children measure 0, so the landscape / short-viewport rules and
       the Liquid-injected Pinterest row are counted as they really are */
    var chrome = 0;
    [].forEach.call(sheet.children, function (c) { if (c !== dock && c !== grid && !c.classList.contains('pz-wb-pin-guide')) chrome += c.offsetHeight; });
    /* Arjun 09-09 night: "poster choose panra idam chinnadha irukku, preview
       konjam chinnadhu pannu" - phones now show 3-up tiles (bigger art) and the
       band drops to ~21% of the sheet so two full rows of designs stay in view;
       dense packs (18/36 spots) keep the taller band so the spots stay tappable */
    var row = desk ? 150 : Math.round((W - 30) / (short ? 6 : 3) * 1.414 + 20);
    var left = H - chrome - (dense && !desk ? 1.5 : 2) * row;
    var share, cap, floor;
    /* Arjun 18-09: "wall picker la wall preview rombo chinna tha eruku, nalla visible ah therinum". The sheet's
       chrome grew since 09-11 (size row, progress row, the paste-link / upload cards), so on a real phone `left`
       was always under the floor and the band simply WAS its floor: 120px = posters 24px wide. The floor is now a
       share of the sheet (26% up to 10 spots, 30% above) - posters ~1.5x bigger,
       and the grid still opens on the upload cards plus a full row of designs. */
    var fl = function (lo, sh, hi) { return Math.max(lo, Math.min(hi, Math.round(H * sh))); };
    if (short) { share = .26; cap = 200; floor = 100; }
    else if (desk) { share = .32; cap = 320; floor = 180; }
    else if (dense) { share = H >= 600 ? .38 : .30; cap = 320; floor = fl(130, .30, 205); }
    else if (state.slots.length > 10) { share = .30; cap = 205; floor = fl(150, .30, 205); }   /* 11-17 spots (Mosaic, Track, Heart, Large) */
    else { share = .26; cap = 180; floor = fl(120, .26, 180); }   /* up to 10 spots */
    h = Math.max(floor, Math.min(cap, Math.round(H * share), left));
    /* plain (Build Your Wall) walls fit the band's width: cap the band at the
       wall's own height (+12px ring clearance) so a wide wall does not float
       in a band of empty beige while the grid loses that space. Photo rooms
       keep the crop-based framing (the room is taller than the band by design). */
    var L = LAYOUTS[state.size];
    var ratio = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pz-ratio')) || 1;
    if (!(L && L.mock)) {
      var dpad = BAND_WALL && dimsBox(computeLayout(state.size, { plain: true })).pad;   /* 16-10: .pz-wb-paint--pad band (18 + 10 px, 24 + 12 px) */
      h = Math.max(Math.min(floor, 120), Math.min(h, Math.ceil((W - (dpad ? 60 : 44)) / ratio) + (dpad ? 28 : 12))); /* 44 = dock 2x12 + wallwrap 2x10 */
    }
    if (sheet.classList.contains('kb')) h = Math.min(h, 120); /* keyboard up: keep ~2 rows of results */
    sheet.style.setProperty('--pz-wall-h', h + 'px');
    /* photo rooms: the wall never shrinks below the width at which its
       SMALLEST spot is still a thumb target (MIN_SPOT px). Derived from the
       layout, not the viewport height: a 36-room on a 553px SE gets the same
       ~30px spots as on an 812px phone, the lower rows a drag away inside the
       band (overflow-y + keepInBand + the fade cue). Clamped to the band's
       inner width (W - 24) so the clamp() in CSS never exceeds 100%. */
    var minWall = 0;
    if (L && L.mock && !desk) {
      var fr = 1;
      computeLayout(state.size).slots.forEach(function (g) { fr = Math.min(fr, g.w / 100); });
      minWall = Math.min(W - 24, Math.ceil(MIN_SPOT / fr));
    }
    sheet.style.setProperty('--pz-wall-min', minWall + 'px');
    dockScrollCue();
  }
  /* animated page scroll to an element (rAF + cubic ease; native smooth
     scrolling gets cancelled by the site's periodic DOM sweeps). `target` may
     be a function returning the element, re-read every frame because render()
     can replace the node mid-flight. */
  function pzScrollTo(target, offset) {
    var gen = ++pzScrollGen;
    var start = window.pageYOffset;
    var t0 = null, DUR = reduceMotion ? 0 : 600;
    if (offset === undefined) offset = 90;
    function el() {
      var w = typeof target === 'function' ? target() : target;
      return w && document.body.contains(w) ? w : null;
    }
    function step(ts) {
      if (gen !== pzScrollGen) return; /* newer scroll took over */
      if (t0 === null) t0 = ts;
      var p = DUR ? Math.min((ts - t0) / DUR, 1) : 1;
      var e = 1 - Math.pow(1 - p, 3);
      var w = el();
      if (!w) return;
      var to = w.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo(0, start + (to - start) * e);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  /* Arjun 08-09 ("size select option hidden aaguthu"): the size pills live in the
     sheet too - a deep link (?go=1) lands straight in the picker, and the sheet
     covers the page, so the shopper could not change A5/A4/A3 without leaving. */
  function renderDrawerSizes() {
    if (!drawer) return;
    var row = drawer.querySelector('.pz-wb-d-sizes');
    if (!row) return;
    if (!MODE || MODE === 'custom8' || isFixedKey(state.size)) { row.innerHTML = ''; row.hidden = true; return; }
    var curSz = (SIZE_META[state.size] || {}).size;
    row.hidden = false;
    row.innerHTML = '<span class="pz-wb-d-sizes-k">Size</span>';
    gridSizes().forEach(function (sz) {
      var pb = document.createElement('button');
      pb.type = 'button';
      pb.className = 'pz-wb-szpill' + (sz.key === curSz ? ' on' : '');
      pb.textContent = sz.label;
      pb.setAttribute('data-size', sz.key);
      pb.addEventListener('click', function () {
        if (sz.key === (SIZE_META[state.size] || {}).size) return;
        var want = (SIZE_META[state.size] || {}).posters;
        var next = Object.keys(SIZE_META).filter(function (k) { return SIZE_META[k].size === sz.key; })
          .sort(function (a, b) { return SIZE_META[a].posters - SIZE_META[b].posters; });
        var hit = next.filter(function (k) { return SIZE_META[k].posters === want; })[0] || next[0];
        if (!hit) return;
        pzTrack('size');
        row.querySelectorAll('.pz-wb-szpill').forEach(function (b) { b.classList.toggle('on', b === pb); });
        morphSize(hit);                                   /* re-renders the board after its tween */
        setTimeout(function () { updateDrawerHead(); markCur(); }, 600);
      });
      row.appendChild(pb);
    });
    /* the pack price for this size, right-aligned (Arjun 08-09 "price um show aaganum") */
    var vr = variantFor(state.size), m = SIZE_META[state.size];
    if (vr && vr.v) {
      var pr = document.createElement('span');
      pr.className = 'pz-wb-d-price';
      pr.innerHTML = '<b>' + money(vr.v.price) + '</b>' + (vr.v.compareAt > vr.v.price ? ' <s>' + money(vr.v.compareAt) + '</s>' : '') +
        (m && m.posters ? '<small>' + money(perUnit(vr, m)) + ' / ' + unitNoun(m, 1) + '</small>' : '');
      row.appendChild(pr);
    }
  }
  function updateDrawerHead() {
    if (!drawer || activeSlot < 0) return;
    renderDrawerSizes();
    var slot = state.slots[activeSlot];
    var done = filledCount(), total = state.slots.length;
    drawer.querySelector('.pz-wb-d-title').textContent =
      (PHOTO ? 'Photo ' : MODE === 'splits' ? 'Set ' : 'Poster ') + (activeSlot + 1) + ' of ' + total + ' \u00b7 ' + sizeLabel(slot.size);
    var prog = drawer.querySelector('.pz-wb-d-prog');
    if (prog) {
      /* fill from the category being browsed (a real singles pool - never a
         splits tab, whose items are 3-piece sets), else Best Sellers; the
         button names its source so it matches the page's labelled chips */
      var theme = fillTheme();
      var themeLab = theme ? (theme.key === 'all' ? 'Best Sellers' : theme.label) : '';
      prog.innerHTML = '<i class="pz-wb-d-track" style="--p:' + (total ? (done / total).toFixed(3) : 0) + '"><i></i></i>' +
        '<b>' + done + '</b> / ' + total + ' chosen';
      var fr = null;
      if (done < total && theme) {
        fr = document.createElement('button');
        fr.type = 'button';
        fr.className = 'pz-wb-d-fillrest';
        fr.textContent = 'Fill the rest \u00b7 ' + themeLab; /* textContent: collection labels are store data */
        fr.title = 'Fill the empty spots with ' + themeLab;
        prog.appendChild(fr);
      }
      if (fr) fr.addEventListener('click', function () {
        /* close without the page tween: applyFill lands on the upsell card
           (same landing as the last catalog pick) once the wall is full */
        closeDrawer({ to: 'none' });
        fillWith(theme, true);
      });
    }
    /* Done turns gold once every spot is filled */
    var x = drawer.querySelector('.pz-wb-d-x');
    if (x) x.textContent = done === total ? (EDIT && EDIT.item ? 'OK \u2713' : 'See wall \u2713') : 'Done';
    var sh = drawer.querySelector('.pz-wb-d-sheet');
    if (sh) sh.classList.toggle('done', done === total);
  }

  /* after filling a slot, nudge to the next empty one */
  function autoAdvance() {
    var next = -1;
    for (var i = 0; i < state.slots.length; i++) {
      if (!state.slots[i].sel) { next = i; break; }
    }
    if (next > -1) {
      var el = slotEl(next);
      if (el) {
        el.classList.add('pulse');
        setTimeout(function () { el.classList.remove('pulse'); }, 1400);
      }
    }
  }

  /* ---------- crop editor (adapted from pz-uploader) ---------- */
  var ed = { open: false, img: null, file: null, iw: 0, ih: 0, rot: 0, flip: 1, zoom: 1, tx: 0, ty: 0, frame: { w: 0, h: 0 }, cw: 0, ch: 0, dpr: 1, dom: null, canvas: null, ctx: null, slider: null, pointers: {}, lastDist: 0 };

  function slotSize() {
    return activeSlot > -1 ? state.slots[activeSlot].size : 'A4';
  }

  function edBuild() {
    if (ed.dom) return;
    var o = document.createElement('div');
    o.className = 'pz-wb-ed';
    o.innerHTML =
      '<div class="pz-wb-ed-sheet">' +
        '<div class="pz-wb-ed-head"><span class="pz-wb-ed-title"></span><span class="pz-wb-ed-hint">Drag to position · pinch or slide to zoom</span></div>' +
        '<div class="pz-wb-ed-stage"><canvas></canvas></div>' +
        '<div class="pz-wb-ed-tools">' +
          '<button type="button" data-act="rotate">⟳ Rotate</button>' +
          '<button type="button" data-act="flip">⇋ Flip</button>' +
          '<input type="range" min="100" max="300" value="100" aria-label="Zoom">' +
        '</div>' +
        '<div class="pz-wb-ed-actions">' +
          (PHOTO ? '<button type="button" class="pz-wb-ed-remove" hidden>Remove</button>' : '') +   /* 28-09: a placed photo can be removed here too */
          '<button type="button" class="pz-wb-ed-cancel">Cancel</button>' +
          '<button type="button" class="pz-wb-ed-done">Use photo</button>' +
        '</div>' +
      '</div>';
    if (PHOTO) o.classList.add('pz-wb-ed--photo');
    /* 28-09 round 2: the photo editor goes FIRST in <body>, so every toast (appended at the end) is its later sibling and
       the CSS '.pz-wb-ed--photo.show ~ .pz-wb-toast' moves it to the top - also a toast already on screen when the
       editor is built (a Switch / Undo toast sat on Cancel / Use photo). Fixed + z-index: no visual change. */
    if (PHOTO) document.body.insertBefore(o, document.body.firstChild); else document.body.appendChild(o);
    ed.dom = o;
    var rmB = o.querySelector('.pz-wb-ed-remove');
    if (rmB) rmB.addEventListener('click', function () { var ri = ed.rmIdx; edClose(); if (ri > -1) photoRemove(ri); });
    ed.canvas = o.querySelector('canvas');
    ed.ctx = ed.canvas.getContext('2d');
    ed.slider = o.querySelector('input[type="range"]');

    o.querySelector('[data-act="rotate"]').addEventListener('click', function () { ed.rot = (ed.rot + 90) % 360; edClamp(); edDraw(); });
    o.querySelector('[data-act="flip"]').addEventListener('click', function () { ed.flip *= -1; edClamp(); edDraw(); });
    ed.slider.addEventListener('input', function () { ed.zoom = ed.slider.value / 100; edClamp(); edDraw(); });
    o.querySelector('.pz-wb-ed-cancel').addEventListener('click', function () { edClose(); });
    o.querySelector('.pz-wb-ed-done').addEventListener('click', edExport);

    var c = ed.canvas;
    c.style.touchAction = 'none';
    c.addEventListener('pointerdown', function (e) {
      c.setPointerCapture(e.pointerId);
      ed.pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
      var pts = Object.keys(ed.pointers);
      if (pts.length === 2) {
        var a = ed.pointers[pts[0]], b = ed.pointers[pts[1]];
        ed.lastDist = Math.hypot(a.x - b.x, a.y - b.y);
      }
    });
    c.addEventListener('pointermove', function (e) {
      var p = ed.pointers[e.pointerId];
      if (!p) return;
      var pts = Object.keys(ed.pointers);
      if (pts.length === 1) {
        ed.tx += e.clientX - p.x; ed.ty += e.clientY - p.y;
        edClamp(); edDraw();
      } else if (pts.length === 2) {
        p.x = e.clientX; p.y = e.clientY;
        var a = ed.pointers[pts[0]], b = ed.pointers[pts[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y);
        if (ed.lastDist > 0) {
          ed.zoom = Math.min(3, Math.max(1, ed.zoom * (d / ed.lastDist)));
          ed.slider.value = Math.round(ed.zoom * 100);
          edClamp(); edDraw();
        }
        ed.lastDist = d;
        return;
      }
      p.x = e.clientX; p.y = e.clientY;
    });
    var upFn = function (e) { delete ed.pointers[e.pointerId]; ed.lastDist = 0; };
    c.addEventListener('pointerup', upFn);
    c.addEventListener('pointercancel', upFn);
    window.addEventListener('resize', function () { if (ed.open && ed.img) { edLayout(); edClamp(); edDraw(); } });
  }

  function edRotDims() {
    var swap = (ed.rot % 180) !== 0;
    return { w: swap ? ed.ih : ed.iw, h: swap ? ed.iw : ed.ih };
  }
  function edCover() {
    var rd = edRotDims();
    return Math.max(ed.frame.w / rd.w, ed.frame.h / rd.h);
  }
  function edClamp() {
    var rd = edRotDims();
    var z = edCover() * ed.zoom;
    var exW = Math.max(0, (rd.w * z - ed.frame.w) / 2);
    var exH = Math.max(0, (rd.h * z - ed.frame.h) / 2);
    ed.tx = Math.min(exW, Math.max(-exW, ed.tx));
    ed.ty = Math.min(exH, Math.max(-exH, ed.ty));
  }
  function edDraw() {
    var ctx = ed.ctx, cw = ed.cw, ch = ed.ch, dpr = ed.dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, cw, ch);
    ctx.fillStyle = '#181818';
    ctx.fillRect(0, 0, cw, ch);
    var z = edCover() * ed.zoom;
    ctx.save();
    ctx.translate(cw / 2 + ed.tx, ch / 2 + ed.ty);
    ctx.rotate(ed.rot * Math.PI / 180);
    ctx.scale(ed.flip * z, z);
    ctx.drawImage(ed.img, -ed.iw / 2, -ed.ih / 2);
    ctx.restore();
    var fx = (cw - ed.frame.w) / 2, fy = (ch - ed.frame.h) / 2;
    ctx.fillStyle = 'rgba(10,10,10,0.62)';
    ctx.beginPath();
    ctx.rect(0, 0, cw, ch);
    ctx.rect(fx, fy, ed.frame.w, ed.frame.h);
    ctx.fill('evenodd');
    ctx.strokeStyle = '#ffba00';
    ctx.lineWidth = 2;
    ctx.strokeRect(fx, fy, ed.frame.w, ed.frame.h);
    if (hasJoints(slotSize())) {
      /* real panel cut lines — the design splits into 3 A3 panels (Duo H2A3: one joint across the middle) */
      ctx.strokeStyle = 'rgba(255,255,255,0.85)';
      ctx.lineWidth = 1.5;
      ctx.setLineDash([9, 7]);
      var pn = jointsOf(slotSize());
      for (var p = 1; p < pn.c; p++) {
        ctx.beginPath();
        ctx.moveTo(fx + ed.frame.w * p / pn.c, fy);
        ctx.lineTo(fx + ed.frame.w * p / pn.c, fy + ed.frame.h);
        ctx.stroke();
      }
      for (var q = 1; q < pn.r; q++) {
        ctx.beginPath();
        ctx.moveTo(fx, fy + ed.frame.h * q / pn.r);
        ctx.lineTo(fx + ed.frame.w, fy + ed.frame.h * q / pn.r);
        ctx.stroke();
      }
      ctx.setLineDash([]);
    } else {
      ctx.strokeStyle = 'rgba(255,255,255,0.28)';
      ctx.lineWidth = 1;
      for (var i = 1; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(fx + ed.frame.w * i / 3, fy); ctx.lineTo(fx + ed.frame.w * i / 3, fy + ed.frame.h);
        ctx.moveTo(fx, fy + ed.frame.h * i / 3); ctx.lineTo(fx + ed.frame.w, fy + ed.frame.h * i / 3);
        ctx.stroke();
      }
    }
  }
  function edLayout() {
    var stage = ed.dom.querySelector('.pz-wb-ed-stage');
    var rect = stage.getBoundingClientRect();
    ed.dpr = Math.min(2, window.devicePixelRatio || 1);
    ed.cw = rect.width; ed.ch = rect.height;
    ed.canvas.width = Math.round(ed.cw * ed.dpr);
    ed.canvas.height = Math.round(ed.ch * ed.dpr);
    ed.canvas.style.width = ed.cw + 'px';
    ed.canvas.style.height = ed.ch + 'px';
    var ratio = ratioFor(slotSize());
    var fh = ed.ch * 0.92, fw = fh * ratio;
    if (fw > ed.cw * 0.92) { fw = ed.cw * 0.92; fh = fw / ratio; }
    ed.frame = { w: fw, h: fh };
  }

  function openEditor(file) {
    var preset = edPreset; edPreset = null;   /* photo products: where the frame starts (their last adjust / the 42% cut) */
    if (activeSlot < 0 || !state.slots[activeSlot]) { toast('That spot is no longer open — tap a spot and try again.'); return; }
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) { toast('Only JPG, PNG or WEBP photos.'); return; }
    if (file.size > 30 * 1024 * 1024) { toast('Photo is larger than 30 MB.'); return; }
    edBuild();
    edRemoveFor(-1);   /* photoTap turns Remove on for a placed photo, right after this call */
    ed.file = file;
    ed.rot = 0; ed.flip = 1; ed.zoom = 1; ed.tx = 0; ed.ty = 0;
    ed.slider.value = 100;
    ed.dom.querySelector('.pz-wb-ed-title').textContent = 'Fit your photo — ' + sizeLabel(slotSize());
    ed.dom.querySelector('.pz-wb-ed-hint').textContent = isSplit(slotSize())
      ? 'Dotted lines show where the panels split · drag to position · pinch to zoom'
      : 'Drag to position · pinch or slide to zoom';
    var obj = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var pi = PRINT_IN[slotSize()];
      var d1 = Math.min(img.naturalWidth / pi[0], img.naturalHeight / pi[1]);
      var d2 = Math.min(img.naturalHeight / pi[0], img.naturalWidth / pi[1]);
      var dpi = Math.max(d1, d2);
      var lowQ = lowOK() && dpi < edFloor(slotSize(), file) && dpi >= lowFloorFor(slotSize());
      if (dpi < edFloor(slotSize(), file) && !lowQ) {
        URL.revokeObjectURL(obj);
        /* round 2: the framed cells' names already say "print" (no "A6 retro print print"); photo products say "an A4" */
        var sz = slotSize(), nm = sizeLabel(sz) + (PHOTO_CELL_NAME[sz] ? '' : ' print');
        toast(isPinFile(file)
          ? 'That pin is too small for ' + (PHOTO && /^[AEIOU]/i.test(nm) ? 'an ' : 'a ') + nm + ' even after upscaling — pick a bigger pin, or a smaller size.'
          : 'That photo is too small for a sharp ' + nm + (lowOK() ? ', even with AI upscaling' : '') + ' — please use the original photo, not a WhatsApp-compressed copy.');
        return;
      }
      if (!lowQ && isPinFile(file) && !FRAMED && dpi < floorDpiFor(slotSize())) toast('Small Pinterest image — we will upscale it for print. A bigger pin prints sharper.');
      edLow(lowQ);
      ed.img = img; ed.iw = img.naturalWidth; ed.ih = img.naturalHeight;
      ed.open = true;
      ed.dom.classList.add('show');
      document.documentElement.classList.add('pz-ed-lock');
      edLayout();
      if (preset) preset();
      edClamp(); edDraw();
    };
    img.onerror = function () { URL.revokeObjectURL(obj); toast('Could not read that photo.'); };
    img.src = obj;
  }

  /* 16-10: the low-quality note in the editor head; the button says "Use anyway" while it shows */
  function edLow(on) {
    ed.low = !!on;
    if (!ed.dom) return;
    var n = ed.dom.querySelector('.pz-wb-ed-low');
    if (!n && on) {
      if (!document.getElementById('pz-wb-ed-low-css')) {
        var st = document.createElement('style');
        st.id = 'pz-wb-ed-low-css';
        st.textContent = '.pz-wb-ed-low{margin-top:8px;padding:8px 10px;border-radius:10px;background:#3a2c08;border:1px solid #8a6a12;color:#ffe3a3;font:600 12px/1.35 Barlow,system-ui,sans-serif}' +
          '.pz-wb-ed-low b{display:block;margin-bottom:2px;color:#ffba00;font-size:13px;font-weight:800}';
        document.head.appendChild(st);
      }
      n = document.createElement('div');
      n.className = 'pz-wb-ed-low';
      n.setAttribute('role', 'note');
      n.innerHTML = '<b>\u26a0 Low quality photo</b>We\u2019ll AI-upscale it for the best print we can \u2014 expect some softness, blur or an AI look up close. A bigger original photo prints sharper.';
      ed.dom.querySelector('.pz-wb-ed-head').appendChild(n);
    }
    if (n) n.hidden = !on;
    var d = ed.dom.querySelector('.pz-wb-ed-done');
    if (d && !PHOTO) d.textContent = on ? 'Use anyway' : 'Use photo';
  }

  function edRemoveFor(i) {
    ed.rmIdx = i;
    var b = ed.dom && ed.dom.querySelector('.pz-wb-ed-remove');
    if (b) b.hidden = !(i > -1);
  }
  function edClose() {
    if (ed.img && ed.img.src && ed.img.src.indexOf('blob:') === 0) URL.revokeObjectURL(ed.img.src);
    ed.img = null; ed.open = false; ed.rmIdx = -1;
    if (ed.dom) ed.dom.classList.remove('show');
    document.documentElement.classList.remove('pz-ed-lock');
  }

  function edExport() {
    var size = slotSize();
    var out = OUT_PX[size];
    var z = edCover() * ed.zoom;
    var srcAcross = Math.round(ed.frame.w / z);
    var dpiOut = srcAcross / PRINT_IN[size][0];
    if (dpiOut < (lowOK() ? lowFloorFor(size) : edFloor(size, ed.file))) {
      toast('Zoomed in too far — print quality drops too low. Zoom out a little.');
      return;
    }
    var lowSel = lowOK() && dpiOut < edFloor(size, ed.file);
    if (lowSel && !ed.low) {   /* a sharp photo zoomed below the floor: show the note first, the next tap takes it */
      edLow(true); edLayout(); edClamp(); edDraw();
      toast('This crop is low quality \u2014 tap Use anyway to keep it, or zoom out.');
      return;
    }
    var outW = Math.min(out[0], PHOTO ? Math.max(1, srcAcross) : Math.max(200, srcAcross));   /* photo products: never upscaled */
    var outH = PHOTO && outW === out[0] ? out[1] : Math.round(outW / ratioFor(size));   /* photo products: a full-size cut is exactly the listed size (A4 2480 x 3508, not 3507) */
    /* 14-10 (Arjun: "build pannu"): a 24 MP phone photo in a 2x2 / 3x2 hero spot made a 23-100 M px canvas - iPhone Safari
       refuses canvases over ~16.7 M px ("Could not process the photo") and the upload ran to 15-25 MB. The floor upscales
       customer photos to print size, so a Build Your Wall export stops at 16 M px (A1 ~3360 px across, 3x2 A3 ~4120). */
    if (!PHOTO && outW * outH > 16e6) { var k16 = Math.sqrt(16e6 / (outW * outH)); outW = Math.floor(outW * k16); outH = Math.round(outW / ratioFor(size)); }
    var k = outW / ed.frame.w;
    var c = document.createElement('canvas');
    c.width = outW; c.height = outH;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, outW, outH);
    ctx.translate(outW / 2 + ed.tx * k, outH / 2 + ed.ty * k);
    ctx.rotate(ed.rot * Math.PI / 180);
    ctx.scale(ed.flip * z * k, z * k);
    ctx.drawImage(ed.img, -ed.iw / 2, -ed.ih / 2);
    if (PHOTO) { photoFromEditor(c, z); return; }   /* 28-09: <= 320 px thumb, upload queue, original kept */

    /* small thumb for the wall preview + localStorage */
    var t = document.createElement('canvas');
    var ts = 180 / Math.max(outW, outH);
    t.width = Math.round(outW * ts); t.height = Math.round(outH * ts);
    t.getContext('2d').drawImage(c, 0, 0, t.width, t.height);
    var thumbUrl = t.toDataURL('image/jpeg', 0.6);

    var slotIdx = activeSlot;
    c.toBlob(function (blob) {
      if (slotIdx < 0 || !state.slots[slotIdx]) { toast('That spot is no longer open — tap a spot and try again.'); edClose(); return; }
      if (!blob) { toast('Could not process the photo, please retry.'); return; }
      var file = new File([blob], (ed.file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
      edClose();
      closeDrawer({ to: 'none' });
      /* a file named pinterest-* came in through the Pinterest row (snippet) - remembered so the order says so (Arjun 09-09) */
      state.slots[slotIdx].sel = { type: 'upload', title: 'Your photo', thumb: thumbUrl, blobUrl: URL.createObjectURL(file), url: null, status: 'uploading', pct: 0, pin: /^pinterest-/i.test(file && file.name || ''), low: lowSel ? Math.max(1, Math.round(dpiOut)) : 0 };
      pzTrack('fill');
      render();
      uploadSlot(slotIdx, file);
    }, 'image/jpeg', 0.92);
  }

  function uploadSlot(slotIdx, file) {
    var sel = state.slots[slotIdx].sel;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', cfg.endpoint.replace(/\/$/, '') + '/upload');
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.upload.onprogress = function (e) {
      if (e.lengthComputable) {
        sel.pct = Math.round((e.loaded / e.total) * 100);
        var rs = slotEl(slotIdx), ring = rs && rs.querySelector('.pz-wb-ring');
        if (ring) ring.setAttribute('data-pct', sel.pct + '%');
      }
    };
    xhr.onload = function () {
      try {
        var res = JSON.parse(xhr.responseText || '{}');
        if (xhr.status === 200 && res.url) {
          sel.status = 'done'; sel.url = res.url;
          save();
        } else {
          sel.status = 'error';
          toast('Upload failed — tap the photo to retry.');
        }
      } catch (e) {
        sel.status = 'error';
        toast('Upload failed — tap the photo to retry.');
      }
      render();
      autoAdvance();
    };
    xhr.onerror = function () {
      sel.status = 'error';
      toast('No connection — tap the photo to retry.');
      render();
    };
    xhr.send(file);
  }

  /* ================= photo products: the batch photo flow (Arjun 28-09) =================
     Mini / Retro / Photobooth / Personalize. A tap on an empty spot opens the phone's picker for MANY photos; they fill
     the empty spots from the tapped one on (then wrap round). Every photo is decoded ONE at a time (a phone dies on 30
     parallel 12 MP decodes), checked against its print (hard floor: 80 DPI of the photo window; LOW RES line: 150 DPI),
     cut to the window automatically (centred across; 42% down when the photo is taller than the window - faces sit
     high), exported at 600 DPI of the window (never upscaled, JPEG q.92, white background) and uploaded with at most 3
     uploads in flight. Spots, the rail and the preview only ever show the <= 320 px thumb.
     A filled spot re-opens the crop editor on the ORIGINAL photo (kept in memory for this visit only; after a reload
     the shopper removes it and adds it again). Personalize prints big posters: a single photo goes straight to the
     crop editor instead of the automatic cut.
     State keeps every photo across pack / size changes (a 30 -> 5 switch shows 5 and keeps 25 in state.more for the
     way back); only the first N go on the line, as the floor's _Poster contract (photoProps). */
  var PH = { from: 0, input: null, q: [], busy: false, up: [], flying: 0, jobs: new WeakMap(), small: [], toasts: [], toastNow: null,
             rT: null, pinRow: null, pinBusy: false, soldKey: null, spare: [], addOk: null };
  var PH_TTL = 6 * 3600 * 1000;   /* a saved photo session lives 6 h (as the uploader's) */
  var PH_UPS = 3;                 /* uploads in flight */
  var PH_STALL = 30000;                 /* no bytes moving for 30 s = dead connection: abort, retry */
  var PH_BACKOFF = [2000, 5000, 10000]; /* automatic retries before the spot shows Retry */
  if (PHOTO) window.addEventListener('online', function () { phPump(); });
  var PV_ATC_CAP_PHOTO = 6000;    /* the photo products' preview is for the cart only - never hold Add to cart longer */
  var edPreset = null;            /* set just before openEditor(): where the editor starts (re-crop / 42% cut) */
  /* the photo DPI floor: the framed prints never get the Pinterest leniency (small prints, no upscale); Personalize and
     every other mode keep floorDpiFor as it was */
  function edFloor(size, file) { return FRAMED ? 80 : floorDpiFor(size, file); }
  function phJob(sel) { var j = PH.jobs.get(sel); if (!j) { j = {}; PH.jobs.set(sel, j); } return j; }
  function photoAll() { return state.slots.map(function (s) { return s.sel; }).concat(state.more || []); }
  function phAlive(sel) { return !!sel && photoAll().indexOf(sel) > -1; }
  function phIndex(sel) { for (var i = 0; i < state.slots.length; i++) if (state.slots[i].sel === sel) return i; return -1; }
  function phFileKey(f) { return [f.name || '', f.size || 0, f.lastModified || 0].join('|'); }
  function phName(f) { var n = String((f && f.name) || 'photo'); return isPinFile(f) ? 'Pinterest image' : n.replace(/\.[^.]+$/, '').slice(0, 32); }
  /* print / prints, strip / strips, poster / posters - the pack's own noun (n defaults to the pack's units) */
  function photoNoun(n) { var m = SIZE_META[state.size] || { unit: 'posters' }; return unitNoun(m, n == null ? (m.units || m.posters || 2) : n); }
  /* a pack / size change: the spots take the photos in order, the rest waits in state.more (never truncated) */
  function photoCarry(geoSlots) {
    var all = photoAll();
    state.slots = geoSlots.map(function (g, i) { return { size: g.size, sel: all[i] || null }; });
    var rest = all.slice(geoSlots.length);
    while (rest.length && !rest[rest.length - 1]) rest.pop();
    state.more = rest;
  }
  function photoCancel(sel) {
    var j = sel && PH.jobs.get(sel);
    if (!j) return;
    j.cancelled = true; j.out = null; clearTimeout(j.retryT);
    var k = PH.up.indexOf(sel);
    if (k > -1) PH.up.splice(k, 1);
    if (j.xhr) { try { j.xhr.abort(); } catch (e) {} }
  }
  function photoClearAll() {
    photoAll().forEach(photoCancel);
    state.slots.forEach(function (s) { s.sel = null; });
    state.more = [];
  }
  function phDrop(sel) {
    photoCancel(sel);
    var i = phIndex(sel);
    if (i > -1) state.slots[i].sel = null;
    else { var k = (state.more || []).indexOf(sel); if (k > -1) state.more[k] = null; }
    phRender();
  }
  /* one render for a burst of changes (a batch finishes photos every few hundred ms); never under a half-typed link */
  function phRender() {
    if (PH.rT) return;
    PH.rT = setTimeout(function () {
      PH.rT = null;
      var a = document.activeElement;
      if (PH.pinRow && a && PH.pinRow.contains(a)) { phRender(); return; }
      render();
    }, 120);
  }
  /* toasts one after the other (a batch can raise several) */
  function phToast(msg) {
    if (PH.toastNow === msg || PH.toasts.indexOf(msg) > -1) return;
    PH.toasts.push(msg);
    if (!PH.toastNow) phToastNext();
  }
  function phToastNext() {
    var m = PH.toasts.shift();
    PH.toastNow = m || null;
    if (!m) return;
    toast(m);
    setTimeout(phToastNext, 2900);
  }

  /* ---- storage: 6 h, the saved pack, only finished uploads ---- */
  function photoSave() {
    if (PH.soldKey && PH.soldKey === pvKeyNow()) return;   /* this exact set is in the cart: a late hidden upload must not bring it back */
    PH.soldKey = null;
    var all = photoAll(), big = all.filter(Boolean).length <= 12;
    while (all.length && !(all[all.length - 1] && all[all.length - 1].url)) all.pop();   /* nothing to keep past the last finished photo */
    var pack = function (useBig) {
      return JSON.stringify({ v: 2, t: Date.now(), size: state.size, pv: state.pv || null, pvKey: state.pvKey || null,
        sels: all.map(function (s) {
          if (!s || s.type !== 'upload' || s.status !== 'done' || !s.url) return null;
          return { type: 'upload', title: s.title || 'Your photo', thumb: (useBig ? s.thumb : (s.st || s.thumb)) || s.url, url: s.url,
                   status: 'done', pct: 100, pin: !!s.pin, fk: s.fk || null, px: s.px || null, cut: s.cut || null, ox: s.ox || null };
        }) });
    };
    try { localStorage.setItem(LS_KEY, pack(big)); }
    catch (e) { try { localStorage.setItem(LS_KEY, pack(false)); } catch (e2) {} }
  }
  function photoRestore() {
    var raw = null;
    try { raw = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) {}
    if (!raw) return;
    if (!raw.t || Date.now() - raw.t > PH_TTL) { try { localStorage.removeItem(LS_KEY); } catch (e) {} return; }
    /* the pack the shopper left on (not the page's opening pack); a pack gone since falls back to the opening one */
    var key = LAYOUTS[raw.size] && variantFor(raw.size) ? raw.size : startPackKey();
    if (!key || !LAYOUTS[key]) return;
    /* only finished uploads come back - a spot saved mid-upload has no XHR behind it any more (the stuck "uploading") */
    var sels = (raw.sels || []).map(function (s) {
      if (!s || s.type !== 'upload' || s.status !== 'done' || !s.url) return null;
      return { type: 'upload', title: s.title || 'Your photo', thumb: s.thumb || s.url, url: s.url, status: 'done', pct: 100,
               pin: !!s.pin, fk: s.fk || null, px: s.px || null, cut: s.cut || null, ox: s.ox || null };
    });
    if (!sels.some(Boolean)) return;
    state.slots = []; state.more = sels;
    setSize(key, true);
    state.pv = raw.pv || null;
    state.pvKey = raw.pvKey || null;
  }
  /* ?pack=m15 / ?start=r20-a6 (ads, menu): that pack, unless a saved session already brought one back */
  function photoLinkPack() {
    if (EDIT || photoAll().some(Boolean)) return;
    var m = /[?&](?:pack|start)=([a-z0-9-]+)/.exec(LANDING_QS);
    if (m && m[1] !== state.size && LAYOUTS[m[1]] && SIZE_META[m[1]] && variantFor(m[1])) setSize(m[1], true);
  }

  /* ---- picking ---- */
  function photoPick(i) {
    PH.from = i;
    var inp = PH.input;
    if (!inp) {
      /* on <body>, never inside the product form (a file field there would ride along with the add) */
      inp = PH.input = document.createElement('input');
      inp.type = 'file'; inp.multiple = true; inp.accept = 'image/jpeg,image/png,image/webp';
      inp.className = 'pz-wb-photo-input'; inp.hidden = true; inp.tabIndex = -1;
      inp.setAttribute('aria-hidden', 'true');
      document.body.appendChild(inp);
      inp.addEventListener('change', function () {
        var files = [].slice.call(inp.files || []);
        inp.value = '';
        if (files.length) photoAdd(files, PH.from, false);
      });
    }
    inp.click();
  }
  function phEmpties(from) {
    var n = state.slots.length, out = [];
    for (var k = 0; k < n; k++) { var i = (from + k) % n; if (!state.slots[i].sel) out.push(i); }
    return out;
  }
  function photoAdd(files, from, pin) {
    var ok = [], bad = 0, big = 0, dups = [], seen = {}, parked = {};
    /* a duplicate is a photo already on a SHOWN spot. One parked in state.more (a 30 -> 5 switch) is taken back below:
       its cut and upload are reused and it leaves state.more, so switching back never shows it twice */
    state.slots.forEach(function (s) { if (s.sel && s.sel.fk) seen[s.sel.fk] = 1; });
    (state.more || []).forEach(function (s, k) { if (s && s.fk && !(s.fk in parked)) parked[s.fk] = k; });
    files.forEach(function (f) {
      if (!/^image\/(jpeg|png|webp)$/.test(f.type || '')) { bad++; return; }
      if (f.size > 30 * 1024 * 1024) { big++; return; }
      var fk = phFileKey(f);
      if (seen[fk]) { dups.push(f); return; }
      seen[fk] = 1; ok.push(f);
    });
    if (bad) phToast(bad === 1 ? 'Only JPG, PNG or WEBP photos.' : bad + ' files skipped — only JPG, PNG or WEBP photos.');
    if (big) phToast(big === 1 ? 'A photo is larger than 30 MB — skipped.' : big + ' photos are larger than 30 MB — skipped.');
    if (dups.length) phToast(dups.length === 1 ? '"' + phName(dups[0]) + '" is already added — skipped' : dups.length + ' photos were already added — skipped');
    if (!ok.length) return;
    var one = ok.length === 1;   /* Personalize: exactly ONE photo picked opens the crop editor (spec 5.3) - a multi-pick never does */
    var spots = phEmpties(Math.max(0, Math.min(from || 0, state.slots.length - 1)));
    var over = [];
    PH.spare = [];
    if (!spots.length) {
      /* 28-09 preview test: a full pack offers the pack that takes the new photos too */
      if (phOfferBigger(ok)) return;
      phToast('Every spot has a photo — tap × on one to change it'); return;
    }
    if (ok.length > spots.length) {
      over = ok.slice(spots.length);
      ok = ok.slice(0, spots.length);
      PH.spare = over.slice();   /* a photo of this batch that turns out too small hands its spot to the next of these */
    }
    pzTrack('fill');
    var fresh = [], moved = 0;
    ok.forEach(function (f, k) {
      var pk = parked[phFileKey(f)], old = pk == null ? null : state.more[pk];
      if (!old) { fresh.push({ f: f, i: spots[k] }); return; }
      state.more[pk] = null;
      if (!phJob(old).orig) phJob(old).orig = f;   /* restored after a reload: tap-to-adjust works again */
      state.slots[spots[k]].sel = old;
      moved++;
    });
    if (moved) photoRefit();   /* a parked photo cut for another size is cut again for its new spot */
    if (!FRAMED && one && fresh.length === 1) {
      /* Personalize: one photo is one big poster - the crop editor, as before (starts on the same 42% cut) */
      activeSlot = fresh[0].i;
      edPreset = phBias;
      openEditor(fresh[0].f);
      return;
    }
    fresh.forEach(function (o) {
      var f = o.f, sel = { type: 'upload', title: 'Your photo', thumb: null, url: null, status: 'uploading', pct: 0, pin: !!pin || isPinFile(f), fk: phFileKey(f), px: null };
      phJob(sel).orig = f;
      state.slots[o.i].sel = sel;
      PH.q.push(sel);
    });
    if (moved) save();
    render();
    /* 28-09 preview test: the photos the pack had no room for are offered the pack that takes them all (before, they were
       dropped silently - Mini is 97% 5-packs, and this is the moment 15 prints makes sense) */
    if (over.length && !phOfferBigger(over)) phToast(spots.length === 1 ? 'Only 1 spot left — added the first photo' : 'Only ' + spots.length + ' spots left — added the first ' + spots.length);
    phNext();
  }
  /* one photo at a time: decode -> DPI gate -> cut -> export -> thumbs -> upload queue */
  function phNext() {
    if (PH.busy) return;
    var sel = PH.q.shift();
    while (sel && !phAlive(sel)) sel = PH.q.shift();
    if (!sel) {
      PH.spare = [];   /* the batch is done: its leftover photos wait only in a Switch offer (photoAdd) */
      if (PH.small.length) {
        var s = PH.small; PH.small = [];
        phToast(s.length === 1 ? '"' + s[0] + '" is too small for a sharp print — use the original photo, not a WhatsApp copy'
                               : s.length + ' photos are too small for a sharp print — use the original photos, not WhatsApp copies');
      }
      return;
    }
    PH.busy = true;
    photoPrep(sel, function () { PH.busy = false; setTimeout(phNext, 0); });
  }
  function phSizeOf(sel) { var i = phIndex(sel); return ((i > -1 ? state.slots[i] : state.slots[0]) || {}).size; }
  function phDecode(file, cb) {
    /* <img> decodes with the photo's EXIF orientation applied (every current browser), like the crop editor */
    var url = URL.createObjectURL(file), im = new Image(), fired = false;
    var free = function () { try { im.onload = im.onerror = null; im.removeAttribute('src'); } catch (e) {} URL.revokeObjectURL(url); };
    var ok = function () {
      if (fired) return; fired = true;
      var w = im.naturalWidth, h = im.naturalHeight;
      if (!w || !h) { free(); cb(null); return; }
      cb(im, w, h, free);
    };
    im.onload = function () { if (im.decode) im.decode().then(ok, ok); else ok(); };
    im.onerror = function () { if (fired) return; fired = true; free(); cb(null); };
    im.src = url;
  }
  function phThumb(c, max, q) {
    var s = Math.min(1, max / Math.max(c.width, c.height)), t = document.createElement('canvas');
    t.width = Math.max(1, Math.round(c.width * s)); t.height = Math.max(1, Math.round(c.height * s));
    var x = t.getContext('2d');
    x.imageSmoothingQuality = 'high';
    x.drawImage(c, 0, 0, t.width, t.height);
    var d = t.toDataURL('image/jpeg', q);
    t.width = t.height = 0;
    return d;
  }
  function phOutName(f) { return phName(f).replace(/[^\w.-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) + '.jpg'; }
  function photoPrep(sel, done) {
    var file = phJob(sel).orig;
    if (!file) { sel.status = 'error'; phRender(); done(); return; }
    phDecode(file, function (img, w, h, free) {
      if (!img) { var at0 = phIndex(sel); phDrop(sel); phSpare(at0); phToast('Could not read "' + phName(file) + '" — try another photo.'); done(); return; }
      if (!phAlive(sel)) { free(); done(); return; }
      var size = phSizeOf(sel), pi = PRINT_IN[size], out = OUT_PX[size];
      if (!pi || !out) { free(); sel.status = 'error'; phRender(); done(); return; }
      var ratio = ratioFor(size), cw, ch, cx, cy;
      if (w / h > ratio) { ch = h; cw = h * ratio; cx = (w - cw) / 2; cy = 0; }     /* wider than the window: centred across */
      else { cw = w; ch = w / ratio; cx = 0; cy = (h - ch) * 0.42; }                  /* taller: 42% down - faces sit high */
      var dpi = Math.min(cw / pi[0], ch / pi[1]);
      if (dpi < edFloor(size, file)) { var at1 = phIndex(sel); free(); phDrop(sel); PH.small.push(phName(file)); phSpare(at1); done(); return; }   /* its spot goes to the batch's next photo */
      if (!FRAMED && isPinFile(file) && dpi < floorDpiFor(size)) phToast('Small Pinterest image — we will upscale it for print. A bigger pin prints sharper.');
      /* 600 DPI of the window, never upscaled: full size is exactly OUT_PX (sheets.py), smaller photos keep their own pixels */
      var ow = Math.max(1, Math.min(out[0], Math.round(cw))), oh = ow === out[0] ? out[1] : Math.max(1, Math.round(ow / ratio));
      var c = document.createElement('canvas');
      c.width = ow; c.height = oh;
      var x = c.getContext('2d');
      x.fillStyle = '#ffffff'; x.fillRect(0, 0, ow, oh);
      x.imageSmoothingQuality = 'high';
      x.drawImage(img, cx, cy, cw, ch, 0, 0, ow, oh);
      free();
      sel.px = [Math.round(cw), Math.round(ch)];
      sel.cut = size; sel.ox = [ow, oh];   /* what the uploaded file was cut for (photoRefit, phTooSmall, lowRes) */
      sel.thumb = phThumb(c, 320, 0.72);
      sel.st = phThumb(c, 150, 0.6);
      phRender();
      c.toBlob(function (blob) {
        c.width = c.height = 0;
        if (!blob) { sel.status = 'error'; phRender(); done(); return; }
        if (phAlive(sel) && phSizeOf(sel) !== size) { if (PH.q.indexOf(sel) < 0) PH.q.push(sel); done(); return; }   /* the size changed during the cut: cut again */
        if (phAlive(sel)) phUpload(sel, new File([blob], phOutName(file), { type: 'image/jpeg' }));
        done();
      }, 'image/jpeg', 0.92);
    });
  }
  /* ---- uploads: at most 3 in flight ---- */
  function phUpload(sel, file) {
    var j = phJob(sel);
    j.out = file; j.cancelled = false; j.tries = 0; clearTimeout(j.retryT);   /* a manual Retry or a re-crop starts fresh */
    sel.status = 'uploading'; sel.pct = 0; sel.url = null;
    if (PH.up.indexOf(sel) < 0) PH.up.push(sel);
    phRender();
    phPump();
  }
  function phPump() {
    if (navigator.onLine === false) return;   /* the 'online' listener resumes the queue */
    while (PH.flying < PH_UPS && PH.up.length) {
      var sel = PH.up.shift();
      if (phAlive(sel)) phSend(sel);
    }
  }
  function phSend(sel) {
    var j = phJob(sel), file = j.out;
    if (!file) { sel.status = 'error'; phRender(); return; }
    PH.flying++;
    var xhr = new XMLHttpRequest(), ended = false, idleT = null;
    j.xhr = xhr;
    /* 28-09 fix: a connection that hangs with no error (a cell change mid-batch) held one of the 3 slots for ever -
       no bytes moving for PH_STALL aborts it, and the abort retries */
    var poke = function () { if (ended) return; clearTimeout(idleT); idleT = setTimeout(function () { if (!ended) { try { xhr.abort(); } catch (e) {} } }, PH_STALL); };
    var fin = function (url, retry) {
      if (ended) return;
      ended = true; PH.flying--; j.xhr = null; clearTimeout(idleT);
      if (!j.cancelled) {
        if (url) { sel.status = 'done'; sel.url = url; sel.pct = 100; j.out = null; j.tries = 0; save(); }
        else if (phAlive(sel)) {
          /* a network drop / stall / 429 / 5xx retries by itself (offline: waits for 'online', no try used); a 4xx is final */
          if (retry && navigator.onLine === false) { sel.status = 'uploading'; sel.pct = 0; if (PH.up.indexOf(sel) < 0) PH.up.unshift(sel); }
          else if (retry && (j.tries || 0) < PH_BACKOFF.length) {
            sel.status = 'uploading'; sel.pct = 0;
            j.retryT = setTimeout(function () { if (!j.cancelled && j.out && phAlive(sel) && PH.up.indexOf(sel) < 0) { PH.up.push(sel); phPump(); } }, PH_BACKOFF[j.tries++]);
          } else { sel.status = 'error'; phToast('Upload failed — tap Retry on the photo.'); }
        }
        phRender();
      }
      phPump();
    };
    xhr.open('POST', cfg.endpoint.replace(/\/$/, '') + '/upload');
    xhr.setRequestHeader('Content-Type', 'image/jpeg');
    xhr.upload.onprogress = function (e) {
      poke();
      if (!e.lengthComputable) return;
      sel.pct = Math.min(99, Math.round(e.loaded / e.total * 100));
      var i = phIndex(sel), el = i > -1 ? slotEl(i) : null, ring = el && el.querySelector('.pz-wb-ring');
      if (ring) ring.setAttribute('data-pct', sel.pct + '%');
    };
    xhr.upload.onload = xhr.onprogress = poke;
    xhr.onload = function () {
      var url = null;
      try { var r = JSON.parse(xhr.responseText || '{}'); if (xhr.status === 200 && r.url) url = String(r.url); } catch (e) {}
      fin(url, !url && (xhr.status === 0 || xhr.status === 429 || xhr.status >= 500));
    };
    xhr.onerror = function () { fin(null, true); };
    xhr.onabort = function () { fin(null, true); };   /* a × tap sets j.cancelled first, so it never retries */
    poke();
    xhr.send(file);
  }
  /* ---- a tap on a spot ---- */
  function phBias() {
    /* the editor opens on the automatic cut: 42% down a photo taller than the frame */
    var rd = edRotDims(), ih = rd.h * edCover() * ed.zoom;
    if (ih > ed.frame.h + 1) ed.ty = 0.08 * (ih - ed.frame.h);
  }
  function photoTap(i) {
    var s = state.slots[i];
    if (!s) return;
    var sel = s.sel;
    if (!sel) { photoPick(i); return; }
    var j = PH.jobs.get(sel);
    if (sel.status === 'error') {
      if (j && j.out) { phUpload(sel, j.out); return; }
      if (j && j.orig) { sel.status = 'uploading'; PH.q.push(sel); phRender(); phNext(); return; }
      toast('To adjust this photo, remove it and add it again.');
      return;
    }
    if (sel.status !== 'done') { toast('Hold on — this photo is still uploading…'); return; }
    if (!j || !j.orig) { toast('To adjust this photo, remove it and add it again.'); return; }
    activeSlot = i;
    var st = j.ed;
    edPreset = st ? function () {
      ed.rot = st.rot; ed.flip = st.flip; ed.zoom = st.zoom; ed.slider.value = Math.round(st.zoom * 100);
      ed.tx = st.txf * ed.frame.w; ed.ty = st.tyf * ed.frame.h;
    } : phBias;
    openEditor(j.orig);
    edRemoveFor(i);   /* 28-09 preview test: Remove sits in the editor too */
  }
  /* the crop editor's "Use photo" on a photo product: same export (above), then a <= 320 px thumb, the upload queue,
     and the original kept for the next adjust */
  function photoFromEditor(c, z) {
    var slotIdx = activeSlot, file0 = ed.file;
    var thumbUrl = phThumb(c, 320, 0.72), st = phThumb(c, 150, 0.6);
    var px = [Math.round(ed.frame.w / z), Math.round(ed.frame.h / z)];
    var saved = { rot: ed.rot, flip: ed.flip, zoom: ed.zoom, txf: ed.frame.w ? ed.tx / ed.frame.w : 0, tyf: ed.frame.h ? ed.ty / ed.frame.h : 0 };
    var cut0 = slotSize(), ox0 = [c.width, c.height];   /* read before toBlob: c.width is zeroed inside it */
    c.toBlob(function (blob) {
      c.width = c.height = 0;
      if (slotIdx < 0 || !state.slots[slotIdx]) { toast('That spot is no longer open — tap a spot and try again.'); edClose(); return; }
      if (!blob) { toast('Could not process the photo, please retry.'); return; }
      edClose();
      var old = state.slots[slotIdx].sel;
      if (old) photoCancel(old);
      var sel = { type: 'upload', title: 'Your photo', thumb: thumbUrl, st: st, url: null, status: 'uploading', pct: 0,
                  pin: isPinFile(file0), fk: file0 ? phFileKey(file0) : ((old && old.fk) || null), px: px, cut: cut0, ox: ox0 };
      var j = phJob(sel);
      j.orig = file0; j.ed = saved;
      state.slots[slotIdx].sel = sel;
      pzTrack('fill');
      render();
      phUpload(sel, new File([blob], phOutName(file0), { type: 'image/jpeg' }));
    }, 'image/jpeg', 0.92);
  }
  /* ---- what a spot shows ---- */
  function lowRes(sel, size) {
    var pi = PRINT_IN[size];
    var e = sel && (sel.ox || sel.px);   /* the pixels that print (the export never upscales, so ox <= px) */
    if (!e || !pi) return false;
    return Math.min(e[0] / pi[0], e[1] / pi[1]) < 150;
  }
  /* below the hard floor for this size: an original is judged on its source crop (it can be cut again), anything
     else (restored, cart edit) on the file it has */
  function phTooSmall(sel, size) {
    var pi = PRINT_IN[size], j = PH.jobs.get(sel);
    var e = (j && j.orig) ? sel.px : (sel.ox || sel.px);
    return !!(pi && e) && Math.min(e[0] / pi[0], e[1] / pi[1]) < edFloor(size, sel.pin ? { name: 'pinterest-' } : null);
  }
  /* 28-09 fix: a size / pack switch re-cuts every photo whose file was cut for another size (new aspect, new export
     size) from its original; a photo too small for the new size stays as it was (for a switch back) and blocks Add to
     cart. Restored / cart-edit photos have no original and are only gated. */
  function photoRefit() {
    var n = 0;
    state.slots.forEach(function (s) {
      var sel = s.sel, j = sel && PH.jobs.get(sel);
      if (!sel || !sel.cut || sel.cut === s.size || !j || !j.orig) return;
      if (phTooSmall(sel, s.size)) return;   /* kept for a switch back; blocked at Add to cart */
      var same = Math.abs(ratioFor(s.size) / ratioFor(sel.cut) - 1) < 0.01;
      var want = Math.min(OUT_PX[s.size][0], sel.px ? sel.px[0] : 1e9);
      if (same && sel.ox && sel.ox[0] >= want - 2) return;   /* file already big enough */
      photoCancel(sel); j.ed = null;
      sel.status = 'uploading'; sel.url = null; sel.pct = 0;   /* old thumb stays until the new one lands */
      if (PH.q.indexOf(sel) < 0) PH.q.push(sel);
      n++;
    });
    if (n) { phRender(); phNext(); }
  }
  function lowBadge(tiny) { var b = document.createElement('span'); b.className = 'pz-wb-lowres'; b.textContent = tiny ? 'LOW' : 'LOW RES'; return b; }
  /* 28-09 preview test: a photo below the hard floor for the size on screen (after a size switch) is not "soft" - it
     cannot be added. Its own red TOO SMALL badge (the photo dims), not the LOW RES warning. */
  function photoBadge(sel, size, tiny) {
    if (!sel) return null;
    if (sel.status === 'done' && phTooSmall(sel, size)) {
      var b = document.createElement('span'); b.className = 'pz-wb-lowres pz-wb-toosmall'; b.textContent = tiny ? 'SMALL' : 'TOO SMALL'; return b;
    }
    return lowRes(sel, size) ? lowBadge(tiny) : null;
  }
  function phSmallCount() {
    return state.slots.filter(function (s) { return s.sel && s.sel.status === 'done' && phTooSmall(s.sel, s.size); }).length;
  }
  function phSmallMsg(n) {
    var sz0 = state.slots[0] && state.slots[0].size, nm = sizeLabel(sz0) + (PHOTO_CELL_NAME[sz0] ? '' : ' print');
    return n === 1 ? '1 photo is too small for a sharp ' + nm + ' — tap × and add the original photo, or pick a smaller size.'
                   : n + ' photos are too small for a sharp ' + nm + ' — tap × and add the original photos, or pick a smaller size.';
  }
  /* said once, when a size switch makes a photo too small (not only at Add to cart) */
  function phSmallNote() { var n = phSmallCount(); if (n) phToast(phSmallMsg(n)); }

  /* ---- the x (28-09 preview test) ----
     It was a child of the spot button with a 31 px hit area: Chrome's touch adjustment sends a tap to the innermost
     clickable, so a tap on the middle of a 45-60 px photo removed it instead of opening the editor. It is now the spot's
     SIBLING (a tap inside the photo belongs to the photo), centred on the top-right corner of the card (mini, retro), of
     the window (booth: inside a 45 px window it would cover the middle) or of the poster (Personalize: on an 18-pack's
     39 px poster an inside x took a third of it), so it sits mostly off the photo. */
  /* 28-09 round 2: where the finger really went down. Chrome's touch adjustment (and its rect hit-test) retargets a tap
     near a photo's corner to the x that overlaps it - often the NEIGHBOUR's x (booth: the x sat on the junction with
     the window above). The x's click checks the raw point: on a photo spot (not on this x) = that spot's tap. */
  var phTouch = null;
  if (PHOTO) document.addEventListener('touchstart', function (e) {
    var p = e.touches && e.touches[0];
    if (p) phTouch = { x: p.clientX, y: p.clientY, t: Date.now() };
  }, { capture: true, passive: true });
  function photoClearBtn(i, g, tiny) {
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'pz-wb-fx corner' + (tiny ? ' tiny' : '');
    x.setAttribute('aria-label', 'Remove photo ' + (i + 1));
    x.innerHTML = '<span aria-hidden="true">&#10005;</span>';
    x.style.left = (g.x + g.w).toFixed(3) + '%';
    x.style.top = g.y.toFixed(3) + '%';
    x.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (phTouch && Date.now() - phTouch.t < 1000) {
        /* on this x = inside its box at layout size, as Chrome hit-tests it (the :active scale(.9) must not shrink it) */
        var r = x.getBoundingClientRect(), dx = phTouch.x - (r.left + r.width / 2), dy = phTouch.y - (r.top + r.height / 2);
        var raw = (Math.abs(dx) > x.offsetWidth / 2 || Math.abs(dy) > x.offsetHeight / 2) && document.elementFromPoint(phTouch.x, phTouch.y);
        if (raw && !x.contains(raw) && raw.closest) {
          var ox = raw.closest('.pz-wb-fx'), sp = raw.closest('.pz-wb-slot');
          if (ox && ox !== x && root.contains(ox)) { ox.click(); return; }   /* the finger was on another photo's x */
          if (sp && root.contains(sp)) { sp.click(); return; }             /* the finger was on a photo: open it, never remove */
        }
      }
      photoRemove(i);
    });
    return x;
  }
  /* a removed photo can come back for a few seconds (Undo); one whose upload was stopped goes back in the queue */
  function phRevive(list) {
    var n = 0;
    list.forEach(function (sel) {
      if (!sel || (sel.status === 'done' && sel.url)) return;
      var j = PH.jobs.get(sel);
      if (j && j.orig) { j.cancelled = false; sel.status = 'uploading'; sel.url = null; sel.pct = 0; if (PH.q.indexOf(sel) < 0) PH.q.push(sel); n++; }
      else {
        var k = phIndex(sel);
        if (k > -1) state.slots[k].sel = null;
        else { var m = (state.more || []).indexOf(sel); if (m > -1) state.more[m] = null; }
      }
    });
    if (n) phNext();
  }
  function photoRemove(i) {
    var s = state.slots[i], sel = s && s.sel;
    if (!sel) return;
    var size = state.size;
    var j0 = PH.jobs.get(sel), kept = j0 && j0.out;   /* round 2: the file being sent (the shopper's own crop) - Undo re-sends it, never a fresh automatic cut */
    photoCancel(sel);
    s.sel = null;
    save(); render();
    phActToast('Photo removed', 'Undo', function () {
      if (state.size !== size || !state.slots[i] || state.slots[i].sel || phAlive(sel)) return;
      state.slots[i].sel = sel;   /* back in the set first: phPump skips a photo that is not */
      if (kept && !(sel.status === 'done' && sel.url)) phUpload(sel, kept);
      else phRevive([sel]);
      save(); render();
    }, 5000);
  }
  /* a toast with one action (Undo / Switch). Plain toasts that arrive meanwhile sit above it (CSS). */
  var phAct = null;
  function phActToast(msg, label, fn, ms) {
    if (phAct) { clearTimeout(phAct.t); if (phAct.el.parentNode) phAct.el.parentNode.removeChild(phAct.el); }
    var el = document.createElement('div');
    el.className = 'pz-wb-toast pz-wb-toast--act';
    el.setAttribute('role', 'status');
    el.innerHTML = '<span class="pz-wb-toast-t"></span><button type="button" class="pz-wb-toast-b"></button>';
    el.firstChild.textContent = msg;
    el.lastChild.textContent = label;
    var me = { el: el, t: null };
    var gone = function () { clearTimeout(me.t); if (el.parentNode) el.parentNode.removeChild(el); if (phAct === me) phAct = null; };
    el.lastChild.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); gone(); fn(); });
    document.body.appendChild(el);
    me.t = setTimeout(gone, ms || 5000);
    phAct = me;
  }
  /* 28-09 preview test: more photos picked than there are empty spots - the smallest pack of this size that takes them
     all (its spots, not its price), if the product sells one */
  function photoFitPack(n) {
    var m0 = SIZE_META[state.size];
    if (!m0) return null;
    var best = null;
    Object.keys(SIZE_META).forEach(function (k) {
      var m = SIZE_META[k];
      if (k === state.size || m.size !== m0.size || !LAYOUTS[k] || !variantFor(k) || m.posters < n || m.posters <= m0.posters) return;
      if (!best || m.posters < SIZE_META[best].posters) best = k;
    });
    return best;
  }
  /* the offer: "8 photos picked - get 15 prints (Rs 219) for all of them [Switch]". Prices and pack names are the
     product's own; the switch keeps every photo (photoCarry) and adds the rest. false = no bigger pack takes them. */
  function phOfferBigger(files) {
    if (EDIT) return false;   /* editing a cart line: its pack changes only on the rail, on purpose */
    if (phCartDup(true)) return false;   /* round 2: photos already in the cart - no "for all of them" upgrade (it adds a SECOND line) */
    var parked = {};
    (state.more || []).forEach(function (s) { if (s && s.fk) parked[s.fk] = 1; });   /* parked photos come back by themselves */
    var extra = files.filter(function (f) { return !f.__pzUsed && !parked[phFileKey(f)]; });
    if (!extra.length) return false;
    var n = photoAll().filter(Boolean).length + extra.length, key = photoFitPack(n);
    if (!key) return false;
    var m = SIZE_META[key], vr = variantFor(key);
    phActToast(n + ' photos picked — get ' + m.name + ' (' + money(vr.v.price) + ') for all of them', 'Switch', function () {
      if (!LAYOUTS[key] || !variantFor(key)) return;
      if (state.size !== key) { pzTrack('pack'); setSize(key); }
      var left = extra.filter(function (f) { return !f.__pzUsed; }), at = phEmpties(0)[0];
      if (left.length && at != null) photoAdd(left, at, false);
    }, 8000);
    return true;
  }
  /* a photo of this batch that was too small (or unreadable) leaves its spot to the next photo the batch had no room for */
  function phSpare(i) {
    if (i < 0 || !state.slots[i] || state.slots[i].sel) return;
    var f = PH.spare.shift();
    if (!f) return;
    f.__pzUsed = true;
    var sel = { type: 'upload', title: 'Your photo', thumb: null, url: null, status: 'uploading', pct: 0, pin: isPinFile(f), fk: phFileKey(f), px: null };
    phJob(sel).orig = f;
    state.slots[i].sel = sel;
    PH.q.push(sel);
    phRender();
  }
  /* 28-09 preview test: the bigger packs say what they save per print against the smallest pack of the same size - the
     old pack cards' "Save 26%" (same numbers). Only where the card has no compare-at strike (mini 15 / 30, retro 20 / 50). */
  function photoSaveHtml(key) {
    if (!FRAMED) return '';
    var m = SIZE_META[key], vr = variantFor(key);
    if (!m || !vr || !m.units || vr.v.compareAt > vr.v.price) return '';
    var base = null;
    Object.keys(SIZE_META).forEach(function (k) {
      var x = SIZE_META[k];
      if (x.size === m.size && x.units && LAYOUTS[k] && variantFor(k) && (!base || x.units < SIZE_META[base].units)) base = k;
    });
    if (!base || base === key) return '';
    var bv = variantFor(base), pct = Math.round((1 - (vr.v.price / m.units) / (bv.v.price / SIZE_META[base].units)) * 100);
    return pct >= 3 ? ' <span class="pz-wb-size-save">Save ' + pct + '%</span>' : '';
  }
  /* 28-09 preview test: after Add to cart, look for the line in the cart. Found: the button reads "In your cart" until the
     set changes (a second tap opens the cart - no twin line by accident). Not found (a 429 / a dropped connection): the
     photos are saved again (they were cleared at the tap) and Add to cart works again. */
  function phWatchAdd(key) {
    var u1 = state.slots[0] && state.slots[0].sel && state.slots[0].sel.url, lay = state.size, tries = [1500, 3500, 7000], k = 0;
    if (!u1) return;
    (function look() {
      setTimeout(function () {
        if (PH.soldKey !== key) return;   /* the set changed meanwhile - nothing to confirm */
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          var has = (c.items || []).some(function (it) { var p = it.properties || {}; return p['_Poster 1'] === u1 && p['_Print Layout'] === lay; });
          if (has) phCartSeen(c);
          return has;
        }).catch(function () { return false; }).then(function (inCart) {
          if (PH.soldKey !== key) return;
          if (inCart) { PH.addOk = key; render(); return; }
          if (++k < tries.length) { look(); return; }
          PH.soldKey = null;
          photoSave();
          render();
          phToast('Your photos are still here — tap Add to cart to try again.');
        });
      }, tries[k] - (k ? tries[k - 1] : 0));
    })();
  }
  function phInCart() { return !!(PHOTO && !EDIT && PH.addOk && PH.addOk === pvKeyNow()); }
  /* 28-09 round 2: the photo URLs the cart holds (every '_Poster N' of every line), read whenever the builder reads
     /cart.js. PH.addOk is gone as soon as one photo changes; this is not - a photo already in a cart line never rides
     into a second line by accident (the Switch offer, a pack tap after the add) without the shopper saying so. */
  function phCartSeen(c) {
    var u = [];
    (c && c.items || []).forEach(function (it) {
      var p = it.properties || {};
      Object.keys(p).forEach(function (k) { if (/^_Poster \d+$/.test(k) && p[k]) u.push(String(p[k])); });
    });
    PH.cartUrls = u;
  }
  /* how many photos of this set (all = also the ones kept past the pack) are already in a cart line */
  function phCartDup(all) {
    var c = PH.cartUrls || [];
    if (!c.length) return 0;
    return (all ? photoAll() : state.slots.map(function (s) { return s.sel; })).filter(function (x) { return x && x.url && c.indexOf(x.url) > -1; }).length;
  }
  function photoPrepEl() { var p = document.createElement('span'); p.className = 'pz-wb-prep'; p.setAttribute('aria-hidden', 'true'); p.innerHTML = '<i></i>'; return p; }
  /* under the stage: the LOW RES line (when any) and the paste-a-link row */
  function photoUnderStage() {
    var small = phSmallCount();
    var low = state.slots.filter(function (s) { return s.sel && lowRes(s.sel, s.size) && !(s.sel.status === 'done' && phTooSmall(s.sel, s.size)); }).length;
    if (small) {
      /* 28-09 preview test: too small for this size is a blocker, said as one (not "may print soft") */
      var sz0 = state.slots[0].size, gs = gridSizes(), smaller = gs.length > 1 && gs[0].key !== (SIZE_META[state.size] || {}).size;
      var ps = document.createElement('p');
      ps.className = 'pz-wb-lowline pz-wb-lowline--small';
      ps.innerHTML = '<b>TOO SMALL</b><span>' + (small === 1 ? '1 photo is' : small + ' photos are') + ' too small for a sharp ' +
        sizeLabel(sz0) + (PHOTO_CELL_NAME[sz0] ? '' : ' print') + ' — tap × to swap ' + (small === 1 ? 'it' : 'them') +
        (smaller ? ', or pick a smaller size' : '') + '.</span>';
      root.appendChild(ps);
    }
    if (low) {
      var p = document.createElement('p');
      p.className = 'pz-wb-lowline';
      p.innerHTML = '<b>LOW RES</b><span>' + (low === 1 ? '1 photo may print soft' : low + ' photos may print soft') +
        ' — use the original photo if you have it (× to swap).</span>';
      root.appendChild(p);
    }
    root.appendChild(photoPinRow());
  }
  function photoPinRow() {
    if (PH.pinRow) return PH.pinRow;
    var row = PH.pinRow = document.createElement('div');
    row.className = 'pz-wb-pinrow';
    row.innerHTML = '<span class="pz-wb-pinrow-ico" aria-hidden="true">' + (window.PZ_PIN_ICON || '') + '</span>' +
      '<input type="url" inputmode="url" autocomplete="off" spellcheck="false" placeholder="or paste a Pinterest link" aria-label="Paste a Pinterest link">' +
      '<button type="button">Add</button>';
    var inp = row.querySelector('input'), btn = row.querySelector('button');
    var fin = function () { PH.pinBusy = false; btn.disabled = false; btn.textContent = 'Add'; };
    var go = function () {
      var raw = (inp.value || '').trim();
      if (!raw) { inp.focus(); return; }
      if (!/^https?:\/\/\S+$/i.test(raw)) { toast('That is not a link - paste the image link.'); return; }
      if (/instagram\.com|instagr\.am|facebook\.com|fb\.com/i.test(raw)) { toast('Instagram does not share pictures by link. Save the picture (or take a screenshot) and add it from your photos.'); return; }
      if (PH.pinBusy) return;
      var spot = phEmpties(0)[0];
      if (spot == null) { toast('Every spot has a photo — tap × on one to change it'); return; }
      PH.pinBusy = true; btn.disabled = true; btn.textContent = '…';
      var xhr = new XMLHttpRequest();
      xhr.open('GET', cfg.endpoint.replace(/\/$/, '') + '/pin?url=' + encodeURIComponent(raw));
      xhr.responseType = 'blob'; xhr.timeout = 30000;
      xhr.onload = function () {
        fin();
        if (xhr.status === 429 || xhr.status === 403 || xhr.status >= 500) { toast('Pinterest fetch is unavailable right now - save the image from Pinterest and add it from your photos.'); return; }
        if (xhr.status !== 200) {
          var msg = 'Could not fetch that image.';
          try { var r = new FileReader(); r.onload = function () { try { msg = JSON.parse(r.result).error || msg; } catch (e) {} toast(msg); }; r.readAsText(xhr.response); } catch (e) { toast(msg); }
          return;
        }
        var type = (xhr.getResponseHeader('Content-Type') || 'image/jpeg').split(';')[0];
        if (!/^image\/(jpeg|png|webp)$/.test(type)) type = 'image/jpeg';
        var ext = type === 'image/png' ? '.png' : type === 'image/webp' ? '.webp' : '.jpg';
        var file = new File([xhr.response], 'pinterest-' + Date.now() + ext, { type: type, lastModified: Date.now() });
        inp.value = '';
        inp.blur();
        photoAdd([file], spot, true);
      };
      xhr.onerror = function () { fin(); toast(navigator.onLine === false ? 'No connection — try again.' : 'Pinterest fetch is unavailable right now - save the image from Pinterest and add it from your photos.'); };
      xhr.ontimeout = function () { fin(); toast('Pinterest took too long — try again or add the photo from your phone.'); };
      xhr.send();
    };
    btn.addEventListener('click', go);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
    inp.addEventListener('paste', function () { setTimeout(go, 60); });
    return row;
  }
  /* ---- the cart line (floor contract, spec 28-09 section 2) ----
     _Poster 1..N (worker URLs, spot order; booth strip-major), Uploaded Images, _Print Layout (for Edit),
     optional _Wall Preview and _Pinterest. Never _Wall Layout / Wall Size / Slot N / _Slot N Image / _Wall Preview Status. */
  function photoProps() {
    var out = [], n = 0, pins = 0;
    var add = function (k, v) { out.push([k, v]); };
    state.slots.forEach(function (s, i) {
      if (!s.sel || !s.sel.url) return;
      add('_Poster ' + (i + 1), s.sel.url);
      n++;
      if (s.sel.pin) pins++;
    });
    add('Uploaded Images', n === 1 ? '1 image ✓' : n + ' images ✓');
    add('_Print Layout', state.size);
    if (previewReady()) add('_Wall Preview', state.pv);
    if (pins) add('_Pinterest', pins + (pins === 1 ? ' photo' : ' photos') + ' from Pinterest');
    else if (EDIT && EDIT.pinNote && (EDIT.lineUrls || []).every(function (u) { return state.slots.some(function (s) { return s.sel && s.sel.url === u; }); })) add('_Pinterest', EDIT.pinNote);
    return out;
  }
  /* Add to cart only with every spot uploaded (status done + a URL) */
  function photoReadyToAdd() {
    var busy = 0, errs = 0, missing = 0, first = -1, urls = {}, dup = false, small = 0;
    state.slots.forEach(function (s, i) {
      var x = s.sel;
      if (!x) { missing++; if (first < 0) first = i; return; }
      if (x.status === 'error') { errs++; return; }
      if (x.status !== 'done' || !x.url) { busy++; return; }
      if (phTooSmall(x, s.size)) small++;
      if (urls[x.url]) dup = true;
      urls[x.url] = 1;
    });
    if (errs) {
      /* 28-09 fix: this one tap sends every spot that did not upload again (no Retry tap per photo) */
      var n = 0;
      state.slots.forEach(function (s) {
        var x = s.sel, j = x && PH.jobs.get(x);
        if (!x || x.status !== 'error' || !j) return;
        if (j.out) { phUpload(x, j.out); n++; }
        else if (j.orig) { x.status = 'uploading'; x.pct = 0; PH.q.push(x); n++; }
      });
      if (n) { phNext(); phRender(); toast(n === 1 ? 'Retrying 1 photo that did not upload…' : 'Retrying ' + n + ' photos that did not upload…'); }
      else toast(errs === 1 ? '1 photo did not upload — tap Retry on it.' : errs + ' photos did not upload — tap Retry on them.');
      return false;
    }
    if (busy) { toast('Hold on — your photos are still uploading…'); return false; }
    if (missing) {
      toast('Add ' + missing + ' more photo' + (missing === 1 ? '' : 's'));
      if (first > -1) photoPick(first);   /* the tap's own gesture: the phone's picker opens on the first empty spot */
      return false;
    }
    if (small) {
      var sz0 = state.slots[0].size, nm = sizeLabel(sz0) + (PHOTO_CELL_NAME[sz0] ? '' : ' print');
      toast(small === 1
        ? '1 photo is too small for a sharp ' + nm + ' — tap × and add the original photo, or pick a smaller size.'
        : small + ' photos are too small for a sharp ' + nm + ' — tap × and add the original photos, or pick a smaller size.');
      return false;
    }
    if (dup) { toast('The same photo is in two spots — remove one and add another photo.'); return false; }
    return true;
  }
  /* ?pzedit: the line's _Poster N back into the spots (thumb = the uploaded file) */
  function photoFromLine(p) {
    var urls = [];
    state.slots.forEach(function (s, i) {
      var u = p['_Poster ' + (i + 1)] ? String(p['_Poster ' + (i + 1)]) : '';
      if (u.indexOf('//') === 0) u = 'https:' + u;
      s.sel = u ? { type: 'upload', title: 'Your photo', thumb: u, url: u, status: 'done', pct: 100, pin: false, fk: null, px: null, cut: s.size, ox: null } : null;
      if (u) urls.push(u);
    });
    EDIT.pinNote = p['_Pinterest'] ? String(p['_Pinterest']) : null;
    EDIT.lineUrls = urls;
  }
  /* _Wall Preview for the cart's "See your prints": the arrangement from the thumbs (never the full-size files), frames
     drawn as printed. Only a single Personalize poster uses its uploaded file - a 320 px thumb is too soft that big. */
  var PH_BG = { mini: '#efe8dc', retro: '#f1ebe1', booth: '#eee8df' };
  /* 21-10 #331500 (Showcase, all 15 boxes white): a picture that fails is tried ONCE more on the next URL
     (thumb -> full file); the same URL again gets a cache-buster. done(im|null) fires exactly once. */
  var PV_GUARD_MS = 20000;
  function pvLoadImg(srcs, done) {
    var list = [];
    srcs.forEach(function (u) { if (u && list.indexOf(u) < 0) list.push(u); });
    if (!list.length) { done(null); return; }
    if (list.length === 1 && !/^(data|blob):/.test(list[0])) list.push(list[0] + (list[0].indexOf('?') > -1 ? '&' : '?') + 'pzr=1');
    var k = 0;
    (function go() {
      var src = list[k], im = new Image();
      if (!/^(data|blob):/.test(src)) im.crossOrigin = 'anonymous';
      if (/posterized-uploads|posterizedfloor\.uk/.test(src) && !/[?&]cors=1/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'cors=1';
      im.onload = function () { if (im.naturalWidth) done(im); else if (++k < Math.min(list.length, 2)) go(); else done(null); };
      im.onerror = function () { if (++k < Math.min(list.length, 2)) go(); else done(null); };
      im.src = src;
    })();
  }
  /* the slot boxes as % of the wall, [[x,y,w,h],...] - the floor can always redraw the preview from these */
  function wallBoxes() {
    try {
      return JSON.stringify(computeLayout(state.size).slots.map(function (g) {
        return [g.x, g.y, g.w, g.h].map(function (v) { return Math.round(v * 100) / 100; });
      }));
    } catch (e) { return ''; }
  }
  /* 23-10 #332128 (s18-a3 Mix & Match, 7 of 18 boxes WHITE): 3363x4756 customer uploads (3-5 MB) "loaded", the phone
     painted them onto the canvas as nothing (too big to decode next to the rest) and got++ still counted them.
     Now (1) a picture over PV_MAX_PX on its long side is drawn from a downscaled copy (createImageBitmap resize, else a
     canvas step), one at a time, never the full original; (2) after drawing, every box is pixel-checked - a box that
     is still the empty fill counts only when its own source picture is near that colour too (real white-design
     posters); (3) a failed box is tried ONCE more at PV_RETRY_PX; still failing -> cb(null) -> the MISSING path. */
  var PV_MAX_PX = 1600, PV_RETRY_PX = 800, PV_RETRY_MS = 8000, PV_SHRINK_MS = 6000;
  var pvShrinkQ = [], pvShrinkBusy = false;
  /* the source's own pixels on a fresh, transparent 12x12 canvas: ok = it really paints, mean = its average tone */
  function pvProbe(src) {
    if (src && src.__pzProbe) return src.__pzProbe;
    var r = { ok: false, mean: [0, 0, 0] };
    try {
      var n = 12, pc = document.createElement('canvas'); pc.width = n; pc.height = n;
      var px = pc.getContext('2d'); px.drawImage(src, 0, 0, n, n);
      var d = px.getImageData(0, 0, n, n).data, op = 0, sr = 0, sg = 0, sb = 0;
      for (var q = 0; q < d.length; q += 4) if (d[q + 3] > 200) { op++; sr += d[q]; sg += d[q + 1]; sb += d[q + 2]; }
      if (op >= n * n * 0.5) r = { ok: true, mean: [sr / op, sg / op, sb / op] };
    } catch (e) {}
    try { src.__pzProbe = r; } catch (e) {}
    return r;
  }
  /* im -> done(a picture <= max px on its long side that really paints | null); big ones queue, one decode at a time */
  function pvShrink(im, max, done) {
    var w = im && (im.naturalWidth || im.width), h = im && (im.naturalHeight || im.height);
    if (!w || !h) { done(null); return; }
    if (Math.max(w, h) <= max) { done(im); return; }
    pvShrinkQ.push({ im: im, w: w, h: h, max: max, done: done });
    pvShrinkNext();
  }
  function pvShrinkNext() {
    if (pvShrinkBusy || !pvShrinkQ.length) return;
    pvShrinkBusy = true;
    var job = pvShrinkQ.shift(), k = job.max / Math.max(job.w, job.h);
    var tw = Math.max(1, Math.round(job.w * k)), th = Math.max(1, Math.round(job.h * k)), settled = false;
    var tmo = setTimeout(function () { fin(null); }, PV_SHRINK_MS);
    function fin(out) {
      if (settled) { try { if (out && out.close) out.close(); } catch (e) {} return; }
      settled = true; clearTimeout(tmo);
      if (out && !pvProbe(out).ok) { try { if (out.close) out.close(); } catch (e) {} out = null; }
      pvShrinkBusy = false;
      try { job.done(out); } catch (e) {}
      pvShrinkNext();
    }
    function viaCanvas(src) {
      try {
        var sc = document.createElement('canvas'); sc.width = tw; sc.height = th;
        var sx = sc.getContext('2d'); sx.imageSmoothingQuality = 'high';
        sx.drawImage(src, 0, 0, tw, th);
        fin(sc);
      } catch (e) { fin(null); }
    }
    if (window.createImageBitmap) {
      try {
        window.createImageBitmap(job.im, { resizeWidth: tw, resizeHeight: th, resizeQuality: 'high' }).then(function (bm) {
          if (settled) { try { bm.close(); } catch (e) {} return; }
          if (Math.abs(bm.width - tw) <= 1 && Math.abs(bm.height - th) <= 1) { fin(bm); return; }
          viaCanvas(bm); try { bm.close(); } catch (e) {}   /* resize options ignored (older Safari): one canvas step */
        }, function () { if (!settled) viaCanvas(job.im); });
      } catch (e) { viaCanvas(job.im); }
    } else viaCanvas(job.im);
  }
  /* srcs -> done(downscaled picture | null): pvLoadImg (one URL retry) + pvShrink */
  function pvLoadSmall(srcs, max, done) {
    pvLoadImg(srcs, function (im) { if (!im) { done(null); return; } pvShrink(im, max, done); });
  }
  /* boxes [{i, r:{x,y,w,h}, pic(cx,x,y,w,h)}] -> the slot indexes that did not really draw. A box still the empty
     fill (9x9 samples, inner 76%) counts only when the SAME crop of its own picture, drawn by pic() on a fresh
     transparent canvas, really paints and is near that colour too (a real white-design poster). */
  function pvBadBoxes(ctx, W, H, boxes, imgs, fill) {
    var bad = [], data = null;
    try { data = ctx.getImageData(0, 0, W, H).data; } catch (e) { return boxes.map(function (b) { return b.i; }); }
    boxes.forEach(function (b) {
      var im = imgs[b.i], r = b.r;
      if (!im) { bad.push(b.i); return; }
      var blank = true, n = 9, ix = r.w * 0.12, iy = r.h * 0.12;
      for (var a = 0; a < n && blank; a++) for (var c2 = 0; c2 < n && blank; c2++) {
        var X = Math.min(W - 1, Math.max(0, Math.round(r.x + ix + (r.w - 2 * ix) * a / (n - 1))));
        var Y = Math.min(H - 1, Math.max(0, Math.round(r.y + iy + (r.h - 2 * iy) * c2 / (n - 1))));
        var o = (Y * W + X) * 4;
        if (Math.abs(data[o] - fill[0]) > 10 || Math.abs(data[o + 1] - fill[1]) > 10 || Math.abs(data[o + 2] - fill[2]) > 10) blank = false;
      }
      if (!blank) return;
      var near = false;
      try {
        var pw = 32, ph = Math.max(8, Math.min(96, Math.round(32 * r.h / Math.max(1, r.w))));
        var pc = document.createElement('canvas'); pc.width = pw; pc.height = ph;
        var pcx = pc.getContext('2d');
        b.pic(pcx, 0, 0, pw, ph);
        var x0 = Math.floor(pw * 0.12), y0 = Math.floor(ph * 0.12), x1 = Math.ceil(pw * 0.88), y1 = Math.ceil(ph * 0.88);
        var pd = pcx.getImageData(x0, y0, x1 - x0, y1 - y0).data, op = 0, sr = 0, sg = 0, sb = 0, cnt = pd.length / 4;
        for (var q = 0; q < pd.length; q += 4) if (pd[q + 3] > 200) { op++; sr += pd[q]; sg += pd[q + 1]; sb += pd[q + 2]; }
        near = op >= cnt * 0.9 && Math.abs(sr / op - fill[0]) < 24 && Math.abs(sg / op - fill[1]) < 24 && Math.abs(sb / op - fill[2]) < 24;
      } catch (e) { near = false; }
      if (!near) bad.push(b.i);
    });
    return bad;
  }
  /* 23-10: failed boxes get ONE more load at PV_RETRY_PX (load(i, done) per box), then end() - capped at PV_RETRY_MS */
  function pvRetry(list, load, imgs, end) {
    var left = list.length, over = false;
    var t = setTimeout(fin, PV_RETRY_MS);
    function fin() { if (over) return; over = true; clearTimeout(t); end(); }
    list.forEach(function (i) {
      load(i, function (im) { if (over) return; if (im) imgs[i] = im; if (--left === 0) fin(); });
    });
  }
  function composePhotoPreview(cb) {
    var geo, W = 1400, H, m, iw, ih, c, x;
    try {
      geo = computeLayout(state.size);
      m = Math.round(W * 0.045); iw = W - 2 * m; ih = Math.round(iw * geo.H / geo.W); H = ih + 2 * m;
      c = document.createElement('canvas'); c.width = W; c.height = H;
      x = c.getContext('2d');
      x.fillStyle = PH_BG[FRAMED_KIND] || '#f4f1ec'; x.fillRect(0, 0, W, H);
    } catch (e) { cb(null); return; }
    var box = function (g) { return { x: m + g.x / 100 * iw, y: m + g.y / 100 * ih, w: g.w / 100 * iw, h: g.h / 100 * ih }; };
    var one = state.slots.length === 1 && !FRAMED;
    var imgs = [], left = geo.slots.length, finished = false, want = geo.slots.length, got = 0, wins = [];
    var guard = setTimeout(function () { draw(true); }, PV_GUARD_MS);   /* 21-10: 9 s -> 20 s; draw() refuses a partial wall */
    function shadowed(r, fill) {
      x.save();
      x.shadowColor = 'rgba(50,35,15,.28)'; x.shadowBlur = Math.max(4, r.w * 0.05); x.shadowOffsetY = Math.max(2, r.w * 0.02);
      x.fillStyle = fill; x.fillRect(r.x, r.y, r.w, r.h);
      x.restore();
    }
    function pic(i) { return function (cx, px, py, pw, ph) { if (imgs[i]) drawCover(cx, imgs[i], px, py, pw, ph, 1, 0.5); }; }
    function paintWin(i) {
      var win = wins[i];
      x.save();
      x.beginPath(); x.rect(win.x, win.y, win.w, win.h); x.clip();
      x.fillStyle = '#e9e3d9'; x.fillRect(win.x, win.y, win.w, win.h);
      pic(i)(x, win.x, win.y, win.w, win.h);
      x.restore();
    }
    function bad(list) {   /* 23-10: got++ only for a window whose pixels really show the photo */
      return pvBadBoxes(x, W, H, list.map(function (i) { return { i: i, r: wins[i], pic: pic(i) }; }), imgs, [233, 227, 217]);
    }
    function finish(badList) {
      try {
        got = want - badList.length;
        if (got < want) { cb(null); return; }   /* 21-10: never upload a blank or partial preview */
        c.toBlob(function (blob) { cb(blob || null); }, 'image/jpeg', 0.85);
      } catch (e) { cb(null); }
    }
    function draw(fromGuard) {
      if (finished) return;
      finished = true;
      clearTimeout(guard);
      try {
        (geo.rows || []).forEach(function (y) {
          x.strokeStyle = '#b39670'; x.lineWidth = 2;
          x.beginPath(); x.moveTo(0, m + y / 100 * ih); x.lineTo(W, m + y / 100 * ih); x.stroke();
        });
        (geo.deco || []).forEach(function (d) { shadowed(box(d), '#ffffff'); });
        geo.slots.forEach(function (g, i) {
          var r = box(g), win = r, fw = FRAME_WIN[g.size];
          if (FRAMED_KIND !== 'booth') shadowed(r, '#ffffff');
          if (fw) win = { x: r.x + fw[0] * r.w, y: r.y + fw[1] * r.h, w: fw[2] * r.w, h: fw[3] * r.h };
          wins[i] = win;
          paintWin(i);
        });
        var all = geo.slots.map(function (g, i) { return i; }), b1 = bad(all);
        if (!b1.length || fromGuard === true) { finish(b1); return; }   /* the 20 s guard already ran out: no retry */
        pvRetry(b1, function (i, d) { var sl = state.slots[i] && state.slots[i].sel; if (!sl) { d(null); return; } pvLoadSmall([sl.thumb, sl.url], PV_RETRY_PX, d); },
          imgs, function () { try { b1.forEach(paintWin); finish(bad(b1)); } catch (e) { cb(null); } });
      } catch (e) { cb(null); }
    }
    geo.slots.forEach(function (g, i) {
      var sel = state.slots[i] && state.slots[i].sel;
      var src = sel ? (one ? (sel.url || sel.thumb) : (sel.thumb || sel.url)) : null;
      if (!src) { if (--left === 0) draw(); return; }
      /* 21-10: one retry on the other URL; 23-10: drawn from a <= 1600 px copy, never the full original */
      pvLoadSmall([src, sel.url, sel.thumb], PV_MAX_PX, function (im) { imgs[i] = im; if (--left === 0) draw(); });
    });
  }

  /* ---------- packing-slip preview ----------
     When the wall is complete, render the exact preview the customer sees
     (numbered slots, same crops) to a JPEG, upload it to the worker, and
     attach the URL to the order as _Wall Preview for the assorting team. */
  var pvBusy = false, pvTimer = null, pvWaiters = [];
  /* longest we make the customer wait at Add-to-cart for the preview */
  var PV_ATC_CAP = 12000;

  function pvKeyNow() {
    return state.size + '|' + state.slots.map(function (s) {
      if (!s.sel) return '';
      return s.sel.type === 'upload' ? (s.sel.url || 'u') : s.sel.img + (canMove(s) && selPos(s.sel) ? '@' + posProp(s.sel) : '');   /* a moved hero = a new picture */
    }).join('|');
  }

  function drawCover(ctx, im, dx, dy, dw, dh, zoom, oy, ox) {
    var scale = Math.max(dw / im.width, dh / im.height) * zoom;
    var sw = dw / scale, sh = dh / scale;
    var sx = (im.width - sw) * (ox == null ? 0.5 : ox);   /* ox: a moved Showcase hero (15-10) */
    var sy = (im.height - sh) * oy;
    ctx.drawImage(im, sx, sy, sw, sh, dx, dy, dw, dh);
  }

  function composeWallPreview(cb) {
    if (PHOTO) { composePhotoPreview(cb); return; }   /* 28-09: from thumbs, frames drawn */
    var geo, W, H, c, ctx;
    try {
      geo = computeLayout(state.size);
      W = 1400; H = Math.round(W * geo.H / geo.W);
      c = document.createElement('canvas'); c.width = W; c.height = H;
      ctx = c.getContext('2d');
      ctx.fillStyle = '#f4f1ec'; ctx.fillRect(0, 0, W, H);
    } catch (e) { cb(null); return; }
    var imgs = new Array(geo.slots.length);
    var remaining = geo.slots.length, finished = false, want = geo.slots.length, got = 0;
    /* photo-backed wall: the room photo goes under the posters (R2 serves CORS) */
    var bgReady = !geo.mock, bg = null;
    if (geo.mock) {
      bg = new Image(); bg.crossOrigin = 'anonymous';
      bg.onload = function () { bgReady = true; if (!remaining) draw(); };
      bg.onerror = function () { bg = null; bgReady = true; if (!remaining) draw(); };
      bg.src = geo.mock + (geo.mock.indexOf('?') > -1 ? '&' : '?') + 'cors=1';
    }
    /* #297042 (04-09) drew whatever had loaded at 9 s. 21-10 #331500: that shipped a Showcase preview with
       all 15 boxes WHITE. Arjun: "intha issue inimel vara kodathu" - the guard is 20 s and draw() uploads
       ONLY a complete wall (got === want); otherwise cb(null) -> no _Wall Preview, the floor uses _Wall Boxes
       + _Slot N Image. A blank or partial preview is never uploaded. */
    var guard = setTimeout(function () { if (!finished) draw(true); }, PV_GUARD_MS);
    function rect(i) { var g = geo.slots[i]; return { x: g.x / 100 * W, y: g.y / 100 * H, w: g.w / 100 * W, h: g.h / 100 * H }; }
    function bad(list) {   /* 23-10 #332128: got++ only for a box whose pixels really show its picture */
      return pvBadBoxes(ctx, W, H, list.map(function (i) { return { i: i, r: rect(i), pic: function (cx, px, py, pw, ph) { drawPic(cx, i, px, py, pw, ph); } }; }), imgs, [255, 255, 255]);
    }
    function finish(badList) {
      try {
        got = want - badList.length;
        if (got < want) { cb(null); return; }   /* 21-10: never upload a blank or partial preview */
        geo.slots.forEach(function (g, i) { badge(i); });
        c.toBlob(function (blob) { cb(blob || null); }, 'image/jpeg', 0.82);
      } catch (e) { cb(null); }
    }
    function badge(i) {
      var bx = rect(i), dx = bx.x, dy = bx.y;
      /* slot number badge — matches the Slot N rows on the packing slip */
      var r = 16;
      ctx.beginPath(); ctx.arc(dx + r + 6, dy + r + 6, r, 0, 7);
      ctx.fillStyle = 'rgba(17,17,17,0.88)'; ctx.fill();
      ctx.fillStyle = '#ffba00';
      ctx.font = '700 17px system-ui, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText(String(i + 1), dx + r + 6, dy + r + 7);
    }
    /* the picture of slot i into any rect (the preview, or the 32 px pixel-check probe) - same crop either way */
    function drawPic(cx, i, dx, dy, dw, dh) {
      var s = state.slots[i], im = imgs[i];
      if (!im || !s || !s.sel) return;
      if (s.sel.type === 'upload') cx.drawImage(im, dx, dy, dw, dh);
      else if (isFlatSel(s.sel)) { var mp = canMove(s) ? selPos(s.sel) : null; drawCover(cx, im, dx, dy, dw, dh, 1, mp ? mp[1] : 0.5, mp ? mp[0] : 0.5); }
      else if (isSplit(s.size)) drawCover(cx, im, dx, dy, dw, dh, 1, 0.30);
      else if (isLandscape(s.size)) drawCover(cx, im, dx, dy, dw, dh, 1, 0.5);
      else drawCover(cx, im, dx, dy, dw, dh, 1.5, 0.42);
    }
    function paintSlot(i) {
          var bx = rect(i), dx = bx.x, dy = bx.y, dw = bx.w, dh = bx.h;
          ctx.save();
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(dx, dy, dw, dh);
          ctx.beginPath(); ctx.rect(dx, dy, dw, dh); ctx.clip();
          var s = state.slots[i];
          drawPic(ctx, i, dx, dy, dw, dh);
          if (hasJoints(s.size)) {
            ctx.strokeStyle = 'rgba(255,255,255,0.9)';
            ctx.lineWidth = 2; ctx.setLineDash([10, 8]);
            var pn2 = jointsOf(s.size);
            for (var pnl = 1; pnl < pn2.c; pnl++) {
              ctx.beginPath();
              ctx.moveTo(dx + dw * pnl / pn2.c, dy); ctx.lineTo(dx + dw * pnl / pn2.c, dy + dh);
              ctx.stroke();
            }
            for (var pr = 1; pr < pn2.r; pr++) {
              ctx.beginPath();
              ctx.moveTo(dx, dy + dh * pr / pn2.r); ctx.lineTo(dx + dw, dy + dh * pr / pn2.r);
              ctx.stroke();
            }
            ctx.setLineDash([]);
          }
          ctx.restore();
    }
    function altsFor(i) {
      var s = state.slots[i];
      var src = s && s.sel ? (s.sel.type === 'upload' ? (s.sel.blobUrl || s.sel.url || s.sel.thumb) : thumb(s.sel.img, 480)) : null;
      if (!src) return null;
      /* 21-10: one retry - catalog thumb -> full image, an upload -> its next URL (cors=1 rule inside pvLoadImg) */
      return s.sel.type === 'upload' ? [src, s.sel.url, s.sel.thumb] : [src, s.sel.img];
    }
    function draw(fromGuard) {
      if (finished) return;
      finished = true;
      clearTimeout(guard);
      try {
        if (bg && bg.complete && bg.naturalWidth) {
          var z = geo.mockZoom;
          if (z) { ctx.fillStyle = '#e9e4da'; ctx.fillRect(0, 0, W, H); ctx.drawImage(bg, W * (1 - z[0]) * z[1], H * (1 - z[0]) * z[2], W * z[0], H * z[0]); }
          else ctx.drawImage(bg, 0, 0, W, H);
        }
        geo.slots.forEach(function (g, i) { paintSlot(i); });
        var all = geo.slots.map(function (g, i) { return i; }), b1 = bad(all);
        if (!b1.length || fromGuard === true) { finish(b1); return; }   /* the 20 s guard already ran out: no retry */
        /* 23-10: each failed box once more, smaller (~800 px); still failing -> cb(null) -> MISSING */
        pvRetry(b1, function (i, d) { var a = altsFor(i); if (!a) { d(null); return; } pvLoadSmall(a, PV_RETRY_PX, d); },
          imgs, function () { try { b1.forEach(paintSlot); finish(bad(b1)); } catch (e) { cb(null); } });
      } catch (e) { cb(null); }
    }
    geo.slots.forEach(function (g, i) {
      var alts = altsFor(i);
      if (!alts) { imgs[i] = null; if (--remaining === 0 && bgReady) draw(); return; }
      /* 23-10: drawn from a <= 1600 px copy (pvShrink), never the full 16 M px original */
      pvLoadSmall(alts, PV_MAX_PX, function (im) { imgs[i] = im; if (--remaining === 0 && bgReady) draw(); });
      /* R2 files were served without a CORS header until 04-09; browsers may
         still hold that copy (1-year immutable cache) and refuse it for
         canvas. A distinct URL for the canvas load skips that cache entry. */
      /* 28-09 round 2: floor designs (img.posterizedfloor.uk) too - a split spot shows the SAME ?width=480 URL without
         CORS, the image server varies on Origin, and the canvas load hit that copy: the 3-piece tile came out blank
         (21-10: that cors=1 rule now lives in pvLoadImg) */
    });
  }

  function previewReady() {
    return !!(state.pv && state.pvKey === pvKeyNow());
  }

  /* one compose+upload round. cb(url|null) always fires exactly once, so
     submitWall can await it instead of shipping the order without a preview
     (#289041 / #288995 — fast Add-to-cart beat the background render). */
  function runPreview(cb) {
    cb = cb || function () {};
    if (pvBusy) { pvWaiters.push(cb); return; }
    pvBusy = true;
    var keyAtStart = pvKeyNow();
    function done(url) {
      pvBusy = false;
      var waiting = pvWaiters; pvWaiters = [];
      cb(url);
      waiting.forEach(function (w) { w(url); });
    }
    composeWallPreview(function (blob) {
      if (!blob) { done(null); return; }
      var xhr = new XMLHttpRequest();
      xhr.open('POST', cfg.endpoint.replace(/\/$/, '') + '/upload');
      xhr.setRequestHeader('Content-Type', 'image/jpeg');
      xhr.timeout = 15000;
      xhr.onload = function () {
        var url = null;
        try {
          var res = JSON.parse(xhr.responseText || '{}');
          if (xhr.status === 200 && res.url && pvKeyNow() === keyAtStart) {
            url = res.url;
            state.pv = url; state.pvKey = keyAtStart; save();
          }
        } catch (e) {}
        done(url);
      };
      xhr.onerror = function () { done(null); };
      xhr.ontimeout = function () { done(null); };
      xhr.send(blob);
    });
  }

  function ensurePreview() {
    if (filledCount() !== state.slots.length || !state.slots.length) return;
    if (state.slots.some(function (s) { return s.sel && s.sel.status === 'uploading'; })) return;
    if (previewReady() || pvBusy) return;
    clearTimeout(pvTimer);
    pvTimer = setTimeout(function () {
      if (previewReady()) return;
      runPreview();
    }, 1200);
  }

  /* block Add-to-cart until the preview exists — capped so a dead worker can
     never trap the customer on the page. cb(true) = preview attached. */
  function awaitPreview(cb) {
    if (previewReady()) { cb(true); return; }
    clearTimeout(pvTimer);
    var settled = false;
    var cap = setTimeout(function () {
      if (settled) return;
      settled = true;
      cb(previewReady());
    }, PHOTO ? PV_ATC_CAP_PHOTO : PV_ATC_CAP);
    function attempt(triesLeft) {
      runPreview(function () {
        if (settled) return;
        if (previewReady()) {
          settled = true; clearTimeout(cap); cb(true); return;
        }
        if (triesLeft > 0) { attempt(triesLeft - 1); return; }
        settled = true; clearTimeout(cap); cb(false);
      });
    }
    attempt(1);
  }

  /* ---------- pricing ---------- */
  function priceInfo() {
    var vr = state.size && variantFor(state.size);
    if (!vr) return null;
    return {
      price: Number(vr.v.price),
      compare: Number(vr.v.compareAt || 0),
      count: state.slots.length
    };
  }

  /* ---------- render ---------- */
  function filledCount() {
    return state.slots.filter(function (s) { return s.sel && s.sel.status !== 'error'; }).length;
  }

  /* Arjun 27-08 v3: FULL title always (he wants it complete on mobile) -
     bold, wraps to two lines naturally; no shrinking, no "|"-truncation. */
  function fitTitle() {
    [].slice.call(document.querySelectorAll('.product__title h1, h1.product__title'))
      .forEach(function (t) {
        var full = t.getAttribute('data-pz-full') || (t.textContent || '').trim();
        t.setAttribute('data-pz-full', full);
        if (t.textContent !== full) t.textContent = full;
        t.style.fontWeight = '800';
        t.style.whiteSpace = 'normal';
        t.style.fontSize = '';
      });
  }
  window.addEventListener('resize', fitTitle);
  /* rotation / iOS toolbar: re-share the sheet between wall band and grid */
  var dockT = null;
  function dockResize() { clearTimeout(dockT); dockT = setTimeout(sizeDock, 80); }
  window.addEventListener('resize', dockResize);
  window.addEventListener('orientationchange', dockResize);

  /* ---- size morph (pick-any modes) ----
     Arjun 04-09: changing the size must not re-draw the layout - the boxes stay
     where they are and only the posters grow or shrink. So a size change keeps
     every card and every wall spot in the DOM and tweens them: the mini rooms
     are repainted frame by frame between the old and the new scene, the wall
     spots slide to their new boxes on CSS transitions, texts swap mid-way. A
     plain render() follows once the motion is done so every shared bit
     (summary bar, sticky, props) reads the new state - pixel-identical, so it
     is invisible. */
  function lerp(a, b, t) { return a + (b - a) * t; }
  function lerpScene(a, b, t) {
    var f = {};
    ['artW', 'artH', 'cx', 'W', 'bottom', 'top', 'viewTop', 'H'].forEach(function (k) { f[k] = lerp(a[k], b[k], t); });
    f.furn = t < 0.5 ? a.furn : b.furn;
    f.geo = { slots: a.geo.slots.map(function (sa, i) {
      var sb = b.geo.slots[i] || sa;
      return { size: sb.size, x: lerp(sa.x, sb.x, t), y: lerp(sa.y, sb.y, t), w: lerp(sa.w, sb.w, t), h: lerp(sa.h, sb.h, t) };
    }) };
    return f;
  }
  function tweenScene(el, a, b, dur) {
    if (!el) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || a.geo.slots.length !== b.geo.slots.length) { el.innerHTML = sceneSVG(b); fitMini(el); return; }
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.innerHTML = sceneSVG(p < 1 ? lerpScene(a, b, e) : b);
      fitMini(el);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function morphSize(newKey) {
    var oldKey = state.size;
    if (!oldKey || oldKey === newKey || !LAYOUTS[newKey]) return;
    var newMeta = SIZE_META[newKey];
    var DUR = 450;
    /* state: same spot count, new cell size, picks kept by index */
    var oldSlots = state.slots;
    state.size = newKey;
    if (PHOTO) { photoCarry(computeLayout(newKey).slots); photoRefit(); phSmallNote(); }   /* 28-09: too small for the new size - said now */
    else state.slots = computeLayout(newKey).slots.map(function (g, i) {
      return { size: g.size, sel: oldSlots[i] ? oldSlots[i].sel : null };
    });
    syncVariant(newKey);
    save();
    /* pills */
    root.querySelectorAll('.pz-wb-szpill').forEach(function (pb) {
      pb.classList.toggle('on', pb.getAttribute('data-size') === newMeta.size);
    });
    /* cards: each keeps its pack count and moves to the new size */
    root.querySelectorAll('.pz-wb-sizes--mode .pz-wb-size').forEach(function (card) {
      var ok = card.getAttribute('data-key'), om = SIZE_META[ok];
      if (!om) return;
      var nk = Object.keys(SIZE_META).filter(function (k) {
        return SIZE_META[k].size === newMeta.size && SIZE_META[k].posters === om.posters;
      })[0];
      if (!nk) { if (isFixedKey(ok)) card.classList.toggle('on', ok === newKey); return; }
      card.setAttribute('data-key', nk);
      card.classList.toggle('on', nk === newKey);
      /* the photo products' own pictures (framed arrangement / the 1-poster ledge): swapped, not tweened (28-09) */
      if (FRAMED || (PHOTO && isOneKey(nk))) { var fmn = card.querySelector('.pz-wb-size-mini'); if (fmn) fmn.innerHTML = miniDiagram(nk); var fsb = card.querySelector('.pz-wb-size-sub'); if (fsb) fsb.outerHTML = photoCardSub(nk); }
      else if (!(LAYOUTS[ok] && LAYOUTS[ok].mock) && !(LAYOUTS[nk] && LAYOUTS[nk].mock)) tweenScene(card.querySelector('.pz-wb-size-mini'), sceneFor(ok), sceneFor(nk), DUR);
      else { var mn = card.querySelector('.pz-wb-size-mini'); if (mn) { mn.className = 'pz-wb-size-mini' + (LAYOUTS[nk].mock ? ' photo' : ''); mn.style.aspectRatio = LAYOUTS[nk].mock ? miniRatio(nk) : ''; mn.innerHTML = LAYOUTS[nk].mock ? miniPhoto(nk) : miniDiagram(nk); } }
      var vr = variantFor(nk), nm = SIZE_META[nk];
      setTimeout(function () {
        var d = card.querySelector('.pz-wb-size-desc');
        if (d) d.textContent = vr ? money(perUnit(vr, nm)) + ' per ' + unitNoun(nm, 1) : nm.desc;
        var w = card.querySelector('.pz-wb-size-wall');
        if (w) w.textContent = wallFeet(nk);
        var pr = card.querySelector('.pz-wb-size-price');
        if (pr && vr) pr.innerHTML = money(vr.v.price) + (vr.v.compareAt > vr.v.price ? ' <s>' + money(vr.v.compareAt) + '</s>' : '') + (PHOTO ? photoSaveHtml(nk) : '');
        var pp = card.querySelector('.pz-wb-ppp');
        if (pp && vr) pp.innerHTML = pppHtml(nk);
      }, DUR / 2);
    });
    /* wall: the box stays, each spot slides to its new size (wallEl: the wall
       may be docked in the sheet) */
    var ww0 = wallEl();
    var wall = ww0 && ww0.querySelector('.pz-wb-wall');
    if (wall) {
      var geo = computeLayout(newKey);
      if (PHOTO) wall.classList.add('pz-wb-morphing');   /* the x buttons (spot siblings) fade while the spots slide */
      if (FRAMED) {
        /* 28-09: the twine / strips fade out while the cards slide to the new size; the settle render() draws them anew.
           The photo window moves with its card (retro 3.5 x 4.2 and A6 have different windows). */
        wall.style.setProperty('--pz-wdm', geo.W.toFixed(3));
      }
      wall.style.height = wall.getBoundingClientRect().height + 'px';
      wall.style.aspectRatio = '';
      requestAnimationFrame(function () {
        wall.style.height = Math.round(wall.clientWidth / (geo.W / geo.H)) + 'px';
        geo.slots.forEach(function (g, i) {
          var el = wall.querySelector('[data-slot="' + i + '"]');
          if (!el) return;
          el.style.left = g.x + '%'; el.style.top = g.y + '%'; el.style.width = g.w + '%'; el.style.height = g.h + '%';
          var fwin = FRAMED && el.querySelector('.pz-wb-win'), fw = FRAME_WIN[g.size];
          if (fwin && fw) { fwin.style.left = (fw[0] * 100).toFixed(2) + '%'; fwin.style.top = (fw[1] * 100).toFixed(2) + '%'; fwin.style.width = (fw[2] * 100).toFixed(2) + '%'; fwin.style.height = (fw[3] * 100).toFixed(2) + '%'; }
          var lab = el.querySelector('.pz-wb-slot-size');
          if (lab) lab.textContent = sizeLabel(g.size);
          el.classList.toggle('split', isSplit(g.size));
        });
      });
    }
    /* settle: one silent render so the summary bar, sticky and props match */
    setTimeout(function () { animNext = false; render(); }, DUR + 80);
  }

  /* the next bigger pack of the same size - the one-step upsell */
  var upDismissed = {};
  function nextPack(key) {
    var m = SIZE_META[key];
    if (!m) return null;
    var best = null;
    Object.keys(SIZE_META).forEach(function (k) {
      var x = SIZE_META[k];
      if (k === key || x.size !== m.size || isFixedKey(k) || RETIRED_KEYS[k] || x.posters <= m.posters || !variantFor(k)) return;
      if (!best || x.posters < best.m.posters) best = { key: k, m: x, vr: variantFor(k) };
    });
    return best && best.vr ? best : null;
  }

  /* ---- spots: shared pieces (28-09) ----
     spotTap(i)       - what a tap on spot i does. Today: the picker (or, on the own-photo products, the phone's photo
                        picker via openDrawer). The photo flow (multi-select, re-crop of a filled spot) plugs in HERE.
     spotSrc(sel)     - the picture a spot shows. The photo products show the small thumb (<= 320 px) - never 30-50
                        full-size decodes; everything else keeps blob -> url -> thumb as before.
     pooledImg()      - the decoded <img> reused per picture (17-09 iPhone flicker fix), unchanged.
     slotClearBtn(i)  - the x that empties a spot, unchanged. */
  function spotTap(i) {
    if (PHOTO) { photoTap(i); return; }   /* 28-09: empty = the phone's picker (many at once), filled = adjust, error = retry */
    if (drawer && drawer.classList.contains('show') && isSplitOn()) jumpToSlot(i); else openDrawer(i);
  }
  function spotSrc(sel, size) {
    if (sel.type === 'upload') return PHOTO ? (sel.thumb || sel.blobUrl || sel.url) : (sel.blobUrl || sel.url || sel.thumb);
    return thumb(sel.img, isSplit(size) ? 480 : 360);
  }
  function pooledImg(src, alt) {
    var pool = slotImgPool[src] || (slotImgPool[src] = []), im = null;
    for (var pi = 0; pi < pool.length; pi++) if (pool[pi].__pzUsed !== renderSeq) { im = pool[pi]; break; }
    if (!im) { im = document.createElement('img'); im.decoding = 'sync'; im.src = src; pool.push(im); }
    im.__pzUsed = renderSeq;
    im.alt = alt;
    return im;
  }
  function slotClearBtn(i) {
    var x = document.createElement('span');
    x.className = 'pz-wb-slot-x';
    x.innerHTML = '&#10005;';
    x.addEventListener('click', function (e) {
      e.stopPropagation();
      /* the wall is no longer full: the last-pick auto-close must not fire
         (stopPropagation skips the slot click that would have cleared it) */
      clearTimeout(holdTimer); holdTimer = null;
      if (PHOTO) photoCancel(state.slots[i].sel);   /* its upload stops */
      state.slots[i].sel = null;
      save(); render();
      /* cleared from the docked wall: the picker's ticks / counter follow */
      refreshPicker();
    });
    return x;
  }
  /* ---- Showcase hero: move the design (Arjun 15-10 "showcase hero adjust build pannu") ----
     The 3 x 2 A3 hero is nearly square (1.05 : 1), so a portrait design loses about a third of its height, and the floor
     cuts it from the centre (prep.py split_job). For a flat design file - the picture is what prints - the shopper can
     slide the design to choose what shows. sel.pos = [x, y], each 0..1 of the spare room, the same as CSS
     object-position (0.5 = centre = the floor's cut so far). It goes to the order as `_Slot N Position` ("x=50 y=32",
     percent) only when it is off centre; the floor cuts the same window (FLOOR-BRIEF-showcase-move.md). A product
     mockup cannot be moved - its picture is a room, not the print - so it keeps the centre cut. */
  var MOVE_SIZES = { H6A3: 1 };
  function canMove(s) { return !!(s && s.sel && MOVE_SIZES[s.size] && s.sel.type === 'catalog' && isFlatSel(s.sel)); }
  function selPos(sel) { var p = sel && sel.pos; return p && p.length === 2 && isFinite(p[0]) && isFinite(p[1]) ? p : null; }
  function posCss(sel) { var p = selPos(sel); return p ? (p[0] * 100).toFixed(1) + '% ' + (p[1] * 100).toFixed(1) + '%' : ''; }
  function posProp(sel) { var p = selPos(sel); return p ? 'x=' + Math.round(p[0] * 100) + ' y=' + Math.round(p[1] * 100) : ''; }
  function posFromProp(v) {
    var m = /x\s*=\s*(\d{1,3})\D+y\s*=\s*(\d{1,3})/i.exec(String(v || ''));
    return m ? [Math.min(100, +m[1]) / 100, Math.min(100, +m[2]) / 100] : null;
  }
  function slotMoveBtn(i) {
    var b = document.createElement('span');
    b.className = 'pz-wb-move';
    b.setAttribute('role', 'button');
    b.setAttribute('aria-label', 'Adjust the design');
    b.innerHTML = '<span aria-hidden="true">\u2195</span> Adjust';
    b.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); openMove(i); });
    return b;
  }
  var moveCssDone = false;
  function moveCss() {
    if (moveCssDone) return;
    moveCssDone = true;
    var st = document.createElement('style');
    st.textContent =
      '.pz-wb-slot .pz-wb-move{position:absolute;left:50%;bottom:6px;transform:translateX(-50%);z-index:4;display:inline-flex;align-items:center;gap:4px;padding:6px 10px;border-radius:100px;background:rgba(18,18,18,.86);color:#fff;font:800 11px/1 Barlow,system-ui,sans-serif;letter-spacing:.02em;white-space:nowrap;box-shadow:0 2px 6px rgba(0,0,0,.3);cursor:pointer;-webkit-tap-highlight-color:transparent}' +
      '.pz-wb-slot .pz-wb-move span{font-size:13px;line-height:1}' +
      '.pz-wb-mv{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.6);-webkit-tap-highlight-color:transparent}' +
      '.pz-wb-mv-card{width:100%;max-width:400px;max-height:100%;overflow:auto;background:#fff;border-radius:18px;padding:16px;box-shadow:0 12px 40px rgba(0,0,0,.35);font-family:Barlow,system-ui,sans-serif;color:#111}' +
      '.pz-wb-mv-h b{display:block;font-size:18px;font-weight:800}.pz-wb-mv-h span{display:block;margin-top:3px;font-size:13px;line-height:1.35;color:#555}' +
      '.pz-wb-mv-stage{position:relative;margin:14px auto 0;overflow:hidden;border-radius:6px;background:#eee;touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none}' +
      '.pz-wb-mv-stage img{display:block;width:100%;height:100%;object-fit:fill;pointer-events:none;-webkit-user-drag:none}' +
      '.pz-wb-mv-win{position:absolute;box-shadow:0 0 0 9999px rgba(0,0,0,.58);outline:2px solid #fff;outline-offset:-1px;pointer-events:none}' +
      '.pz-wb-mv-win i{position:absolute;background:rgba(255,255,255,.75)}' +
      '.pz-wb-mv-win b{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);padding:6px 10px;border-radius:100px;background:rgba(18,18,18,.82);color:#fff;font:800 11px/1 Barlow,system-ui,sans-serif;white-space:nowrap;transition:opacity .25s}' +
      '.pz-wb-mv-note{margin-top:8px;font-size:12px;color:#666;text-align:center}' +
      '.pz-wb-mv-note .pz-wb-mv-reset{border:0;background:none;padding:2px 4px;color:#111;font:800 12px/1 Barlow,system-ui,sans-serif;text-decoration:underline;cursor:pointer}' +
      '.pz-wb-mv-btns{display:flex;gap:10px;margin-top:14px}' +
      '.pz-wb-mv-btns button{flex:1;padding:13px 10px;border-radius:12px;border:1.5px solid #111;background:#fff;color:#111;font:800 14px/1 Barlow,system-ui,sans-serif;cursor:pointer}' +
      '.pz-wb-mv-btns .pz-wb-mv-ok{background:#111;color:#fff}';
    document.head.appendChild(st);
  }
  function openMove(i) {
    var s = state.slots[i];
    if (!canMove(s)) return;
    moveCss();
    var A = PRINT_IN[s.size], ar = A[0] / A[1], J = jointsOf(s.size);
    var start = selPos(s.sel) || [0.5, 0.5], pos = [start[0], start[1]];
    var ov = document.createElement('div');
    ov.className = 'pz-wb-mv';
    ov.innerHTML = '<div class="pz-wb-mv-card" role="dialog" aria-modal="true" aria-label="Adjust the design">' +
      '<div class="pz-wb-mv-h"><b>Adjust the design</b><span>Drag to choose the part you want. The bright box is exactly what we print on your ' + J.c * J.r + ' sheets.</span></div>' +
      '<div class="pz-wb-mv-stage" tabindex="0" aria-label="Design - use the arrow keys to move"><img alt=""><div class="pz-wb-mv-win"><b>\u2195 Drag</b></div></div>' +
      '<div class="pz-wb-mv-note">White lines = where the sheets join \u00b7 <button type="button" class="pz-wb-mv-reset">\u21ba Centre</button></div>' +
      '<div class="pz-wb-mv-btns"><button type="button" class="pz-wb-mv-swap">Change poster</button><button type="button" class="pz-wb-mv-ok">Done</button></div></div>';
    var stage = ov.querySelector('.pz-wb-mv-stage'), img = stage.querySelector('img'), win = stage.querySelector('.pz-wb-mv-win');
    for (var c = 1; c < J.c; c++) { var v = document.createElement('i'); v.style.cssText = 'top:0;bottom:0;width:1px;left:' + (c * 100 / J.c) + '%'; win.appendChild(v); }
    for (var r = 1; r < J.r; r++) { var h = document.createElement('i'); h.style.cssText = 'left:0;right:0;height:1px;top:' + (r * 100 / J.r) + '%'; win.appendChild(h); }
    var g = null;   /* stage px, window px and the spare room in px */
    function layout() {
      if (!img.naturalWidth) return;
      var ia = img.naturalWidth / img.naturalHeight;
      var maxW = Math.min(ov.querySelector('.pz-wb-mv-card').clientWidth - 32, 360), maxH = Math.max(200, window.innerHeight * 0.52);
      var sw = maxW, sh = sw / ia;
      if (sh > maxH) { sh = maxH; sw = sh * ia; }
      stage.style.width = Math.round(sw) + 'px'; stage.style.height = Math.round(sh) + 'px';
      var ww = ia > ar ? sh * ar : sw, wh = ia > ar ? sh : sw / ar;   /* the print window, cover-fit like the floor's cut */
      g = { sw: sw, sh: sh, ww: ww, wh: wh, rx: sw - ww, ry: sh - wh };
      paint();
    }
    function paint() {
      if (!g) return;
      win.style.width = g.ww + 'px'; win.style.height = g.wh + 'px';
      win.style.left = (g.rx * pos[0]) + 'px'; win.style.top = (g.ry * pos[1]) + 'px';
    }
    function clamp(v) { return Math.max(0, Math.min(1, v)); }
    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      if (!g) return;
      drag = { x: e.clientX, y: e.clientY, p0: pos.slice() };
      try { stage.setPointerCapture(e.pointerId); } catch (er) {}
      stage.style.cursor = 'grabbing';
      var hint = win.querySelector('b'); if (hint) hint.style.opacity = '0';
      e.preventDefault();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag) return;
      if (g.rx > 1) pos[0] = clamp(drag.p0[0] + (e.clientX - drag.x) / g.rx);
      if (g.ry > 1) pos[1] = clamp(drag.p0[1] + (e.clientY - drag.y) / g.ry);
      paint();
    });
    function endDrag() { drag = null; stage.style.cursor = ''; }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('keydown', function (e) {
      var k = { ArrowUp: [0, -0.05], ArrowDown: [0, 0.05], ArrowLeft: [-0.05, 0], ArrowRight: [0.05, 0] }[e.key];
      if (!k || !g) return;
      e.preventDefault();
      if (g.rx > 1) pos[0] = clamp(pos[0] + k[0]);
      if (g.ry > 1) pos[1] = clamp(pos[1] + k[1]);
      paint();
    });
    function close(apply) {
      document.removeEventListener('keydown', onKey, true);
      window.removeEventListener('resize', layout);
      if (ov.parentNode) ov.parentNode.removeChild(ov);
      if (!apply) return;
      var sel = state.slots[i] && state.slots[i].sel;
      if (!sel || !canMove(state.slots[i])) return;
      var was = String(selPos(sel) || '');
      if (Math.abs(pos[0] - 0.5) < 0.01 && Math.abs(pos[1] - 0.5) < 0.01) delete sel.pos;
      else sel.pos = [Math.round(pos[0] * 1000) / 1000, Math.round(pos[1] * 1000) / 1000];
      if (String(selPos(sel) || '') === was) return;   /* opened by a tap and closed unchanged: nothing to say */
      save(); render();
      toast(selPos(sel) ? 'Moved — your wall prints it exactly like this.' : 'Back to the centre.');
    }
    function onKey(e) { if (e.key === 'Escape') { e.stopPropagation(); close(false); } }
    ov.addEventListener('click', function (e) { if (e.target === ov) close(false); });
    ov.querySelector('.pz-wb-mv-ok').addEventListener('click', function () { close(true); });
    ov.querySelector('.pz-wb-mv-reset').addEventListener('click', function () { pos = [0.5, 0.5]; paint(); });
    ov.querySelector('.pz-wb-mv-swap').addEventListener('click', function () { close(false); spotTap(i); });   /* the old tap: the picker on this spot */
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('resize', layout);
    img.onload = layout;
    img.src = thumb(s.sel.img, 900);
    document.body.appendChild(ov);
    if (img.complete) layout();
    setTimeout(function () { try { stage.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  /* a framed print as it is printed: the white card (the spot) with its photo window; the photo covers the window.
     Booth: the spot IS the window, the strip is drawn behind it (renderFramedDeco). Upload ring / Retry sit in the
     window; the x sits in the white band, clear of the photo. Retro cards hang a little crooked on their clips. */
  var FR_TILT = [-1.2, 0.8, -0.4, 1.1, -0.8, 0.5, 1.3, -0.6, 0.3, -1, 0.9, -0.3];
  function frTilt(i) { return FRAMED_KIND === 'retro' ? FR_TILT[i % FR_TILT.length] : 0; }
  function framedSpot(el, s, i, isNext, tiny) {
    el.classList.add('pz-wb-fr');
    if (tiny) el.classList.add('tiny');
    var win = document.createElement('span'), fw = FRAME_WIN[s.size];
    win.className = 'pz-wb-win';
    if (fw) { win.style.left = (fw[0] * 100).toFixed(2) + '%'; win.style.top = (fw[1] * 100).toFixed(2) + '%'; win.style.width = (fw[2] * 100).toFixed(2) + '%'; win.style.height = (fw[3] * 100).toFixed(2) + '%'; }
    else win.classList.add('pz-wb-win--full');
    if (frTilt(i)) el.style.setProperty('--tilt', frTilt(i) + 'deg');
    if (s.sel) {
      var fsrc = spotSrc(s.sel, s.size);
      win.appendChild(fsrc ? pooledImg(fsrc, s.sel.title) : photoPrepEl());   /* no thumb yet: still being cut */
      var fBadge = photoBadge(s.sel, s.size, tiny);
      if (fBadge) { win.appendChild(fBadge); if (/toosmall/.test(fBadge.className)) el.classList.add('toosmall'); }
      if (s.sel.status === 'uploading' && fsrc) {
        var ring = document.createElement('span');
        ring.className = 'pz-wb-ring';
        ring.setAttribute('data-pct', PHOTO && !s.sel.pct ? '' : (s.sel.pct || 0) + '%');   /* photo products: a photo waiting its upload turn shows no 0% */
        win.appendChild(ring);
      }
      if (s.sel.status === 'error') {
        var errB = document.createElement('span');
        errB.className = 'pz-wb-err';
        errB.textContent = 'Retry';
        win.appendChild(errB);
      }
      el.appendChild(win);   /* the x is a sibling of the spot (photoClearBtn, render) - never inside it */
      el.setAttribute('aria-label', 'Photo ' + (i + 1));
    } else {
      win.innerHTML = '<span class="pz-wb-plus" aria-hidden="true">+</span>';
      el.appendChild(win);
      if (isNext) el.classList.add('next');
      el.setAttribute('aria-label', 'Add photo ' + (i + 1));
    }
  }
  /* behind the cards: the booth strips (white, taped at the top) and the retro twine, one per row */
  function renderFramedDeco(wall, geo) {
    (geo.deco || []).forEach(function (d) {
      var st = document.createElement('span');
      st.className = 'pz-wb-strip';
      st.setAttribute('aria-hidden', 'true');
      st.style.left = d.x + '%'; st.style.top = d.y + '%'; st.style.width = d.w + '%'; st.style.height = d.h + '%';
      wall.appendChild(st);
    });
    if (geo.rows && geo.rows.length) {
      var sag = 0.05 / geo.H * 100, svg = '';
      geo.rows.forEach(function (y) { svg += '<path d="M0 ' + y.toFixed(2) + ' Q50 ' + (y + sag * 2).toFixed(2) + ' 100 ' + y.toFixed(2) + '" vector-effect="non-scaling-stroke"/>'; });
      wall.insertAdjacentHTML('beforeend', '<svg class="pz-wb-twine" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">' + svg + '</svg>');
      if (geo.clips) {
        /* String Wall (29-09): warm fairy lights along each twine - on the quadratic's own curve, y = y0 + 4 sag t(1 - t) */
        var lights = '';
        geo.rows.forEach(function (y) {
          for (var li = 1; li < 24; li++) { var t = li / 24; lights += '<i class="pz-wb-light" style="left:' + (t * 100).toFixed(2) + '%;top:' + (y + 4 * sag * t * (1 - t)).toFixed(2) + '%"></i>'; }
        });
        wall.insertAdjacentHTML('beforeend', '<span class="pz-wb-lights" aria-hidden="true">' + lights + '</span>');
      }
    }
  }
  function render() {
    renderSeq++;
    var keepWall = (root.querySelector('.pz-wb-wallwrap') || {}).scrollLeft || 0;
    var keepRail = (root.querySelector('.pz-wb-sizes') || {}).scrollLeft || 0;
    var keepPage = window.pageYOffset;
    root.innerHTML = '';
    root.classList.toggle('pz-wb-anim', !!animNext);
    root.classList.toggle('pz-wb-mode', !!MODE);
    /* the photo products (28-09): hooks for their stage / spot styles */
    if (PHOTO) { root.classList.add('pz-wb-photo'); if (FRAMED) root.classList.add('pz-wb-framed', 'pz-wb-m-' + FRAMED_KIND); }
    /* pack mode follows the wall on a ?fill= visit: whenever the current wall is a ready-made pack wall
       (the fill itself, or a reload of that page) the page shows the pack header and no rail - until
       "Change layout" (packOff), which lasts until another wall is chosen or this one is continued (Arjun 16-09).
       Without ?fill= (packUrl) there is never a pack header: that visit is the normal builder. */
    var pkNow = !MODE && packUrl ? packForLayout(state.size) : null;
    if (pkNow && packOff !== state.size) packMode = { key: pkNow.key, name: pkNow.name || 'Your wall', layout: state.size };
    else packMode = null;
    if (packOff && packOff !== state.size) packOff = null;
    root.classList.toggle('pz-wb-packmode', !!packMode);
    animNext = false;

    /* step 1: size cards */
    var head = document.createElement('div');
    if (packMode) {
      /* Arjun 16-09 (pack mode): a shopper who came from a pack page ("customise this wall")
         has already chosen the wall - no layout rail, no step 1. The pack's header carries
         the name, count, size and price; "Change layout" opens the gallery and ends pack mode.
         The rail is still built below (hidden by CSS) so the rest of render() is untouched. */
      var vrP = variantFor(state.size), mP = SIZE_META[state.size] || {};
      head.className = 'pz-wb-pack';
      head.innerHTML =
        '<span class="pz-wb-pack-tag">Ready-made wall</span>' +
        '<span class="pz-wb-pack-name">' + String(packMode.name).replace(/[<>&]/g, '') + '</span>' +
        (vrP ? '<span class="pz-wb-pack-price">' + money(vrP.v.price) + (vrP.v.compareAt > vrP.v.price ? ' <s>' + money(vrP.v.compareAt) + '</s>' : '') + '</span>' : '') +
        '<span class="pz-wb-pack-meta">' + (mP.posters || state.slots.length) + ' posters &middot; ' + (mP.name || '') + ' &middot; ' + wallFeet(state.size).replace(/^~/, '') + '</span>' +
        '<span class="pz-wb-pack-hint">Already filled &middot; tap any poster to swap it, or add your own photo</span>' +
        '<button type="button" class="pz-wb-pack-change">Change layout &rarr;</button>';
      root.appendChild(head);
      head.querySelector('.pz-wb-pack-change').addEventListener('click', function () { packOff = state.size; packMode = null; render(); showGallery(); });
    } else {
      head.className = 'pz-wb-step' + (MODE ? ' pz-wb-step--lead' : '');
      head.innerHTML = '<span class="pz-wb-stepnum">1</span> ' + (MODE === 'custom8' ? 'Pick your size' : PHOTO && gridSizes().length < 2 ? 'Pick your pack' : MODE ? 'Pick your size and pack' : 'Pick your wall layout') +
        (PHOTO ? '' : CUSTOM ? '<em class="pz-wb-hint">swipe for more &rarr;</em>' : '<button type="button" class="pz-wb-seeall">' + (MODE ? 'See all packs' : 'See all layouts') + ' &rarr;</button>');
      root.appendChild(head);
      if (LEAN_RAIL && !MODE) {
        /* 27-09 redesign: Arjun's "PICK ANY DESIGNS" said once, here, instead of on all 8 pictures */
        var pickAny = document.createElement('p');
        pickAny.className = 'pz-wb-pickany';
        pickAny.innerHTML = '<i aria-hidden="true"></i><span><b>PICK ANY DESIGNS</b> &middot; or upload your own photos</span>';
        root.appendChild(pickAny);
      }
      var seeAll = head.querySelector('.pz-wb-seeall');
      if (seeAll) seeAll.addEventListener('click', function () { showGallery(); });
    }

    var fixedOn = MODE && isFixedKey(state.size);
    if (MODE && MODE !== 'custom8' && !(PHOTO && gridSizes().length < 2)) {   /* Mini / Booth: one size, no size row (28-09) */
      var curSz = (SIZE_META[state.size] || {}).size;
      if (!fixedOn && curSz) state.lastSz = curSz;
      var pills = document.createElement('div');
      var sizeCards = (MODE === 'singles' || PHOTO) && LEAN_RAIL, curPosters = (SIZE_META[state.size] || {}).posters;
      pills.className = 'pz-wb-szpills' + (sizeCards ? ' pz-wb-szpills--cards' : '') + (fixedOn ? ' locked' : '') + (sizeCards && gridSizes().length === 2 ? ' pz-wb-szpills--2' : '');
      if (sizeCards) {
        pills.setAttribute('role', 'group');
        pills.setAttribute('aria-label', PHOTO ? 'Print size' : 'Poster size');
        var curUnits = PHOTO ? ((SIZE_META[state.size] || {}).units || curPosters) : curPosters;
        if (!fixedOn && curPosters) pills.setAttribute('data-note', 'Prices for ' + curUnits + ' ' + (PHOTO ? unitNoun(SIZE_META[state.size], curUnits) : 'posters'));
      }
      gridSizes().forEach(function (sz) {
        var pb = document.createElement('button');
        pb.type = 'button';
        pb.className = 'pz-wb-szpill' + (!fixedOn && sz.key === curSz ? ' on' : '');
        if (sizeCards) {
          pb.innerHTML = szCardHtml(sz, fixedOn ? null : curPosters, fixedOn ? null : curSz);
          pb.setAttribute('aria-pressed', !fixedOn && sz.key === curSz ? 'true' : 'false');
        } else pb.textContent = sz.label;
        pb.setAttribute('data-size', sz.key);
        if (fixedOn) pb.setAttribute('aria-disabled', 'true');
        pb.addEventListener('click', function () {
          if (isFixedKey(state.size)) return; /* locked while the fixed wall is on */
          /* same pack count, new size */
          var want = (SIZE_META[state.size] || {}).posters;
          var next = Object.keys(SIZE_META).filter(function (k) { return SIZE_META[k].size === sz.key; })
            .sort(function (a, b) { return SIZE_META[a].posters - SIZE_META[b].posters; });
          var hit = next.filter(function (k) { return SIZE_META[k].posters === want; })[0] || next[0];
          if (hit) { pzTrack('size'); if (MODE) morphSize(hit); else setSize(hit); }
        });
        pills.appendChild(pb);
      });
      root.appendChild(pills);
    }

    /* Arjun 17-09 (iPhone flicker): the rail is rebuilt only when its inputs change. A rebuilt rail re-creates every
       live-card image (lazy ones start blank until Safari loads them again) and restarts the glove; between picks the
       same element comes back, its scroll position and animation intact. */
    var railKey = [MODE, state.size, packOff || '', packMode ? packMode.key : '', fixedOn ? 1 : 0, state.lastSz || '',
      Object.keys(cfg.variants).filter(function (id) { return cfg.variants[id].available === false; }).join(',')].join('|');
    var cards;
    if (railCache && railCache.key === railKey) {
      cards = railCache.el;
    } else {
    cards = document.createElement('div');
    cards.className = 'pz-wb-sizes' + (MODE ? ' pz-wb-sizes--mode' : '') + (LEAN_RAIL ? ' pz-wb-sizes--lean' : '') +
      ((MODE === 'singles' && MM_RAIL_2X2) || MODE === 'custom' ? ' pz-wb-sizes--2x2' : '') +   /* Personalize: the M&M 2 x 2 (28-09) */
      (FRAMED ? ' pz-wb-sizes--3col' : '') +                                                    /* mini / retro / booth: 3 packs, one row */
      (PHOTO ? ' pz-wb-sizes--photo' : '');
    /* two-card rails (split sets) fill the width instead of leaving a gap (Arjun 04-09) */
    if (MODE) setTimeout(function () {
      var nCards = cards.querySelectorAll('.pz-wb-size:not(.pz-wb-size--mix)').length;
      cards.classList.toggle('pz-wb-sizes--two', nCards <= 2);
      /* 29-09: once Retro 30 (Grid Wall) is shown there are 4 packs - a 2 x 2 reads better than a squeezed row of 4 */
      if (FRAMED && nCards === 4) { cards.classList.remove('pz-wb-sizes--3col'); cards.classList.add('pz-wb-sizes--2x2'); }
    }, 0);
    /* Arjun 27-08: these three are retired from SALE - the cards are hidden,
       but SIZE_META/LAYOUTS/variants stay so existing orders, saved sessions
       and floor reprints keep working. Never delete, only hide. */
    /* Arjun 04-09: the four biggest walls also come off the rail (5-11
       orders each in 60 days). Same rule - hidden, never deleted. */
    /* Arjun 04-09 (later): Compact / Classic / Studio are plain single-poster
       walls - the Mix & Match Posters product covers those, so BYW keeps only
       the walls with a split centrepiece (Large and up). Hidden, never deleted. */
    var RETIRED = RETIRED_KEYS;
    var railKeys = Object.keys(SIZE_META);
    if (MODE) {
      var railSz = fixedOn ? (state.lastSz || normSize((cfg.sizes || [])[0] || 'A4')) : (SIZE_META[state.size] || {}).size;
      var fixedKeys = railKeys.filter(isFixedKey);
      if (MODE === 'custom8') railKeys = railKeys.filter(function (k) { return !!GRID_CELL.custom8[SIZE_META[k].size]; }).sort(function (a, b) { return DIM[GRID_CELL.custom8[SIZE_META[a].size]][0] - DIM[GRID_CELL.custom8[SIZE_META[b].size]][0]; });
      else railKeys = fixedKeys.concat(railKeys.filter(function (k) { return !isFixedKey(k) && SIZE_META[k].size === railSz; })
        .sort(function (a, b) { return SIZE_META[a].posters - SIZE_META[b].posters; }));
    } else if (!CUSTOM) {   /* BYW only - the photo products keep their own order */
      /* Arjun 04-10 "price stepwise-a layouts irukanum": the BYW rail reads cheapest -> premium (Full used to sit after
         Collector in declaration order); same price -> fewer posters first, then declaration order */
      var railOrd = railKeys.slice(), railPr = function (k) { var vr = variantFor(k); return vr ? (parseFloat(vr.v.price) || 0) : Infinity; };
      railKeys.sort(function (a, b) { return (railPr(a) - railPr(b)) || (SIZE_META[a].posters - SIZE_META[b].posters) || (railOrd.indexOf(a) - railOrd.indexOf(b)); });
    }
    var railIdx = 0;
    /* Arjun 27-09 "BEST VALUE vum venum": on the lean BYW rail BEST VALUE goes to the wall with the lowest price per
       poster (what the stickers show - today Full Wall, ₹39), and Large keeps MOST POPULAR */
    var bestKey = null;
    if (LEAN_RAIL && !MODE) {
      var bestPer = Infinity;
      railKeys.forEach(function (k) {
        if (RETIRED[k] || packForLayout(k)) return;
        var bvr = variantFor(k), bm = SIZE_META[k];
        if (!bvr || !bm || !bm.posters) return;
        var per = bvr.v.price / bm.posters;
        if (per < bestPer) { bestPer = per; bestKey = k; }
      });
    }
    railKeys.forEach(function (key) {
      if (RETIRED[key] && (state.size !== key || packForLayout(key))) return;   /* pack walls never sit on the rail (16-09) */
      var m = SIZE_META[key];
      var vr = variantFor(key);
      if (!vr && state.size !== key) return;   /* nothing to buy: no pill */
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-wb-size' + (state.size === key ? ' on' : '') + (PHOTO && isOneKey(key) ? ' pz-wb-size--one' : '');
      b.setAttribute('data-key', key);
      var pkr = packForLayout(key), lvh = liveHtml(key, railIdx++);
      b.innerHTML =
        (pkr && pkr.photo ? '<span class="pz-wb-size-mini photo" style="aspect-ratio:1.2"><img src="' + thumb(pkr.photo, 320) + '" alt="" loading="lazy" style="position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover;object-position:50% 30%"></span>' :
        /* Arjun 17-09: a badge on the live photo says the pack is not fixed - "PICK ANY DESIGNS" (his wording) */
        lvh ? '<span class="pz-wb-size-mini live' + (!MODE ? ' scene' : MODE === 'singles' ? ' singles' : '') + '"' + (MODE === 'splits' ? ' style="aspect-ratio:1"' : MODE ? ' style="aspect-ratio:0.8"' : '') + '>' + lvh + '<span class="pz-wb-live-badge">Pick any designs</span></span>' :
        '<span class="pz-wb-size-mini' + (!MODE ? ' hasbadge' : '') + (LAYOUTS[key] && LAYOUTS[key].mock ? ' photo" style="aspect-ratio:' + miniRatio(key) : '') + '">' + (LAYOUTS[key] && LAYOUTS[key].mock ? miniPhoto(key) : miniDiagram(key)) + (!MODE ? '<span class="pz-wb-live-badge">Pick any designs</span>' : '') + '</span>') +
        '<span class="pz-wb-size-name">' + (pkr ? packLabel(pkr) : m.name) + '</span>' +
        (PHOTO ? photoCardSub(key) : '') +
        '<span class="pz-wb-size-desc">' + (MODE === 'custom8' ? m.desc : MODE ? (vr ? money(perUnit(vr, m)) + ' per ' + unitNoun(m, 1) : m.desc) : (LEAN_RAIL ? m.posters + ' posters' : m.posters + ' posters · ' + m.desc)) + '</span>' +
        '<span class="pz-wb-size-wall">' + wallFeet(key) + '</span>' +
        (vr ? '<span class="pz-wb-size-price">' + money(vr.v.price) +
          (vr.v.compareAt > vr.v.price ? ' <s>' + money(vr.v.compareAt) + '</s>' : '') + (PHOTO ? photoSaveHtml(key) : '') + '</span>' : '');
      if (MODE && m.tier) {
        /* the offer is a strip across the top of the card; the biggest pack's
           strip turns gold and carries BEST VALUE itself, so there is never a
           second badge fighting it for the corner (Arjun 04-09) */
        var ob = document.createElement('span');
        ob.className = 'pz-wb-offer' + (m.top ? ' best' : '');
        var tierTx = String(m.tier).replace(/\s*free\s*$/i, ' FREE').toUpperCase();
        if (LEAN_RAIL && vr) {
          /* Arjun 27-09 "offers label la ye sticker ah yum vei": the per-poster sticker rides in the offer strip */
          ob.className += ' has-ppp';
          var tm = /^\s*(BUY\s+\d+)\s+(GET\s+.+?)\s*$/i.exec(tierTx);
          ob.innerHTML = '<i></i><span class="pz-wb-offer-t">' + (tm ? '<span>' + tm[1] + '</span> <em>' + tm[2] + '</em>' : tierTx) + '</span><span class="pz-wb-offer-row">' +
            (m.top ? '<b>\u2605 BEST VALUE</b>' : '') + '<span class="pz-wb-ppp">' + pppHtml(key) + '</span></span>';
        } else {
          ob.innerHTML = '<i></i>' + tierTx + (m.top ? ' <b>\u2605 BEST VALUE</b>' : '');
        }
        b.appendChild(ob);
      }
      if (LEAN_RAIL && vr && !pkr && !(MODE && m.tier) && !(PHOTO && isOneKey(key))) {   /* 1 poster: its price IS the per-poster price */
        /* the per-poster price as a sticker on the picture's corner (27-09) */
        var ppp = document.createElement('span');
        ppp.className = 'pz-wb-ppp';
        ppp.innerHTML = pppHtml(key);
        b.appendChild(ppp);
        var prc = PRICE_ROW && b.querySelector(':scope > .pz-wb-size-price');
        if (prc) {   /* 16-10: price + sticker share one line (styles: peekCss) */
          peekCss();
          var prow = document.createElement('span');
          prow.className = 'pz-wb-pricerow';
          b.insertBefore(prow, prc);
          prow.appendChild(prc);
          prow.appendChild(ppp);
        }
      }
      var pRib = PHOTO ? photoRibbon(key) : '';   /* 28-09: the photo packs' MOST POPULAR / BEST VALUE, as their pack cards had */
      if (pRib || (MODE ? false : (key === 'large' || (LEAN_RAIL && key === bestKey)))) {
        var bv = document.createElement('span');
        bv.className = 'pz-wb-bestvalue';
        /* 27-09: the lean cards show ₹/poster, and Full (₹39) beats Large (₹47) - Large carries what it really is,
           the most ordered wall (889 of 3,375 in 30 days); BEST VALUE sits on the lowest ₹/poster wall */
        bv.textContent = pRib || (!LEAN_RAIL || key === bestKey ? 'BEST VALUE' : 'MOST POPULAR');
        b.appendChild(bv);
      }
      if (LEAN_RAIL) { var fm = b.querySelector('.pz-wb-size-mini'); if (fm) { var fsv = fm.querySelector('svg.pz-wb-scene'); if (fsv) fitScene(fsv, MINI_ASPECT, 0.1); } }
      b.addEventListener('click', function () {
        pzTrack('pack');
        railFollowsSelection = true;
        setSize(b.getAttribute('data-key') || key);
        galPackFill(b.getAttribute('data-key') || key);
        /* Arjun 07-09: pack chosen → straight into picking, wall in view */
        if (MODE && !CUSTOM && MODE !== 'custom8') {
          setTimeout(function () { openOnCategory(pendingCat || drawerTab); }, 750);
          return;
        }
        /* Arjun 27-08: picking a layout scrolls to "Tap each spot" — animated,
           not a jump-cut ("takkunu poga koodathu"), so the user keeps their
           bearings and can scroll back up to reselect a pack. Native
           behavior:'smooth' gets cancelled by the site's periodic DOM sweeps,
           so animate by hand with rAF; the target is re-read every frame
           because images settling shift the layout mid-flight. */
        function pzGoWall() { pzScrollTo(function () { return root.querySelector('.pz-wb-wallwrap'); }, 90); }
        setTimeout(pzGoWall, 120);
      });
      cards.appendChild(b);
    });
    if (MODE && !CUSTOM && MODE !== 'custom8') {
      /* Arjun 06-09: one size per pack here; anyone who wants A3 + A4 on one
         wall is a Build Your Wall customer - say so on the rail and carry
         their picks across instead of making them start over */
      var mix = document.createElement('a');
      mix.className = 'pz-wb-size pz-wb-size--mix';
      mix.href = '/products/build-your-wall-custom-poster-wall-collage';
      mix.innerHTML =
        '<span class="pz-wb-size-mini"><svg viewBox="0 0 100 72" aria-hidden="true">' +
          '<rect x="35" y="6" width="30" height="44" rx="1.5" fill="#fff" stroke="#111" stroke-width="2"/>' +
          '<rect x="6" y="16" width="22" height="30" rx="1.5" fill="#fff" stroke="#111" stroke-width="2"/>' +
          '<rect x="72" y="16" width="22" height="30" rx="1.5" fill="#fff" stroke="#111" stroke-width="2"/>' +
          '<text x="50" y="33" text-anchor="middle" font-size="11" font-weight="800" fill="#111">A3</text>' +
          '<text x="17" y="35" text-anchor="middle" font-size="9" font-weight="800" fill="#111">A4</text>' +
          '<text x="83" y="35" text-anchor="middle" font-size="9" font-weight="800" fill="#111">A4</text>' +
          '<rect x="6" y="58" width="88" height="8" rx="2" fill="#ffba00"/></svg></span>' +
        '<span class="pz-wb-size-name">Mix sizes?</span>' +
        '<span class="pz-wb-size-desc">A3 + A4 in one wall</span>' +
        '<span class="pz-wb-size-price">Build Your Wall →</span>';
      mix.addEventListener('click', function (ev) {
        ev.preventDefault();
        pzTrack('mix-sizes');
        var picks = state.slots.map(function (sl) { return sl.sel && sl.sel.type === 'catalog' && sl.sel.handle; }).filter(Boolean);
        location.href = mix.href + (picks.length ? '?pick=' + picks.join(',') : '');
      });
      cards.appendChild(mix);
    }
    railCache = { key: railKey, el: cards };
    }
    root.appendChild(cards);
    /* the chosen layout's details, under the rail (27-09): what the cards no longer print */
    if (LEAN_RAIL && !packMode && SIZE_META[state.size]) {
      var im = SIZE_META[state.size], ipk = packForLayout(state.size);
      var bits = [!MODE ? im.posters + ' posters: ' + im.desc : galSizeNote(im.size), FRAMED || (PHOTO && isOneKey(state.size)) ? '' : 'wall ' + wallFeet(state.size)].filter(Boolean);   /* framed prints and a single poster: no wall feet */
      var info = document.createElement('p');
      info.className = 'pz-wb-pickinfo';
      info.innerHTML = '<b>' + (ipk ? packLabel(ipk) : im.name) + '</b> &middot; ' + bits.join(' &middot; ');
      root.appendChild(info);
      if ((MODE === 'singles' || (PHOTO && gridSizes().length > 1)) && !fixedOn) { var su = sizeUpBtn(state.size); if (su) info.appendChild(su); }   /* 27-09 size upgrade; retro: "Bigger A6?" */
    }
    var lks = looksStrip(state.size);   /* 15-10: "Get this look" - the chosen layout's sample walls */
    if (lks) root.appendChild(lks);
    /* Homepage "Verified Reviews" marquee, reproduced on the builder page
       (Arjun 27-08: "home page la irukra scroll ah BYW page top la vei").
       Same 35 review photos, same two counter-scrolling rows as
       sections/poster-carousel.liquid - class names pz-prefixed because that
       section's CSS only exists on the homepage. Rows duplicate their image
       list so the translateX(-50%) loop is seamless. */
    /* Arjun 27-08: the marquee header is the ONE review line on this page -
       the old "4.9/5 - Reviews - See their experiences" line under the title
       is removed entirely (it duplicated the header right above it). */
    [].slice.call(document.querySelectorAll('.product__info-container p, .product__info-container div'))
      .forEach(function (el) {
        if (el.closest('.pz-wb-ugc')) return;
        var t = (el.textContent || '').replace(/\s+/g, ' ');
        if (t.length < 140 && /4\.9\s*\/\s*5/.test(t) && /Reviews/i.test(t)) el.remove();
      });
    /* Review marquee (Arjun 27-08 v3): lives ABOVE THE REELS ROW now, not
       above the title - built here, placed by the reels timer below. */
    /* Arjun 29-08: the two auto-scrolling rows of customer photos are GONE from
       this page — he wants no image marquee here. The rating + reviews link
       stays as a single quiet line under the title (that is not a scroll).
       The reels row further down is video, untouched. */
    window.__pzBuildUgc = function () {
      if (document.querySelector('.pz-wb-ugc')) return null;
      var ugc = document.createElement('div');
      ugc.className = 'pz-wb-ugc';
      ugc.innerHTML =
        '<div class="pz-wb-ugc-head"><a class="pz-wb-ugc-link" href="/pages/posterized-insta-reivews">4.9 <b class="pz-wb-ugc-star">\u2605</b> \u00b7 45,000+ reviews</a></div>';
      return ugc;
    };
    /* Arjun 27-08 v4: marquee sits right UNDER the product title */
    (function placeUgc() {
      var t = [].slice.call(document.querySelectorAll('.product__info-container .product__title'))
        .filter(function (x) { return x.offsetWidth > 0; })[0];
      if (!t || !t.parentElement) return;
      var ugc = window.__pzBuildUgc();
      if (ugc) t.parentElement.insertBefore(ugc, t.nextSibling);
    })();
    /* Reels row under the delivery-date card (Arjun 27-08). Same 20 videos as
       the homepage video-carousel section, same lazy rule: a video downloads
       and plays only while on screen. The delivery card is rendered by
       pz-delivery-promise on its own timer, so poll until it exists. */
    if (!window.__pzReelsArmed) {
      window.__pzReelsArmed = true;
      /* no delivery card after 6 s: the product photos show where Liquid put them (after the detail cards) */
      var REELS = ['620f51360be748979fa05d8b2050e8e8','3de453b593cd4f98abda70ffae4f4f9e','b5d52a24f0b343ce99dd17ae1c403341','621ec27748284d2baf2519a84fb413ed','51031ae4616940c489d8918391d2fbb1','05114663cbaf4a768de16addb601d175','199683807f9843eba6aa06b594a99bca','c498f76c4cec4866bdcdec4644cd2fd2','f987827d1f494baa97a9564493262051','9818d7d49621418eae5225c56bb4dd4e','ae04231f89fe4f5a927e145e7af37285','003287e042a445159b0ea5dd26bf2d4d','64c2db02cc17470f9c5977e40c650829','41bcd825a48c4651b468d1e8f7678920','73c4e1e8fdce41ccbd817080e574a154','d584b7bc18c64e9e8bae04dc32025086','10b507a60f654acd82c6722cab12eb3d','0e072b3ac4d34c029f25097e127588f3','ee0b6075078f49eb8a50cc2a6f0a9afc','d3e095efe39c4f5ab7833ba05a6ec8b6'];
      var reelsTimer = setInterval(function () {
        var dlv = [].slice.call(document.querySelectorAll('.pz-dlv'))
          .filter(function (d) { return d.offsetWidth > 40; })[0];
        if (!dlv || document.querySelector('.pz-wb-reels')) return;
        clearInterval(reelsTimer);
        /* 28-09 preview test: the photo products show their OWN product photos here (the prints in a hand, on a wall - the
           real size of a 6 cm print), rendered by main-product.liquid, instead of the poster-wall reels */
        /* 29-09: the photo products carry their own photos on top of the page (pz-wall-builder.liquid) - no poster-wall reels */
        if (PHOTO) return;
        var wrap = document.createElement('div');
        wrap.className = 'pz-wb-reels';
        /* Arjun 18-09 (phone heat): one copy of each video - the row is swiped now, not an endless marquee */
        var reelHtml = REELS.map(function (id) {
          return '<div class="pz-wb-reel"><video muted loop playsinline preload="none" data-src="https://cdn.shopify.com/videos/c/o/v/' + id + '.mp4"></video></div>';
        }).join('');
        wrap.innerHTML =
          '<div class="pz-wb-reels-head">🏆 5,00,000+ Happy Customers</div>' +
          '<div class="pz-wb-reels-track">' + reelHtml + '</div>';
        dlv.parentElement.insertBefore(wrap, dlv.nextSibling);
        /* pz-calm.js: Shopify's 480p copy + first-frame poster, one video plays at a time, none behind the picker
           (the 4K originals played three or four at a time, also while the picker covered them) */
        if (window.pzReels && window.pzReels(wrap.querySelector('.pz-wb-reels-track'))) return;
        if ('IntersectionObserver' in window) {
          var vio = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              var v = en.target;
              if (en.isIntersecting) {
                if (!v.src) v.src = v.getAttribute('data-src');
                v.play().catch(function () {});
              } else if (v.src) v.pause();
            });
          }, { rootMargin: '150px' });
          wrap.querySelectorAll('video').forEach(function (v) { vio.observe(v); });
        }
      }, 800);
    }
    if (keepRail) cards.scrollLeft = keepRail;
    var onCard = cards.querySelector('.pz-wb-size.on');
    if (PEEK_RAIL && window.innerWidth < 750) {
      peekRail(cards, onCard);   /* 16-10: phones - one-card carousel */
    } else if (onCard) {
      var cr = cards.getBoundingClientRect(), br = onCard.getBoundingClientRect();
      if (railFollowsSelection && (br.left < cr.left || br.right > cr.right)) cards.scrollLeft = Math.max(0, onCard.offsetLeft - cards.offsetLeft);
    }

    if (!state.size) return;

    /* step 2: the wall */
    var head2 = document.createElement('div');
    head2.className = 'pz-wb-step';
    head2.innerHTML = '<span class="pz-wb-stepnum">2</span> ' + (PHOTO ? 'Add your photos' : MODE === 'custom8' ? 'Tap the wall \u2014 add your photo' : CUSTOM ? 'Tap each spot \u2014 add your photo' : 'Tap each spot \u2014 pick a poster or add your photo');
    if (packMode) head2.innerHTML = '<span class="pz-wb-stepnum">1</span> Tap any poster to swap it \u2014 or add your own photo';
    root.appendChild(head2);
    if (PHOTO) {
      /* 28-09: one line under the step - many photos go in at once, each is cropped to its print automatically */
      var sub2 = document.createElement('p');
      sub2.className = 'pz-wb-step-sub';
      sub2.textContent = (FRAMED_KIND === 'booth' ? '3 photos per strip \u00b7 ' : '') + 'Select many at once \u2014 each is fitted to the ' + (FRAMED ? 'print' : 'poster');
      root.appendChild(sub2);
    }
    root.appendChild(readyBar());

    var geo = computeLayout(state.size, { plain: isSplitOn() });   /* picking = plain board; the room photo is the reward on the page wall */
    var wrap = document.createElement('div');
    wrap.className = 'pz-wb-wallwrap';
    var wall = document.createElement('div');
    wall.className = 'pz-wb-wall';
    /* Arjun 27-08: default is FIT TO SCREEN - the whole wall visible at once.
       The old behaviour (scale up so A5 stays >=64px tappable, scroll sideways)
       is now behind a zoom toggle for anyone who wants close-up taps. */
    var minA5 = 64; /* px */
    var scale = minA5 / (DIM.A5[0] / geo.W); /* px per 100% */
    wall.style.aspectRatio = (geo.W / geo.H).toFixed(4);
    root.style.setProperty('--pz-ratio', (geo.W / geo.H).toFixed(4));
    document.documentElement.style.setProperty('--pz-ratio', (geo.W / geo.H).toFixed(4)); /* the drawer (body level) sizes the docked wall from it */
    /* --pz-crop: how much of the room's height the docked wall band shows. The
       floor .76 is the old 32vh/42vh framing (a 3:4 room cropped to its top
       76%); layouts whose spots sit lower simply show more of the room. */
    var yb = 0;
    geo.slots.forEach(function (g) { yb = Math.max(yb, (g.y + g.h) / 100); });
    document.documentElement.style.setProperty('--pz-crop', Math.min(1, Math.max(0.76, yb + 0.08)).toFixed(3));
    if (geo.mock) {
      wrap.classList.add('photo');
      /* Arjun 07-09: every spot filled → the thumbs-up photo (same wall, same spots) */
      var allIn = state.slots.length && state.slots.every(function (sl) { return sl.sel; });
      wall.style.backgroundImage = 'url(' + (allIn && geo.mockDone ? geo.mockDone : geo.mock) + ')';
      wrap.style.setProperty('--pz-room', 'url(' + (allIn && geo.mockDone ? geo.mockDone : geo.mock) + ')'); /* blurred side-fill in the dock */
      if (geo.mockDone) { var pre = new Image(); pre.src = geo.mockDone; }   /* warm the cache so the swap is instant */
      if (geo.mockZoom) {
        var mz = geo.mockZoom, pct = (mz[0] * 100).toFixed(3) + '%';
        wall.style.backgroundSize = pct + ' ' + pct;
        wall.style.backgroundPosition = (mz[1] * 100).toFixed(3) + '% ' + (mz[2] * 100).toFixed(3) + '%';
      }
    }
    if (state.wallZoom) { wall.style.minWidth = Math.round(scale) + 'px'; wrap.classList.add('zoomed'); }
    if (FRAMED) {
      /* 28-09: the product's own surface (pinboard / twine wall / taped strips), the strips and twine behind the cards */
      wrap.classList.add('pz-wb-stage', 'pz-wb-stage--' + FRAMED_KIND);
      wall.style.setProperty('--pz-wdm', geo.W.toFixed(3));   /* desktop caps the wall at an honest px-per-dm */
      renderFramedDeco(wall, geo);
    }
    /* the photo products point at the first empty spot ("start here"); tiny spots drop their size text */
    var firstEmpty = -1, wallPx = Math.max(0, (root.clientWidth || 0) - 28);   /* the wall sits inside the board's padding */
    /* 28-09 round 2 (BYW / M&M): a zoomed wall is at least `scale` px wide (A5 spots >= 64 px) */
    var wallPxZ = (!PHOTO && state.wallZoom) ? Math.max(wallPx, scale) : wallPx;
    if (PHOTO) for (var fe = 0; fe < state.slots.length; fe++) if (!state.slots[fe].sel) { firstEmpty = fe; break; }

    geo.slots.forEach(function (g, i) {
      var s = state.slots[i];
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'pz-wb-slot' + (s.sel ? ' filled' : '') + (isSplit(s.size) ? ' split' : '') +
        (i === activeSlot && isSplitOn() && drawer && drawer.classList.contains('show') ? ' cur' : '');
      if (s.sel && s.sel.type === 'catalog') el.classList.add(isSplit(s.size) ? 'mockup' : (isLandscape(s.size) || isFlatSel(s.sel)) ? 'land' : 'art');
      el.setAttribute('data-slot', i);
      el.style.left = g.x + '%';
      el.style.top = g.y + '%';
      el.style.width = g.w + '%';
      el.style.height = g.h + '%';
      var tinyS = PHOTO && wallPx * g.w / 100 < 48;   /* photo products: a spot under 48 px gets the compact badge and x */
      if (FRAMED) {
        framedSpot(el, s, i, i === firstEmpty, tinyS);
      } else if (s.sel) {
        var psrc = spotSrc(s.sel, s.size);
        var pim = psrc || !PHOTO ? pooledImg(psrc, s.sel.title) : photoPrepEl();
        if (!PHOTO && pim.tagName === 'IMG') pim.style.objectPosition = canMove(s) ? posCss(s.sel) : '';   /* pooled images keep their last style - always set (15-10 Showcase move) */
        el.appendChild(pim);
        if (PHOTO) {
          var pBadge = photoBadge(s.sel, s.size, tinyS);
          if (pBadge) { el.appendChild(pBadge); if (/toosmall/.test(pBadge.className)) el.classList.add('toosmall'); }
          if (tinyS) el.classList.add('tiny');
        }
        if (isSplit(s.size)) {
          var cuts = document.createElement('span');
          cuts.className = 'pz-wb-cuts' + (/^SPLIT8/.test(s.size) ? ' pz-wb-cuts--8' : '');
          el.appendChild(cuts);
        } else if (s.size === 'Q2A3' || s.size === 'H2A3' || s.size === 'H6A3') {
          var qcuts = document.createElement('span');
          qcuts.className = 'pz-wb-cuts pz-wb-cuts--' + (s.size === 'H2A3' ? 'h' : s.size === 'H6A3' ? 's' : 'q');   /* H6A3: Showcase Wall 3 x 2 (14-10) */   /* Duo Wall: one design, printed as 2 (H2A3) / 4 (Q2A3) A3 sheets */
          el.appendChild(qcuts);
        }
        if (s.sel.status === 'uploading' && (psrc || !PHOTO)) {
          var ring = document.createElement('span');
          ring.className = 'pz-wb-ring';
          ring.setAttribute('data-pct', PHOTO && !s.sel.pct ? '' : (s.sel.pct || 0) + '%');   /* photo products: a photo waiting its upload turn shows no 0% */
          el.appendChild(ring);
        }
        if (s.sel.status === 'error') {
          var errB = document.createElement('span');
          errB.className = 'pz-wb-err';
          errB.textContent = 'Retry';
          el.appendChild(errB);
        }
        if (!PHOTO) {
          if (canMove(s)) { moveCss(); el.appendChild(slotMoveBtn(i)); }   /* 15-10: Showcase hero - slide the design */
          el.appendChild(slotClearBtn(i));   /* photo products: the x is the spot's sibling (below) */
          /* 28-09 round 2: on a spot under 48 px (A5 on a ready-made wall at 375 px: 32-35 px wide) the 20 px x covered
             most of the poster and Chrome's touch adjustment sent "tap any poster to swap it" to it - the poster was
             removed. Such a spot hides its x on the page wall (CSS .nox), so a tap opens the picker to swap; the
             docked wall's current-spot x and Clear all are unchanged. */
          if (wallPx > 0 && wallPxZ * g.w / 100 < 48) el.classList.add('nox');
        }
      } else {
        /* 14-10: a room photo whose sheets already carry a "+" (BYW Real Walls) - the spot itself stays clear */
        var onPhoto = !!(geo.mock && LAYOUTS[state.size] && LAYOUTS[state.size].native && BYW_ROOMS_ON && !MODE);
        if (onPhoto) { el.classList.add('pz-native'); el.setAttribute('aria-label', 'Add a poster - ' + sizeLabel(s.size)); }
        else el.innerHTML = '<span class="pz-wb-plus">+</span><span class="pz-wb-slot-size">' + sizeLabel(s.size) + '</span>';
        if (/^SPLIT8/.test(s.size)) { var pre = document.createElement('span'); pre.className = 'pz-wb-cuts pz-wb-cuts--8 pz-wb-cuts--empty'; el.appendChild(pre); } /* empty 8-panel spot shows its 4 x 2 grid */
        else if (s.size === 'Q2A3') { var qpre = document.createElement('span'); qpre.className = 'pz-wb-cuts pz-wb-cuts--q pz-wb-cuts--qe'; el.appendChild(qpre); }
        else if (s.size === 'H2A3') { var hpre = document.createElement('span'); hpre.className = 'pz-wb-cuts pz-wb-cuts--h pz-wb-cuts--qe'; el.appendChild(hpre); }
        else if (s.size === 'H6A3') { var spre = document.createElement('span'); spre.className = 'pz-wb-cuts pz-wb-cuts--s pz-wb-cuts--qe'; el.appendChild(spre); }   /* empty Showcase hero shows its 3 x 2 joints */   /* empty Duo 2x2 spot shows its cuts */
        if (PHOTO) { if (wallPx * g.w / 100 < 48) el.classList.add('tiny'); if (i === firstEmpty) el.classList.add('next'); }
      }
      /* picker already open: a tap on a spot just moves the ring there (no
         re-open, no grid reset); otherwise open on that spot */
      /* Arjun 15-10 ("hero poster click pannave adjust panrathu default ah varra maari pannu"): a tap on a movable hero
         opens Adjust; "Change poster" in that sheet is the swap */
      el.addEventListener('click', function () { if (!PHOTO && canMove(state.slots[i])) openMove(i); else spotTap(i); });
      wall.appendChild(el);
      if (PHOTO && s.sel) wall.appendChild(photoClearBtn(i, g, tinyS));
    });
    /* 29-09: the retro pegs belong on the twine - Heart / Grid / Mega Collage hang flat, no peg */
    if (FRAMED_KIND === 'retro' && !(geo.rows && geo.rows.length)) wall.classList.add('pz-wb-nopeg');
    if (PHOTO && !FRAMED && isOneKey(state.size)) wall.classList.add('pz-wb-wall--one');   /* desktop caps the single poster's board */
    wrap.appendChild(wall);
    /* Arjun 16-10 ("option 3 build pannu"): the picking band reads as a real wall - warm paint, a skirting line and
       the posters' real width / height in feet (the size card's wallFeet numbers). Build Your Wall only. */
    if (BAND_WALL && !geo.mock) wallDims(wrap, wall, geo);   /* 16-10: + Mix & Match singles / splits */
    /* zoom toggle pinned on the wall preview */
    var zbtn = document.createElement('button');
    zbtn.type = 'button';
    zbtn.className = 'pz-wb-zoom' + (state.wallZoom ? ' on' : '');
    zbtn.innerHTML = state.wallZoom ? '&#8722; Fit to screen' : '&#128269; Zoom in';
    zbtn.addEventListener('click', function (e) {
      e.stopPropagation();
      state.wallZoom = !state.wallZoom;
      render();
    });
    /* 16-10 night (QA): on the painted picking band the pill sat on the bottom-right spot of small walls and took its taps;
       a wall of up to 12 spots is never too small to tap, so the band shows no zoom pill there */
    var zoomOff = BAND_WALL && !geo.mock && geo.slots.length <= 12 && !state.wallZoom;
    if (!PHOTO && !zoomOff) wrap.appendChild(zbtn);   /* photo products always fit the screen; a tapped photo opens big (28-09) */
    if (!PHOTO && filledCount() && geo.mock) {   /* the room-photo wall only: on the plain picking board it covered posters and Zoom in (Arjun 15-10 "remove all en ipdi eruku?") */
      /* Arjun 15-10 ("remove all button veklam. innum easy ah erukum"): the Clear all chip sat at the far end of the
         "Fill it in one tap" row, off screen - one button on the wall clears every spot (Undo in the toast) */
      var rmAll = document.createElement('button');
      rmAll.type = 'button';
      rmAll.className = 'pz-wb-rmall';
      rmAll.innerHTML = '<span aria-hidden="true">\u2715</span> Remove all';
      /* Arjun 15-10 ("ithula x mark visible ah therira maari pannu"): in the bottom corner the pill was cut off on his
         phone - it now sits on the bare wall just under the posters, centred on them (bottom corner only if no room) */
      var rx0 = 100, rx1 = 0;
      geo.slots.forEach(function (g) { rx0 = Math.min(rx0, g.x); rx1 = Math.max(rx1, g.x + g.w); });
      rmAll.style.left = ((rx0 + rx1) / 2).toFixed(2) + '%';
      rmAll.style.top = 'min(calc(' + (yb * 100).toFixed(2) + '% + 10px), calc(100% - 40px))';
      rmAll.style.bottom = 'auto';
      rmAll.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); clearWall(); });
      wall.appendChild(rmAll);
      /* 20-10 (ad landing looks): after a "Get this look" / ?lk= fill, a small muted line under the pill says the wall is
         only a start. Pill + line share one centred column; the bottom clamp leaves room for both */
      if (lookHint === state.size) {
        var rmHint = document.createElement('span');
        rmHint.className = 'pz-wb-rmhint';
        rmHint.textContent = 'Change any posters you want';
        rmAll.style.top = 'min(calc(' + (yb * 100).toFixed(2) + '% + 10px), calc(100% - 60px))';
        rmHint.style.left = rmAll.style.left;
        rmHint.style.top = 'min(calc(' + (yb * 100).toFixed(2) + '% + 44px), calc(100% - 26px))';
        wall.appendChild(rmHint);
      }
    }
    root.appendChild(wrap);
    if (PHOTO) photoUnderStage();   /* LOW RES line + paste-a-link row (28-09) */
    if (keepWall) wrap.scrollLeft = keepWall;

    /* progress + price bar */
    var done = filledCount(), total = state.slots.length;
    var bar = document.createElement('div');
    bar.className = 'pz-wb-bar';
    var pi = priceInfo();
    var saveAmt = pi && pi.compare > pi.price ? pi.compare - pi.price : 0;
    var barOk = done === total;
    /* 28-09 preview test: photo products turn green only when every photo is uploaded and none is too small */
    if (PHOTO && barOk) barOk = state.slots.every(function (s) { return s.sel && s.sel.status === 'done' && s.sel.url && !phTooSmall(s.sel, s.size); });
    var inCart = phInCart();
    bar.innerHTML =
      '<div class="pz-wb-bar-left">' +
        '<span class="pz-wb-bar-count' + (barOk ? ' ok' : '') + '">' + done + ' / ' + total + (PHOTO ? (total === 1 ? ' photo' : ' photos') + ' added' : ' chosen') + '</span>' +
        (pi ? '<span class="pz-wb-bar-price">' + money(pi.price) +
          (pi.compare > pi.price ? ' <s>' + money(pi.compare) + '</s>' : '') + '</span>' : '') +
        (saveAmt ? '<span class="pz-wb-bar-save">You save ' + money(saveAmt) + '</span>' : '') +
      '</div>' +
      /* Arjun 17-09: the goal label always - "Add to cart", never "Fill your wall"; with spots still empty the tap
         says how many more and opens the picker (submitWall), so the button is never disabled or grey */
      '<button type="button" class="pz-wb-atc' + (inCart ? ' pz-wb-atc--in' : '') + '">' + (EDIT && EDIT.item ? (PHOTO ? 'OK \u2713 Update ' + photoNoun() : 'OK \u2713 Update wall') : inCart ? 'In your cart \u2713' : 'Add to cart') + '</button>';
    bar.querySelector('.pz-wb-atc').addEventListener('click', submitWall);
    root.appendChild(bar);
    /* Arjun 06-09: the moment every spot is filled is the AOV moment - they own
       these designs now (endowment); the next pack costs a little more for a lot
       more posters (anchoring). One card, one number, above the wall. */
    if (MODE && !CUSTOM && MODE !== 'custom8' && total && done === total && !upDismissed[state.size] && !EDIT) {
      var up = nextPack(state.size);
      if (up && pi) {
        var extra = up.m.posters - SIZE_META[state.size].posters;
        var diff = Math.round(up.vr.v.price - pi.price);
        var unit = up.m.unit === 'sets' ? 'set' : 'poster';
        var upc = document.createElement('div');
        upc.className = 'pz-wb-up';
        upc.innerHTML =
          '<div class="pz-wb-up-t">Add <b>' + extra + ' more ' + unit + (extra > 1 ? 's' : '') + '</b> for just <b>' + money(diff) + '</b>?</div>' +
          '<div class="pz-wb-up-s">' + up.m.posters + ' ' + unit + 's for ' + money(up.vr.v.price) + ' · ' + money(Math.round(up.vr.v.price / up.m.posters)) + ' each' +
            (up.m.tier ? ' · ' + String(up.m.tier).replace(/\s*free\s*$/i, ' FREE') : '') + '</div>' +
          '<div class="pz-wb-up-b"><button type="button" class="pz-wb-up-yes">Yes, add ' + extra + ' more</button>' +
          '<button type="button" class="pz-wb-up-no">No, keep ' + total + '</button></div>';
        upc.querySelector('.pz-wb-up-yes').addEventListener('click', function () {
          pzTrack('upsell-yes');
          setSize(up.key);
          setTimeout(function () { openOnCategory(drawerTab); }, 250);
        });
        upc.querySelector('.pz-wb-up-no').addEventListener('click', function () {
          upDismissed[state.size] = 1; pzTrack('upsell-no'); render();
        });
        var ww = root.querySelector('.pz-wb-wallwrap');
        if (ww) root.insertBefore(upc, ww); else root.appendChild(upc);
      }
    }
    if (atcWaiting || (EDIT && EDIT.saving)) setAtcBusy(true);
    if (keepPage && Math.abs(window.pageYOffset - keepPage) > 2) window.scrollTo(0, keepPage);
    stageWall();
    ensurePreview();
  }

  /* size card = the pack drawn at REAL scale on a room wall, with a 170 cm
     person for reference (Arjun 22-08: customers pick by the picture, not by
     reading "~4.5 x 3 ft"). Units are centimetres; ceiling sits at 300.
     Every card shares ONE scale and ONE person so the packs stay comparable —
     only the furniture under the art changes with how wide the pack is, which
     is safe because every piece is drawn at its true size. */
  var FLOOR = 300;                               /* everything is drawn off the floor */
  /* Each card crops to its OWN content instead of sharing one room-sized box
     (Arjun 22-08: "poster size romba chinnadha therikirathu, mela empty space
     irukku"). A 91 cm pack inside a 300 cm room left two thirds of the card
     empty. Scale now varies per card; the 170 cm person is what carries the
     size comparison, backed by the ft label. */
  function sceneFor(key) {
    var geo = computeLayout(key);
    var artW = geo.W * 10, artH = geo.H * 10;
    var furn = furnitureFor(artW);
    var blockW = Math.max(artW, furn.w + 30);    /* furniture + its plant */
    var cx = 78 + blockW / 2;                    /* the person owns x 2..70 */
    var W = 78 + blockW + 6;
    /* the console is the only piece shorter than the art it sits under, so it
       needs a taller gap or the lamp and the plant crash into the posters */
    var bottom = FLOOR - furn.h - (furn.kind === 'console' ? 38 : 20);
    var top = bottom - artH;
    /* never crop the person's head off */
    var viewTop = Math.min(top - 16, FLOOR - 186);
    return { geo: geo, artW: artW, artH: artH, furn: furn, cx: cx, W: W,
             bottom: bottom, top: top, viewTop: viewTop, H: FLOOR + 12 - viewTop };
  }
  /* true-scale furniture chosen by pack width — a narrow pack over a queen bed
     looks lost, a 6 ft pack over a console looks absurd */
  function furnitureFor(wallW) {
    if (wallW < 150) return { kind: 'console', w: 120, h: 76 };
    if (wallW < 176) return { kind: 'sofa', w: 180, h: 84 };
    return { kind: 'bed', w: 190, h: 104 };
  }
  /* ISO-style standing person, drawn in a 0-100 tall box and scaled to 170 cm */
  var PERSON_PATH = 'M20 0a8 8 0 1 0 0.01 0zM13 18h14c4 0 6.5 2.5 7 6.5l3.5 24.5-5 .8-3.2-20.5h-1v23l3.2 45h-7l-3.3-40h-1.4l-3.3 40h-7l3.2-45v-23h-1l-3.2 20.5-5-.8 3.5-24.5c.5-4 3-6.5 7-6.5z';
  var R = function (x, y, w, h, fill, rx) {
    return '<rect x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) +
      '" height="' + h.toFixed(1) + '"' + (rx ? ' rx="' + rx + '"' : '') + ' fill="' + fill + '"/>';
  };
  function drawPlant(x, base) {
    return R(x - 6, base - 13, 12, 13, '#b85c3a', 1.5) +
      '<circle cx="' + x.toFixed(1) + '" cy="' + (base - 20).toFixed(1) + '" r="7" fill="#7aa56a"/>' +
      '<circle cx="' + (x - 6).toFixed(1) + '" cy="' + (base - 17).toFixed(1) + '" r="5" fill="#8fb67e"/>' +
      '<circle cx="' + (x + 6).toFixed(1) + '" cy="' + (base - 17).toFixed(1) + '" r="5" fill="#6b9a5c"/>';
  }
  function drawFurniture(f, cx, floor) {
    var L = cx - f.w / 2, top = floor - f.h;
    if (f.kind === 'console') {
      return R(L, top, f.w, 7, '#8e7052', 2) +
        R(L + 4, top + 7, f.w - 8, 46, '#a98a66', 2) +
        '<line x1="' + cx + '" y1="' + (top + 9) + '" x2="' + cx + '" y2="' + (top + 51) + '" stroke="#8e7052" stroke-width="1.4"/>' +
        R(L + 8, top + 53, 8, f.h - 53, '#6f5640') + R(L + f.w - 16, top + 53, 8, f.h - 53, '#6f5640') +
        drawPlant(L + f.w - 16, top) +
        R(cx - 40, top - 12, 5, 12, '#6f5640') + R(cx - 52, top - 22, 29, 10, '#d9cdb8', 3);
    }
    if (f.kind === 'sofa') {
      return R(L, top, f.w, 48, '#7d8e9c', 9) +
        R(L, top + 34, f.w, f.h - 34 - 9, '#8fa2b1', 7) +
        R(L, top + 12, 17, f.h - 12 - 9, '#6f8091', 7) + R(L + f.w - 17, top + 12, 17, f.h - 12 - 9, '#6f8091', 7) +
        R(L + 22, top + 6, (f.w - 52) / 2, 30, '#93a6b5', 5) + R(L + 26 + (f.w - 52) / 2, top + 6, (f.w - 52) / 2, 30, '#93a6b5', 5) +
        R(L + 12, floor - 9, 7, 9, '#5c4a38') + R(L + f.w - 19, floor - 9, 7, 9, '#5c4a38') +
        drawPlant(L + f.w + 20, floor);
    }
    /* bed: upholstered headboard, mattress, sheet, blanket, pillows, legs */
    var mt = top + 62;
    return R(L, top, f.w, mt - top + 14, '#8e7052', 9) +
      R(L + 7, top + 7, f.w - 14, mt - top - 2, '#a98a66', 6) +
      R(L - 5, mt, f.w + 10, 26, '#fbf9f4', 4) +
      R(L - 5, mt + 11, f.w + 10, 15, '#6e8ea9', 4) +
      R(L - 5, mt + 11, f.w + 10, 4, '#8fa9bf') +
      R(L + 20, mt + 2, 66, 11, '#ffffff', 4) + R(L + f.w - 86, mt + 2, 66, 11, '#ffffff', 4) +
      R(L - 5, mt + 26, f.w + 10, 6, '#8e7052') +
      R(L + 2, mt + 32, 7, floor - mt - 32, '#6f5640') + R(L + f.w - 9, mt + 32, 7, floor - mt - 32, '#6f5640') +
      R(L + f.w + 10, floor - 40, 34, 40, '#a98a66', 2) +
      drawPlant(L + f.w + 27, floor - 40);
  }
  /* the picking band's real-wall look (Arjun 16-10, option 3): measurement lines on the posters' own extent, in feet
     like wallFeet. A layout whose posters touch the board edge (Full Wall's columns) has no margin for the lines, so
     its band gets extra padding (.pz-wb-paint--pad, sizeDock adds the same room). */
  /* 16-10 carousel + price row styles (one <style>, like dimsCss) */
  var peekCssDone = false;
  function peekCss() {
    if (peekCssDone) return;
    peekCssDone = true;
    var R = '.pz-wb-sizes.pz-wb-sizes--peek', st = document.createElement('style');
    st.textContent =
      '.pz-wb-sizes--lean .pz-wb-pricerow{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:6px 8px;margin:5px 10px 0}' +
      '.pz-wb-sizes--lean .pz-wb-pricerow>.pz-wb-size-price{margin:0!important;min-width:0}' +
      '.pz-wb-sizes--lean .pz-wb-pricerow>.pz-wb-ppp{margin:0!important;align-self:center}' +
      '@media (max-width:749px){' +
        R + '{display:grid!important;grid-template-rows:none!important;grid-template-columns:none!important;grid-auto-flow:column!important;grid-auto-columns:74vw!important;gap:12px!important;width:100vw!important;max-width:none!important;margin-left:calc(50% - 50vw)!important;margin-right:calc(50% - 50vw)!important;padding:16px 13vw 12px!important;box-sizing:border-box!important;overflow-x:auto!important;scroll-snap-type:x mandatory!important;scroll-padding:0 13vw;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
        R + '::-webkit-scrollbar{display:none}' +
        R + '>.pz-wb-size{scroll-snap-align:center;scroll-snap-stop:always;width:auto!important;min-width:0!important;max-width:none!important;transition:transform .25s,opacity .25s}' +
        R + '>.pz-wb-size:not(.pz-wb-size--mid):not(.pz-wb-size--mix){transform:scale(.92);opacity:.75}' +
        R + '>.pz-wb-size--mix{display:none!important}' +
      '}';
    document.head.appendChild(st);
  }
  /* the card nearest the rail's middle is the "mid" one (full size, full colour) */
  function peekMark(cards) {
    var rc = cards.getBoundingClientRect(), mid = rc.left + rc.width / 2, best = null, bd = 1e9;
    var list = cards.querySelectorAll('.pz-wb-size:not(.pz-wb-size--mix)');
    [].forEach.call(list, function (c) { var r = c.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid); if (d < bd) { bd = d; best = c; } });
    [].forEach.call(list, function (c) { c.classList.toggle('pz-wb-size--mid', c === best); });
  }
  function peekCenter(cards, card) {
    var rc = cards.getBoundingClientRect(), cr = card.getBoundingClientRect();
    cards.scrollLeft += (cr.left + cr.width / 2) - (rc.left + rc.width / 2);
    peekMark(cards);
  }
  /* first view: the chosen card, else MOST POPULAR (Large - the card Arjun's 16-10 mock centred), else the first card;
     later renders keep where the shopper swiped to, and a tap on a card brings it to the middle */
  var peekStarted = false;
  function peekRail(cards, onCard) {
    peekCss();
    cards.classList.add('pz-wb-sizes--peek');
    if (!cards._pzPeek) {
      cards._pzPeek = true;
      var raf = 0;
      cards.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; peekMark(cards); });
      }, { passive: true });
    }
    var go = null;
    if (!peekStarted) go = onCard || cards.querySelector('.pz-wb-size[data-key="large"]') || cards.querySelector('.pz-wb-size:not(.pz-wb-size--mix)');
    else if (railFollowsSelection && onCard) go = onCard;
    peekStarted = true;
    if (go) peekCenter(cards, go);
    else peekMark(cards);
  }
  function dimsBox(geo) {
    var b = { x0: 100, y0: 100, x1: 0, y1: 0 };
    geo.slots.forEach(function (g) { b.x0 = Math.min(b.x0, g.x); b.y0 = Math.min(b.y0, g.y); b.x1 = Math.max(b.x1, g.x + g.w); b.y1 = Math.max(b.y1, g.y + g.h); });
    b.pad = b.x0 < 3 || b.y0 < 4;   /* the abs layouts keep ~4.5% margins (enough for the lines); columns (Full Wall) have none */
    return b;
  }
  var dimsCssDone = false;
  function dimsCss() {
    if (dimsCssDone) return;
    dimsCssDone = true;
    var P = '.pz-wb-d-wall .pz-wb-wallwrap.pz-wb-paint:not(.photo)';
    var st = document.createElement('style');
    st.textContent =
      '.pz-wb-dim{display:none}' +
      P + '{background:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27120%27 height=%27120%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%27.85%27 numOctaves=%272%27/%3E%3CfeColorMatrix type=%27saturate%27 values=%270%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url(%23n)%27 opacity=%27.12%27/%3E%3C/svg%3E"),linear-gradient(#cbbfa8,#cbbfa8) 0 calc(100% - 10px)/100% 1px no-repeat,linear-gradient(#e2d8c6,#d6cab4) 0 100%/100% 10px no-repeat,radial-gradient(120% 90% at 50% 0%,#fbf8f2 0%,#f1ebe0 55%,#e7dfd1 100%) #efe8dc;background-blend-mode:multiply,normal,normal,normal}' +
      P + '.pz-wb-paint--pad{padding:18px 12px 10px 24px}' +
      P + '.pz-wb-paint--pad:not(.zoomed) .pz-wb-wall{width:min(100%,calc((var(--pz-wall-h,240px) - 28px) * var(--pz-ratio,1)))}' +
      P + ' .pz-wb-slot:not(.filled):not(.cur){background:#fff;border-color:#cfc6b3;box-shadow:0 2px 4px rgba(80,60,30,.12)}' +
      P + ':not(.zoomed) .pz-wb-dim{display:block;position:absolute;z-index:1;pointer-events:none;box-sizing:border-box;color:#8a8070;font:800 10px/1 Barlow,system-ui,sans-serif;letter-spacing:.02em}' +
      '.pz-wb-dim--w{height:9px;border-left:1.5px solid #b9ae98;border-right:1.5px solid #b9ae98}' +
      '.pz-wb-dim--w::before{content:"";position:absolute;left:0;right:0;top:3.5px;border-top:1.5px solid #b9ae98}' +
      '.pz-wb-dim--w b{position:absolute;left:50%;top:-1px;transform:translateX(-50%);padding:0 5px;background:#f8f4ec;font-weight:800;white-space:nowrap}' +
      '.pz-wb-dim--h{width:9px;border-top:1.5px solid #b9ae98;border-bottom:1.5px solid #b9ae98}' +
      '.pz-wb-dim--h::before{content:"";position:absolute;top:0;bottom:0;left:3.5px;border-left:1.5px solid #b9ae98}' +
      '.pz-wb-dim--h b{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%) rotate(-90deg);padding:0 5px;background:#f2ece2;font-weight:800;white-space:nowrap}' +
      '.pz-wb-d-sheet.kb .pz-wb-dim{display:none!important}' +
      '@media (max-height:519px){.pz-wb-d-wall .pz-wb-dim{display:none!important}}';
    document.head.appendChild(st);
  }
  function wallDims(wrap, wall, geo) {
    var b = dimsBox(geo);
    if (!(b.x1 > b.x0 && b.y1 > b.y0)) return;
    function ft(dm) { return '~' + (dm * 10 / 30.48).toFixed(1).replace(/\.0$/, '') + ' ft'; }
    dimsCss();
    wrap.classList.add('pz-wb-paint');
    if (b.pad) wrap.classList.add('pz-wb-paint--pad');
    var w = document.createElement('span'), h = document.createElement('span');
    w.className = 'pz-wb-dim pz-wb-dim--w';
    w.setAttribute('aria-hidden', 'true');
    w.style.left = b.x0.toFixed(3) + '%';
    w.style.width = (b.x1 - b.x0).toFixed(3) + '%';
    w.style.top = 'calc(' + b.y0.toFixed(3) + '% - 15px)';
    w.innerHTML = '<b>' + ft((b.x1 - b.x0) / 100 * geo.W) + '</b>';
    h.className = 'pz-wb-dim pz-wb-dim--h';
    h.setAttribute('aria-hidden', 'true');
    h.style.top = b.y0.toFixed(3) + '%';
    h.style.height = (b.y1 - b.y0).toFixed(3) + '%';
    h.style.left = 'calc(' + b.x0.toFixed(3) + '% - 19px)';
    h.innerHTML = '<b>' + ft((b.y1 - b.y0) / 100 * geo.H) + '</b>';
    wall.appendChild(w);
    wall.appendChild(h);
  }
  /* coverage in feet, straight off the geometry — no hand-maintained strings */
  function wallFeet(key) {
    var g = computeLayout(key);
    var gw = g.art ? g.art.w : g.W, gh = g.art ? g.art.h : g.H;
    function ft(dm) { return (dm * 10 / 30.48).toFixed(1).replace(/\.0$/, ''); }
    return '~' + ft(gw) + ' \u00d7 ' + ft(gh) + ' ft';
  }
  function miniDiagram(key) { return FRAMED ? framedDiagram(key) : PHOTO && isOneKey(key) ? onePosterIco(key) : sceneSVG(sceneFor(key)); }
  /* ---- framed photo prints: the rail card's picture (28-09) ----
     The pack laid out as it hangs - white cards with their photo window (yellow on the chosen pack, like the sheets
     on the Mix & Match cards), retro rows on a twine, booth strips side by side. One scale for every size of a pack,
     so the A6 card of "10 prints" is visibly bigger than the 3.5 x 4.2 one. Units: dm x 100. */
  function framedDiagram(key) {
    var m = SIZE_META[key], cells = GRID_CELL[MODE] || {}, cell = m && cells[m.size];
    if (!cell) return '';
    var units = m.units || m.posters, K = 100;
    var d = frUnitDim(cell), a = frPlace(d, units, true), UW = 0, UH = 0;
    Object.keys(cells).forEach(function (sz) { var b = frPlace(frUnitDim(cells[sz]), units, true); UW = Math.max(UW, b.W); UH = Math.max(UH, b.H); });
    var pad = Math.max(UW / MINI_ASPECT, UH) * 0.2, VW = UW + 2 * pad, VH = UH + 2 * pad * 1.25;
    if (VW / VH < MINI_ASPECT) VW = VH * MINI_ASPECT; else VH = VW / MINI_ASPECT;
    var ox = (VW - a.W) / 2, oy = (VH - a.H) / 2 + pad * 0.12, f = function (v) { return (v * K).toFixed(1); }, out = '';
    var sh = Math.max(d[0], d[1]) * 0.035;
    if (FRAMED_KIND === 'retro') a.tops.forEach(function (t) {
      var y = oy + t + 0.012;
      var x0 = (VW - UW) / 2 - pad * 0.45, x1 = (VW + UW) / 2 + pad * 0.45;
      out += '<path class="tw" vector-effect="non-scaling-stroke" d="M' + f(x0) + ' ' + f(y) + ' Q' + f(VW / 2) + ' ' + f(y + 0.05) + ' ' + f(x1) + ' ' + f(y) + '"/>';
      for (var li = 1; li < 9; li++) { var lt = li / 9; out += '<circle class="lt" cx="' + f(x0 + (x1 - x0) * lt) + '" cy="' + f(y + 0.1 * lt * (1 - lt)) + '" r="' + f(d[0] * 0.05) + '"/>'; }   /* fairy lights */
    });
    a.at.forEach(function (p) {
      var x = ox + p[0], y = oy + p[1];
      out += '<rect class="sh" x="' + f(x + sh * 0.2) + '" y="' + f(y + sh) + '" width="' + f(d[0]) + '" height="' + f(d[1]) + '"/>' +
        '<rect class="c" vector-effect="non-scaling-stroke" x="' + f(x) + '" y="' + f(y) + '" width="' + f(d[0]) + '" height="' + f(d[1]) + '"/>';
      if (FRAMED_KIND === 'booth') BOOTH_WIN.y.forEach(function (fy) {
        out += '<rect class="w" x="' + f(x + BOOTH_WIN.x * d[0]) + '" y="' + f(y + fy * d[1]) + '" width="' + f(BOOTH_WIN.w * d[0]) + '" height="' + f(BOOTH_WIN.h * d[1]) + '"/>';
      });
      else { var w = FRAME_WIN[cell]; out += '<rect class="w" x="' + f(x + w[0] * d[0]) + '" y="' + f(y + w[1] * d[1]) + '" width="' + f(w[2] * d[0]) + '" height="' + f(w[3] * d[1]) + '"/>'; }
      if (FRAMED_KIND === 'retro' && a.tops.length) out += '<rect class="cl" x="' + f(x + d[0] * 0.44) + '" y="' + f(y - d[1] * 0.07) + '" width="' + f(d[0] * 0.12) + '" height="' + f(d[1] * 0.16) + '" rx="' + f(d[0] * 0.02) + '"/>';
    });
    return '<svg class="pz-wb-arr pz-wb-arr--' + FRAMED_KIND + '" viewBox="0 0 ' + f(VW) + ' ' + f(VH) + '" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' + out + '</svg>';
  }
  /* Personalize "1 Poster": the slim card's picture - one poster on a ledge at its real height (the size cards' look) */
  function isOneKey(key) { var m = SIZE_META[key]; return !!(m && (m.units || m.posters) === 1); }
  function onePosterIco(key) {
    var m = SIZE_META[key], s = SZC[m.size] || { h: 0.6 };
    return '<span class="pz-wb-one-ico"><i style="--h:' + s.h + '"></i></span>';
  }
  /* rail card for a photo wall: the blank room with the posters of that pack/size
     drawn as white sheets at their real positions (Arjun 07-09: "layout choose
     panrathula poster sizes eh kaanom") */
  /* rail card for a photo wall (Arjun 07-09 "intha images layout choose la vei"):
     the same picture as the wall - the whole photo at its own aspect, the spots
     as dashed sheets, and whatever is already picked shown in its spot */
  function miniPhoto(key) {
    var L = LAYOUTS[key], g = computeLayout(key);
    var z = L.mockZoom, zs = '';
    if (z) zs = ' style="position:absolute;width:' + (z[0] * 100).toFixed(2) + '%;height:' + (z[0] * 100).toFixed(2) + '%;left:' + (-z[1] * (z[0] - 1) * 100).toFixed(2) + '%;top:' + (-z[2] * (z[0] - 1) * 100).toFixed(2) + '%"';
    var h = '<img src="' + (L.mockSmall || L.mock) + '" alt="" loading="lazy"' + zs + '>';
    g.slots.forEach(function (sl, i) {
      var s = state.slots[i], sel = s && s.sel, src = '';
      if (sel) src = sel.type === 'upload' ? (sel.blobUrl || sel.url || sel.thumb || '') : thumb(sel.img, 160);
      var mpos = key === state.size && canMove(s) ? posCss(sel) : '';
      h += '<i class="' + (src ? 'f' + (sel.type !== 'upload' && !isFlatSel(sel) ? ' art' : '') : '') + '" style="left:' + sl.x.toFixed(2) + '%;top:' + sl.y.toFixed(2) + '%;width:' + sl.w.toFixed(2) + '%;height:' + sl.h.toFixed(2) + '%">' + (src ? '<img src="' + src + '" alt=""' + (mpos ? ' style="object-position:' + mpos + '"' : '') + '>' : '') + '</i>';
    });
    return h;
  }
  function miniRatio(key) { var g = computeLayout(key); return (g.W / g.H).toFixed(4); }
  /* Arjun 17-09: on the pick-any builders the rail's pack cards are the home page's live builder cards -
     the 4:5 room photo, a ghost design faint on every sheet, the glove tapping them solid one by one
     (snippets/pz-home-live, stamped as <template id="pz-wb-live-tpl"> by pz-card-atc-assets on these
     two product pages; assets/pz-home-live.js picks the clones up on its next scan and runs one hand
     per rail). Build Your Wall keeps its drawn scenes: its gallery already shows the ghosts. */
  function liveKind(key) {
    var m = SIZE_META[key];
    return m && MODE === 'singles' ? 'mix' + m.posters : null;
  }
  /* the live cards' glove hand (snippets/pz-home-live), for the cards built here from a gallery photo */
  var LIVE_HAND = '<span class="hand" aria-hidden="true"><svg viewBox="5.53 6.73 20 20"><path class="glove" d="M11.3,20.4c-0.3-0.4-0.6-1.1-1.2-2c-0.3-0.5-1.2-1.5-1.5-1.9c-0.2-0.4-0.2-0.6-0.1-1c0.1-0.6,0.7-1.1,1.4-1.1c0.5,0,1,0.4,1.4,0.7c0.2,0.2,0.5,0.6,0.7,0.8c0.2,0.2,0.2,0.3,0.4,0.5c0.2,0.3,0.3,0.5,0.2,0.1c-0.1-0.5-0.2-1.3-0.4-2.1c-0.1-0.6-0.2-0.7-0.3-1.1c-0.1-0.5-0.2-0.8-0.3-1.3c-0.1-0.3-0.2-1.1-0.3-1.5c-0.1-0.5-0.1-1.4,0.3-1.8c0.3-0.3,0.9-0.4,1.3-0.2c0.5,0.3,0.8,1,0.9,1.3c0.2,0.5,0.4,1.2,0.5,2c0.2,1,0.5,2.5,0.5,2.8c0-0.4-0.1-1.1,0-1.5c0.1-0.3,0.3-0.7,0.7-0.8c0.3-0.1,0.6-0.1,0.9-0.1c0.3,0.1,0.6,0.3,0.8,0.5c0.4,0.6,0.4,1.9,0.4,1.8c0.1-0.4,0.1-1.2,0.3-1.6c0.1-0.2,0.5-0.4,0.7-0.5c0.3-0.1,0.7-0.1,1,0c0.2,0,0.6,0.3,0.7,0.5c0.2,0.3,0.3,1.3,0.4,1.7c0,0.1,0.1-0.4,0.3-0.7c0.4-0.6,1.8-0.8,1.9,0.6c0,0.7,0,0.6,0,1.1c0,0.5,0,0.8,0,1.2c0,0.4-0.1,1.3-0.2,1.7c-0.1,0.3-0.4,1-0.7,1.4c0,0-1.1,1.2-1.2,1.8c-0.1,0.6-0.1,0.6-0.1,1c0,0.4,0.1,0.9,0.1,0.9s-0.8,0.1-1.2,0c-0.4-0.1-0.9-0.8-1-1.1c-0.2-0.3-0.5-0.3-0.7,0c-0.2,0.4-0.7,1.1-1.1,1.1c-0.7,0.1-2.1,0-3.1,0c0,0,0.2-1-0.2-1.4c-0.3-0.3-0.8-0.8-1.1-1.1L11.3,20.4z"/><path class="marks" d="M19.6,20.7v-3.4M17.6,20.7l-0.1-3.4M15.6,17.3v3.4"/></svg><i class="ring"></i></span>';
  /* Arjun 18-09: on the Build Your Wall rail the ghosts read as colour specks (a sheet is 8-12 px on a phone card) -
     "pazhaya padiye irukkattum": the plain scenes again, the yellow badge stays. Flip to bring the live scenes back. */
  var BYW_RAIL_LIVE = false;
  function liveHtml(key, idx) {
    if (!MODE && !BYW_RAIL_LIVE) return '';
    if (!MODE) {
      /* Build Your Wall (Arjun 17-09 "intha layouts-um prefill pannu"): the drawn scene with a ghost design on every
         sheet (the gallery's look) and the glove; the chosen wall shows its own picks. GHOST is defined further
         down, so the first render draws plain scenes and re-renders right after (the GAL_SPLIT_PHOTO line). */
      var L0 = LAYOUTS[key];
      return L0 && !L0.mock && GHOST ? '<span class="pz-live">' + sceneSVG(sceneFor(key), state.size === key, idx * 7) + '</span>' + LIVE_HAND : '';
    }
    if (MODE === 'splits') {
      /* the split rail: the gallery's own square room photos (3 and 8 sets, GAL_SPLIT_PHOTO) with a ghost set on
         every measured sheet - the gallery card's crop. Those photos and the ghost list are defined further down,
         so the first render draws the plain scenes and re-renders right after (see the GAL_SPLIT_PHOTO line). */
      var sp = SIZE_META[key] && typeof GAL_SPLIT_PHOTO === 'object' && GAL_SPLIT_PHOTO && GAL_SPLIT_PHOTO[SIZE_META[key].posters];
      return sp && GHOST ? ('<span class="pz-live">' + galPic(key, false, idx) + '</span>').replace(/\sloading="lazy"|\sdecoding="async"/g, '') + LIVE_HAND : '';
    }
    if (MODE === 'singles' && !MM_ROOMS_ON) return '';   /* 27-09: the drawn scene (miniDiagram), no room photo */
    var k = liveKind(key), tpl = k && document.getElementById('pz-wb-live-tpl');
    var box = tpl && tpl.content && tpl.content.querySelector('[data-live-kind="' + k + '"]');
    /* no lazy / async-decode attributes on the rail's images: a re-created lazy image starts blank on iPhone Safari */
    return box ? box.innerHTML.replace(/\sloading="lazy"|\sdecoding="async"/g, '') : '';
  }
  /* mine / off: a gallery card draws the wall's picks and ghost designs on the sheets
     (off = where this card starts in the ghost list); the rail's size cards pass nothing */
  /* Arjun 30-09 "E2": the Build Your Wall layout cards (gallery grid + rail) draw a warmer room (wall light, wood, plank floor, soft shadow)
     and every sheet as an EMPTY dotted spot with a "+" - no designs ("posters pre fill la eruntha users confuse avanga"),
     the same look as an empty spot inside the builder. A card's own picks still draw over their sheets; other modes keep their scenes. */
  var sceneSeq = 0;
  function sceneSVG(f, mine, off) {
    var left = f.cx - f.artW / 2;
    var e2 = !MODE, eid = e2 ? 'pzse' + (++sceneSeq) : '';
    var tiles = f.geo.slots.map(function (g, i) {
      var x = left + g.x / 100 * f.artW, y = f.top + g.y / 100 * f.artH, w = g.w / 100 * f.artW, h = g.h / 100 * f.artH;
      var m = Math.min(w, h);
      var out = e2
        ? '<rect class="t e" x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" rx="0.8" style="stroke-width:' + Math.max(0.5, m * 0.035).toFixed(2) +
          ';stroke-dasharray:' + (m * 0.09).toFixed(2) + ' ' + (m * 0.07).toFixed(2) + '"/>' +
          '<path d="M' + (x + w / 2 - m * 0.16).toFixed(1) + ' ' + (y + h / 2).toFixed(1) + 'h' + (m * 0.32).toFixed(1) + 'M' + (x + w / 2).toFixed(1) + ' ' + (y + h / 2 - m * 0.16).toFixed(1) + 'v' + (m * 0.32).toFixed(1) +
          '" fill="none" stroke="#8d8272" stroke-width="' + Math.max(0.6, m * 0.06).toFixed(2) + '" stroke-linecap="round"/>'
        : '<rect class="t" x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" rx="0.6"/>';
      if (off !== undefined) {
        var sel = mine && state.slots[i] && state.slots[i].sel, src = '';
        if (sel) src = sel.type === 'upload' ? (sel.blobUrl || sel.url || sel.thumb || '') : thumb(sel.img, 160);
        else src = ghostSrc(off + i, g.size, true);   /* a drawn scene's sheets are always small */
        if (src) out += '<image class="' + (sel ? 'p' : 'g') + '" href="' + src + '" x="' + x.toFixed(1) + '" y="' + y.toFixed(1) + '" width="' + w.toFixed(1) + '" height="' + h.toFixed(1) + '" preserveAspectRatio="xMidYMid slice"/>';
      }
      var pn = jointsOf(g.size);
      for (var c = 1; c < pn.c; c++) out += '<line x1="' + (x + w * c / pn.c).toFixed(1) + '" y1="' + y.toFixed(1) + '" x2="' + (x + w * c / pn.c).toFixed(1) + '" y2="' + (y + h).toFixed(1) + '" stroke="#fff" stroke-width="1.2"/>';
      for (var r = 1; r < pn.r; r++) out += '<line x1="' + x.toFixed(1) + '" y1="' + (y + h * r / pn.r).toFixed(1) + '" x2="' + (x + w).toFixed(1) + '" y2="' + (y + h * r / pn.r).toFixed(1) + '" stroke="#fff" stroke-width="1.2"/>';
      return out;
    }).join('');
    var ft = function (cm) { return (cm / 30.48).toFixed(1).replace(/\.0$/, ''); };
    var dimY = f.bottom + 13;
    /* the ceiling line sits at y=9 unless the art climbs past it (36 x 13x19 is
       7 ft tall) - then it lifts to stay clear of the top row, so the wall
       always reads as one finished surface behind the posters */
    var ceilY = Math.min(9, f.top - 12);
    var ceiling = R(0, f.viewTop, f.W, Math.max(0, ceilY - f.viewTop), '#e3dbcc') + (e2 ? '' : R(0, ceilY, f.W, 2, '#d3c9b7')); /* no negative-height rect when the view starts below the ceiling line */
    var furn = drawFurniture(f.furn, f.cx, FLOOR);
    if (e2) furn = '<ellipse cx="' + f.cx.toFixed(1) + '" cy="' + (FLOOR + 1) + '" rx="' + (f.furn.w * 0.55).toFixed(1) + '" ry="3.5" fill="#000" opacity=".18"/>' +
      furn.replace(/fill="#(a98a66|8e7052)"/g, 'fill="url(#' + eid + 'd)"');
    return '<svg class="pz-wb-scene' + (off !== undefined && GHOST ? ' ghost' : '') + '" viewBox="0 ' + f.viewTop.toFixed(1) + ' ' + f.W.toFixed(1) + ' ' + f.H.toFixed(1) + '" preserveAspectRatio="xMidYMax meet" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      (e2
        ? '<defs><linearGradient id="' + eid + 'w" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#f3ece1"/><stop offset="1" stop-color="#e7dccb"/></linearGradient>' +
          '<radialGradient id="' + eid + 'l" cx=".55" cy=".25" r=".6"><stop offset="0" stop-color="#fff" stop-opacity=".55"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient>' +
          '<pattern id="' + eid + 'f" width="28" height="12" patternUnits="userSpaceOnUse"><rect width="28" height="12" fill="#c9ab82"/><line x1="0" y1="0" x2="0" y2="12" stroke="#b39269" stroke-width="1"/></pattern>' +
          '<linearGradient id="' + eid + 'd" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#b8946b"/><stop offset="1" stop-color="#96734f"/></linearGradient></defs>' +
          R(0, f.viewTop - 300, f.W, FLOOR - f.viewTop + 300, 'url(#' + eid + 'w)') + R(0, f.viewTop, f.W, (FLOOR - f.viewTop) * 0.9, 'url(#' + eid + 'l)')
        : R(0, f.viewTop, f.W, FLOOR - f.viewTop, '#f5f1ea')) +
      ceiling +
      R(0, FLOOR, f.W, 12, e2 ? 'url(#' + eid + 'f)' : '#dfd6c8') +
      R(0, FLOOR - 2, f.W, 2.5, '#cdc3b3') +
      '<path d="' + PERSON_PATH + '" fill="' + (e2 ? '#a79d8f" opacity=".75' : '#b9b0a2') + '" transform="translate(2,' + (FLOOR - 170).toFixed(1) + ') scale(1.7)"/>' +
      furn +
      tiles +
      '<line x1="' + left.toFixed(1) + '" y1="' + dimY.toFixed(1) + '" x2="' + (left + f.artW).toFixed(1) + '" y2="' + dimY.toFixed(1) + '" stroke="#a79e8d" stroke-width="0.9"/>' +
      '<text x="' + f.cx.toFixed(1) + '" y="' + (dimY + 4).toFixed(1) + '" text-anchor="middle" font-size="9.5" font-weight="700" fill="#6d665a" font-family="Barlow, system-ui, sans-serif" style="paint-order:stroke" stroke="#f5f1ea" stroke-width="3">' +
        ft(f.artW) + ' x ' + ft(f.artH) + ' ft</text>' +
      '</svg>';
  }

  /* ---------- add to cart ---------- */
  function findForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var fallback = null;
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if ((f.getAttribute('id') || '').indexOf('installment') !== -1) continue;
      var idInput = f.querySelector('input[name="id"], select[name="id"]');
      if (!idInput || !cfg.variants[String(idInput.value)]) continue;
      if (f.querySelector('button[type="submit"], [name="add"]')) return f;
      if (!fallback) fallback = f;
    }
    return fallback;
  }

  /* the line property naming the layout: the photo products write _Print Layout (never _Wall Layout - the floor drops
     _Wall Layout lines from the cutting slips), everything else _Wall Layout */
  var LAYOUT_PROP = PHOTO ? '_Print Layout' : '_Wall Layout';
  /* 28-09 (spec 5.6, every mode): once the add request has landed - success or not - the wall's hidden inputs leave the
     Dawn form, so they can never ride on the next product added from this page / drawer (the floor has no dedupe for a
     leaked _Poster set). Dawn / Corner read the form when the submit fires, so the add itself already has them. The add
     is seen as a /cart/add resource entry; 8 s is the backstop. A newer add owns the form: an older watcher leaves it. */
  var stripGen = 0;
  function stripPropsAfterAdd() {
    var gen = ++stripGen, fired = false, po = null, t = null;
    var strip = function () {
      if (fired) return;
      fired = true;
      clearTimeout(t);
      try { if (po) po.disconnect(); } catch (e) {}
      if (gen !== stripGen) return;
      [].slice.call(document.querySelectorAll('.pz-wb-props')).forEach(function (n) { n.remove(); });
      propsBox = null;
    };
    try {
      po = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { if (/\/cart\/add(\.js)?([?#]|$)/.test(e.name || '')) setTimeout(strip, 0); });
      });
      po.observe({ type: 'resource' });
    } catch (e) { po = null; }
    t = setTimeout(strip, 8000);
  }
  function syncProps() {
    if (!form) return;
    /* Order #291135: a second wall added in the same session inherited the
       first wall's slot properties - propsBox was re-created (the reference
       nulled) but the OLD hidden-input div stayed in the form, so both walls'
       properties posted together. Kill every previous props container first;
       the box is always rebuilt fresh. */
    [].slice.call(form.querySelectorAll('.pz-wb-props')).forEach(function (n) { n.remove(); });
    propsBox = document.createElement('div');
    propsBox.className = 'pz-wb-props';
    propsBox.style.display = 'none';
    form.appendChild(propsBox);
    wallProps().forEach(function (pr) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + pr[0] + ']';
      inp.value = pr[1];
      propsBox.appendChild(inp);
    });
  }
  /* the wall's line properties, in order - the Add-to-cart form (syncProps) and the cart
     edit (updateCartWall, 27-09) post exactly the same names and values */
  function wallProps() {
    if (PHOTO) return photoProps();   /* 28-09: the floor's _Poster contract - never _Wall Layout / Slot rows */
    var out = [];
    var m = SIZE_META[state.size];
    if (!m) return out;
    function add(name, value) { out.push([name, value]); }
    add('Wall Size', m.name + ' — ' + m.posters + ' ' + (m.unit || 'posters') + ' (' + m.desc + ')');
    add('_Wall Layout', state.size);
    if (previewReady()) add('_Wall Preview', state.pv);
    /* never let a missing preview pass silently — the floor slip falls back to
       slot numbers, but this flag makes the order findable in Shopify search */
    else add('_Wall Preview Status', 'MISSING — rebuild from slot images');
    var wbx = wallBoxes();
    if (wbx) add('_Wall Boxes', wbx);   /* 21-10: slot boxes in % [[x,y,w,h],...] (slot order) - the floor redraws a missing preview */
    state.slots.forEach(function (s, i) {
      if (!s.sel) return;
      var label = 'Slot ' + (i + 1) + ' · ' + sizeLabel(s.size);
      if (s.sel.type === 'catalog') {
        add(label, s.sel.title);
        add('_Slot ' + (i + 1) + ' Image', s.sel.img.split('?')[0]);
        if (canMove(s) && selPos(s.sel)) add('_Slot ' + (i + 1) + ' Position', posProp(s.sel));   /* 15-10: the floor cuts this window (prep.py --pos) */
      } else {
        add(label, 'Your photo ✓' + (s.sel.pin ? ' · Pinterest' : '') + (s.sel.low ? ' · Low quality (AI upscale)' : ''));
        if (s.sel.url) add('_Slot ' + (i + 1) + ' Image', s.sel.url);
      }
    });
    /* Arjun 09-09: "pinterest use panni evlo order" - one countable property per order */
    var pins = state.slots.filter(function (s) { return s.sel && s.sel.type === 'upload' && s.sel.pin; }).length;
    if (pins) add('_Pinterest', pins + ' slot' + (pins > 1 ? 's' : '') + ' from Pinterest');
    /* 16-10: low-quality photos the shopper accepted - findable in Shopify search, read by the floor and support */
    var lows = [];
    state.slots.forEach(function (s, i) { if (s.sel && s.sel.type === 'upload' && s.sel.low) lows.push('Slot ' + (i + 1) + (s.sel.low > 1 ? ' (' + s.sel.low + ' DPI)' : '')); });
    if (lows.length) add('_Low Quality Photo', lows.join(', ') + ' - accepted with the AI-upscale warning');
    return out;
  }

  /* Add-to-cart while the preview is still rendering */
  var atcWaiting = false, pvAtcTriedKey = null;

  function setAtcBusy(on) {
    var b = root.querySelector('.pz-wb-atc');
    if (!b) return;
    b.disabled = !!on;
    b.classList.toggle('pz-wb-atc-busy', !!on);
    var ed0 = EDIT && EDIT.item;
    if (PHOTO) b.textContent = on ? (ed0 ? 'Updating your ' + photoNoun() + '\u2026' : 'Preparing your ' + photoNoun() + '\u2026') : (ed0 ? 'OK \u2713 Update ' + photoNoun() : 'Add to cart');
    else b.textContent = on ? (ed0 ? 'Updating your wall…' : 'Preparing your wall…') : (ed0 ? 'OK \u2713 Update wall' : 'Add to cart');
  }

  function submitWall() {
    if (EDIT && !EDIT.item) { toast(PHOTO ? 'Loading your photos\u2026' : 'Loading your wall\u2026'); return; }
    if (EDIT && (atcWaiting || EDIT.saving)) return;   /* one save at a time: the drawer's OK and the bar's OK are both wired here */
    if (!state.size) { toast(PHOTO ? 'Pick a pack first.' : 'Pick a wall size first.'); return; }
    var misfit = dropMisfits();
    if (misfit) { save(); render(); toast(misfit === 1 ? 'One spot needs a different design (it does not fit that spot) \u2014 please pick it again.' : misfit + ' spots need a different design \u2014 please pick them again.'); return; }
    var vrS = variantFor(state.size);
    if (vrS && vrS.oos) { toast('Preview only \u2014 not on sale yet. This layout goes on sale after the theme is published.'); return; }
    if (PHOTO && PH.btnWait) return;           /* already waiting for Dawn's Add button (below) - one add per tap */
    if (PHOTO && !EDIT && PH.soldKey && PH.soldKey === pvKeyNow() && !PH.addOk) { toast('Adding to your cart…'); return; }   /* this set's add is still on its way (phWatchAdd) */
    if (phInCart()) {
      /* 28-09 preview test: this exact set is already a line in the cart - a second tap opens the cart instead of adding a
         twin (the floor would print it twice). If the line has gone from the cart since, it is added again. */
      var u1 = state.slots[0] && state.slots[0].sel && state.slots[0].sel.url, lay = state.size, key0 = PH.addOk;
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        phCartSeen(c);   /* round 2: the line was removed from the cart meanwhile - its photos are no longer "in your cart" */
        return (c.items || []).some(function (it) { var p = it.properties || {}; return p['_Poster 1'] === u1 && p['_Print Layout'] === lay; });
      }).catch(function () { return true; }).then(function (has) {
        if (has) {
          var a = document.getElementById('cart-icon-bubble') || document.querySelector('a[href="/cart"], a[href$="/cart"]');
          if (a) a.click(); else location.href = '/cart';
          return;
        }
        if (PH.addOk === key0) { PH.addOk = null; PH.soldKey = null; render(); submitWall(); }
      });
      return;
    }
    if (PHOTO && !photoReadyToAdd()) return;   /* 28-09: every spot uploaded (done + URL), else say what is missing */
    /* round 2: some of these photos are already in a cart line (a Switch / pack tap after the add): say so first - a
       second tap within 5 s adds them anyway (a deliberate second set, #10), and that OK holds for this exact set
       (the preview wait below calls submitWall again) */
    if (PHOTO && !EDIT && PH.dupKey !== pvKeyNow() && phCartDup()) {
      var dk = pvKeyNow();
      if (PH.dupAsk && PH.dupAsk.k === dk && Date.now() - PH.dupAsk.t < 5000) { PH.dupKey = dk; PH.dupAsk = null; }
      else {
        var nd = phCartDup();
        PH.dupAsk = { k: dk, t: Date.now() };
        toast(nd + (nd === 1 ? ' of these photos is' : ' of these photos are') + ' already in your cart — tap Add to cart again to print ' +
          (nd === 1 ? 'it' : 'them') + ' twice, or Clear all to start a new set.');
        return;
      }
    }
    var missing = state.slots.length - filledCount();
    var uploading = state.slots.some(function (s) { return s.sel && s.sel.status === 'uploading'; });
    if (uploading) { toast('Hold on — your photo is still uploading…'); return; }
    if (missing > 0) {
      toast('Pick ' + missing + ' more to add to cart — tap any + spot.');
      autoAdvance();
      /* Arjun 17-09: the tap is "I want this" - open the picker on the first empty spot (a + spot's own tap;
         on the own-photo builders that is the phone's photo picker, which needs the tap's own gesture, so no delay) */
      var firstEmpty = -1;
      for (var fi = 0; fi < state.slots.length; fi++) if (!state.slots[fi].sel) { firstEmpty = fi; break; }
      if (firstEmpty > -1 && !(drawer && drawer.classList.contains('show'))) openDrawer(firstEmpty);
      return;
    }
    /* the preview renders in the background after the last slot is filled; a
       quick Add-to-cart used to beat it and the order shipped with no preview
       at all. Hold the button until it lands (capped by PV_ATC_CAP). */
    if (!previewReady() && !atcWaiting && pvAtcTriedKey !== pvKeyNow()) {
      atcWaiting = true;
      pvAtcTriedKey = pvKeyNow();   /* one wait per wall — never loop the customer */
      setAtcBusy(true);
      var edAt = EDIT;
      awaitPreview(function () {
        atcWaiting = false;
        setAtcBusy(false);
        if (edAt !== EDIT) return;   /* the edit ended meanwhile - never turn this into a plain add to cart */
        submitWall();
      });
      return;
    }

    if (EDIT && EDIT.item) { updateCartWall(); return; }   /* 27-09: OK on a cart wall - write the same line back */
    form = findForm();
    if (!form) { toast('Something went wrong — please refresh the page.'); return; }
    propsBox = null;
    syncVariant(state.size);
    syncProps();
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (idInput) idInput.disabled = false;
    /* 28-09 photo products: Dawn 16 resolves the ticked radios with a section fetch, so the form's id can lag a quick
       pack change - the line must be exactly the pack on screen */
    if (PHOTO && idInput) { var pvr = variantFor(state.size); if (pvr) idInput.value = pvr.id; }
    var btn = form.querySelector('button[type="submit"], [name="add"]');
    /* 28-09 photo products (integration): a pack tapped a moment ago - Dawn 16 keeps its (hidden) Add button disabled
       while it fetches that variant's section, and a click on a disabled button does nothing (no add, no error). Wait
       for Dawn (at most 3 s), then add; after that wait the click goes ahead as before. BYW / Mix & Match unchanged. */
    if (PHOTO && btn && btn.disabled && !PH.btnWaited) {
      var t0 = Date.now();
      PH.btnWait = t0;
      setAtcBusy(true);
      (function waitBtn() {
        var b = form && form.querySelector('button[type="submit"], [name="add"]');
        if (b && b.disabled && Date.now() - t0 < 3000) { setTimeout(waitBtn, 100); return; }
        PH.btnWait = 0;
        setAtcBusy(false);
        /* 28-09 fix: the props synced above leave the form before re-entering - a re-entry that stops short (a photo
           removed or a pack changed during the wait) must not leave a _Poster set in Dawn's form; a re-entry that
           goes ahead rebuilds them fresh in its own syncProps() */
        [].slice.call(document.querySelectorAll('.pz-wb-props')).forEach(function (n) { n.remove(); });
        propsBox = null;
        PH.btnWaited = true;
        try { submitWall(); } finally { PH.btnWaited = false; }
      })();
      return;
    }
    /* 28-09 photo products: Dawn's section fetch is slow (>3 s) or failed (Dawn never re-enables then). The id above is already the pack's available variant, so do not click a disabled button (a silent no-add that still wiped the saved photos). Dawn resets the flag when its fetch lands. */
    if (PHOTO && btn && btn.disabled && idInput && variantFor(state.size)) btn.removeAttribute('disabled');
    pzTrack('atc');
    /* clear the saved wall once it's in the cart */
    try { localStorage.removeItem(LS_KEY); } catch (e) {}
    /* click the real (hidden) Dawn button so Corner/Dawn keep the add
       AJAX — drawer opens and AddToCart pixels fire like normal products */
    if (btn) btn.click();
    else if (form.requestSubmit) form.requestSubmit();
    else form.submit();
    stripPropsAfterAdd();   /* 28-09 (every mode): the hidden inputs never ride on the next product added from this form */
    if (PHOTO) { PH.soldKey = pvKeyNow(); PH.addOk = null; phWatchAdd(PH.soldKey); }   /* 28-09 preview test: confirm the line landed (else the photos are saved again) */
    /* Arjun 04-09: the preview link also goes on the CART (order "Additional
       details"), so it sits at the top of the order page instead of buried
       among 30 slot properties. One key per wall in the cart. */
    if (previewReady() && !PHOTO) {   /* never a 'Wall preview N' cart attribute for the photo products */
      var pvUrl = state.pv;
      setTimeout(function () {
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          var walls = (c.items || []).filter(function (it) { return it.properties && it.properties['_Wall Layout']; }).length || 1;
          var attrs = {}; attrs['Wall preview ' + walls] = pvUrl;
          return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
        }).catch(function () {});
      }, 2500);
    }
  }

  /* ---------- edit a wall that is already in the cart (Arjun 27-09) ---------- */
  function cartPost(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function startEdit() {
    if (root) root.style.opacity = '.45';
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var items = c.items || [];
      var it = items.filter(function (x) { return x.key === EDIT.key; })[0];
      if (!it) {
        /* the key is gone (the line was changed elsewhere): the only wall of this product left in the cart, if there is exactly one */
        var same = items.filter(function (x) { return x.properties && x.properties[LAYOUT_PROP] && cfg.variants[String(x.variant_id)]; });
        if (same.length === 1) it = same[0];
      }
      var p = it && it.properties || {}, key = p[LAYOUT_PROP];
      if (!it || !cfg.variants[String(it.variant_id)]) { finishEdit(false, PHOTO ? 'That item is not in your cart any more.' : 'That wall is not in your cart any more.'); return; }
      if (!key || !LAYOUTS[key] || !variantFor(key)) { finishEdit(false, PHOTO ? 'This item cannot be edited here \u2014 remove it and add it again.' : 'This wall cannot be edited here \u2014 remove it and build it again.'); return; }
      EDIT.item = it;
      packMode = null; packOff = null;
      if (PHOTO) photoClearAll();   /* the shopper's own unfinished photos stay in storage, not in this line */
      setSize(key, true);
      if (PHOTO) photoFromLine(p);
      else state.slots.forEach(function (s, i) {
        var n = i + 1, pre = 'Slot ' + n + ' \u00b7 ';
        var vk = Object.keys(p).filter(function (k) { return k.indexOf(pre) === 0; })[0];
        var v = vk ? String(p[vk]) : '', img = p['_Slot ' + n + ' Image'] ? String(p['_Slot ' + n + ' Image']) : '';
        if (!img) { s.sel = null; return; }
        if (/^Your photo/i.test(v)) s.sel = { type: 'upload', title: 'Your photo', thumb: img, url: img, status: 'done', pct: 100, pin: /Pinterest/i.test(v), low: /Low quality/i.test(v) ? 1 : 0 };
        /* a catalogue pick: its title and picture are all the line keeps. Product photos (cdn.shopify.com) are
           lifestyle mockups the builder zooms into; design-drop pictures are the flat artwork */
        else {
          s.sel = { type: 'catalog', title: v, img: img, handle: null, flat: !/cdn\.shopify\.com|\/cdn\/shop\//.test(img) };
          var lp = posFromProp(p['_Slot ' + n + ' Position']);
          if (lp && canMove(s)) s.sel.pos = lp;   /* 15-10: a moved Showcase hero comes back where it was */
        }
      });
      /* an unchanged wall keeps the preview that is already on the order line */
      state.pv = p['_Wall Preview'] ? String(p['_Wall Preview']) : null;
      state.pvKey = state.pv ? pvKeyNow() : null;
      if (root) root.style.opacity = '';
      render();
      toast(PHOTO ? 'Editing your ' + photoNoun() + ' \u2014 tap \u00d7 to change a photo, then OK' : 'Editing your wall \u2014 tap any poster to change it, then OK');
      if (!CUSTOM) setTimeout(function () { if (EDIT && EDIT.item) openDrawer(0); }, reduceMotion ? 0 : 350);
    }).catch(function () { finishEdit(false, PHOTO ? 'Could not load your photos \u2014 please try again.' : 'Could not load your wall \u2014 please try again.'); });
  }
  function updateCartWall() {
    if (EDIT.saving) return;
    var it = EDIT.item, vr = variantFor(state.size);
    if (!vr) { toast(PHOTO ? 'This pack is sold out \u2014 pick another pack.' : 'This wall size is sold out \u2014 tap Change pack.'); return; }
    var props = {};
    wallProps().forEach(function (pr) { props[pr[0]] = pr[1]; });
    /* the order-level "Wall preview N" note follows what the line really carries: a line saved without a fresh
       preview (MISSING) must not keep - or get - a picture of another wall (review 27-09) */
    var newPv = props['_Wall Preview'] || '', oldPv = (it.properties && it.properties['_Wall Preview']) || '';
    var samePack = String(vr.id) === String(it.variant_id);
    EDIT.saving = true;
    setAtcBusy(true);
    var ed = EDIT, cart0 = null;
    /* read the cart first: the quantity the shopper has NOW (they may have changed it in the drawer meanwhile),
       and whether the line is still there */
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      cart0 = c;
      var cur = (c.items || []).filter(function (x) { return x.key === it.key; })[0];
      if (!cur && !ed.added) return 'gone';
      var qty = cur ? cur.quantity : (ed.addedQty || it.quantity || 1);
      if (samePack) return cur ? cartPost('/cart/change.js', { id: it.key, quantity: qty, properties: props }) : c;
      /* another pack: add the new wall once (remembered, so a retry never adds it twice), then remove the old line */
      var add = ed.added ? Promise.resolve() : cartPost('/cart/add.js', { items: [{ id: Number(vr.id), quantity: qty, properties: props }] })
        .then(function () { ed.added = true; ed.addedQty = qty; });
      return add.then(function () {
        if (!cur) return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
        return cartPost('/cart/change.js', { id: it.key, quantity: 0 })
          .catch(function () { return cartPost('/cart/change.js', { id: it.key, quantity: 0 }); });   /* one quiet retry */
      });
    }).then(function (cart) {
      ed.saving = false;
      if (cart === 'gone') {
        /* the wall was removed from the cart while editing: OK means "I want this wall" - add it as a new one */
        EDIT = null;
        try { history.replaceState(history.state, '', location.pathname + location.search.replace(/([?&])pzedit=[^&#]*(&|$)/, function (m0, a, b) { return b ? a : ''; }).replace(/[?&]$/, '') + location.hash); } catch (e) {}
        setAtcBusy(false);
        render();
        submitWall();
        return;
      }
      var attrs = (cart && cart.attributes) || (cart0 && cart0.attributes) || {}, upd = {}, n = 0;
      if (oldPv && oldPv !== newPv) Object.keys(attrs).forEach(function (k) { if (attrs[k] === oldPv) { upd[k] = newPv; n++; } });
      else if (!oldPv && newPv) {
        var walls = ((cart && cart.items) || []).filter(function (x) { return x.properties && x.properties['_Wall Layout']; }).length || 1;
        upd['Wall preview ' + walls] = newPv; n = 1;
      }
      if (n && !PHOTO) cartPost('/cart/update.js', { attributes: upd }).catch(function () {});   /* no cart attribute for the photo products */
      finishEdit(true);
    }).catch(function () {
      ed.saving = false;
      setAtcBusy(false);
      if (PHOTO) toast(ed.added ? 'Your new pack is in the cart \u2014 tap OK once more to remove the old one.' : 'Could not update your ' + photoNoun() + ' \u2014 please try again.');
      else toast(ed.added ? 'Your new wall is in the cart \u2014 tap OK once more to remove the old one.' : 'Could not update your wall \u2014 please try again.');
    });
  }
  function finishEdit(updated, msg) {
    /* the edited line's own noun, read before restore() brings back the shopper's unfinished set (28-09 preview test:
       a 1-poster edit said "Your posters are updated") */
    var edNoun = PHOTO ? photoNoun() : '', edOne = PHOTO && edNoun === photoNoun(1);
    EDIT = null;
    if (root) root.style.opacity = '';
    try {
      var qs = location.search.replace(/([?&])pzedit=[^&#]*(&|$)/, function (m0, a, b) { return b ? a : ''; }).replace(/[?&]$/, '');
      history.replaceState(history.state, '', location.pathname + qs + location.hash);
    } catch (e) {}
    /* back to the shopper's own unfinished wall (if any): a second Add to cart never copies the wall already in the cart */
    state.slots.forEach(function (s) { s.sel = null; });
    if (PHOTO) state.more = [];
    state.pv = null; state.pvKey = null;
    restore();
    setAtcBusy(false);
    render();
    if (msg) toast(msg);
    if (updated) {
      toast(PHOTO ? 'Your ' + edNoun + ' ' + (edOne ? 'is' : 'are') + ' updated \u2713' : 'Your wall is updated \u2713');
      var a = document.getElementById('cart-icon-bubble') || document.querySelector('a[href="/cart"], a[href$="/cart"]');
      if (a) a.click(); else location.href = '/cart';
    }
  }

  /* hide the native ATC button — the wall bar is the only entry point */
  document.documentElement.classList.add('pz-wb-page');
  /* Arjun 27-08: no announcement ticker on this page - the marquee + offers
     already crowd the top. Find the scrolling BUY-X-GET-Y section and hide it. */
  (function hideTicker() {
    var secs = document.querySelectorAll('main .shopify-section, .shopify-section');
    for (var i = 0; i < secs.length; i++) {
      var sec = secs[i];
      if (sec.offsetHeight > 0 && sec.offsetHeight < 220 &&
          /BUY 4 GET 3 FREE/i.test(sec.textContent || '') &&
          !sec.querySelector('.pz-wb-sizes')) {
        sec.style.display = 'none';
      }
    }
  })();

  /* Dawn re-renders the product section on variant change, which replaces
     #pz-wall with the empty div from liquid — re-attach and re-render */
  setInterval(function () {
    var el = document.getElementById('pz-wall');
    if (el && el !== root) {
      root = el;
      form = findForm();
      propsBox = null;
      render();
      setTimeout(sizeDock, 300);
    }
  }, 400);

  pzTrack('view');
  form = findForm();
  restore();
  /* Arjun 16-09: a ready-made wall (Track / Garage) lives only behind its pack page's "customise this wall"
     link. Landing here without ?fill= - "Build your own wall" from any other pack page, the menu or home -
     starts the normal builder on the default layout; the pack wall is parked with its swaps and comes back
     on the next ?fill= visit. Slots are dropped too, so its posters never carry into the fresh wall. */
  if (!MODE && !packUrl && state.size && packForLayout(state.size)) {
    parkPackWall();
    state.size = null;
    state.slots = [];
  }
  /* Arjun 29-08: default is COMPACT, not Large. The beacon's first day showed
     the real wall is fill -> add-to-cart (349 filled a slot, only 80 reached
     the cart, 23%) — 15 empty slots is too much work to finish. Compact is 5.
     BEST VALUE stays on Large so the upsell anchor is untouched.
     A saved session still keeps whatever size that visitor picked. */
  if (!state.size) {
    var startKey = 'compact';
    if (MODE) startKey = startPackKey() || Object.keys(SIZE_META)[0];
    /* Arjun 04-09: Compact is retired, so a plain BYW landing starts on the
       first wall still on sale (Large). A saved session keeps its own size. */
    /* 08-10: an old ad / link with ?variant=<Classic> opens Studio (the variant itself is hidden at publish) */
    if (!MODE && /[?&]variant=/.test(LANDING_QS)) {
      mapVariantKeys();
      var lv = cfg.variants[String(cfg.selectedVariantId)];
      /* 16-10 (Growth, plan v2; Arjun "build pannu"): every ad / catalog ?variant= link opened Compact - only a retired key was
         ever remapped. Now the wall the link names opens; a retired wall opens its replacement, first one on sale wins.
         Landing links only - saved walls and cart edits keep their own wall (RETIRE_TO). */
      var VARIANT_TO = { classic: ['studio'], heart: ['large'], cinema: ['mosaic'],
                         full: ['hero', 'mosaic'], mix: ['hero', 'mosaic'], cinema2: ['hero', 'mosaic'], collector: ['hero', 'mosaic'] };
      if (lv && lv.key) {
        var vChain = VARIANT_TO[lv.key] || [lv.key];
        for (var vc = 0; vc < vChain.length; vc++) {
          var vk = vChain[vc];
          if (LAYOUTS[vk] && SIZE_META[vk] && !RETIRED_KEYS[vk] && variantFor(vk)) { startKey = vk; break; }
        }
      }
    }
    if (!MODE && RETIRED_KEYS[startKey]) {
      startKey = Object.keys(SIZE_META).filter(function (k) { return !RETIRED_KEYS[k]; })[0] || startKey;
    }
    setSize(startKey, true);
  }
  render();
  if (EDIT) startEdit();

  /* Arjun 06-09: a design card (home rows, collections) opens the matching
     Mix & Match builder with that design already in spot 1 - ?pick=<handle>
     (comma list allowed: the "Mix sizes" card carries every pick into BYW).
     The card is the hook, the builder is the sale; the shopper fills the rest.
     ?cat=<tab> opens the drawer straight on that category (home category circles). */
  var TAG_TAB = [[/anime|manga/, 'anime'], [/\bcars?\b|bike|jdm|porsche|bmw|ferrari|lambo|mustang|supercar/, 'cars'],
    [/marvel|\bdc\b|superhero|batman|spider|avenger|iron ?man/, 'heroes'], [/gam(e|es|ing)\b|valorant|gta|minecraft|pubg/, 'gaming'],
    [/foot|cricket|sport|\bf1\b|formula|nba|ipl/, 'sports'], [/music|hip.?hop|\brap\b|k.?pop|album|singer/, 'music'],
    [/movie|cinema|series|netflix|film/, 'movies'], [/gym|motivat|quote|hustle|discipline/, 'gym'],
    [/\bgod\b|devotion|hindu|shiva|krishna|hanuman|divine|spiritual/, 'divine'], [/kollywood|tamil|rajini|vijay|south/, 'desi']];
  function tabForTags(tags) {
    var t = (tags || []).join(' ').toLowerCase();
    for (var i = 0; i < TAG_TAB.length; i++) if (TAG_TAB[i][0].test(t)) return TAG_TAB[i][1];
    return null;
  }
  var pendingCat = null;
  /* split view: while the picker is open the wall lives INSIDE the sheet
     (.pz-wb-d-wall, the band under the head). position:fixed on the wallwrap
     itself breaks inside Dawn's animated (transformed) section wrappers, so
     the element is still MOVED - now into the body-level drawer's flex column,
     where it can never overlap the head. render() rebuilds root and calls
     stageWall() again, so the dock always holds the freshest wall
     (replaceChildren: no empty frame between picks). closeDrawer() sets
     closeTimer before its render(), so the dock keeps the wall for the exit
     fade; finishClose() empties it. */
  var closeTimer = null;
  var holdTimer = null; /* the 500ms last-pick hold before the auto-close */
  function cancelHold() { clearTimeout(holdTimer); holdTimer = null; }
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function stageWall() {
    var dock = drawer && drawer.querySelector('.pz-wb-d-wall');
    if (!dock) return;
    if (isSplitOn()) {
      var ww = root.querySelector('.pz-wb-wallwrap');
      if (ww) {
        /* render() hands over a fresh wallwrap every time: carry the band's
           scroll position across so a dense room does not snap back to its
           top row on every pick / clear / jumpToSlot (instant, never tweened) */
        var old = dock.firstElementChild, st = old && old !== ww ? old.scrollTop : 0;
        if (dock.replaceChildren) dock.replaceChildren(ww);
        else { dock.innerHTML = ''; dock.appendChild(ww); }
        if (st) { ww.style.scrollBehavior = 'auto'; ww.scrollTop = st; ww.style.scrollBehavior = ''; }
        if (!ww._pzCue) { ww._pzCue = 1; ww.addEventListener('scroll', dockScrollCue, { passive: true }); }
        /* the blurred room side-fill is painted by the dock (it must not live
           inside the scrolling wallwrap): mirror the room there */
        var photo = ww.classList.contains('photo');
        dock.classList.toggle('photo', photo);
        dock.style.setProperty('--pz-room', photo ? (ww.style.getPropertyValue('--pz-room') || 'none') : 'none');
      }
      markCur();
      dockScrollCue();
    } else if (!closeTimer) {
      dock.innerHTML = '';
      dock.classList.remove('photo', 'scrolls', 'at-end');
    }
  }
  function openOnCategory(key) {
    if (CUSTOM) return;
    var next = nextEmptySlot(-1);
    if (next < 0) return;
    if (key && DYN[key]) drawerTab = key;
    else if (!isSplit(state.slots[next].size) && key && TABS.some(function (t) { return t.key === key; })) drawerTab = key;
    openDrawer(next);
  }
  (function applyPick() {
    /* Arjun 09-15: ?fill=<pack> - a best-selling pack's designs already in the matching wall
       (Porsche -> Track Wall), so the pack page's "customise this wall" starts from the finished
       wall, not from empty spots. cfg.packs (snippets/pz-packs-data.liquid) lists each pack's
       layout and its designs by slot size; the gallery is skipped and no picker opens - the
       shopper taps whatever they want to change. */
    var fm = /[?&]fill=([a-z0-9-]+)/.exec(location.search || '');
    var pkf = fm && !MODE && cfg.packs && cfg.packs[fm[1]];
    if (pkf && LAYOUTS[pkf.layout] && SIZE_META[pkf.layout] && variantFor(pkf.layout)) {
      /* a reopened session on this same wall keeps its swaps; any other wall is replaced by the pack */
      var keepPicks = state.size === pkf.layout && state.slots.some(function (sl) { return sl.sel; });
      packOff = null;
      setSize(pkf.layout, true);
      /* Arjun 16-09: the wall a plain visit parked in between comes back with its swaps */
      var parked = keepPicks ? null : unparkPackWall(pkf.layout);
      if (parked) {
        (parked.sels || []).forEach(function (sel, i) {
          if (sel && sel.type === 'upload' && !sel.url && !(sel.thumb && !/^blob:/.test(sel.thumb))) return;
          if (sel && sel.type === 'upload') delete sel.blobUrl;
          if (sel && state.slots[i]) state.slots[i].sel = sel;
        });
        dropMisfits();
        keepPicks = state.slots.some(function (sl) { return sl.sel; });
      }
      var filled = fillFromPack(pkf, keepPicks);
      save(); render();
      pzTrack('pack');
      if (filled) {
        toast((pkf.name || 'Your wall') + ' is ready — tap any poster to change it, or add your own photo');
        /* land on the finished wall, not on the layout rail above it */
        setTimeout(function () { pzScrollTo(function () { return root.querySelector('.pz-wb-wallwrap'); }, 90); }, 350);
      }
      return;
    }
    var m = /[?&]pick=([^&#]+)/.exec(location.search || '');
    var cm = /[?&]cat=([a-z0-9]+)/.exec(location.search || '');
    var cat = cm ? cm[1] : null;
    /* ?col=handle[,handle]&label=Name - a merged category the store has no single
       collection for (Hollywood = movies + series, Sports = 5 collections): one
       dynamic drawer tab over all of them, same in the split builder */
    var colm = /[?&]col=([^&#]+)/.exec(location.search || '');
    if (colm && !m) {
      var handles = decodeURIComponent(colm[1]).split(/[,+ ]/).filter(Boolean);
      var lm = /[?&]label=([^&#]+)/.exec(location.search || '');
      var key = 'c:' + handles[0];
      DYN[key] = { key: key, kind: MODE === 'splits' ? 3 : 0, label: lm ? decodeURIComponent(lm[1].replace(/\+/g, ' ')) : handles[0].replace(/-/g, ' '),
                   handles: handles, pages: 2, include: MODE === 'splits' ? SPLIT3_RE : undefined, merge: 'concat' };
      cat = key;
    }
    if (!m) {
      /* Arjun 07-09: layouts first. Remember the category; the picker opens on it
         as soon as they choose a pack on the rail (or tap a spot). */
      if (cat) { pendingCat = cat; if (DYN[cat] || TABS.some(function (t) { return t.key === cat; })) drawerTab = cat; }
      /* ?go=1: the layout was chosen on the Shop All Posters page - straight into picking */
      if (/[?&]go=1/.test(location.search || '')) setTimeout(function () { openOnCategory(cat || drawerTab); }, 700);
      return;
    }
    var handles = decodeURIComponent(m[1]).split(',').filter(Boolean).slice(0, 36);
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).catch(function () { return null; });
    })).then(function (list) {
      var used = {}, placed = 0, inferred = null, firstTitle = '';
      list.forEach(function (p, n) {
        if (!p) return;
        var it = toItem(p);
        if (!it) return;
        var want = SPLIT5_RE.test(p.title || '') ? 5 : SPLIT3_RE.test(p.title || '') ? 3 : 1;
        var idx = -1;
        for (var i = 0; i < state.slots.length; i++) {
          if (used[i] || panelsOf(state.slots[i].size).c !== want || !fitsSlot(p.title, state.slots[i].size, false)) continue;   /* 03-10 */
          if (n === 0 || !state.slots[i].sel) { idx = i; break; }
        }
        if (idx < 0) return;
        used[idx] = 1;
        state.slots[idx].sel = { type: 'catalog', title: it.title, img: it.img, handle: it.handle };
        if (!inferred) inferred = tabForTags(p.tags);
        if (!firstTitle) firstTitle = it.title;
        placed++;
      });
      if (!placed) return;
      save(); render();
      var left = state.slots.filter(function (s) { return !s.sel; }).length;
      toast(placed === 1 ? firstTitle + ' is in - pick ' + left + ' more'
                         : placed + ' designs carried over - ' + left + ' spot' + (left === 1 ? '' : 's') + ' left');
      pzTrack('pick-link');
      /* do not leave them staring at empty spots: open the drawer on the next
         spot, in the category the pick came from */
      if (left) setTimeout(function () { openOnCategory(cat || inferred || 'all'); }, 900);
    });
  })();

  /* ---------- layout gallery (Arjun 09-10) ----------
     "product click panna direct-a builder pogama, first ella layouts show pannanum":
     the builder opens on a full-screen gallery.
       Build Your Wall - every wall on sale; Mosaic Wall leads as the wide card with the
         product photo (Arjun 09-10: it is the product image, visitors expect that wall first).
       Mix & Match Posters - size pills + packs; A4 is the default size and
         10 Posters (Buy 5 Get 5) leads as Most popular (Arjun 09-10 - by orders
         7 Posters sells more, 88 vs 37 in 14 days; this is the pack he pushes).
       Split Sets - 3 Sets (214 of 445) and 8 Sets side by side.
     Tap = the pack is set and the picker opens on the first empty spot. Skipped
     when the visitor already chose (?variant= / ?pick= / ?pack= / ?go=1), is back
     from Pinterest, or in the theme editor; never on the own-photo products.
     Back from the builder returns here; "Change pack" and "See all" reopen it.
     A wall in progress gets a "Continue your wall" bar. */
  var gal, galPushed = false, galSize = null, galSeen = false;
  /* ---- ghost designs (Arjun 09-14) ----
     Every card's empty sheets carry one of the builder's own flat designs at low opacity
     (snippets/pz-ghost-data.liquid: R2 thumbnails of pz-extra picks / listed 3-piece sets - never a
     Shopify-listed single), so a pack reads as a finished wall. They stay still: the tapping-hand
     animation lives on the home page cards only (Arjun 09-15 - a moving hand in the pack chooser
     read as cheap). The list rides in the page, not a fetch: the gallery opens on load, and a late
     list would redraw it (cards animating in twice, the Mosaic photo's posters swapping to sheets). */
  /* Arjun 18-09: no ghost designs anywhere on Build Your Wall ("choose layout-la pre-filled posters venda") - its layout
     gallery and rail show the plain scenes and the plain Mosaic photo again. The Mix & Match builders keep them. */
  /* Arjun 27-09: "mix and match singles la posters prefill venda" - the Mix & Match pack gallery shows the plain drawn
     scenes (grey sheets) like Build Your Wall; the chosen wall still shows its own picks. Split sets keep their ghosts. */
  var GHOST = !CUSTOM && MODE && MODE !== 'singles' && cfg.ghost && cfg.ghost.mix && cfg.ghost.mix.length ? cfg.ghost : null;
  /* the i-th ghost for a sheet: splits from the split list, the landing category's own
     designs when ?cat= brought the visitor, else the mixed list; small = the 110px thumb */
  function ghostSrc(i, size, small) {
    if (!GHOST) return '';
    var t = pendingCat && GHOST.tabs && GHOST.tabs[pendingCat];
    var list = isSplit(size) ? GHOST.split : (t && t.length > 3 ? t : GHOST.mix);
    if (!list || !list.length) return '';
    return (GHOST.base || '') + (small ? 's/' : '') + list[((i % list.length) + list.length) % list.length] + '.jpg';
  }
  /* Arjun 09-10: Mosaic first (the product image), then the old order; Classic and Studio close it */
  var GAL_BYW_ORDER = ['mix', 'large', 'compact', 'duo', 'full', 'cinema2', 'collector', 'classic', 'studio'];   /* 03-10: Mix leads in Mosaic's place */   /* track / garage: pack pages only (16-09) */
  var GAL_BYW_FEATURE = null;   /* Arjun 04-10 "gallery-um price order-la vei": no pinned feature card - every wall in price order */
  var GAL_BYW_LEAD = 'large';   /* the labels' lead: the most ordered wall (Best seller); the walls above its price show Save Rs X */
  /* the Mosaic card shows the product's own photo (17-piece wall above the desk), not a drawing */
  /* sheets: the photo's own sheets in layout slot order, measured off the photo (homepage/measure_sheets.py) - Arjun 09-14:
     ghosts placed by the layout sat off the paper and covered the man's head; over: what stands in front of the sheets,
     cut out and laid back over the ghosts */
  var GAL_BYW_PHOTO = { mosaic: { src: 'https://cdn.shopify.com/s/files/1/0758/7246/9288/files/build-your-own-wall.jpg?v=1788957613&width=900', box: [0.087, 0.078, 0.931, 0.667],
    sheets: [[0.087, 0.312, 0.0972, 0.1324], [0.0898, 0.4546, 0.0954, 0.1472], [0.1954, 0.2306, 0.0963, 0.138], [0.1954, 0.3787, 0.0963, 0.1481], [0.1926, 0.5361, 0.0991, 0.1361],
             [0.3324, 0.0852, 0.0954, 0.1352], [0.4407, 0.0852, 0.0954, 0.1352], [0.5491, 0.1231, 0.1361, 0.0963], [0.3037, 0.2315, 0.4139, 0.2102], [0.3056, 0.4537, 0.1463, 0.0972],
             [0.4657, 0.4537, 0.0972, 0.1324], [0.575, 0.4528, 0.0972, 0.1333], [0.7296, 0.0769, 0.0954, 0.137], [0.7296, 0.2269, 0.0954, 0.1472], [0.7296, 0.387, 0.0954, 0.1361],
             [0.8361, 0.1324, 0.0944, 0.138], [0.837, 0.2852, 0.0935, 0.1389]],
    over: { src: 'https://img.posterizedfloor.uk/ghost/byw-over.webp', box: [0.0833, 0.413, 0.1944, 0.675] } } };
  /* 03-10: Mix takes the lead card and its product photo (no measured sheets - the photo is the wall above the desk) */
  /* 03-10: Mix took Mosaic's product photo while Mosaic was retired; 14-10 Mosaic is back with that photo, so Mix draws its
     own scene again (two cards with one photo read as the same wall) - carried over from live MAIN 190721163560 (16-10) */
  var GAL_BYW_BADGE = { track: ['Ready-made', 'new'], garage: ['Ready-made', 'new'], mix: ['New \u00b7 25 posters', 'gold'] };   /* 04-10: Mix keeps its New label without the feature slot */   /* the two pack walls (16-09) */
  /* Arjun 09-10: Classic and Studio are plain A4 walls that Mix & Match also sells - they stay on sale
     (137 orders, Rs58k in the week to 09-10) but close the gallery, and an "Only A4 posters?" bar under
     them points to Mix & Match */
  var GAL_BYW_LAST = ['classic', 'studio'];
  var GAL_POPULAR = MODE === 'splits' ? 3 : 10;   /* the lead pack: 3 Sets (214 of 445 split orders); 10 Posters = Buy 5 Get 5 (Arjun 09-10) */
  /* split sets have no room photo in the builder - the Shop All page's photos (Arjun 09-09) */
  var GAL_SPLIT_PHOTO = { 3: { src: 'https://img.posterizedfloor.uk/site/2026/09/3002ba07-7800-42b0-a54a-b872dc739449.jpg', box: [0.026, 0.267, 0.957, 0.693],
                               sheets: [[0.0259, 0.2648, 0.4556, 0.2093], [0.5019, 0.2657, 0.4556, 0.2083], [0.2565, 0.4833, 0.4546, 0.2093]] },
                          8: { src: 'https://img.posterizedfloor.uk/site/2026/09/11d26f45-9cad-4d8c-9b24-4c980e9c1843.jpg', box: [0.065, 0.044, 0.928, 0.806],
                               /* the photo's rows stagger the other way from the layout's (Arjun 09-14: "CH O" / "UR E" showed past the ghosts) */
                               sheets: [[0.1185, 0.0426, 0.3981, 0.1833], [0.5278, 0.0426, 0.4, 0.1833], [0.0648, 0.237, 0.4, 0.1833], [0.4741, 0.2352, 0.4, 0.1833],
                                        [0.1167, 0.4296, 0.4, 0.1833], [0.5278, 0.4296, 0.4, 0.1833], [0.0648, 0.6222, 0.4, 0.1833], [0.4741, 0.6222, 0.4, 0.1833]] } };   /* box = the sheets, traced 09-10; sheets measured 09-14 */
  /* the split and BYW rails' live cards need the photos above and the ghost list - the first render ran before them (17-09) */
  if ((MODE === 'splits' || (!MODE && BYW_RAIL_LIVE)) && root && root.querySelector('.pz-wb-size') && !root.querySelector('.pz-live i, .pz-live image')) {
    railCache = null;   /* the cached rail was built before the photos / ghost list existed (18-09: BYW and split rails stayed plain) */
    render();
  }
  function galKeys() {
    var keys;
    if (!MODE) {
      keys = Object.keys(SIZE_META).filter(function (k) { return !RETIRED_KEYS[k] && LAYOUTS[k] && variantFor(k); });
      /* Arjun 09-12: the feature card (Mosaic, the product photo) stays on top, the rest
         read cheapest -> premium; walls on the same price keep GAL_BYW_ORDER between them */
      var rank = function (k) { var i = GAL_BYW_ORDER.indexOf(k); return i > -1 ? i : GAL_BYW_ORDER.indexOf(GAL_BYW_LAST[0]) - 0.5; };
      var priceOf = function (k) { var vr = variantFor(k); return vr ? (parseFloat(vr.v.price) || 0) : 0; };
      return keys.sort(function (a, b) {
        return (priceOf(a) - priceOf(b)) || (SIZE_META[a].posters - SIZE_META[b].posters) || (rank(a) - rank(b));
      });
    }
    keys = Object.keys(SIZE_META).filter(function (k) {
      return SIZE_META[k].size === galSize && !isFixedKey(k) && !RETIRED_KEYS[k] && LAYOUTS[k] && variantFor(k);
    }).sort(function (a, b) { return SIZE_META[a].posters - SIZE_META[b].posters; });
    if (MODE === 'singles') {
      var p = keys.filter(function (k) { return SIZE_META[k].posters === GAL_POPULAR; })[0];
      if (p) { keys.splice(keys.indexOf(p), 1); keys.unshift(p); }
    }
    return keys;
  }
  function galIsFeature(key) {
    return !MODE ? key === GAL_BYW_FEATURE : (MODE === 'singles' && SIZE_META[key].posters === GAL_POPULAR);
  }
  /* labels for a bigger basket (Arjun 09-10 "labels vei high aov kaga", animated, premium):
       Most popular - the lead pack (BYW Large, Posters 10, Split 3 Sets)
       Best value   - the lowest price per poster (Posters / Splits: the biggest pack;
                      BYW: worked out, Full Wall at Rs39 a poster)
       Save Rs X    - every pack priced above the lead one, from its compare-at price
       New          - Track Wall
     The small packs below the lead carry no label, so the eye travels up the ladder. */
  function galLabels() {
    var keys = galKeys(), out = {}, lead = null, best = null, bestPer = Infinity;
    keys.forEach(function (k) { if (!lead && (!MODE ? k === GAL_BYW_LEAD : SIZE_META[k].posters === GAL_POPULAR)) lead = k; });
    var leadVr = lead && variantFor(lead), leadPrice = leadVr ? leadVr.v.price : Infinity;
    keys.forEach(function (k) {
      var vr = variantFor(k);
      if (!vr || k === lead) return;
      if (MODE) { if (SIZE_META[k].top) best = k; return; }
      if (GAL_BYW_BADGE[k]) return;
      var per = vr.v.price / SIZE_META[k].posters;
      if (per < bestPer) { bestPer = per; best = k; }
    });
    keys.forEach(function (k) {
      var vr = variantFor(k);
      if (k === lead) out[k] = MODE ? ['Most popular', 'gold'] : k === 'mix' ? ['New \u00b7 25 posters', 'gold'] : ['Best seller', 'gold'];   /* 03-10: Mix is new - no best-seller claim */
      else if (!MODE && GAL_BYW_BADGE[k]) out[k] = GAL_BYW_BADGE[k];
      else if (k === best) out[k] = ['Best value', 'best'];
      else if (vr && vr.v.price > leadPrice && vr.v.compareAt > vr.v.price) out[k] = ['Save ' + money(Math.round(vr.v.compareAt - vr.v.price)), 'save'];
    });
    return out;
  }
  function galBadgeHtml(b, idx) {
    var ico = b[1] === 'gold' ? '<i class="st" aria-hidden="true">\u2605</i>' : b[1] === 'best' ? '<i class="st" aria-hidden="true">\u2726</i>' : b[1] === 'new' ? '<i class="dot" aria-hidden="true"></i>' : '';
    return '<span class="pz-wb-gal-badge ' + b[1] + '" style="--pz-bd:' + (0.28 + idx * 0.07).toFixed(2) + 's">' + ico + '<b>' + b[0] + '</b></span>';
  }
  /* the framed prints: the card and its photo window, straight off the print templates (28-09) */
  function framedSizeNote(sz) {
    var cell = (GRID_CELL[MODE] || {})[sz];
    if (!cell) return '';
    /* 28-09 preview test: each measure stays on one line (a lone "cm" wrapped at 375 px) */
    var cm = function (v) { return String(Math.round(v * 100) / 10); }, d = frUnitDim(cell), X = '&nbsp;\u00d7&nbsp;';
    if (FRAMED_KIND === 'booth') return 'Each strip ' + cm(d[0]) + X + cm(d[1]) + '&nbsp;cm &middot; 3&nbsp;photos per&nbsp;strip';
    var w = FRAME_WIN[cell], ww = d[0] * w[2], wh = d[1] * w[3];
    return 'Each print ' + cm(d[0]) + X + cm(d[1]) + '&nbsp;cm &middot; photo ' + (Math.abs(ww - wh) < 0.004 ? cm(ww) + '&nbsp;cm&nbsp;square' : cm(ww) + X + cm(wh) + '&nbsp;cm');
  }
  /* the real size of one poster / one set, from the print dimensions */
  function galSizeNote(sz) {
    if (FRAMED) return framedSizeNote(sz);
    var cell = (GRID_CELL[MODE] || {})[sz], d = cell && DIM[cell];
    if (!d) return '';
    var cm = function (v) { return String(Math.round(v * 100) / 10); };
    return (MODE === 'splits' ? 'Each set ' : 'Each poster ') + cm(d[0]) + ' × ' + cm(d[1]) + ' cm' + (MODE === 'splits' ? ' · 3 panels' : '');
  }
  /* card picture: the room photo cropped in on its sheets (Arjun 09-10 "images zoom
     paniko, posters nalla perutha therinum") - the sheets fill the card with a 7%
     margin and sit a little low so the desk still reads; a wall in progress shows
     its picks on top; the drawn scene where there is no photo yet */
  function galCrop(x0, y0, x1, y1, ar) {
    ar = ar || 1;   /* photo height / width (14-10): a 4:5 room photo is 1.25 widths tall */
    var bw = x1 - x0, bh = y1 - y0, m = 0.07;
    var z = Math.max(1, Math.min(1 / (bw + 2 * m), 1 / (bh + 2 * m), 3));
    var clamp = function (v, lo, hi) { return lo <= hi ? Math.min(Math.max(v, lo), hi) : v; };
    var left = clamp(0.5 - (x0 + x1) / 2 * z, m - x0 * z, 1 - m - x1 * z);
    var top = clamp(0.5 - ((y0 + y1) / 2 + bh * 0.12) * z, m - y0 * z, 1 - m - y1 * z);
    return { z: z, ar: ar, left: clamp(left, 1 - z, 0), top: clamp(top, 1 - z * ar, 0) };   /* the photo always covers the card */
  }
  function galImg(src, c) {
    var pct = (c.z * 100).toFixed(2) + '%', pctH = (c.z * (c.ar || 1) * 100).toFixed(2) + '%';
    return '<img class="pz-wb-gal-img" src="' + src + '" alt="" loading="lazy" style="width:' + pct + ';height:' + pctH + (c.ar && c.ar !== 1 ? ';object-fit:fill' : '') +
      ';left:' + (c.left * 100).toFixed(2) + '%;top:' + (c.top * 100).toFixed(2) + '%">';
  }
  function galPic(key, mine, idx) {
    /* a ready-made wall's card is the pack's own photo (Arjun 16-09), not a drawn scene with 21 thumbnails */
    var pkc = packForLayout(key);
    if (pkc && pkc.photo) {
      return '<img class="pz-wb-gal-img" src="' + thumb(pkc.photo, 480) + '" alt="" loading="lazy" decoding="async" style="width:100%;height:100%;left:0;top:0;object-fit:cover;object-position:50% 30%">';
    }
    /* off: every card starts its ghosts elsewhere in the list; big: only the lead card's sheets are large enough for the 220px thumbs */
    var L = LAYOUTS[key], m = SIZE_META[key], off = (idx || 0) * 7, big = galIsFeature(key);
    var sp = MODE === 'splits' ? GAL_SPLIT_PHOTO[m.posters] : !MODE && !(BYW_ROOMS_ON && L && L.mock) ? GAL_BYW_PHOTO[key] : null;   /* 14-10: a room photo wins */
    if (sp) {
      /* the photo's own sheets where measured (sp.sheets, slot order), else where the layout puts them inside the traced box */
      var bc = galCrop(sp.box[0], sp.box[1], sp.box[2], sp.box[3]), bw = sp.box[2] - sp.box[0], bh = sp.box[3] - sp.box[1];
      var sl = computeLayout(key).slots, ms = sp.sheets && sp.sheets.length === sl.length ? sp.sheets : null;
      var bs = sp.ghost === false ? [] : sl.map(function (g, i) {
        return ms ? { x: ms[i][0], y: ms[i][1], w: ms[i][2], h: ms[i][3], size: g.size }
          : { x: sp.box[0] + g.x / 100 * bw, y: sp.box[1] + g.y / 100 * bh, w: g.w / 100 * bw, h: g.h / 100 * bh, size: g.size };
      });
      return galImg(sp.src, bc) + galSpots(bs, bc, mine, off, big) + (sp.over && bs.length ? galOver(sp.over, bc) : '');
    }
    if (!L.mock) return sceneSVG(sceneFor(key), mine, off);
    /* spots live in the ZOOMED frame of the page wall (mockZoom [f, cx, cy]): map them
       back onto the photo first, u = c + (v - c) / f */
    var z = L.mockZoom || [1, 0.5, 0.5], f = z[0];
    /* 14-10: the 4:5 room photos are taller than wide - heights in units of the photo's width (ar = H / W), so the
       square card crops the photo in its own aspect instead of the old square 1080 x 1080 rooms' */
    var ar = L.box ? L.box[1] / L.box[0] : 1;
    var spots = computeLayout(key).slots.map(function (g) {
      return { x: z[1] + (g.x / 100 - z[1]) / f, y: (z[2] + (g.y / 100 - z[2]) / f) * ar, w: g.w / 100 / f, h: g.h / 100 / f * ar, size: g.size };
    });
    var x0 = Infinity, y0 = Infinity, x1 = 0, y1 = 0;
    spots.forEach(function (p) { x0 = Math.min(x0, p.x); y0 = Math.min(y0, p.y); x1 = Math.max(x1, p.x + p.w); y1 = Math.max(y1, p.y + p.h); });
    /* 14-10: room for the card's badge over the top-left (Arjun: "best seller label posters marakkuthu") - the wall sits a little lower */
    y0 = Math.max(0, y0 - 0.07);
    /* 14-10: the desk under the wall stays on the card (galCrop adds 0.07) - but only as far as the square card can still show the
       whole wall (Arjun: Duo and Hero lost their top rows). 0.84, not 0.86: at exactly 1 - 2 x 0.07 the two clamp bounds met and a
       rounding error made galCrop skip them */
    if (L.keepU) y1 = Math.max(y1, Math.min(L.keepU - 0.07, y0 + 0.84));
    var c = galCrop(x0, y0, x1, y1, ar);
    return galImg(L.mockSmall || L.mock, c) + galSpots(spots, c, mine, off, big) + (!mine && !MODE && !CUSTOM ? galLkSpots(spots, c) : '');
  }
  /* 15-10: empty sheets over the photo's own, for the rail/gallery look animation (railLkTick) to fill */
  function galLkSpots(spots, c) {
    return spots.map(function (p) {
      return '<i class="pz-glk" style="left:' + ((c.left + p.x * c.z) * 100).toFixed(2) + '%;top:' + ((c.top + p.y * c.z) * 100).toFixed(2) +
        '%;width:' + (p.w * c.z * 100).toFixed(2) + '%;height:' + (p.h * c.z * 100).toFixed(2) + '%"></i>';
    }).join('');
  }
  /* what stands in front of a photo's sheets (the man's head on the Mosaic photo), laid back over the ghosts */
  function galOver(o, c) {
    return '<img class="pz-wb-gal-over" src="' + o.src + '" alt="" loading="lazy" decoding="async" style="left:' + ((c.left + o.box[0] * c.z) * 100).toFixed(2) +
      '%;top:' + ((c.top + o.box[1] * c.z) * 100).toFixed(2) + '%;width:' + ((o.box[2] - o.box[0]) * c.z * 100).toFixed(2) + '%;height:' + ((o.box[3] - o.box[1]) * c.z * 100).toFixed(2) + '%">';
  }
  /* the sheets over a card photo: the wall's own picks in their spots, a ghost design on
     every empty one (Arjun 09-14: never a Shopify-listed poster - the builder's flat designs) */
  function galSpots(spots, c, mine, off, big) {
    var h = '';
    spots.forEach(function (p, i) {
      var sel = mine && state.slots[i] && state.slots[i].sel, src, g = false;
      if (sel) src = sel.type === 'upload' ? (sel.blobUrl || sel.url || sel.thumb || '') : thumb(sel.img, 160);
      else { src = ghostSrc(off + i, p.size, !big || p.w * c.z < 0.12); g = true; }
      if (!src) return;
      h += '<i' + (g ? ' class="g"' : '') + ' style="left:' + ((c.left + p.x * c.z) * 100).toFixed(2) + '%;top:' + ((c.top + p.y * c.z) * 100).toFixed(2) +
        '%;width:' + (p.w * c.z * 100).toFixed(2) + '%;height:' + (p.h * c.z * 100).toFixed(2) + '%"><img src="' + src + '" alt="" loading="lazy" decoding="async"></i>';
    });
    return h;
  }
  function galCard(key, picked, labels, idx) {
    var m = SIZE_META[key], vr = variantFor(key), pkg = packForLayout(key);
    var feat = galIsFeature(key), mine = picked > 0 && key === state.size;
    var badge = mine ? ['Your wall', 'mine'] : (labels[key] || null);
    var feet = wallFeet(key).replace(/^~/, '');
    var meta = !MODE ? m.posters + ' posters &middot; ' + feet
      : (vr ? money(Math.round(vr.v.price / m.posters)) + ' per ' + (m.unit === 'sets' ? 'set' : 'poster') + ' &middot; ' : '') + feet;
    var offer = MODE && m.tier ? '<span class="pz-wb-gal-offer">' + String(m.tier).replace(/\s*free\s*$/i, ' free') + '</span>' : '';
    var price = vr ? '<span class="pz-wb-gal-price">' + money(vr.v.price) +
      (vr.v.compareAt > vr.v.price ? ' <s>' + money(vr.v.compareAt) + '</s>' : '') + '</span>' : '';
    return '<button type="button" class="pz-wb-gal-card' + (feat ? ' feat' : '') + (mine ? ' mine' : '') + (badge && badge[1] === 'best' ? ' best' : '') + '" data-gal-key="' + key + '">' +
      '<span class="pz-wb-gal-pic">' + galPic(key, mine, idx) + '</span>' +
      (badge ? galBadgeHtml(badge, idx || 0) : '') +
      '<span class="pz-wb-gal-info">' +
        '<span class="pz-wb-gal-name">' + (pkg ? packLabel(pkg) : m.name) + '</span>' +
        offer +
        '<span class="pz-wb-gal-meta">' + meta + '</span>' +
        (feat && !MODE ? '<span class="pz-wb-gal-desc">' + m.desc + '</span>' : '') +
        '<span class="pz-wb-gal-row">' + price + '<span class="pz-wb-gal-go" aria-hidden="true">' + (feat ? 'Choose &rarr;' : '&rarr;') + '</span></span>' +
      '</span>' +
    '</button>';
  }
  function renderGallery() {
    if (!gal) {
      gal = document.createElement('div');
      gal.className = 'pz-wb-gal';
      gal.setAttribute('role', 'dialog');
      gal.setAttribute('aria-modal', 'true');
      gal.setAttribute('aria-labelledby', 'pz-wb-gal-h');
      document.body.appendChild(gal);
      gal.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var sz = t.closest('[data-gal-size]');
        if (sz) { var st = gal.scrollTop; galSize = sz.getAttribute('data-gal-size'); renderGallery(); gal.scrollTop = st; return; }
        var card = t.closest('[data-gal-key]');
        if (card) { galPick(card.getAttribute('data-gal-key'), card); return; }
        if (t.closest('.pz-wb-gal-cont')) { galPick(state.size, null); return; }
        if (t.closest('.pz-wb-gal-mix')) {
          if (!MODE) {
            /* BYW -> Mix & Match: single-poster picks come along (?pick= fills matching spots there) */
            var picks = state.slots.map(function (sl) { return !isSplit(sl.size) && sl.sel && sl.sel.type === 'catalog' && sl.sel.handle; }).filter(Boolean);
            location.href = '/products/build-your-poster-pack' + (picks.length ? '?pick=' + picks.slice(0, 36).join(',') : '');
            return;
          }
          /* the rail's Mix sizes card carries the picks over (?pick=) */
          var mx = root.querySelector('.pz-wb-size--mix');
          if (mx) mx.click(); else location.href = '/products/build-your-wall-custom-poster-wall-collage';
          return;
        }
        if (t.closest('.pz-wb-gal-x')) hideGallery();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && gal.classList.contains('show') && !(drawer && drawer.classList.contains('show'))) hideGallery();
      });
    }
    var picked = state.slots.filter(function (s) { return s.sel; }).length;
    var T = !MODE ? ['Layout', 'Posters', 'Choose your wall layout', 'Tap a layout, then pick a poster for every spot, or add your own pictures.']
      : MODE === 'splits' ? ['Pack', 'Sets', 'Choose your split sets', 'Every set is one picture printed across 3 panels. Pick a size and a pack, then choose every set.']
      : ['Pack', 'Posters', 'Choose your poster pack', 'Pick a size and a pack, then choose every poster, or add your own pictures.'];
    var keys = galKeys(), labels = galLabels();
    var cont = picked && SIZE_META[state.size]
      ? '<button type="button" class="pz-wb-gal-cont"><span class="tx"><b>Continue your wall</b><i>' + SIZE_META[state.size].name +
        ' &middot; ' + picked + ' of ' + state.slots.length + ' picked</i></span><span class="a" aria-hidden="true">&rarr;</span></button>'
      : '';
    var pills = MODE
      ? '<div class="pz-wb-gal-sizes" role="group" aria-label="Poster size">' + gridSizes().map(function (sz) {
          var on = sz.key === galSize;
          return '<button type="button" class="pz-wb-gal-sz' + (on ? ' on' : '') + '" data-gal-size="' + sz.key + '" aria-pressed="' + on + '">' + (sz.key === '13X19' ? '13×19' : sz.label) + '</button>';
        }).join('') + '</div><p class="pz-wb-gal-szhint">' + galSizeNote(galSize) + '</p>'
      : '';
    var mix = MODE === 'singles'
      ? '<button type="button" class="pz-wb-gal-mix"><span class="tx"><b>A3 and A4 on one wall?</b><i>Build Your Wall mixes sizes in one layout</i></span><span class="a" aria-hidden="true">&rarr;</span></button>'
      : !MODE
      ? '<button type="button" class="pz-wb-gal-mix"><span class="tx"><b>Only A4 posters?</b><i>Mix &amp; Match: pick any 7, 10, 18 or 36</i></span><span class="a" aria-hidden="true">&rarr;</span></button>'
      : '';
    gal.innerHTML =
      '<div class="pz-wb-gal-in">' +
        '<div class="pz-wb-gal-top">' +
          '<div class="pz-wb-gal-ttl">' +
            '<ol class="pz-wb-gal-steps" aria-label="Steps"><li class="on">' + T[0] + '</li><li>' + T[1] + '</li><li>Cart</li></ol>' +
            '<h2 class="pz-wb-gal-h" id="pz-wb-gal-h" tabindex="-1">' + T[2] + '</h2>' +
          '</div>' +
          '<button type="button" class="pz-wb-gal-x" aria-label="Close">&times;</button>' +
        '</div>' +
        '<p class="pz-wb-gal-sub">' + T[3] + '</p>' +
        cont + pills +
        '<div class="pz-wb-gal-grid' + (keys.length <= 2 ? ' few' : '') + '">' + keys.map(function (k, i) { return galCard(k, picked, labels, i); }).join('') + '</div>' +
        mix +
        '<p class="pz-wb-gal-foot">Premium 300 GSM matte posters &middot; sizes marked on every print</p>' +
      '</div>';
  }
  function showGallery() {
    if (MODE) {
      var list = gridSizes().map(function (x) { return x.key; }), cur = (SIZE_META[state.size] || {}).size;
      /* Arjun 09-10: A4 is the default - the first look is always A4; later opens (Change pack, Back) stay on the wall's size */
      galSize = (!galSeen && list.indexOf('A4') > -1) ? 'A4' : list.indexOf(cur) > -1 ? cur : (list.indexOf('A4') > -1 ? 'A4' : list[0]);
      galSeen = true;
    }
    renderGallery();
    gal.classList.remove('out');
    gal.classList.add('show');
    gal.scrollTop = 0;
    document.documentElement.classList.add('pz-wb-gal-on');
    try { gal.querySelector('.pz-wb-gal-h').focus({ preventScroll: true }); } catch (e) {}
  }
  function hideGallery() {
    if (!gal || !gal.classList.contains('show')) return;
    document.documentElement.classList.remove('pz-wb-gal-on');
    if (reduceMotion) { gal.classList.remove('show'); return; }
    gal.classList.add('out');
    setTimeout(function () { gal.classList.remove('show'); gal.classList.remove('out'); }, 180);
  }
  /* a ready-made wall chosen from the gallery or the rail: its designs go into the empty spots */
  /* ---- "Get this look" (Arjun 15-10, option B of byw-real-walls-1410/pdp-mockup: "B ok, draft la build pannu") ----
     Under the chosen layout: a swipeable strip of that layout's 5 sample walls - real-room photos, one theme each, real
     designs at true size (samples/curated). "Get this wall" fills every spot with exactly the designs in the photo, in
     spot order; the shopper can still swap any poster, and Undo puts the old picks back. A design the spot would refuse
     (fitsSlot / landscape rules) is skipped, never forced. Data: assets/pz-byw-looks.json
     { v, looks: { <layout key>: [ { name, img, items: [ { size, title, img, handle, land } x spots ] } ] } }
     Bump LOOKS_VER whenever the JSON changes (the CDN keys on the URL). Images are Shopify Files copies (pzflat / pz-byw-land)
     and titles are snapshots, so a product going draft (or away) never changes a look - the floor prints by title. */
  var LOOKS_VER = '3010dv1', LOOKS = null, looksPick = {}, looksEls = {}, lookHint = null;   /* 20-10: lookHint = layout last filled by a look / ?lk= link */
  (function () {
    if (MODE || CUSTOM) return;
    var sc = document.querySelector('script[src*="pz-wall-builder"]');
    if (!sc) return;
    var u = sc.src.split('?')[0].replace(/pz-wall-builder[^\/]*\.js$/, 'pz-byw-looks.json');
    if (u === sc.src.split('?')[0]) return;
    var x = new XMLHttpRequest();
    x.open('GET', u + '?v=' + LOOKS_VER, true);
    x.timeout = 8000;
    x.onload = function () {
      var j = null;
      try { j = JSON.parse(x.responseText); } catch (e) {}
      if (x.status !== 200 || !j || !j.looks) return;
      LOOKS = j.looks;
      if (state.size && LOOKS[state.size]) render();
    };
    x.send();
  })();
  function lkEsc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function looksStrip(key) {
    var L = !MODE && !EDIT && LOOKS && LOOKS[key], m = SIZE_META[key];
    if (!L || !L.length || !m) return null;
    var vr = variantFor(key), price = vr ? money(vr.v.price) : '';
    if (!looksPick.hasOwnProperty(key)) looksPick[key] = 0;
    var ck = key + '|' + price;
    if (looksEls[key] && looksEls[key].ck === ck) return looksEls[key].el;   /* same element between renders: images and scroll stay */
    var w = document.createElement('div');
    w.className = 'pz-wb-looks';
    w.innerHTML = '<p class="pz-wb-looks-k">Wall ideas &middot; ' + lkEsc(m.name) + '</p><p class="pz-wb-looks-h">Get this look</p>' +
      '<p class="pz-wb-looks-s">Tap a wall. We add all ' + m.posters + ' posters for you. Swap any poster after.</p>';
    var row = document.createElement('div');
    row.className = 'pz-wb-looks-row';
    var go = document.createElement('button');
    go.type = 'button';
    go.className = 'pz-wb-looks-go';
    var goTx = function () { go.textContent = 'Get this wall' + (price ? ' \u00b7 ' + price : ''); };
    L.forEach(function (lk, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pz-wb-look' + (i === looksPick[key] ? ' on' : '');
      b.innerHTML = '<span class="pz-wb-look-pic"><img src="' + thumb(lk.img, 520) + '" alt="' + lkEsc(lk.name) + ' wall idea" loading="lazy" decoding="async"><i aria-hidden="true"></i></span>' +
        '<span class="pz-wb-look-n">' + lkEsc(lk.name) + '</span><span class="pz-wb-look-m">' + m.posters + ' posters' + (price ? ' &middot; ' + price : '') + '</span>';
      b.addEventListener('click', function () {
        if (looksPick[key] === i) { applyLook(key, i); return; }   /* a second tap on the chosen wall = get it */
        looksPick[key] = i;
        [].forEach.call(row.children, function (c, j) { c.classList.toggle('on', j === i); });
      });
      row.appendChild(b);
    });
    goTx();
    go.addEventListener('click', function () { applyLook(key, looksPick[key] || 0); });
    w.appendChild(row);
    w.appendChild(go);
    var or = document.createElement('p');
    or.className = 'pz-wb-looks-or';
    or.textContent = 'or pick every poster yourself \u2193';
    w.appendChild(or);
    looksEls[key] = { ck: ck, el: w };
    return w;
  }
  function applyLook(key, i) {
    var lk = LOOKS && LOOKS[key] && LOOKS[key][i];
    if (!lk || state.size !== key) return;
    var before = state.slots.map(function (s) { return s.sel; }), n = 0;
    lk.items.forEach(function (it, k) {
      var s = state.slots[k];
      if (!s || !it || s.size !== it.size) return;
      if (!fitsSlot(it.title, s.size, !it.handle)) return;
      if (!isSplit(s.size) && !!(it.land || isLandscapeTitle(it.title)) !== isLandscape(s.size)) return;
      s.sel = { type: 'catalog', title: it.title, img: it.img, handle: it.handle || null, flat: !it.handle };
      if (it.pos && canMove(s)) s.sel.pos = it.pos;   /* 20-10: the Showcase hero opens on the ad's crop */
      n++;
    });
    if (!n) return;
    pzTrack('fill');
    lookHint = key;   /* 20-10: "Change any posters you want" under Remove all */
    save(); render();
    phActToast(lk.name + ' wall added. Tap any poster to swap it.', 'Undo', function () {
      before.forEach(function (sel, k) { if (state.slots[k]) state.slots[k].sel = sel; });
      lookHint = null;
      save(); render();
    }, 6500);
    pzScrollTo(function () { return root.querySelector('.pz-wb-wallwrap'); }, 90);
  }
  (function () {
    if (MODE || CUSTOM) return;
    var st = document.createElement('style');
    st.textContent =
      '.pz-wb-looks{margin:14px 0 8px;font-family:Barlow,system-ui,sans-serif}' +
      '.pz-wb-looks-k{margin:0 0 2px;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#0e7a4d}' +
      '.pz-wb-looks-h{margin:0;font-size:20px;font-weight:800;line-height:1.15;color:#111}' +
      '.pz-wb-looks-s{margin:3px 0 10px;font-size:13px;line-height:1.35;color:#555}' +
      '.pz-wb-looks-row{display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:3px 3px 8px;margin:0 -3px;scrollbar-width:none}' +
      '.pz-wb-looks-row::-webkit-scrollbar{display:none}' +
      '.pz-wb-look{flex:0 0 44%;max-width:210px;scroll-snap-align:start;background:none;border:0;padding:0;margin:0;text-align:left;cursor:pointer;font-family:inherit;color:inherit;-webkit-tap-highlight-color:transparent}' +
      '.pz-wb-look-pic{position:relative;display:block;aspect-ratio:4/5;border-radius:10px;overflow:hidden;background:#ececec;box-shadow:0 0 0 1px #e2e2e2}' +
      '.pz-wb-look-pic img{display:block;width:100%;height:100%;object-fit:cover}' +
      '.pz-wb-look.on .pz-wb-look-pic{box-shadow:0 0 0 3px #111}' +
      '.pz-wb-look-pic i{display:none;position:absolute;top:7px;right:7px;width:22px;height:22px;border-radius:50%;background:#ffba00 url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M5 12.5l4.5 4.5L19 7.5%27 fill=%27none%27 stroke=%27%23111%27 stroke-width=%273%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E") center/15px no-repeat;box-shadow:0 1px 3px #0005}' +
      '.pz-wb-look.on .pz-wb-look-pic i{display:block}' +
      '.pz-wb-look-n{display:block;margin-top:6px;font-size:13.5px;font-weight:700;line-height:1.2;color:#111}' +
      '.pz-wb-look-m{display:block;font-size:12px;line-height:1.3;color:#666}' +
      '.pz-wb-looks-go{display:block;width:100%;margin:6px 0 4px;padding:14px 16px;border:0;border-radius:10px;background:#ffba00;color:#111;font:800 16px/1 Barlow,system-ui,sans-serif;cursor:pointer;box-shadow:0 2px 0 #d39a00;-webkit-tap-highlight-color:transparent}' +
      '.pz-wb-looks-go:active{transform:translateY(1px);box-shadow:0 1px 0 #d39a00}' +
      '.pz-wb-looks-or{margin:4px 0 0;font-size:12px;color:#777;text-align:center}' +
      '@media (min-width:750px){.pz-wb-look{flex-basis:31%}}';
    document.head.appendChild(st);
  })();
  /* Arjun 15-10 ("balck spaces la posters one by one appear aagura maari pannu under 2sec, every 3 sec athe maari vera theme
     la maaranum"): the layout rail's room cards fill their empty sheets with one of that layout's "Get this look" walls -
     sheet by sheet in under 2 s, biggest first - and every 3 s switch to the next wall. Only cards on screen, only while the
     tab is visible, at most RAIL_LOOKS_MAX switches per page view (phone heat, 18-09), then the card keeps its last wall.
     A card that already shows the shopper's own picks is left alone. Reduced motion: the first wall, no cycling. */
  var RAIL_LOOKS_MS = 3000, RAIL_LOOKS_MAX = 24, railLkTicks = 0, railLkIdx = {}, railLkSeen = {}, railLkCur = {}, railLkTimer = null, railLkIO = null;
  var railLkCalm = false;
  try { railLkCalm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function railLkCard(card) {
    var gal = card.classList.contains('pz-wb-gal-card');
    var key = card.getAttribute(gal ? 'data-gal-key' : 'data-key');
    var box = card.querySelector(gal ? '.pz-wb-gal-pic' : '.pz-wb-size-mini.photo');
    if (!key || !box || !LOOKS || !LOOKS[key] || !LOOKS[key].length) return null;
    if (gal && card.classList.contains('mine')) return null;   /* the gallery's "Your wall" card shows the shopper's picks */
    if (key === state.size && state.slots && state.slots.some(function (x) { return x && x.sel; })) return null;   /* a wall already being picked keeps its own sheets */
    var spots = Array.prototype.slice.call(box.querySelectorAll(gal ? ':scope > i.pz-glk' : ':scope > i'));
    if (!spots.length) return null;
    var isF = function (i) { return /(^|\s)f(\s|$)/.test(i.className); };
    if (key === state.size) { if (spots.some(isF)) return null; }   /* own picks */
    else spots.forEach(function (i) {
      /* miniPhoto draws the current wall's picks by spot number on every card - on another layout they are strays */
      if (!isF(i)) return;
      i.className = '';
      Array.prototype.forEach.call(i.querySelectorAll('img:not(.pz-lk)'), function (im) { im.parentNode.removeChild(im); });
    });
    return { key: key, id: (gal ? 'g:' : 'r:') + key, mini: box, spots: spots };
  }
  /* Arjun 15-10 ("empty wall um oru time varra maari veklam"): after its walls the cycle shows the card's empty sheets once.
     railLkCur[card id] = the wall on screen (its index), -1 while the sheets are empty. */
  function railLkShow(c, animate) {
    var looks = LOOKS[c.key], L = looks.length, n = railLkIdx[c.id] || 0, slot = n % (L + 1);
    c.mini.setAttribute('data-pzlk', '1');
    var oldLab = c.mini.querySelector('.pz-lk-yours');
    if (slot === L) {   /* the empty turn */
      /* Arjun 15-10 ("plain ... just stop aana maari eruku, athuku bathila your image here nu text podalama?"): the empty
         turn is animated too - blank sheets pop in one by one and a "Your image here" label lands on the wall */
      railLkCur[c.id] = -1;
      c.spots.forEach(function (el) { el.classList.remove('pz-lk-on'); });
      var bx0 = Infinity, by0 = Infinity, bx1 = 0, by1 = 0;
      var ordE = c.spots.map(function (el, i) {
        bx0 = Math.min(bx0, el.offsetLeft); by0 = Math.min(by0, el.offsetTop);
        bx1 = Math.max(bx1, el.offsetLeft + el.offsetWidth); by1 = Math.max(by1, el.offsetTop + el.offsetHeight);
        return { i: i, a: el.offsetWidth * el.offsetHeight, y: el.offsetTop, x: el.offsetLeft };
      }).sort(function (p, q) { return (q.a - p.a) || (p.y - q.y) || (p.x - q.x); });
      var stepE = Math.min(90, Math.floor(1200 / Math.max(1, c.spots.length)));
      setTimeout(function () {
        ordE.forEach(function (o, k) { var el = c.spots[o.i]; el.style.setProperty('--pzd', (animate ? k * stepE : 0) + 'ms'); el.classList.add('pz-lk-blank'); });
        if (oldLab) oldLab.parentNode.removeChild(oldLab);
        var lab = document.createElement('span');
        lab.className = 'pz-lk-yours';
        lab.textContent = 'Choose any poster';   /* Arjun 15-10: "choose any poster nu podu" (was Your image here, then Choose any image) */
        if (bx1 > bx0) { lab.style.left = ((bx0 + bx1) / 2) + 'px'; lab.style.top = ((by0 + by1) / 2) + 'px'; }
        c.mini.appendChild(lab);
      }, animate ? 260 : 0);
      looks[0].items.forEach(function (it) { var w = new Image(); w.src = thumb(it.img, 160); });
      return;
    }
    var lk = looks[slot];
    if (!lk || !lk.items || lk.items.length !== c.spots.length) return;
    railLkCur[c.id] = slot;
    if (oldLab) oldLab.parentNode.removeChild(oldLab);
    c.spots.forEach(function (el) { el.classList.remove('pz-lk-blank'); });
    /* reveal order: biggest sheet first (the split / hero), then top-to-bottom, left-to-right */
    var order = c.spots.map(function (el, i) { return { i: i, a: el.offsetWidth * el.offsetHeight, y: el.offsetTop, x: el.offsetLeft }; })
      .sort(function (p, q) { return (q.a - p.a) || (p.y - q.y) || (p.x - q.x); });
    var step = Math.min(110, Math.floor(1600 / Math.max(1, c.spots.length)));
    var put = function () {
      order.forEach(function (o, k) {
        var el = c.spots[o.i], it = lk.items[o.i], im = el.querySelector('img.pz-lk');
        if (!im) { im = document.createElement('img'); im.className = 'pz-lk'; im.alt = ''; el.appendChild(im); }
        im.src = thumb(it.img, 160);
        el.style.setProperty('--pzd', (animate ? k * step : 0) + 'ms');
      });
      /* force a layout so the class change starts the transitions (not rAF: it stalls in a background tab) */
      void c.mini.offsetWidth;
      c.spots.forEach(function (el) { el.classList.add('pz-lk-on'); });
    };
    var was = c.spots[0].classList.contains('pz-lk-on');
    if (was && animate) { c.spots.forEach(function (el) { el.classList.remove('pz-lk-on'); }); setTimeout(put, 260); }
    else put();
    /* warm the next wall's thumbnails so it pops in whole */
    var nx = looks[slot + 1];
    if (nx && nx.items) nx.items.forEach(function (it) { var w = new Image(); w.src = thumb(it.img, 160); });
  }
  function railLkTick() {
    if (!LOOKS || document.hidden) return;
    var cards = document.querySelectorAll('.pz-wb-size[data-key], .pz-wb-gal-card[data-gal-key]');
    if (!railLkIO && 'IntersectionObserver' in window) {
      railLkIO = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.__pzVis = e.isIntersecting; }); }, { threshold: 0.35 });
    }
    var moved = false;
    Array.prototype.forEach.call(cards, function (card, ci) {
      if (railLkIO && !card.__pzObs) { card.__pzObs = 1; railLkIO.observe(card); }
      var c = railLkCard(card); if (!c) return;
      if (!c.mini.getAttribute('data-pzlk')) {   /* first fill animates, a re-render just restores */
        /* each card starts on a different wall, so their empty turns never land together (it read as "stopped") */
        if (!railLkSeen[c.id]) railLkIdx[c.id] = ci % LOOKS[c.key].length;
        railLkShow(c, !railLkSeen[c.id] && !railLkCalm); railLkSeen[c.id] = 1; return;
      }
      if (railLkCalm || (railLkIO && !card.__pzVis)) return;
      if (railLkTicks >= RAIL_LOOKS_MAX) {   /* done cycling: never rest on the empty turn */
        if (railLkCur[c.id] === -1) { railLkIdx[c.id] = (railLkIdx[c.id] || 0) + 1; railLkShow(c, true); }
        return;
      }
      railLkIdx[c.id] = (railLkIdx[c.id] || 0) + 1; railLkShow(c, true); moved = true;
    });
    if (moved) railLkTicks++;
  }
  /* Arjun 15-10 ("naan paarthadhu enga - athuve varra maari panlam ... athu click panna empty ah erkatum"): tapping a layout card
     while it shows a wall fills the builder with exactly that wall (same as "Get this wall": Undo toast, scroll to the wall);
     tapping it during its empty turn opens the layout empty, as before. Capture phase, so the wall on screen is read before the
     card's own handler re-renders the rail. */
  function railLkClick(e) {
    var card = e.target && e.target.closest && e.target.closest('.pz-wb-size[data-key], .pz-wb-gal-card[data-gal-key]');
    if (!card || !LOOKS) return;
    var gal = card.classList.contains('pz-wb-gal-card'), key = card.getAttribute(gal ? 'data-gal-key' : 'data-key');
    var cur = railLkCur[(gal ? 'g:' : 'r:') + key];
    if (cur == null || cur < 0 || !LOOKS[key] || !LOOKS[key][cur] || !card.querySelector('.pz-lk-on')) return;
    var tries = 0;
    var go = function () {
      if (state.size === key) {
        looksPick[key] = cur; applyLook(key, cur);
        Array.prototype.forEach.call(document.querySelectorAll('.pz-wb-looks .pz-wb-look'), function (el, i) { el.classList.toggle('on', i === cur); });
        return;
      }
      if (++tries < 12) setTimeout(go, 60);   /* the picker closes / the layout switches first */
    };
    setTimeout(go, 60);   /* always after the card's own handler (setSize, picker close) */
  }
  if (!MODE && !CUSTOM) {
    try {
      var railLkCss = document.createElement('style');
      /* Arjun 15-10 "borders rombo perusa eruku": no white card behind the poster and no dashed border on a filled sheet.
         Then "gaps suthama therila": the poster sits exactly on its sheet (an earlier 3% overhang closed the gaps) */
      railLkCss.textContent =
        '.pz-wb-size-mini.photo>i .pz-lk,.pz-wb-gal-pic>i.pz-glk .pz-lk{position:absolute;left:0;top:0;width:100%;height:100%;max-width:none;object-fit:cover;opacity:0;transform:scale(.55);transition:opacity .22s ease,transform .3s cubic-bezier(.2,.9,.3,1.25);transition-delay:0s}' +
        '.pz-wb-size-mini.photo>i.pz-lk-on{border:0!important;background:transparent!important;box-shadow:none!important;overflow:visible!important}' +
        '.pz-wb-gal-pic>i.pz-glk{position:absolute;overflow:visible;background:transparent;pointer-events:none}' +
        '.pz-wb-size-mini.photo>i.pz-lk-on .pz-lk,.pz-wb-gal-pic>i.pz-glk.pz-lk-on .pz-lk{opacity:1;transform:none;transition-delay:var(--pzd,0ms);box-shadow:0 1px 1.5px rgba(0,0,0,.28)}';
      railLkCss.textContent +=
        '.pz-wb-size-mini.photo>i.pz-lk-blank,.pz-wb-gal-pic>i.pz-glk.pz-lk-blank{background:#fff!important;border:1px solid rgba(0,0,0,.12)!important;box-shadow:0 1px 1.5px rgba(0,0,0,.2);animation:pzLkBlank .32s cubic-bezier(.2,.9,.3,1.25) var(--pzd,0ms) both}' +
        '@keyframes pzLkBlank{from{opacity:0;transform:scale(.55)}to{opacity:1;transform:none}}' +
        '.pz-lk-yours{position:absolute;left:50%;top:40%;z-index:5;transform:translate(-50%,-50%);padding:6px 11px;border-radius:100px;background:#111;color:#fff;font:800 10.5px/1 Barlow,system-ui,sans-serif;letter-spacing:.06em;text-transform:uppercase;white-space:nowrap;box-shadow:0 3px 10px rgba(0,0,0,.3);pointer-events:none;animation:pzLkYours .4s cubic-bezier(.2,.9,.3,1.3) .45s both}' +
        '@keyframes pzLkYours{from{opacity:0;transform:translate(-50%,-50%) scale(.6)}to{opacity:1;transform:translate(-50%,-50%) scale(1)}}' +
        '.pz-wb-gal-pic .pz-lk-yours{font-size:11.5px;padding:7px 12px}' +
        '.pz-wb-wall .pz-wb-rmall{position:absolute;left:50%;top:auto;bottom:8px;transform:translateX(-50%);z-index:6;display:inline-flex;align-items:center;gap:6px;padding:8px 14px;white-space:nowrap;border:0;border-radius:100px;background:rgba(18,18,18,.88);color:#fff;font:700 12px/1 Barlow,system-ui,sans-serif;letter-spacing:.02em;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.25);-webkit-tap-highlight-color:transparent}' +
        '.pz-wb-wall .pz-wb-rmall span{font-size:13px;line-height:1}.pz-wb-wall .pz-wb-rmall:active{transform:translate(-50%,1px)}' +
        '.pz-wb-wall .pz-wb-rmhint{position:absolute;transform:translateX(-50%);z-index:6;padding:3px 9px;white-space:nowrap;border-radius:100px;background:rgba(255,255,255,.82);color:#555;font:600 11px/1.2 Barlow,system-ui,sans-serif;pointer-events:none;box-shadow:0 1px 4px rgba(0,0,0,.12)}';
      document.head.appendChild(railLkCss);
    } catch (e) {}
    /* first fill as soon as the walls list has loaded, then one switch every 3 s */
    var railLkTry = 0, railLkBoot = setInterval(function () {
      if (LOOKS) { clearInterval(railLkBoot); railLkTick(); railLkTimer = setInterval(railLkTick, RAIL_LOOKS_MS); }
      else if (++railLkTry > 60) clearInterval(railLkBoot);   /* the walls list never came: stay with the empty sheets */
    }, 300);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) railLkTick(); });
    document.addEventListener('click', railLkClick, true);
  }
  function galPackFill(key) {
    var pk = packForLayout(key);
    if (!pk || state.size !== key) return;
    var n = fillFromPack(pk, true);
    if (!n) return;
    save(); render();
    toast(packLabel(pk) + ' is ready \u2014 tap any poster to change it, or add your own photo');
  }
  function galPick(key, card) {
    if (!LAYOUTS[key]) return;
    if (packForLayout(key)) packOff = null;   /* continuing / choosing the ready-made wall: back to pack mode */
    pzTrack('pack');   /* the funnel beacon only counts view/pack/fill/atc - a gallery pick IS the pack step */
    if (card) card.classList.add('press');
    /* one history entry for the builder, so the phone's Back comes here first */
    if (!galPushed) { try { history.pushState({ pzwb: 'build' }, '', location.href); galPushed = true; } catch (e) {} }
    railFollowsSelection = true;
    if (key === state.size) render();
    else if (MODE && SIZE_META[state.size] && SIZE_META[key].size !== SIZE_META[state.size].size && state.slots.some(function (s) { return s.sel; })) morphSize(key);   /* new size: picks come along, like the size pills */
    else setSize(key);
    galPackFill(key);
    hideGallery();
    setTimeout(function () {
      if (nextEmptySlot(-1) < 0) { pzScrollTo(function () { return root.querySelector('.pz-wb-wallwrap'); }, 90); return; }
      openOnCategory(pendingCat || drawerTab);
    }, reduceMotion ? 0 : 190);
  }
  window.addEventListener('popstate', function () {
    if (!galPushed) return;
    /* never throw away a photo mid-crop: stay on the builder */
    if (ed && ed.open) { try { history.pushState({ pzwb: 'build' }, '', location.href); } catch (e) {} return; }
    galPushed = false;
    if (drawer && drawer.classList.contains('show')) closeDrawer({ to: 'none' });
    showGallery();
  });
  (function openGalleryFirst() {
    if (PHOTO) { photoLinkPack(); return; }   /* 28-09: no gallery; a ?pack= / ?start= link picks the pack */
    if (CUSTOM) return;
    if (EDIT) return;   /* editing a cart wall: straight to that wall */
    if (window.Shopify && window.Shopify.designMode) return;
    /* Arjun 18-09 night: from the home page (?start=large on Build Your Wall, ?start=s10-a4 on Mix & Match) there is
       no "choose your layout" gallery and no picker - the page opens on that wall, or on the wall the visitor already
       started (their picks stay), and the shopper taps a spot when ready. An unknown / sold-out layout falls back to
       the gallery. */
    var sm = /[?&]start=([a-z0-9-]+)/.exec(LANDING_QS);
    if (sm && RETIRE_TO[sm[1]]) sm[1] = RETIRE_TO[sm[1]];   /* 08-10: ?start=classic opens Studio */
    if (sm) {
      var begun = state.size && state.slots.some(function (s) { return s.sel; });
      var okStart = LAYOUTS[sm[1]] && SIZE_META[sm[1]] && variantFor(sm[1]);
      /* Arjun 15-10 (home "Build Your Wall" row): a card there names its layout and the wall it was showing - &lk=N (that
         "Get this look" wall) or &lk=e (its empty turn). The tapped card wins over a wall begun on another layout, the same
         as a tap on a layout card here; lk=N fills it like "Get this wall" (Undo in the toast) */
      var lkm = /[?&]lk=(\d{1,2}|e)(?:&|$)/.exec(LANDING_QS);
      if (okStart && (!begun || (lkm && state.size !== sm[1]))) { railFollowsSelection = true; setSize(sm[1]); }
      if (okStart && lkm && lkm[1] !== 'e') {
        var lkKey = sm[1], lkN = +lkm[1], lkTry = 0;
        (function lkGo() {
          if (LOOKS && LOOKS[lkKey]) {
            if (LOOKS[lkKey][lkN] && state.size === lkKey) {
              looksPick[lkKey] = lkN; applyLook(lkKey, lkN);
              Array.prototype.forEach.call(document.querySelectorAll('.pz-wb-looks .pz-wb-look'), function (el, i) { el.classList.toggle('on', i === lkN); });
            }
          } else if (++lkTry < 60) setTimeout(lkGo, 150);   /* the walls list is still loading */
        })();
      }
      if (state.size) return;
    }
    var pk = /[?&]pack=([a-z0-9-]+)/.exec(LANDING_QS);
    if (pk && RETIRE_TO[pk[1]]) pk[1] = RETIRE_TO[pk[1]];
    if (pk && LAYOUTS[pk[1]] && SIZE_META[pk[1]] && variantFor(pk[1])) {
      /* ?pack=track / ?pack=s7-a4 - a link for one pack (ads, menu): straight into picking */
      setSize(pk[1]);
      setTimeout(function () { openOnCategory(pendingCat || drawerTab); }, 700);
      return;
    }
    if (/[?&](pick|fill|variant|go|nogallery)=/.test(LANDING_QS)) return;
    try { if (Date.now() - Number(sessionStorage.getItem('pz_pin_went') || 0) < 15 * 60 * 1000) return; } catch (e) {}
    showGallery();
  })();
})();
